<template>
	<div>
		<div style="width: 80%; margin-left: 10%;">
			<div style="display: flex;flex-direction: column;align-items: center;">
				<h1><span>{{stu_name}}的</span>儿童康复档案列表 {{stu_type}} ({{year}}年度)</h1>
			</div>
			<!-- 基本资料 -->
			<el-card id="id1">
				<div slot="header" class="clearfix">
					<span>基本资料信息</span>

				</div>
				<div>
					<el-descriptions title="基本信息" :column="4" size="" border>
						<template slot="extra" v-if="false">
							<el-button type="primary" size="small">操作</el-button>
						</template>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								姓名
							</template>
							{{ stu_info_tlyy.stu_name }}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-mobile-phone"></i>
								身份证号
							</template>
							{{ stu_info_tlyy.stu_ID }}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-location-outline"></i>
								性别
							</template>
							{{ stu_info_tlyy.stu_sex }}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-tickets"></i>
								民族
							</template>
							{{ stu_info_tlyy.minzu }}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-office-building"></i>
								出生日期
							</template>
							{{ stu_info_tlyy.shengri }}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-office-building"></i>
								户口所在地
							</template>
							{{ stu_info_tlyy.stu_info_jbxx.address}}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-office-building"></i>
								联系人
							</template>
							{{ stu_info_tlyy.stu_info_jbxx.lianxinren }}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-office-building"></i>
								联系人关系
							</template>
							{{ stu_info_tlyy.stu_info_jbxx.lianxinren_guanxi }}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-office-building"></i>
								联系人电话
							</template>
							{{ stu_info_tlyy.stu_info_jbxx.lianxinren_phone }}
						</el-descriptions-item>
					</el-descriptions>
					<div class="el-descriptions__title margin-top">
						父母家庭信息
					</div>
					<el-table class="margin-top" :data="stu_info_tlyy.family_info" border style="width: 100%">
						<el-table-column prop="name" label="" width="120">
						</el-table-column>
						<el-table-column prop="value" label="姓名" width="120">
							<template slot-scope="scope">
								{{ scope.row.value.name }}
							</template>
						</el-table-column>
						<el-table-column prop="value" label="民族" width="100">
							<template slot-scope="scope">
								{{ scope.row.value.minzu }}
							</template>
						</el-table-column><el-table-column prop="value" label="身份证号" width="183">
							<template slot-scope="scope">
								{{ scope.row.value.idcard }}
							</template>
						</el-table-column><el-table-column prop="value" label="听力状况" width="145">
							<template slot-scope="scope">
								{{ scope.row.value.tingli }}
							</template>
						</el-table-column><el-table-column prop="value" label="教育程度" width="145">
							<template slot-scope="scope">
								{{ scope.row.value.jiaoyu }}
							</template>
						</el-table-column><el-table-column prop="value" label="职业" width="145">
							<template slot-scope="scope">
								{{ scope.row.value.zhiyie }}
							</template>
						</el-table-column><el-table-column prop="value" label="联系电话" width="145">
							<template slot-scope="scope">
								{{ scope.row.value.phone }}
							</template>
						</el-table-column>
					</el-table>
					<!--基本信息结束-->
					<el-descriptions class="margin-top" title="家庭状况" :column="3" size="" border>
						<template slot="extra" v-if="false">
							<el-button type="primary" size="small">操作</el-button>
						</template>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								家庭状况
							</template>
							{{ stu_info_tlyy.family_zhuangkuang.jiatingzuangkuang }}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-mobile-phone"></i>
								有无兄弟姊妹
							</template>
							{{ stu_info_tlyy.family_zhuangkuang.xiongdijiemei}}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-mobile-phone"></i>
								家庭主要输入语言类型
							</template>
							{{ stu_info_tlyy.family_zhuangkuang.yuyanleixing}}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-mobile-phone"></i>
								主要照顾者与儿童关系
							</template>
							{{ stu_info_tlyy.family_zhuangkuang.zhuayaozhaoguzheguanxi}}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-mobile-phone"></i>
								主要照顾者出生日期
							</template>
							{{ stu_info_tlyy.family_zhuangkuang.zhuayaozhaoguzhe_riqi}}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-mobile-phone"></i>
								主要照顾者联系电话
							</template>
							{{ stu_info_tlyy.family_zhuangkuang.phone}}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-mobile-phone"></i>
								现居住地址
							</template>
							{{ stu_info_tlyy.family_zhuangkuang.xian_address}}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-mobile-phone"></i>
								家庭地址
							</template>
							{{ stu_info_tlyy.family_zhuangkuang.jia_address}}
						</el-descriptions-item>
					</el-descriptions>
					<el-descriptions class="margin-top" title="入园信息" :column="3" size="" border>
						<template slot="extra" v-if="false">
							<el-button type="primary" size="small">操作</el-button>
						</template>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								入园时间
							</template>
							{{ stu_info_tlyy.ruyuan_info.time_ruyuan}}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-mobile-phone"></i>
								班级
							</template>
							{{ stu_info_tlyy.ruyuan_info.class}}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-mobile-phone"></i>
								个别化教师
							</template>
							{{ stu_info_tlyy.ruyuan_info.teacher_gx}}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-mobile-phone"></i>
								集体教师
							</template>
							{{ stu_info_tlyy.ruyuan_info.teacher_jtk}}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-mobile-phone"></i>
								听力师
							</template>
							{{ stu_info_tlyy.ruyuan_info.teacher_tl}}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-mobile-phone"></i>
								AVT教师
							</template>
							{{ stu_info_tlyy.ruyuan_info.teacher_avt}}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-mobile-phone"></i>
								言语矫治师
							</template>
							{{ stu_info_tlyy.ruyuan_info.teacher_yuyan}}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-mobile-phone"></i>
								评估师
							</template>
							{{ stu_info_tlyy.ruyuan_info.teacher_pg}}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-mobile-phone"></i>
								社区管理员
							</template>
							{{ stu_info_tlyy.ruyuan_info.teacher_shequ}}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-mobile-phone"></i>
								其他
							</template>
							{{ stu_info_tlyy.ruyuan_info.qita}}
						</el-descriptions-item>
					</el-descriptions>
				</div>
			</el-card>
			<div style="height: 50px;width: 200px;"></div>
			<el-card id="id2">
				<div slot="header" class="clearfix">
					<span>首次评估</span>
				</div>
				<el-descriptions title="基本信息" :column="3" size="" border>
					<template slot="extra" v-if="false">
						<el-button type="primary" size="small">操作</el-button>
					</template>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							姓名
						</template>
						{{ shouci_list.stu_name }}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-mobile-phone"></i>
							性别
						</template>
						{{ shouci_list.sex }}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-location-outline"></i>
							出生年月
						</template>
						{{ stu_info_tlyy.shengri }}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-tickets"></i>
							入园时间
						</template>
						{{ getdate(stu_info_tlyy.ins_date) }}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-office-building"></i>
							班级
						</template>
						<!-- {{ stu_info_tlyy.shengri }} -->
					</el-descriptions-item>
				</el-descriptions>
				<el-descriptions title="听力状况" :column="1" size="" border>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							确诊时间
						</template>
						{{ shouci_list.tinglizhuangkuang.quezhentime }}
					</el-descriptions-item>
				</el-descriptions>
				<div v-for="(item,index) in shouci_list.tinglizhuangkuang.pinggujieguo" :key="index">
					<el-descriptions class="margin-top" :column="3" border>
						<template slot="extra" v-if="false">
							<el-button type="primary" size="small">操作</el-button>
						</template>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								双耳
							</template>
							{{ index==0?'听力状况-左耳':'听力状况-右耳' }}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								听力状况
							</template>
							{{ item.tingsunchengdu }}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-mobile-phone"></i>
								补偿/重建方式
							</template>
							<span style="margin-right: 10px;">设备：{{ item.chongjianfangshi }}.</span> <span
								style="margin-right: 10px;"> 型号：{{item.chongjianfangshi_xinghao}}.</span> <span
								style="margin-right: 10px;">验配/开机时间：{{item.time=="请选择日期"?'未填写':item.time}} </span>
						</el-descriptions-item>
					</el-descriptions>
					<el-table class="" :data="item.zhuting" border style="width: 100%">
						<el-table-column>
							助听听阈
						</el-table-column>
						<el-table-column prop="zhuting_1" label="项" width="285">
						</el-table-column>
						<el-table-column prop="zhuting1" label="值(dB(HL))" width="285">
							<template slot-scope="scope">
								{{scope.row.zhuting1}}<span style="font-size: 90%;">dB(HL)</span>
							</template>
						</el-table-column>
						<el-table-column prop="zhuting_2" label="项" width="285">
						</el-table-column>
						<el-table-column prop="zhuting2" label="值(dB(HL))" width="285">
							<template slot-scope="scope">
								{{scope.row.zhuting2}}<span style="font-size: 90%;">dB(HL)</span>
							</template>
						</el-table-column>
					</el-table>
				</div>
				<el-descriptions :column="1" size="" border>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							听力刺激策略
						</template>
						{{shouci_list.tinglizhuangkuang.tingli_ciji }}
					</el-descriptions-item>
				</el-descriptions>
				<div
					style="height: 40px; display: flex;align-items: center; justify-content: start; font-size: 110%; font-weight: 550;">
					<span>评估内容</span>
				</div>
				<el-descriptions title="听能管理" :column="2" size="" border>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							{{shouci_list.awp.tingnengguanli[0].tingnengguanli_biaoti}}
						</template>
						{{shouci_list.awp.tingnengguanli[0].xuanze}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							{{shouci_list.awp.tingnengguanli[1].tingnengguanli_biaoti}}
						</template>
						{{shouci_list.awp.tingnengguanli[1].xuanze}}
					</el-descriptions-item>
				</el-descriptions>
				<el-descriptions :column="3" size="" border>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							家中听能环境
						</template>
						{{shouci_list.awp.tingnenghuanjin}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							幼儿的听觉习惯
						</template>
						{{shouci_list.awp.tingjuexiguan}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							已有助听设备保养工具
						</template>
						{{shouci_list.awp.pingguneirong_tianxie[0].neirong}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							配戴助听设备后幼儿对声音的反应有何改变？
						</template>
						{{shouci_list.awp.pingguneirong_tianxie[1].neirong}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							备注
						</template>
						{{shouci_list.awp.tingnengguanlibeizhu}}
					</el-descriptions-item>
				</el-descriptions>
				<el-descriptions title="听觉能力" :column="3" size="" border>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							{{shouci_list.awp.tingjuenengli_xuanxiang[0].tingjuenengli_biaoti}}
						</template>
						{{shouci_list.awp.tingjuenengli_xuanxiang[0].xuanxiang}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							{{shouci_list.awp.tingjuenengli_xuanxiang[1].tingjuenengli_biaoti}}
						</template>
						{{shouci_list.awp.tingjuenengli_xuanxiang[1].xuanxiang}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							{{shouci_list.awp.tingjuenengli_xuanxiang[2].tingjuenengli_biaoti}}
						</template>
						{{shouci_list.awp.tingjuenengli_xuanxiang[2].xuanxiang}}
					</el-descriptions-item>
				</el-descriptions>
				<div style="height: 40px; display: flex;align-items: center; justify-content: start; ">
					<span>幼儿对林氏（Ling’s）六音的反应</span>
				</div>
				<el-table class="" :data="shouci_list.awp.tingjuenengli_linshiliuyin" border style="width: 100%">
					<el-table-column label="察觉" prop="linshiliuyin_biaoti" width="300">
						<template slot-scope="scope">
							{{scope.row.linshiliuyin_biaoti}}
						</template>
					</el-table-column>
					<el-table-column prop="chajue" label="值" width="300">
						<template slot-scope="scope">
							{{scope.row.chajue}}
						</template>
					</el-table-column>
					<el-table-column width="67">
					</el-table-column>
					<el-table-column label="辨识" prop="linshiliuyin_biaoti" width="300">
						<template slot-scope="scope">
							{{scope.row.linshiliuyin_biaoti}}
						</template>
					</el-table-column>
					<el-table-column prop="chajue" label="值" width="300">
						<template slot-scope="scope">
							{{scope.row.bianshi}}
						</template>
					</el-table-column>
				</el-table>
				<el-descriptions :column="2" size="" border>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							听觉记忆
						</template>
						{{shouci_list.awp.tingjuejiyi_xiang}}项
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							组合类型
						</template>
						{{shouci_list.awp.tingjuejiyi_zuheleixing}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							听觉描述：闭合式
						</template>
						第{{shouci_list.awp.tingjuemiaoshu_bihe}}阶段
					</el-descriptions-item><el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							听觉描述：开放式
						</template>
						第{{shouci_list.awp.tingjuemiaoshu_kaifang}}阶段
					</el-descriptions-item>
				</el-descriptions>
				<el-descriptions :column="2" size="" border>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							听力障碍儿童听觉能力评估标准 言语识别平均得分
						</template>
						{{shouci_list.awp.tingjuenengli_tianxie[0].neirong}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							CAP听觉行为分级记录 级别
						</template>
						{{shouci_list.awp.tingjuenengli_tianxie[1].neirong}}
					</el-descriptions-item>
				</el-descriptions>
				<div class="el-descriptions__title margin-top">
					备注
				</div>
				<el-input class="margin-top" style="font-size: 16px;" type="textarea" :rows="3" disabled
					v-model="shouci_list.awp.tingjuenengli_beizhu">
				</el-input>
				<el-descriptions title="语言能力" :column="3" size="" border>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							沟通模式
						</template>
						{{shouci_list.awp.goutongmuoshi}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							理解性语言程度
						</template>
						{{shouci_list.awp.lijiexingyvyanchengdu}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							表达性语言程度
						</template>
						<span v-if="shouci_list.awp.biaodaxingyvyanchengdu=='模仿复述'">
							{{shouci_list.awp.biaodaxingyvyanchengdu}}
							(句子长度{{shouci_list.awp.biaodaxingyvyanchengdu_tiankong.mofangfushu_changdu}}个字，例如{{shouci_list.awp.biaodaxingyvyanchengdu_tiankong.mofangfushu_liru}})
						</span>
						<span v-if="shouci_list.awp.biaodaxingyvyanchengdu=='无'">
							{{shouci_list.awp.biaodaxingyvyanchengdu}}
						</span>
						<span v-if="shouci_list.awp.biaodaxingyvyanchengdu=='主动表达'">
							{{shouci_list.awp.biaodaxingyvyanchengdu}}
							(句子长度{{shouci_list.awp.biaodaxingyvyanchengdu_tiankong.zhudongbiaoda_changdu}}个字，例如{{shouci_list.awp.biaodaxingyvyanchengdu_tiankong.zhudongbiaoda_liru}})
						</span>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							表达性语言发展阶段
						</template>
						{{shouci_list.awp.biaodaxingyvyanfazhanjieduan_shifou}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							问句能力
						</template>
						<span v-if="shouci_list.awp.wenjvnengli=='理解，会回答'">
							{{shouci_list.awp.wenjvnengli}} (说明：{{shouci_list.awp.wenjvnengli_lijie}})
						</span>
						<span v-if="shouci_list.awp.wenjvnengli=='会表达问句'">
							{{shouci_list.awp.wenjvnengli}} (说明：{{shouci_list.awp.wenjvnengli_huibiaodawenjv}})
						</span>
						<span v-if="shouci_list.awp.wenjvnengli=='不能理解'">
							{{shouci_list.awp.wenjvnengli}}
						</span>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							听力障碍儿童语言能力评估标准 平均语言年龄水平
						</template>
						{{shouci_list.awp.pingjunyvyannianlingshuiping}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							SIR言语可懂度分级记录 级别
						</template>
						{{shouci_list.awp.yanyvkedongdu}}
					</el-descriptions-item>
				</el-descriptions>
				<el-descriptions title="言语能力" :column="3" size="" border>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							能否发出声音
						</template>
						{{shouci_list.awp.yanyvfasheng}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							超音段
						</template>
						<span v-for="(item2,index2) in shouci_list.awp.chaoshengduan_duoxuan " :key="index2">
							{{item2}},
						</span>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							模仿发音
						</template>
						<span v-if="shouci_list.awp.mofangfasheng=='会'">
							{{shouci_list.awp.mofangfasheng}} (说明：{{shouci_list.awp.mofangfasheng_shuoming}})
						</span>
						<span v-if="shouci_list.awp.mofangfasheng=='不会'">
							{{shouci_list.awp.mofangfasheng}}
						</span>
					</el-descriptions-item>
				</el-descriptions>
				<el-descriptions title="认知能力" :column="3" size="" border>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							分类
						</template>
						{{shouci_list.awp.renzhinengli.find(item3=>item3.renzhinengli_biaoti=="分类：").neirong}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							配对
						</template>
						{{shouci_list.awp.renzhinengli.find(item3=>item3.renzhinengli_biaoti=="配对：").neirong}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							颜色
						</template>
						{{shouci_list.awp.renzhinengli.find(item3=>item3.renzhinengli_biaoti=="颜色：").neirong}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							形状
						</template>
						{{shouci_list.awp.renzhinengli.find(item3=>item3.renzhinengli_biaoti=="形状：").neirong}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							质感
						</template>
						{{shouci_list.awp.renzhinengli.find(item3=>item3.renzhinengli_biaoti=="质感：").neirong}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							数学概念
						</template>
						{{shouci_list.awp.renzhinengli.find(item3=>item3.renzhinengli_biaoti=="数学概念：").neirong}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							排序
						</template>
						{{shouci_list.awp.renzhinengli.find(item3=>item3.renzhinengli_biaoti=="排序：").neirong}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							其他思维能力
						</template>
						{{shouci_list.awp.renzhinengli.find(item3=>item3.renzhinengli_biaoti=="其他思维能力：").neirong}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							格雷费斯儿童精神发育检查报告 发育商
						</template>
						{{shouci_list.awp.renzhinengli_tianxie[0].neirong}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							希一内学习能力检验报告 智商/学习能力商
						</template>
						{{shouci_list.awp.renzhinengli_tianxie[1].neirong}}
					</el-descriptions-item>
				</el-descriptions>
				<div class="el-descriptions__title margin-top">
					备注
				</div>
				<el-input class="margin-top" style="font-size: 16px;" type="textarea" :rows="3" disabled
					v-model="shouci_list.awp.yvyannenglibeizhu">
				</el-input>
				<el-descriptions title="沟通能力" :column="3" size="" border>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							表达需求的方式
						</template>
						{{shouci_list.awp.biaodaxvqiufangshi}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							等待能力、轮替
						</template>
						{{shouci_list.awp.dengdainengli}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							眼神交流
						</template>
						{{shouci_list.awp.goutongnengli_xuanze.find(item3=>item3.goutongnengli_biaoti=="眼神交流：").xuanxiang}}
						<span
							v-if="shouci_list.awp.goutongnengli_xuanze.find(item3=>item3.goutongnengli_biaoti=='眼神交流：').xuanxiang=='有'">(说明:{{shouci_list.awp.goutongnengli_xuanze.find(item3=>item3.goutongnengli_biaoti=="眼神交流：：").neirong}})</span>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							主动提问
						</template>
						{{shouci_list.awp.goutongnengli_xuanze.find(item3=>item3.goutongnengli_biaoti=="主动提问：").xuanxiang}}
						<span
							v-if="shouci_list.awp.goutongnengli_xuanze.find(item3=>item3.goutongnengli_biaoti=='主动提问：').xuanxiang=='有'">(说明:{{shouci_list.awp.goutongnengli_xuanze.find(item3=>item3.goutongnengli_biaoti=="主动提问：").neirong}})</span>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							主动互动
						</template>
						{{shouci_list.awp.goutongnengli_xuanze.find(item3=>item3.goutongnengli_biaoti=="主动互动：").xuanxiang}}
						<span
							v-if="shouci_list.awp.goutongnengli_xuanze.find(item3=>item3.goutongnengli_biaoti=='主动互动：').xuanxiang=='有'">(说明:{{shouci_list.awp.goutongnengli_xuanze.find(item3=>item3.goutongnengli_biaoti=="主动互动：").neirong}})</span>
					</el-descriptions-item>

					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							维持话题
						</template>
						{{shouci_list.awp.goutongnengli_xuanze.find(item3=>item3.goutongnengli_biaoti=="维持话题：").xuanxiang}}
						<span
							v-if="shouci_list.awp.goutongnengli_xuanze.find(item3=>item3.goutongnengli_biaoti=='维持话题：').xuanxiang=='有'">(说明:{{shouci_list.awp.goutongnengli_xuanze.find(item3=>item3.goutongnengli_biaoti=="维持话题：").neirong}})</span>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							开启话题
						</template>
						{{shouci_list.awp.goutongnengli_xuanze.find(item3=>item3.goutongnengli_biaoti=="开启话题：").xuanxiang}}
						<span
							v-if="shouci_list.awp.goutongnengli_xuanze.find(item3=>item3.goutongnengli_biaoti=='开启话题：').xuanxiang=='有'">(说明:{{shouci_list.awp.goutongnengli_xuanze.find(item3=>item3.goutongnengli_biaoti=="开启话题：").neirong}})</span>
					</el-descriptions-item>
				</el-descriptions>

				<el-descriptions title="行为表现" :column="3" size="" border>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							好奇心
						</template>
						{{shouci_list.awp.haoqixin}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							稳定性
						</template>
						{{shouci_list.awp.wendingxing}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							行为问题
						</template>
						{{shouci_list.awp.xingweiwenti}}
						<span
							v-if="shouci_list.awp.xingweiwenti=='有'">(说明:{{shouci_list.awp.xingweibiaoxian_xingweiwenti}})</span>
					</el-descriptions-item>
				</el-descriptions>

				<el-descriptions title="自理能力-入厕" :column="2" size="" border>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							有大小便需求时，能自己入厕
						</template>
						{{shouci_list.awp.zilinengli.find(item=>item.biaoti=="入厕").xuanxiang.find(item1=>item1.xuanxiang_biaoti=="有大小便需求时，能自己入厕").xuanxinag_jieguo}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							在成人提醒下便后会用水冲洗
						</template>
						{{shouci_list.awp.zilinengli.find(item=>item.biaoti=="入厕").xuanxiang.find(item1=>item1.xuanxiang_biaoti=="在成人提醒下便后会用水冲洗").xuanxinag_jieguo}}
					</el-descriptions-item>
				</el-descriptions>
				<el-descriptions title="自理能力-进餐" :column="2" size="" border>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							能使用小勺独立进餐
						</template>
						{{shouci_list.awp.zilinengli.find(item=>item.biaoti=="进餐").xuanxiang.find(item1=>item1.xuanxiang_biaoti=="能使用小勺独立进餐").xuanxinag_jieguo}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							餐后能主动漱口和擦嘴
						</template>
						{{shouci_list.awp.zilinengli.find(item=>item.biaoti=="进餐").xuanxiang.find(item1=>item1.xuanxiang_biaoti=="餐后能主动漱口和擦嘴").xuanxinag_jieguo}}
					</el-descriptions-item>
				</el-descriptions>
				<el-descriptions title="自理能力-穿衣" :column="2" size="" border>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							能自己穿脱简单的衣裤和鞋袜
						</template>
						{{shouci_list.awp.zilinengli.find(item=>item.biaoti=="穿衣").xuanxiang.find(item1=>item1.xuanxiang_biaoti=="能自己穿脱简单的衣裤和鞋袜").xuanxinag_jieguo}}
					</el-descriptions-item>
				</el-descriptions>
				<el-descriptions title="自理能力-卫生习惯" :column="3" size="" border>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							能自己擦鼻涕
						</template>
						{{shouci_list.awp.zilinengli.find(item=>item.biaoti=="卫生习惯").xuanxiang.find(item1=>item1.xuanxiang_biaoti=="能自己擦鼻涕").xuanxinag_jieguo}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							饭前、便后、手脏时知道洗手
						</template>
						{{shouci_list.awp.zilinengli.find(item=>item.biaoti=="卫生习惯").xuanxiang.find(item1=>item1.xuanxiang_biaoti=="饭前、便后、手脏时知道洗手").xuanxinag_jieguo}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							在成人提醒下能早晚刷牙
						</template>
						{{shouci_list.awp.zilinengli.find(item=>item.biaoti=="卫生习惯").xuanxiang.find(item1=>item1.xuanxiang_biaoti=="在成人提醒下能早晚刷牙").xuanxinag_jieguo}}
					</el-descriptions-item>
				</el-descriptions>
				<el-descriptions title="自理能力-安全" :column="2" size="" border>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							外出时跟随成人、不乱跑
						</template>
						{{shouci_list.awp.zilinengli.find(item=>item.biaoti=="安全").xuanxiang.find(item1=>item1.xuanxiang_biaoti=="外出时跟随成人、不乱跑").xuanxinag_jieguo}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							游戏时不做危险动作
						</template>
						{{shouci_list.awp.zilinengli.find(item=>item.biaoti=="安全").xuanxiang.find(item1=>item1.xuanxiang_biaoti=="游戏时不做危险动作").xuanxinag_jieguo}}
					</el-descriptions-item>
				</el-descriptions>
				<el-descriptions title="家长受训经验及 教育能力" :column="3" size="" border>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							受训经验：已参加家长培训
						</template>
						{{shouci_list.awp.jiazhangpeixun}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							家长与孩子互动与游戏
						</template>
						{{shouci_list.awp.jiazhanghudongyouxi}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							对于孩子耳聋事件的情绪阶段
						</template>
						{{shouci_list.awp.qingxvjieduan}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							家长参与课堂表现
						</template>
						{{shouci_list.awp.ketangbiaoxian}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							家长技巧学习能力
						</template>
						{{shouci_list.awp.jiazhangshouxun1.find(item3=>item3.biaoti=="家长技巧学习能力").jieguo}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							对孩子教养观念与信念
						</template>
						{{shouci_list.awp.jiazhangshouxun1.find(item3=>item3.biaoti=="对孩子教养观念与信念").jieguo}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							对孩子的期望值
						</template>
						{{shouci_list.awp.jiazhangshouxun2.find(item3=>item3.biaoti=="对孩子的期望值").jieguo}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							对孩子的敏感度
						</template>
						{{shouci_list.awp.jiazhangshouxun2.find(item3=>item3.biaoti=="对孩子的敏感度").jieguo}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							对幼儿发展的认知
						</template>
						{{shouci_list.awp.jiazhangshouxun2.find(item3=>item3.biaoti=="对幼儿发展的认知").jieguo}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							阅读习惯
						</template>
						{{shouci_list.awp.jiazhangshouxun2.find(item3=>item3.biaoti=="阅读习惯").jieguo}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							作息规律性
						</template>
						{{shouci_list.awp.jiazhangshouxun2.find(item3=>item3.biaoti=="作息规律性").jieguo}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							资料收集能力
						</template>
						{{shouci_list.awp.jiazhangshouxun2.find(item3=>item3.biaoti=="资料收集能力").jieguo}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							家长回应孩子需求
						</template>
						{{shouci_list.awp.huiyinghaizixvqiu}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							备注：
						</template>
						{{shouci_list.awp.jiazhangshouxunbeizhu}}
					</el-descriptions-item>
				</el-descriptions>

				<el-descriptions title="综合分析与康复建议" :column="1" size="" border>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							1.简要描述、判断：
						</template>
						{{shouci_list.zonghefenxi.find(item3=>item3.biaoti=="简要描述、判断：").neirong}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							2.分析：
						</template>
						{{shouci_list.zonghefenxi.find(item3=>item3.biaoti=="分析：").neirong}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							3.康复建议：
						</template>
						{{shouci_list.zonghefenxi.find(item3=>item3.biaoti=="康复建议：").neirong}}
					</el-descriptions-item>
				</el-descriptions>
				<el-descriptions :column="2" size="" border>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							评估日期
						</template>
						{{shouci_list.pinggurenyuanriqi.time}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							评估人员
						</template>
						{{shouci_list.pinggurenyuanriqi.pinggurenyuan}}
					</el-descriptions-item>
				</el-descriptions>
			</el-card>
			<div style="height: 50px;width: 200px;"></div>
			<el-card id="id3">
				<div slot="header" class="clearfix">
					<span>持续评估表</span>
					<span style="margin-right: 20px; font-size: 80%; display: flex; justify-content: end;">注明：（1.<div
							class="yuanquan">1</div> 表示评估次数,; 2.<div class="fangkuai">⊥</div>表示结果选项,<div
							class="fangkuai"></div>表示未选择; 3.开始:<div class="fangkuai">⊥</div>，不稳：<div class="fangkuai">〸
						</div>，稳定：<div class="fangkuai">√</div>
						，表达：<div class="fangkuai">乄</div>）</span>
				</div>
				<el-descriptions title="基本资料" :column="4" size="" border>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							姓名
						</template>
						{{cxpg_info.stu_name}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							性别
						</template>
						{{cxpg_info.stu_sex}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							生理年龄
						</template>
						{{cxpg_info.shengli_age}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							听觉年龄
						</template>
						{{cxpg_info.tingjue_age}}
					</el-descriptions-item>
				</el-descriptions>
				<el-table class="" :data="cxpg_info.order_cxpg" border style="width: 100%">
					<el-table-column prop="order_num" label="序号" width="306">
						<template slot-scope="data">
							{{data.row.order_num+1}}
						</template>
					</el-table-column>
					<el-table-column prop="order_num" label="评估次数" width="320">
						<template slot-scope="data">
							第{{data.row.order_num+1}}次评估
						</template>
					</el-table-column>
					<el-table-column prop="time" label="评估日期" width="320">
					</el-table-column>
					<el-table-column label="任教老师签字" width="320">
						<template>
							{{cxpg_info.pg_teacher}}
						</template>
					</el-table-column>
				</el-table>
				<div class="el-descriptions__title margin-top margin-bottom">
					评估内容
				</div>
				<el-table class="" :data="cxpg_info.tingjuejiyi" border style="width: 100%">
					<el-table-column label="名称" width="200">
						听觉记忆
					</el-table-column>
					<el-table-column prop="tingjuejiyi_num" label="项" width="200">
					</el-table-column>
					<el-table-column prop="value" label="评估次数" width="866">
						<template slot-scope="data">
							<div style="display: flex; flex-wrap: wrap;">
								<div v-for="(item_cxpg, index_cxpg) in data.row.value" :key="index_cxpg">
									<div style="display: flex; margin-right: 10px;">
										<div class="yuanquan">{{ item_cxpg.num + 1 }}</div>
										<div class="fangkuai">{{ item_cxpg.value }}</div>
									</div>
								</div>
							</div>
						</template>
					</el-table-column>
				</el-table>
				<div class="el-descriptions__title margin-top margin-bottom">
					领域-听能
				</div>
				<el-descriptions title="声音察觉与辨识-察觉" :column="4" size="" border>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							自己名字
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.tingneng.value.find(item_ly => item_ly.ly_name === '声音察觉与辨识').value.find(itemjj => itemjj.name === '察觉').value.find(item11 => item11.name === '自己名字').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							语音
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.tingneng.value.find(item_ly => item_ly.ly_name === '声音察觉与辨识').value.find(itemjj => itemjj.name === '察觉').value.find(item11 => item11.name === '语音').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							环境音
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.tingneng.value.find(item_ly => item_ly.ly_name === '声音察觉与辨识').value.find(itemjj => itemjj.name === '察觉').value.find(item11 => item11.name === '环境音').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							有声玩具
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.tingneng.value.find(item_ly => item_ly.ly_name === '声音察觉与辨识').value.find(itemjj => itemjj.name === '察觉').value.find(item11 => item11.name === '有声玩具').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
				</el-descriptions>
				<el-descriptions title="声音察觉与辨识-辨识" :column="4" size="" border>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							自己名字
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.tingneng.value.find(item_ly => item_ly.ly_name === '声音察觉与辨识').value.find(itemjj => itemjj.name === '辨识').value.find(item11 => item11.name === '自己名字').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							语音
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.tingneng.value.find(item_ly => item_ly.ly_name === '声音察觉与辨识').value.find(itemjj => itemjj.name === '辨识').value.find(item11 => item11.name === '语音').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							环境音
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.tingneng.value.find(item_ly => item_ly.ly_name === '声音察觉与辨识').value.find(itemjj => itemjj.name === '辨识').value.find(item11 => item11.name === '环境音').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							有声玩具
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.tingneng.value.find(item_ly => item_ly.ly_name === '声音察觉与辨识').value.find(itemjj => itemjj.name === '辨识').value.find(item11 => item11.name === '有声玩具').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
				</el-descriptions>
				<el-descriptions title="声源辨识-优耳" :column="3" size="" border>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							声源方位
						</template>
						前方
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							距离
						</template>
						50cm
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							内容
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.tingneng.value.find(item_ly => item_ly.ly_name ==='声源辨识').value.find(itemjj => itemjj.name === '优耳').value.find(item11 => item11.name === '前方').value50"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							声源方位
						</template>
						前方
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							距离
						</template>
						1m
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							内容
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.tingneng.value.find(item_ly => item_ly.ly_name ==='声源辨识').value.find(itemjj => itemjj.name === '优耳').value.find(item11 => item11.name === '前方').value100"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>

					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							声源方位
						</template>
						后方
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							距离
						</template>
						50cm
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							内容
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.tingneng.value.find(item_ly => item_ly.ly_name ==='声源辨识').value.find(itemjj => itemjj.name === '优耳').value.find(item11 => item11.name === '后方').value50"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							声源方位
						</template>
						后方
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							距离
						</template>
						1m
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							内容
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.tingneng.value.find(item_ly => item_ly.ly_name ==='声源辨识').value.find(itemjj => itemjj.name === '优耳').value.find(item11 => item11.name === '后方').value100"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
				</el-descriptions>

				<el-descriptions title="声源辨识-劣耳" :column="3" size="" border>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							声源方位
						</template>
						前方
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							距离
						</template>
						50cm
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							内容
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.tingneng.value.find(item_ly => item_ly.ly_name ==='声源辨识').value.find(itemjj => itemjj.name === '劣耳').value.find(item11 => item11.name === '前方').value50"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							声源方位
						</template>
						前方
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							距离
						</template>
						1m
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							内容
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.tingneng.value.find(item_ly => item_ly.ly_name ==='声源辨识').value.find(itemjj => itemjj.name === '劣耳').value.find(item11 => item11.name === '前方').value100"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>

					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							声源方位
						</template>
						后方
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							距离
						</template>
						50cm
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							内容
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.tingneng.value.find(item_ly => item_ly.ly_name ==='声源辨识').value.find(itemjj => itemjj.name === '劣耳').value.find(item11 => item11.name === '后方').value50"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							声源方位
						</template>
						后方
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							距离
						</template>
						1m
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							内容
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.tingneng.value.find(item_ly => item_ly.ly_name ==='声源辨识').value.find(itemjj => itemjj.name === '劣耳').value.find(item11 => item11.name === '后方').value100"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
				</el-descriptions>

				<el-descriptions title="声源辨识-双耳" :column="3" size="" border>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							声源方位
						</template>
						前方
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							距离
						</template>
						50cm
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							内容
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.tingneng.value.find(item_ly => item_ly.ly_name ==='声源辨识').value.find(itemjj => itemjj.name === '双耳').value.find(item11 => item11.name === '前方').value50"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							声源方位
						</template>
						前方
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							距离
						</template>
						1m
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							内容
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.tingneng.value.find(item_ly => item_ly.ly_name ==='声源辨识').value.find(itemjj => itemjj.name === '双耳').value.find(item11 => item11.name === '前方').value100"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>

					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							声源方位
						</template>
						后方
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							距离
						</template>
						50cm
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							内容
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.tingneng.value.find(item_ly => item_ly.ly_name ==='声源辨识').value.find(itemjj => itemjj.name === '双耳').value.find(item11 => item11.name === '后方').value50"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							声源方位
						</template>
						后方
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							距离
						</template>
						1m
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							内容
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.tingneng.value.find(item_ly => item_ly.ly_name ==='声源辨识').value.find(itemjj => itemjj.name === '双耳').value.find(item11 => item11.name === '后方').value100"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
				</el-descriptions>

				<div class="el-descriptions__title margin-top" style="margin-bottom: 10px;">
					林氏六音-察觉
				</div>
				<el-table class="" :data="liuyin_list" border style="width: 100%">
					<el-table-column label="距离" prop="value" width="96">
					</el-table-column>
					<el-table-column prop="liuyin_list" label="m" width="195">
						<template slot-scope="data">
							<div style="display: flex;flex-wrap: wrap;">
								<div v-for="(e,i) in cxpg_info.tingneng.value.find(item=>item.ly_name==='林氏六音').value.find(item=>item.name=='m').value.find(item=>item.name==data.row.value).value.find(item=>item.name=='察觉').value"
									:key="i">
									<div style="display: flex; margin-right: 10px;">
										<div class="yuanquan">{{ e.num + 1 }}</div>
										<div class="fangkuai">{{ e.value }}</div>
									</div>
								</div>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="liuyin_list" label="u" width="195">
						<template slot-scope="data">
							<div style="display: flex;flex-wrap: wrap;">
								<div v-for="(e,i) in cxpg_info.tingneng.value.find(item=>item.ly_name==='林氏六音').value.find(item=>item.name=='u').value.find(item=>item.name==data.row.value).value.find(item=>item.name=='察觉').value"
									:key="i">
									<div style="display: flex; margin-right: 10px;">
										<div class="yuanquan">{{ e.num + 1 }}</div>
										<div class="fangkuai">{{ e.value }}</div>
									</div>
								</div>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="liuyin_list" label="a" width="195">
						<template slot-scope="data">
							<div style="display: flex;flex-wrap: wrap;">
								<div v-for="(e,i) in cxpg_info.tingneng.value.find(item=>item.ly_name==='林氏六音').value.find(item=>item.name=='a').value.find(item=>item.name==data.row.value).value.find(item=>item.name=='察觉').value"
									:key="i">
									<div style="display: flex; margin-right: 10px;">
										<div class="yuanquan">{{ e.num + 1 }}</div>
										<div class="fangkuai">{{ e.value }}</div>
									</div>
								</div>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="liuyin_list" label="i" width="195">
						<template slot-scope="data">
							<div style="display: flex;flex-wrap: wrap;">
								<div v-for="(e,i) in cxpg_info.tingneng.value.find(item=>item.ly_name==='林氏六音').value.find(item=>item.name=='i').value.find(item=>item.name==data.row.value).value.find(item=>item.name=='察觉').value"
									:key="i">
									<div style="display: flex; margin-right: 10px;">
										<div class="yuanquan">{{ e.num + 1 }}</div>
										<div class="fangkuai">{{ e.value }}</div>
									</div>
								</div>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="liuyin_list" label="sh" width="195">
						<template slot-scope="data">
							<div style="display: flex;flex-wrap: wrap;">
								<div v-for="(e,i) in cxpg_info.tingneng.value.find(item=>item.ly_name==='林氏六音').value.find(item=>item.name=='sh').value.find(item=>item.name==data.row.value).value.find(item=>item.name=='察觉').value"
									:key="i">
									<div style="display: flex; margin-right: 10px;">
										<div class="yuanquan">{{ e.num + 1 }}</div>
										<div class="fangkuai">{{ e.value }}</div>
									</div>
								</div>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="liuyin_list" label="s" width="195">
						<template slot-scope="data">
							<div style="display: flex;flex-wrap: wrap;">
								<div v-for="(e,i) in cxpg_info.tingneng.value.find(item=>item.ly_name==='林氏六音').value.find(item=>item.name=='s').value.find(item=>item.name==data.row.value).value.find(item=>item.name=='察觉').value"
									:key="i">
									<div style="display: flex; margin-right: 10px;">
										<div class="yuanquan">{{ e.num + 1 }}</div>
										<div class="fangkuai">{{ e.value }}</div>
									</div>
								</div>
							</div>
						</template>
					</el-table-column>
				</el-table>

				<div class="el-descriptions__title margin-top" style="margin-bottom: 10px;">
					林氏六音-辨识
				</div>
				<el-table class="" :data="liuyin_list" border style="width: 100%">
					<el-table-column label="距离" prop="value" width="96">
					</el-table-column>
					<el-table-column prop="liuyin_list" label="m" width="195">
						<template slot-scope="data">
							<div style="display: flex;flex-wrap: wrap;">
								<div v-for="(e,i) in cxpg_info.tingneng.value.find(item=>item.ly_name==='林氏六音').value.find(item=>item.name=='m').value.find(item=>item.name==data.row.value).value.find(item=>item.name=='辨识').value"
									:key="i">
									<div style="display: flex; margin-right: 10px;">
										<div class="yuanquan">{{ e.num + 1 }}</div>
										<div class="fangkuai">{{ e.value }}</div>
									</div>
								</div>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="liuyin_list" label="u" width="195">
						<template slot-scope="data">
							<div style="display: flex;flex-wrap: wrap;">
								<div v-for="(e,i) in cxpg_info.tingneng.value.find(item=>item.ly_name==='林氏六音').value.find(item=>item.name=='u').value.find(item=>item.name==data.row.value).value.find(item=>item.name=='辨识').value"
									:key="i">
									<div style="display: flex; margin-right: 10px;">
										<div class="yuanquan">{{ e.num + 1 }}</div>
										<div class="fangkuai">{{ e.value }}</div>
									</div>
								</div>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="liuyin_list" label="a" width="195">
						<template slot-scope="data">
							<div style="display: flex;flex-wrap: wrap;">
								<div v-for="(e,i) in cxpg_info.tingneng.value.find(item=>item.ly_name==='林氏六音').value.find(item=>item.name=='a').value.find(item=>item.name==data.row.value).value.find(item=>item.name=='辨识').value"
									:key="i">
									<div style="display: flex; margin-right: 10px;">
										<div class="yuanquan">{{ e.num + 1 }}</div>
										<div class="fangkuai">{{ e.value }}</div>
									</div>
								</div>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="liuyin_list" label="i" width="195">
						<template slot-scope="data">
							<div style="display: flex;flex-wrap: wrap;">
								<div v-for="(e,i) in cxpg_info.tingneng.value.find(item=>item.ly_name==='林氏六音').value.find(item=>item.name=='i').value.find(item=>item.name==data.row.value).value.find(item=>item.name=='辨识').value"
									:key="i">
									<div style="display: flex; margin-right: 10px;">
										<div class="yuanquan">{{ e.num + 1 }}</div>
										<div class="fangkuai">{{ e.value }}</div>
									</div>
								</div>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="liuyin_list" label="sh" width="195">
						<template slot-scope="data">
							<div style="display: flex;flex-wrap: wrap;">
								<div v-for="(e,i) in cxpg_info.tingneng.value.find(item=>item.ly_name==='林氏六音').value.find(item=>item.name=='sh').value.find(item=>item.name==data.row.value).value.find(item=>item.name=='辨识').value"
									:key="i">
									<div style="display: flex; margin-right: 10px;">
										<div class="yuanquan">{{ e.num + 1 }}</div>
										<div class="fangkuai">{{ e.value }}</div>
									</div>
								</div>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="liuyin_list" label="s" width="195">
						<template slot-scope="data">
							<div style="display: flex;flex-wrap: wrap;">
								<div v-for="(e,i) in cxpg_info.tingneng.value.find(item=>item.ly_name==='林氏六音').value.find(item=>item.name=='s').value.find(item=>item.name==data.row.value).value.find(item=>item.name=='辨识').value"
									:key="i">
									<div style="display: flex; margin-right: 10px;">
										<div class="yuanquan">{{ e.num + 1 }}</div>
										<div class="fangkuai">{{ e.value }}</div>
									</div>
								</div>
							</div>
						</template>
					</el-table-column>
				</el-table>

				<el-descriptions title="词组中的字词" :column="2" size="" border>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							韵母不同，音节不同
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.tingneng.value.find(item_ly => item_ly.ly_name ==='词组中的字词').value.find(itemjj => itemjj.name === '韵母不同,音节不同').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							声母相同，韵母不同
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.tingneng.value.find(item_ly => item_ly.ly_name ==='词组中的字词').value.find(itemjj => itemjj.name === '声母相同,韵母不同').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							声母不同，韵母相同
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.tingneng.value.find(item_ly => item_ly.ly_name ==='词组中的字词').value.find(itemjj => itemjj.name === '声母不同,韵母相同').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							同音（声韵母相同），声调不同
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.tingneng.value.find(item_ly => item_ly.ly_name ==='词组中的字词').value.find(itemjj => itemjj.name === '同音(声韵母相同),声调不同').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
				</el-descriptions>

				<div class="el-descriptions__title margin-top" style="margin-bottom: 10px;">
					听觉记忆（细则）
				</div>
				<el-descriptions title="1项" :column="3" size="" border>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							拟声词
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.tingneng.value.find(item_ly => item_ly.ly_name ==='听觉记忆(小项)').value.find(item=>item.name==='1项').value.find(item=>item.name=='拟声词').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							名词
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.tingneng.value.find(item_ly => item_ly.ly_name ==='听觉记忆(小项)').value.find(itemjj => itemjj.name === '1项').value.find(item=>item.name=='名词').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							动词
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div style="display: flex;flex-wrap: wrap;">
								<div v-for="(e,i) in cxpg_info.tingneng.value.find(item_ly => item_ly.ly_name ==='听觉记忆(小项)').value.find(item=>item.name==='1项').value.find(item=>item.name=='动词').value"
									:key="i">
									<div style="display: flex; margin-right: 10px;">
										<div class="yuanquan">{{ e.num + 1 }}</div>
										<div class="fangkuai">{{ e.value }}</div>
									</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							形容词
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div style="display: flex;flex-wrap: wrap;">
								<div v-for="(e,i) in cxpg_info.tingneng.value.find(item_ly => item_ly.ly_name ==='听觉记忆(小项)').value.find(item=>item.name==='1项').value.find(item=>item.name=='形容词').value"
									:key="i">
									<div style="display: flex; margin-right: 10px;">
										<div class="yuanquan">{{ e.num + 1 }}</div>
										<div class="fangkuai">{{ e.value }}</div>
									</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							方位词
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.tingneng.value.find(item_ly => item_ly.ly_name ==='听觉记忆(小项)').value.find(item=>item.name==='1项').value.find(item=>item.name=='方位词').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
				</el-descriptions>

				<el-descriptions title="2项" :column="3" size="" border>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							两个名词
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.tingneng.value.find(item_ly => item_ly.ly_name ==='听觉记忆(小项)').value.find(item=>item.name==='2项').value.find(item=>item.name=='两个名词').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							名词+动词
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.tingneng.value.find(item_ly => item_ly.ly_name ==='听觉记忆(小项)').value.find(itemjj => itemjj.name === '2项').value.find(item=>item.name=='名词+动词').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							两个动词
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div style="display: flex;flex-wrap: wrap;">
								<div v-for="(e,i) in cxpg_info.tingneng.value.find(item_ly => item_ly.ly_name ==='听觉记忆(小项)').value.find(item=>item.name==='2项').value.find(item=>item.name=='两个动词').value"
									:key="i">
									<div style="display: flex; margin-right: 10px;">
										<div class="yuanquan">{{ e.num + 1 }}</div>
										<div class="fangkuai">{{ e.value }}</div>
									</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							形容词+名词
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div style="display: flex;flex-wrap: wrap;">
								<div v-for="(e,i) in cxpg_info.tingneng.value.find(item_ly => item_ly.ly_name ==='听觉记忆(小项)').value.find(item=>item.name==='2项').value.find(item=>item.name=='形容词+名词').value"
									:key="i">
									<div style="display: flex; margin-right: 10px;">
										<div class="yuanquan">{{ e.num + 1 }}</div>
										<div class="fangkuai">{{ e.value }}</div>
									</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							其他：（{{cxpg_info.tingneng.value.find(item_ly => item_ly.ly_name ==='听觉记忆(小项)').value.find(item=>item.name==='2项').value.find(item=>item.name=='其他').text}}）
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.tingneng.value.find(item_ly => item_ly.ly_name ==='听觉记忆(小项)').value.find(item=>item.name==='2项').value.find(item=>item.name=='其他').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
				</el-descriptions>

				<el-descriptions title="3项" :column="3" size="" border>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							三个名词
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.tingneng.value.find(item_ly => item_ly.ly_name ==='听觉记忆(小项)').value.find(item=>item.name==='3项').value.find(item=>item.name=='三个名词').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							两个名词+动词
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.tingneng.value.find(item_ly => item_ly.ly_name ==='听觉记忆(小项)').value.find(itemjj => itemjj.name === '3项').value.find(item=>item.name=='两个名词+动词').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							动词+ 两个名词
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div style="display: flex;flex-wrap: wrap;">
								<div v-for="(e,i) in cxpg_info.tingneng.value.find(item_ly => item_ly.ly_name ==='听觉记忆(小项)').value.find(item=>item.name==='3项').value.find(item=>item.name=='动词+ 两个名词').value"
									:key="i">
									<div style="display: flex; margin-right: 10px;">
										<div class="yuanquan">{{ e.num + 1 }}</div>
										<div class="fangkuai">{{ e.value }}</div>
									</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							两个名词+ 方位词
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div style="display: flex;flex-wrap: wrap;">
								<div v-for="(e,i) in cxpg_info.tingneng.value.find(item_ly => item_ly.ly_name ==='听觉记忆(小项)').value.find(item=>item.name==='3项').value.find(item=>item.name=='两个名词+ 方位词').value"
									:key="i">
									<div style="display: flex; margin-right: 10px;">
										<div class="yuanquan">{{ e.num + 1 }}</div>
										<div class="fangkuai">{{ e.value }}</div>
									</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>

					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							两个名词+形容词
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div style="display: flex;flex-wrap: wrap;">
								<div v-for="(e,i) in cxpg_info.tingneng.value.find(item_ly => item_ly.ly_name ==='听觉记忆(小项)').value.find(item=>item.name==='3项').value.find(item=>item.name=='两个名词+形容词').value"
									:key="i">
									<div style="display: flex; margin-right: 10px;">
										<div class="yuanquan">{{ e.num + 1 }}</div>
										<div class="fangkuai">{{ e.value }}</div>
									</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							数量词+形容词+名词
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div style="display: flex;flex-wrap: wrap;">
								<div v-for="(e,i) in cxpg_info.tingneng.value.find(item_ly => item_ly.ly_name ==='听觉记忆(小项)').value.find(item=>item.name==='3项').value.find(item=>item.name=='数量词+形容词+名词').value"
									:key="i">
									<div style="display: flex; margin-right: 10px;">
										<div class="yuanquan">{{ e.num + 1 }}</div>
										<div class="fangkuai">{{ e.value }}</div>
									</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							两个形容词+名词
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div style="display: flex;flex-wrap: wrap;">
								<div v-for="(e,i) in cxpg_info.tingneng.value.find(item_ly => item_ly.ly_name ==='听觉记忆(小项)').value.find(item=>item.name==='3项').value.find(item=>item.name=='两个形容词+名词').value"
									:key="i">
									<div style="display: flex; margin-right: 10px;">
										<div class="yuanquan">{{ e.num + 1 }}</div>
										<div class="fangkuai">{{ e.value }}</div>
									</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							形容词+名词+动词
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div style="display: flex;flex-wrap: wrap;">
								<div v-for="(e,i) in cxpg_info.tingneng.value.find(item_ly => item_ly.ly_name ==='听觉记忆(小项)').value.find(item=>item.name==='3项').value.find(item=>item.name=='形容词+名词+动词').value"
									:key="i">
									<div style="display: flex; margin-right: 10px;">
										<div class="yuanquan">{{ e.num + 1 }}</div>
										<div class="fangkuai">{{ e.value }}</div>
									</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							三个动词
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div style="display: flex;flex-wrap: wrap;">
								<div v-for="(e,i) in cxpg_info.tingneng.value.find(item_ly => item_ly.ly_name ==='听觉记忆(小项)').value.find(item=>item.name==='3项').value.find(item=>item.name=='三个动词').value"
									:key="i">
									<div style="display: flex; margin-right: 10px;">
										<div class="yuanquan">{{ e.num + 1 }}</div>
										<div class="fangkuai">{{ e.value }}</div>
									</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							数量词+名词+动词
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div style="display: flex;flex-wrap: wrap;">
								<div v-for="(e,i) in cxpg_info.tingneng.value.find(item_ly => item_ly.ly_name ==='听觉记忆(小项)').value.find(item=>item.name==='3项').value.find(item=>item.name=='数量词+名词+动词').value"
									:key="i">
									<div style="display: flex; margin-right: 10px;">
										<div class="yuanquan">{{ e.num + 1 }}</div>
										<div class="fangkuai">{{ e.value }}</div>
									</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							其他：（{{cxpg_info.tingneng.value.find(item_ly => item_ly.ly_name ==='听觉记忆(小项)').value.find(item=>item.name==='3项').value.find(item=>item.name=='其他').text}}）
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.tingneng.value.find(item_ly => item_ly.ly_name ==='听觉记忆(小项)').value.find(item=>item.name==='3项').value.find(item=>item.name=='其他').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
				</el-descriptions>

				<el-descriptions title="4项" :column="3" size="" border>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							四个名词
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.tingneng.value.find(item_ly => item_ly.ly_name ==='听觉记忆(小项)').value.find(item=>item.name==='4项').value.find(item=>item.name=='四个名词').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							三个名词+方位词
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.tingneng.value.find(item_ly => item_ly.ly_name ==='听觉记忆(小项)').value.find(itemjj => itemjj.name === '4项').value.find(item=>item.name=='三个名词+方位词').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							两个名词+两个动词
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div style="display: flex;flex-wrap: wrap;">
								<div v-for="(e,i) in cxpg_info.tingneng.value.find(item_ly => item_ly.ly_name ==='听觉记忆(小项)').value.find(item=>item.name==='4项').value.find(item=>item.name=='两个名词+两个动词').value"
									:key="i">
									<div style="display: flex; margin-right: 10px;">
										<div class="yuanquan">{{ e.num + 1 }}</div>
										<div class="fangkuai">{{ e.value }}</div>
									</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							两个名词+两个方位词
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div style="display: flex;flex-wrap: wrap;">
								<div v-for="(e,i) in cxpg_info.tingneng.value.find(item_ly => item_ly.ly_name ==='听觉记忆(小项)').value.find(item=>item.name==='4项').value.find(item=>item.name=='两个名词+两个方位词').value"
									:key="i">
									<div style="display: flex; margin-right: 10px;">
										<div class="yuanquan">{{ e.num + 1 }}</div>
										<div class="fangkuai">{{ e.value }}</div>
									</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>

					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							两个名词+两个形容词
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div style="display: flex;flex-wrap: wrap;">
								<div v-for="(e,i) in cxpg_info.tingneng.value.find(item_ly => item_ly.ly_name ==='听觉记忆(小项)').value.find(item=>item.name==='4项').value.find(item=>item.name=='两个名词+两个形容词').value"
									:key="i">
									<div style="display: flex; margin-right: 10px;">
										<div class="yuanquan">{{ e.num + 1 }}</div>
										<div class="fangkuai">{{ e.value }}</div>
									</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							两个数量词+两个名词
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div style="display: flex;flex-wrap: wrap;">
								<div v-for="(e,i) in cxpg_info.tingneng.value.find(item_ly => item_ly.ly_name ==='听觉记忆(小项)').value.find(item=>item.name==='4项').value.find(item=>item.name=='两个数量词+两个名词').value"
									:key="i">
									<div style="display: flex; margin-right: 10px;">
										<div class="yuanquan">{{ e.num + 1 }}</div>
										<div class="fangkuai">{{ e.value }}</div>
									</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							形容词+名词+名词+方位词
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div style="display: flex;flex-wrap: wrap;">
								<div v-for="(e,i) in cxpg_info.tingneng.value.find(item_ly => item_ly.ly_name ==='听觉记忆(小项)').value.find(item=>item.name==='4项').value.find(item=>item.name=='形容词+名词+名词+方位词').value"
									:key="i">
									<div style="display: flex; margin-right: 10px;">
										<div class="yuanquan">{{ e.num + 1 }}</div>
										<div class="fangkuai">{{ e.value }}</div>
									</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							其他：（{{cxpg_info.tingneng.value.find(item_ly => item_ly.ly_name ==='听觉记忆(小项)').value.find(item=>item.name==='4项').value.find(item=>item.name=='其他').text}}）
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.tingneng.value.find(item_ly => item_ly.ly_name ==='听觉记忆(小项)').value.find(item=>item.name==='4项').value.find(item=>item.name=='其他').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
				</el-descriptions>

				<el-descriptions title="5项" :column="3" size="" border>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							五个名词
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.tingneng.value.find(item_ly => item_ly.ly_name ==='听觉记忆(小项)').value.find(item=>item.name==='5项').value.find(item=>item.name=='五个名词').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							两个名词+两个动词+时间副词
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.tingneng.value.find(item_ly => item_ly.ly_name ==='听觉记忆(小项)').value.find(itemjj => itemjj.name === '5项').value.find(item=>item.name=='两个名词+两个动词+时间副词').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							五个动词
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div style="display: flex;flex-wrap: wrap;">
								<div v-for="(e,i) in cxpg_info.tingneng.value.find(item_ly => item_ly.ly_name ==='听觉记忆(小项)').value.find(item=>item.name==='5项').value.find(item=>item.name=='五个动词').value"
									:key="i">
									<div style="display: flex; margin-right: 10px;">
										<div class="yuanquan">{{ e.num + 1 }}</div>
										<div class="fangkuai">{{ e.value }}</div>
									</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							其他：（{{cxpg_info.tingneng.value.find(item_ly => item_ly.ly_name ==='听觉记忆(小项)').value.find(item=>item.name==='5项').value.find(item=>item.name=='其他').text}}）
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.tingneng.value.find(item_ly => item_ly.ly_name ==='听觉记忆(小项)').value.find(item=>item.name==='5项').value.find(item=>item.name=='其他').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
				</el-descriptions>

				<el-descriptions title="5+项" :column="3" size="" border>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							手填：（{{cxpg_info.tingneng.value.find(item_ly => item_ly.ly_name ==='听觉记忆(小项)').value.find(item=>item.name==='5+项').value.find(item=>item.name=='手填').text}}）
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.tingneng.value.find(item_ly => item_ly.ly_name ==='听觉记忆(小项)').value.find(item=>item.name==='5+项').value.find(item=>item.name=='手填').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
				</el-descriptions>

				<el-descriptions title="" :column="2" size="" border>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							可辨识的儿歌和童谣
						</template>
						{{cxpg_info.tingneng.value.find(item=>item.ly_name=='可辨识的儿歌和童谣').value}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							能注意听延续的故事或对话内容
						</template>
						{{cxpg_info.tingneng.value.find(item=>item.ly_name=="能注意听延续的故事或对话内容").value}}
					</el-descriptions-item>
				</el-descriptions>
				<div class="el-descriptions__title margin-top" style="margin-bottom: 10px;">
					听觉描述
				</div>
				<el-descriptions title="闭合式：阶段" :column="2" size="" border>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							重复拟声词
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.tingneng.value.find(item=>item.ly_name=='听觉描述').value.find(item=>item.name=='闭合式阶段').value.find(item=>item.name=='重复拟声词').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							加入关键词
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.tingneng.value.find(item=>item.ly_name=='听觉描述').value.find(item=>item.name=='闭合式阶段').value.find(item=>item.name=='加入关键词').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							相似特征
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.tingneng.value.find(item=>item.ly_name=='听觉描述').value.find(item=>item.name=='闭合式阶段').value.find(item=>item.name=='相似特征').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							属性相同
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.tingneng.value.find(item=>item.ly_name=='听觉描述').value.find(item=>item.name=='闭合式阶段').value.find(item=>item.name=='属性相同').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
				</el-descriptions>

				<el-descriptions title="开放式：阶段" :column="2" size="" border>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							重复拟声词
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.tingneng.value.find(item=>item.ly_name=='听觉描述').value.find(item=>item.name=='开放式阶段').value.find(item=>item.name=='重复拟声词').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							加入关键词
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.tingneng.value.find(item=>item.ly_name=='听觉描述').value.find(item=>item.name=='开放式阶段').value.find(item=>item.name=='加入关键词').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							复杂描述
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.tingneng.value.find(item=>item.ly_name=='听觉描述').value.find(item=>item.name=='开放式阶段').value.find(item=>item.name=='复杂描述').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							问问题找答案
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.tingneng.value.find(item=>item.ly_name=='听觉描述').value.find(item=>item.name=='开放式阶段').value.find(item=>item.name=='问问题找答案').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
				</el-descriptions>

				<div class="el-descriptions__title margin-top" style="margin-bottom: 10px;">
					能听录音带的内容
				</div>
				<el-descriptions title="听觉记忆（项）" :column="3" size="" border>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							0项
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.tingneng.value.find(item=>item.ly_name=='能听录音带的内容').value.find(item=>item.name=='听觉记忆(项)').value.find(item=>item.name=='0').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							1项
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.tingneng.value.find(item=>item.ly_name=='能听录音带的内容').value.find(item=>item.name=='听觉记忆(项)').value.find(item=>item.name=='1').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							2项
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.tingneng.value.find(item=>item.ly_name=='能听录音带的内容').value.find(item=>item.name=='听觉记忆(项)').value.find(item=>item.name=='2').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							3项
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.tingneng.value.find(item=>item.ly_name=='能听录音带的内容').value.find(item=>item.name=='听觉记忆(项)').value.find(item=>item.name=='3').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							4项
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.tingneng.value.find(item=>item.ly_name=='能听录音带的内容').value.find(item=>item.name=='听觉记忆(项)').value.find(item=>item.name=='4').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							5项
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.tingneng.value.find(item=>item.ly_name=='能听录音带的内容').value.find(item=>item.name=='听觉记忆(项)').value.find(item=>item.name=='5').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							5+项
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.tingneng.value.find(item=>item.ly_name=='能听录音带的内容').value.find(item=>item.name=='听觉记忆(项)').value.find(item=>item.name=='5+').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
				</el-descriptions>
				<el-descriptions title="故事" :column="1" size="" border>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							故事内容
						</template>
						{{cxpg_info.tingneng.value.find(item=>item.ly_name=='能听录音带的内容').value.find(item=>item.name=='故事').value}}
					</el-descriptions-item>
				</el-descriptions>

				<div class="el-descriptions__title margin-top" style="margin-bottom: 10px;">
					听觉描述
				</div>
				<el-descriptions title="闭合式：阶段" :column="2" size="" border>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							重复拟声词
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.tingneng.value.find(item=>item.ly_name=='能听录音带的内容').value.find(item=>item.name=='听觉描述').value.find(item=>item.name=='闭合式阶段').value.find(item=>item.name=='重复拟声词').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							加入关键词
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.tingneng.value.find(item=>item.ly_name=='能听录音带的内容').value.find(item=>item.name=='听觉描述').value.find(item=>item.name=='闭合式阶段').value.find(item=>item.name=='加入关键词').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							相似特征
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.tingneng.value.find(item=>item.ly_name=='能听录音带的内容').value.find(item=>item.name=='听觉描述').value.find(item=>item.name=='闭合式阶段').value.find(item=>item.name=='相似特征').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							属性相同
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.tingneng.value.find(item=>item.ly_name=='能听录音带的内容').value.find(item=>item.name=='听觉描述').value.find(item=>item.name=='闭合式阶段').value.find(item=>item.name=='属性相同').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
				</el-descriptions>

				<el-descriptions title="开放式：阶段" :column="2" size="" border>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							重复拟声词
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.tingneng.value.find(item=>item.ly_name=='能听录音带的内容').value.find(item=>item.name=='听觉描述').value.find(item=>item.name=='开放式阶段').value.find(item=>item.name=='重复拟声词').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							加入关键词
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.tingneng.value.find(item=>item.ly_name=='能听录音带的内容').value.find(item=>item.name=='听觉描述').value.find(item=>item.name=='开放式阶段').value.find(item=>item.name=='加入关键词').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							复杂描述
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.tingneng.value.find(item=>item.ly_name=='能听录音带的内容').value.find(item=>item.name=='听觉描述').value.find(item=>item.name=='开放式阶段').value.find(item=>item.name=='复杂描述').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
				</el-descriptions>

				<div class="el-descriptions__title margin-top" style="margin-bottom: 10px;">
					能在吵杂的环境中倾听
				</div>
				<el-descriptions title="听觉记忆（项）" :column="3" size="" border>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							0项
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.tingneng.value.find(item=>item.ly_name=='能在吵杂的环境中倾听').value.find(item=>item.name=='听觉记忆(项)').value.find(item=>item.name=='0').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							1项
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.tingneng.value.find(item=>item.ly_name=='能在吵杂的环境中倾听').value.find(item=>item.name=='听觉记忆(项)').value.find(item=>item.name=='1').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							2项
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.tingneng.value.find(item=>item.ly_name=='能在吵杂的环境中倾听').value.find(item=>item.name=='听觉记忆(项)').value.find(item=>item.name=='2').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							3项
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.tingneng.value.find(item=>item.ly_name=='能在吵杂的环境中倾听').value.find(item=>item.name=='听觉记忆(项)').value.find(item=>item.name=='3').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							4项
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.tingneng.value.find(item=>item.ly_name=='能在吵杂的环境中倾听').value.find(item=>item.name=='听觉记忆(项)').value.find(item=>item.name=='4').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							5项
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.tingneng.value.find(item=>item.ly_name=='能在吵杂的环境中倾听').value.find(item=>item.name=='听觉记忆(项)').value.find(item=>item.name=='5').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							5+项
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.tingneng.value.find(item=>item.ly_name=='能在吵杂的环境中倾听').value.find(item=>item.name=='听觉记忆(项)').value.find(item=>item.name=='5+').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
				</el-descriptions>

				<div class="el-descriptions__title margin-top" style="margin-bottom: 10px;">
					听觉描述
				</div>
				<el-descriptions title="闭合式：阶段" :column="2" size="" border>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							重复拟声词
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.tingneng.value.find(item=>item.ly_name=='能在吵杂的环境中倾听').value.find(item=>item.name=='听觉描述').value.find(item=>item.name=='闭合式阶段').value.find(item=>item.name=='重复拟声词').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							加入关键词
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.tingneng.value.find(item=>item.ly_name=='能在吵杂的环境中倾听').value.find(item=>item.name=='听觉描述').value.find(item=>item.name=='闭合式阶段').value.find(item=>item.name=='加入关键词').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							相似特征
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.tingneng.value.find(item=>item.ly_name=='能在吵杂的环境中倾听').value.find(item=>item.name=='听觉描述').value.find(item=>item.name=='闭合式阶段').value.find(item=>item.name=='相似特征').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							属性相同
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.tingneng.value.find(item=>item.ly_name=='能在吵杂的环境中倾听').value.find(item=>item.name=='听觉描述').value.find(item=>item.name=='闭合式阶段').value.find(item=>item.name=='属性相同').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
				</el-descriptions>

				<el-descriptions title="开放式：阶段" :column="2" size="" border>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							重复拟声词
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.tingneng.value.find(item=>item.ly_name=='能在吵杂的环境中倾听').value.find(item=>item.name=='听觉描述').value.find(item=>item.name=='开放式阶段').value.find(item=>item.name=='重复拟声词').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							加入关键词
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.tingneng.value.find(item=>item.ly_name=='能在吵杂的环境中倾听').value.find(item=>item.name=='听觉描述').value.find(item=>item.name=='开放式阶段').value.find(item=>item.name=='加入关键词').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							复杂描述
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.tingneng.value.find(item=>item.ly_name=='能在吵杂的环境中倾听').value.find(item=>item.name=='听觉描述').value.find(item=>item.name=='开放式阶段').value.find(item=>item.name=='复杂描述').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							问问题找答案
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.tingneng.value.find(item=>item.ly_name=='能在吵杂的环境中倾听').value.find(item=>item.name=='听觉描述').value.find(item=>item.name=='开放式阶段').value.find(item=>item.name=='问问题找答案').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
				</el-descriptions>

				<div class="el-descriptions__title margin-top" style="margin-bottom: 10px;">
					能在团体对话中倾听
				</div>
				<el-descriptions title="听觉记忆（项）" :column="3" size="" border>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							0项
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.tingneng.value.find(item=>item.ly_name=='能在团体对话中倾听').value.find(item=>item.name=='听觉记忆(项)').value.find(item=>item.name=='0').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							1项
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.tingneng.value.find(item=>item.ly_name=='能在团体对话中倾听').value.find(item=>item.name=='听觉记忆(项)').value.find(item=>item.name=='1').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							2项
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.tingneng.value.find(item=>item.ly_name=='能在团体对话中倾听').value.find(item=>item.name=='听觉记忆(项)').value.find(item=>item.name=='2').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							3项
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.tingneng.value.find(item=>item.ly_name=='能在团体对话中倾听').value.find(item=>item.name=='听觉记忆(项)').value.find(item=>item.name=='3').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							4项
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.tingneng.value.find(item=>item.ly_name=='能在团体对话中倾听').value.find(item=>item.name=='听觉记忆(项)').value.find(item=>item.name=='4').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							5项
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.tingneng.value.find(item=>item.ly_name=='能在团体对话中倾听').value.find(item=>item.name=='听觉记忆(项)').value.find(item=>item.name=='5').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							5+项
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.tingneng.value.find(item=>item.ly_name=='能在团体对话中倾听').value.find(item=>item.name=='听觉记忆(项)').value.find(item=>item.name=='5+').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
				</el-descriptions>

				<div class="el-descriptions__title margin-top" style="margin-bottom: 10px;">
					听觉描述
				</div>
				<el-descriptions title="闭合式：阶段" :column="2" size="" border>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							重复拟声词
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.tingneng.value.find(item=>item.ly_name=='能在团体对话中倾听').value.find(item=>item.name=='听觉描述').value.find(item=>item.name=='闭合式阶段').value.find(item=>item.name=='重复拟声词').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							加入关键词
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.tingneng.value.find(item=>item.ly_name=='能在团体对话中倾听').value.find(item=>item.name=='听觉描述').value.find(item=>item.name=='闭合式阶段').value.find(item=>item.name=='加入关键词').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							相似特征
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.tingneng.value.find(item=>item.ly_name=='能在团体对话中倾听').value.find(item=>item.name=='听觉描述').value.find(item=>item.name=='闭合式阶段').value.find(item=>item.name=='相似特征').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							属性相同
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.tingneng.value.find(item=>item.ly_name=='能在团体对话中倾听').value.find(item=>item.name=='听觉描述').value.find(item=>item.name=='闭合式阶段').value.find(item=>item.name=='属性相同').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
				</el-descriptions>

				<el-descriptions title="开放式：阶段" :column="2" size="" border>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							重复拟声词
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.tingneng.value.find(item=>item.ly_name=='能在团体对话中倾听').value.find(item=>item.name=='听觉描述').value.find(item=>item.name=='开放式阶段').value.find(item=>item.name=='重复拟声词').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							加入关键词
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.tingneng.value.find(item=>item.ly_name=='能在团体对话中倾听').value.find(item=>item.name=='听觉描述').value.find(item=>item.name=='开放式阶段').value.find(item=>item.name=='加入关键词').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							复杂描述
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.tingneng.value.find(item=>item.ly_name=='能在团体对话中倾听').value.find(item=>item.name=='听觉描述').value.find(item=>item.name=='开放式阶段').value.find(item=>item.name=='复杂描述').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							问问题找答案
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.tingneng.value.find(item=>item.ly_name=='能在团体对话中倾听').value.find(item=>item.name=='听觉描述').value.find(item=>item.name=='开放式阶段').value.find(item=>item.name=='问问题找答案').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
				</el-descriptions>

				<el-descriptions title="接听电话技巧" :column="1" size="" border>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							闭合式/熟悉的谈话者，听觉记忆 1-2 项，招呼语
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.tingneng.value.find(item=>item.ly_name=='接听电话技巧').value.find(item=>item.name=='闭合式/熟悉的谈话者，听觉记忆 1-2 项，招呼语').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							闭合式/熟悉的谈话者，听觉描述—闭合式阶段 1-4，听觉记忆 3-4 项
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.tingneng.value.find(item=>item.ly_name=='接听电话技巧').value.find(item=>item.name=='闭合式/熟悉的谈话者，听觉描述—闭合式阶段 1-4，听觉记忆 3-4 项').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							开放式/熟悉的谈话者，听觉描述—开放式阶段 1-4
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.tingneng.value.find(item=>item.ly_name=='接听电话技巧').value.find(item=>item.name=='开放式/熟悉的谈话者，听觉描述—开放式阶段 1-4').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							开放式/熟悉的谈话者/同一话题的对谈
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.tingneng.value.find(item=>item.ly_name=='接听电话技巧').value.find(item=>item.name=='开放式/熟悉的谈话者/同一话题的对谈').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							开放式/熟悉的谈话者/延伸话题的对谈
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.tingneng.value.find(item=>item.ly_name=='接听电话技巧').value.find(item=>item.name=='开放式/熟悉的谈话者/延伸话题的对谈').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							闭合式/陌生的谈话者/主题式对谈
							a 事先设定情境（可预知谈话主题）
							b 告知孩子主题并事先讨论谈话内容
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.tingneng.value.find(item=>item.ly_name=='接听电话技巧').value.find(item=>item.name=='闭合式/陌生的谈话者/主题式对谈a 事先设定情境（可预知谈话主题）b 告知孩子主题并事先讨论谈话内容').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							开放式/非主题式对话
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.tingneng.value.find(item=>item.ly_name=='接听电话技巧').value.find(item=>item.name=='开放式/非主题式对话').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
				</el-descriptions>

				<el-descriptions title="主动聆听技巧" :column="1" size="" border>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							闭合式（事先预知谈话主题）/近距离/熟悉者的声音
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.tingneng.value.find(item=>item.ly_name=='主动聆听技巧').value.find(item=>item.name=='闭合式（事先预知谈话主题）/近距离/熟悉者的声音').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							闭合式/加长距离/熟悉者的声音/两人谈话
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.tingneng.value.find(item=>item.ly_name=='主动聆听技巧').value.find(item=>item.name=='闭合式/加长距离/熟悉者的声音/两人谈话').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							闭合式/加入背景噪音/熟悉者的声音/两人对话
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.tingneng.value.find(item=>item.ly_name=='主动聆听技巧').value.find(item=>item.name=='闭合式/加入背景噪音/熟悉者的声音/两人对话').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							闭合式/近距离/加入陌生者的声音/两人对话
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.tingneng.value.find(item=>item.ly_name=='主动聆听技巧').value.find(item=>item.name=='闭合式/近距离/加入陌生者的声音/两人对话').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							闭合式/加长距离/陌生者的声音/两人对话
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.tingneng.value.find(item=>item.ly_name=='主动聆听技巧').value.find(item=>item.name=='闭合式/加长距离/陌生者的声音/两人对话').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							闭合式/加入背景噪音/陌生者的声音/两人对话
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.tingneng.value.find(item=>item.ly_name=='主动聆听技巧').value.find(item=>item.name=='闭合式/加入背景噪音/陌生者的声音/两人对话').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							开放式（不事先告知主题）/重复阶段1-6 /两人对话
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.tingneng.value.find(item=>item.ly_name=='主动聆听技巧').value.find(item=>item.name=='开放式（不事先告知主题）/重复阶段1-6 /两人对话').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							开放式/重复阶段 1-6/三人以上对话
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.tingneng.value.find(item=>item.ly_name=='主动聆听技巧').value.find(item=>item.name=='开放式/重复阶段 1-6/三人以上对话').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
				</el-descriptions>

				<el-descriptions title="听觉能力评估" :column="2" size="" border>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							平均识别率
						</template>
						{{cxpg_info.tingneng.value.find(item=>item.ly_name=='听觉能力评估').value_sbl}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							评估时间
						</template>
						{{cxpg_info.tingneng.value.find(item=>item.ly_name=='听觉能力评估').value_time}}
					</el-descriptions-item>
				</el-descriptions>
				<el-descriptions title="CAP听觉行为分级" :column="2" size="" border>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							级别
						</template>
						{{cxpg_info.tingneng.value.find(item=>item.ly_name=='听觉能力评估').value_sbl}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							评估时间
						</template>
						{{cxpg_info.tingneng.value.find(item=>item.ly_name=='听觉能力评估').value_time}}
					</el-descriptions-item>
				</el-descriptions>
				<div class="el-descriptions__title margin-top" style="margin-bottom: 10px;">
					领域-语言
				</div>

				<el-descriptions title="初级词汇" :column="2" size="" border>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							名词
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.yuyan.value.find(item=>item.ly_name=='初级词汇').value.find(item=>item.name=='名词').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							动词
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.yuyan.value.find(item=>item.ly_name=='初级词汇').value.find(item=>item.name=='动词').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							代词
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.yuyan.value.find(item=>item.ly_name=='初级词汇').value.find(item=>item.name=='代词').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							形容词
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.yuyan.value.find(item=>item.ly_name=='初级词汇').value.find(item=>item.name=='形容词').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							副词
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.yuyan.value.find(item=>item.ly_name=='初级词汇').value.find(item=>item.name=='副词').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							数量词
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.yuyan.value.find(item=>item.ly_name=='初级词汇').value.find(item=>item.name=='数量词').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							否定词
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.yuyan.value.find(item=>item.ly_name=='初级词汇').value.find(item=>item.name=='否定词').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							连词
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.yuyan.value.find(item=>item.ly_name=='初级词汇').value.find(item=>item.name=='连词').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							日常表达性词语
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.yuyan.value.find(item=>item.ly_name=='初级词汇').value.find(item=>item.name=='日常表达性词语').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
				</el-descriptions>
				<el-descriptions title="中级词汇" :column="2" size="" border>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							名词
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.yuyan.value.find(item=>item.ly_name=='中级词汇').value.find(item=>item.name=='名词').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							动词
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.yuyan.value.find(item=>item.ly_name=='中级词汇').value.find(item=>item.name=='动词').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							代词
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.yuyan.value.find(item=>item.ly_name=='中级词汇').value.find(item=>item.name=='代词').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							形容词
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.yuyan.value.find(item=>item.ly_name=='中级词汇').value.find(item=>item.name=='形容词').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							副词
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.yuyan.value.find(item=>item.ly_name=='中级词汇').value.find(item=>item.name=='副词').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							数量词
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.yuyan.value.find(item=>item.ly_name=='中级词汇').value.find(item=>item.name=='数量词').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							否定词
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.yuyan.value.find(item=>item.ly_name=='中级词汇').value.find(item=>item.name=='否定词').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							连词
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.yuyan.value.find(item=>item.ly_name=='中级词汇').value.find(item=>item.name=='连词').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							日常表达性词语
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.yuyan.value.find(item=>item.ly_name=='中级词汇').value.find(item=>item.name=='日常表达性词语').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
				</el-descriptions>
				<el-descriptions title="高级词汇" :column="2" size="" border>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							名词
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.yuyan.value.find(item=>item.ly_name=='高级词汇').value.find(item=>item.name=='名词').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							动词
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.yuyan.value.find(item=>item.ly_name=='高级词汇').value.find(item=>item.name=='动词').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							代词
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.yuyan.value.find(item=>item.ly_name=='高级词汇').value.find(item=>item.name=='代词').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							形容词
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.yuyan.value.find(item=>item.ly_name=='高级词汇').value.find(item=>item.name=='形容词').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							副词
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.yuyan.value.find(item=>item.ly_name=='高级词汇').value.find(item=>item.name=='副词').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							数量词
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.yuyan.value.find(item=>item.ly_name=='高级词汇').value.find(item=>item.name=='数量词').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							否定词
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.yuyan.value.find(item=>item.ly_name=='高级词汇').value.find(item=>item.name=='否定词').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							连词
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.yuyan.value.find(item=>item.ly_name=='高级词汇').value.find(item=>item.name=='连词').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							日常表达性词语
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.yuyan.value.find(item=>item.ly_name=='高级词汇').value.find(item=>item.name=='日常表达性词语').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
				</el-descriptions>

				<div class="el-descriptions__title margin-top" style="margin-bottom: 10px;">
					问句
				</div>
				<el-descriptions title="小于 2.5 岁" :column="2" size="" border>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							那是什么？
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.yuyan.value.find(item=>item.ly_name=='问句').value.find(item=>item.name=='小于 2.5 岁').value.find(item=>item.name=='那是什么？').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							他在做什么？
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.yuyan.value.find(item=>item.ly_name=='问句').value.find(item=>item.name=='小于 2.5 岁').value.find(item=>item.name=='他在做什么？').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							什么颜色？
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.yuyan.value.find(item=>item.ly_name=='问句').value.find(item=>item.name=='小于 2.5 岁').value.find(item=>item.name=='什么颜色？').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							有几个？
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.yuyan.value.find(item=>item.ly_name=='问句').value.find(item=>item.name=='小于 2.5 岁').value.find(item=>item.name=='有几个？').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
				</el-descriptions>

				<el-descriptions title="2.5~3 岁" :column="2" size="" border>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							在哪里？
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.yuyan.value.find(item=>item.ly_name=='问句').value.find(item=>item.name=='2.5~3 岁').value.find(item=>item.name=='在哪里？').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							是谁？
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.yuyan.value.find(item=>item.ly_name=='问句').value.find(item=>item.name=='2.5~3 岁').value.find(item=>item.name=='是谁？').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							哪一个？
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.yuyan.value.find(item=>item.ly_name=='问句').value.find(item=>item.name=='2.5~3 岁').value.find(item=>item.name=='哪一个？').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							什么形状？
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.yuyan.value.find(item=>item.ly_name=='问句').value.find(item=>item.name=='2.5~3 岁').value.find(item=>item.name=='什么形状？').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							做什么用的？
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.yuyan.value.find(item=>item.ly_name=='问句').value.find(item=>item.name=='2.5~3 岁').value.find(item=>item.name=='做什么用的？').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							怎么了？
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.yuyan.value.find(item=>item.ly_name=='问句').value.find(item=>item.name=='2.5~3 岁').value.find(item=>item.name=='怎么了？').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							怎么办？
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.yuyan.value.find(item=>item.ly_name=='问句').value.find(item=>item.name=='2.5~3 岁').value.find(item=>item.name=='怎么办？').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							什么不见了？
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.yuyan.value.find(item=>item.ly_name=='问句').value.find(item=>item.name=='2.5~3 岁').value.find(item=>item.name=='什么不见了？').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
				</el-descriptions>

				<el-descriptions title="3~4岁" :column="2" size="" border>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							少了什么？
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.yuyan.value.find(item=>item.ly_name=='问句').value.find(item=>item.name=='3~4岁').value.find(item=>item.name=='少了什么？').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							为什么
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.yuyan.value.find(item=>item.ly_name=='问句').value.find(item=>item.name=='3~4岁').value.find(item=>item.name=='为什么').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							（名词）住在哪里？
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.yuyan.value.find(item=>item.ly_name=='问句').value.find(item=>item.name=='3~4岁').value.find(item=>item.name=='（名词）住在哪里？').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							哪一个不一样？
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.yuyan.value.find(item=>item.ly_name=='问句').value.find(item=>item.name=='3~4岁').value.find(item=>item.name=='哪一个不一样？').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							需要什么？
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.yuyan.value.find(item=>item.ly_name=='问句').value.find(item=>item.name=='3~4岁').value.find(item=>item.name=='需要什么？').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							（代名词）叫什么名字？
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.yuyan.value.find(item=>item.ly_name=='问句').value.find(item=>item.name=='3~4岁').value.find(item=>item.name=='（代名词）叫什么名字？').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							什么地方？
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.yuyan.value.find(item=>item.ly_name=='问句').value.find(item=>item.name=='3~4岁').value.find(item=>item.name=='什么地方？').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							多大了
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.yuyan.value.find(item=>item.ly_name=='问句').value.find(item=>item.name=='3~4岁').value.find(item=>item.name=='多大了').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
				</el-descriptions>

				<el-descriptions title="4~5 岁" :column="2" size="" border>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							多少？
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.yuyan.value.find(item=>item.ly_name=='问句').value.find(item=>item.name=='4~5 岁').value.find(item=>item.name=='多少？').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							什么时候？？
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.yuyan.value.find(item=>item.ly_name=='问句').value.find(item=>item.name=='4~5 岁').value.find(item=>item.name=='什么时候？？').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							如何？
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.yuyan.value.find(item=>item.ly_name=='问句').value.find(item=>item.name=='4~5 岁').value.find(item=>item.name=='如何？').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							怎么做？（描述）
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.yuyan.value.find(item=>item.ly_name=='问句').value.find(item=>item.name=='4~5 岁').value.find(item=>item.name=='怎么做？（描述）').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							自创:({{cxpg_info.yuyan.value.find(item=>item.ly_name=='问句').value.find(item=>item.name=='4~5 岁').value.find(item=>item.name=='自创').text}})
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.yuyan.value.find(item=>item.ly_name=='问句').value.find(item=>item.name=='4~5 岁').value.find(item=>item.name=='自创').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
				</el-descriptions>
				<el-descriptions title="语言能力评估" :column="2" size="" border>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							平均语言年龄水平
						</template>
						{{cxpg_info.yuyan.value.find(item=>item.ly_name=='语言能力评估').value_age}}岁
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							评估时间
						</template>
						{{cxpg_info.yuyan.value.find(item=>item.ly_name=='语言能力评估').value_time}}
					</el-descriptions-item>
				</el-descriptions>
				<el-descriptions title="SIR言语可懂度" :column="2" size="" border>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							级别
						</template>
						{{cxpg_info.yuyan.value.find(item=>item.ly_name=='SIR言语可懂度').value_pj}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							评估时间
						</template>
						{{cxpg_info.yuyan.value.find(item=>item.ly_name=='SIR言语可懂度').value_time}}
					</el-descriptions-item>
				</el-descriptions>
				<div class="el-descriptions__title margin-top" style="margin-bottom: 10px;">
					领域-言语
				</div>
				<el-descriptions title="音质" :column="2" size="" border>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							音质自然流畅
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.yanyu.value.find(item=>item.ly_name=='音质').value.find(item=>item.name=='音质自然流畅').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							音质较为自然流畅
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.yanyu.value.find(item=>item.ly_name=='音质').value.find(item=>item.name=='音质较为自然流畅').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
				</el-descriptions>
				<el-descriptions :column="1" size="" border>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							有明显发音问题（如：假声、硬起音、共鸣错误（鼻漏气）、聚焦错误等）
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.yanyu.value.find(item=>item.ly_name=='音质').value.find(item=>item.name=='有明显发音问题').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							有严重发音问题（如：假声、硬起音、共鸣错误（鼻漏气）、聚焦错误等）
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.yanyu.value.find(item=>item.ly_name=='音质').value.find(item=>item.name=='有严重发音问题').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
				</el-descriptions>
				<div class="el-descriptions__title margin-top" style="margin-bottom: 10px;">
					语词辨识度（可懂度）
				</div>
				<el-descriptions title="有情景提示下" :column="3" size="" border>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							完全理解
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.yanyu.value.find(item=>item.ly_name=='语词辨识度（可懂度）').value.find(item=>item.name=='有情景提示下').value.find(item=>item.name=='完全理解').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							基本理解
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.yanyu.value.find(item=>item.ly_name=='语词辨识度（可懂度）').value.find(item=>item.name=='有情景提示下').value.find(item=>item.name=='基本理解').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							部分理解
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.yanyu.value.find(item=>item.ly_name=='语词辨识度（可懂度）').value.find(item=>item.name=='有情景提示下').value.find(item=>item.name=='部分理解').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							不能理解
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.yanyu.value.find(item=>item.ly_name=='语词辨识度（可懂度）').value.find(item=>item.name=='有情景提示下').value.find(item=>item.name=='不能理解').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
				</el-descriptions>
				<el-descriptions title="无情景提示下" :column="3" size="" border>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							完全理解
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.yanyu.value.find(item=>item.ly_name=='语词辨识度（可懂度）').value.find(item=>item.name=='无情景提示下').value.find(item=>item.name=='完全理解').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							基本理解
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.yanyu.value.find(item=>item.ly_name=='语词辨识度（可懂度）').value.find(item=>item.name=='无情景提示下').value.find(item=>item.name=='基本理解').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							部分理解
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.yanyu.value.find(item=>item.ly_name=='语词辨识度（可懂度）').value.find(item=>item.name=='无情景提示下').value.find(item=>item.name=='部分理解').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							不能理解
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.yanyu.value.find(item=>item.ly_name=='语词辨识度（可懂度）').value.find(item=>item.name=='无情景提示下').value.find(item=>item.name=='不能理解').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
				</el-descriptions>

				<div class="el-descriptions__title margin-top" style="margin-bottom: 10px;">
					超语段
				</div>
				<el-descriptions title="时间" :column="3" size="" border>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							长音
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.yanyu.value.find(item=>item.ly_name=='超语段').value.find(item=>item.name=='时间').value.find(item=>item.name=='长音').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							短音
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.yanyu.value.find(item=>item.ly_name=='超语段').value.find(item=>item.name=='时间').value.find(item=>item.name=='短音').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							音长短变化音
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.yanyu.value.find(item=>item.ly_name=='超语段').value.find(item=>item.name=='时间').value.find(item=>item.name=='音长短变化音').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
				</el-descriptions>
				<el-descriptions title="量" :column="3" size="" border>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							大
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.yanyu.value.find(item=>item.ly_name=='超语段').value.find(item=>item.name=='量').value.find(item=>item.name=='大').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							小
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.yanyu.value.find(item=>item.ly_name=='超语段').value.find(item=>item.name=='量').value.find(item=>item.name=='小').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							大小声变化音
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.yanyu.value.find(item=>item.ly_name=='超语段').value.find(item=>item.name=='量').value.find(item=>item.name=='大小声变化音').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
				</el-descriptions>
				<el-descriptions title="调" :column="3" size="" border>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							高
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.yanyu.value.find(item=>item.ly_name=='超语段').value.find(item=>item.name=='调').value.find(item=>item.name=='高').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							低
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.yanyu.value.find(item=>item.ly_name=='超语段').value.find(item=>item.name=='调').value.find(item=>item.name=='低').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							高低变化
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.yanyu.value.find(item=>item.ly_name=='超语段').value.find(item=>item.name=='调').value.find(item=>item.name=='高低变化').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
				</el-descriptions>
				<el-descriptions title="四声" :column="3" size="" border>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							一声
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.yanyu.value.find(item=>item.ly_name=='四声').value.find(item=>item.name=='一声').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							二声
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.yanyu.value.find(item=>item.ly_name=='四声').value.find(item=>item.name=='二声').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							三声
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.yanyu.value.find(item=>item.ly_name=='四声').value.find(item=>item.name=='三声').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							四声
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.yanyu.value.find(item=>item.ly_name=='四声').value.find(item=>item.name=='四声').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							四声变化
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.yanyu.value.find(item=>item.ly_name=='四声').value.find(item=>item.name=='四声变化').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
				</el-descriptions>
				<el-descriptions title="单韵母" :column="3" size="" border>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							a
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.yanyu.value.find(item=>item.ly_name=='单韵母').value.find(item=>item.name=='a').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							u
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.yanyu.value.find(item=>item.ly_name=='单韵母').value.find(item=>item.name=='u').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							e
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.yanyu.value.find(item=>item.ly_name=='单韵母').value.find(item=>item.name=='e').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							i
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.yanyu.value.find(item=>item.ly_name=='单韵母').value.find(item=>item.name=='i').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							ü
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.yanyu.value.find(item=>item.ly_name=='单韵母').value.find(item=>item.name=='ü').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
				</el-descriptions>

				<el-descriptions title="韵母轮换" :column="3" size="" border>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							u-a
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.yanyu.value.find(item=>item.ly_name=='韵母轮换').value.find(item=>item.name=='u-a').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							a-u
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.yanyu.value.find(item=>item.ly_name=='韵母轮换').value.find(item=>item.name=='a-u').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							e-ⅰ
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.yanyu.value.find(item=>item.ly_name=='韵母轮换').value.find(item=>item.name=='e-ⅰ').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							ⅰ-a
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.yanyu.value.find(item=>item.ly_name=='韵母轮换').value.find(item=>item.name=='ⅰ-a').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							u-ⅰ
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.yanyu.value.find(item=>item.ly_name=='韵母轮换').value.find(item=>item.name=='u-ⅰ').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							ⅰ-u
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.yanyu.value.find(item=>item.ly_name=='韵母轮换').value.find(item=>item.name=='ⅰ-u').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							a-ⅰ
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.yanyu.value.find(item=>item.ly_name=='韵母轮换').value.find(item=>item.name=='a-ⅰ').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
				</el-descriptions>

				<el-descriptions title="复韵母结尾" :column="3" size="" border>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							ou
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.yanyu.value.find(item=>item.ly_name=='复韵母结尾').value.find(item=>item.name=='ou').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							ao
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.yanyu.value.find(item=>item.ly_name=='复韵母结尾').value.find(item=>item.name=='ao').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							ei
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.yanyu.value.find(item=>item.ly_name=='复韵母结尾').value.find(item=>item.name=='ei').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							ai
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.yanyu.value.find(item=>item.ly_name=='复韵母结尾').value.find(item=>item.name=='ai').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							ie
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.yanyu.value.find(item=>item.ly_name=='复韵母结尾').value.find(item=>item.name=='ie').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							iu
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.yanyu.value.find(item=>item.ly_name=='复韵母结尾').value.find(item=>item.name=='iu').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							ui
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.yanyu.value.find(item=>item.ly_name=='复韵母结尾').value.find(item=>item.name=='ui').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							üe
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.yanyu.value.find(item=>item.ly_name=='复韵母结尾').value.find(item=>item.name=='üe').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
				</el-descriptions>

				<el-descriptions title="复韵母声母结尾" :column="3" size="" border>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							an
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.yanyu.value.find(item=>item.ly_name=='复韵母声母结尾').value.find(item=>item.name=='an').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							en
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.yanyu.value.find(item=>item.ly_name=='复韵母声母结尾').value.find(item=>item.name=='en').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							in
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.yanyu.value.find(item=>item.ly_name=='复韵母声母结尾').value.find(item=>item.name=='in').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							un
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.yanyu.value.find(item=>item.ly_name=='复韵母声母结尾').value.find(item=>item.name=='un').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							ün
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.yanyu.value.find(item=>item.ly_name=='复韵母声母结尾').value.find(item=>item.name=='ün').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							ang
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.yanyu.value.find(item=>item.ly_name=='复韵母声母结尾').value.find(item=>item.name=='ang').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							eng
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.yanyu.value.find(item=>item.ly_name=='复韵母声母结尾').value.find(item=>item.name=='eng').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							ong
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.yanyu.value.find(item=>item.ly_name=='复韵母声母结尾').value.find(item=>item.name=='ong').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							ing（省略后鼻音）
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.yanyu.value.find(item=>item.ly_name=='复韵母声母结尾').value.find(item=>item.name=='ing（省略后鼻音）').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
				</el-descriptions>

				<el-descriptions title="结合韵母" :column="3" size="" border>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							ia
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.yanyu.value.find(item=>item.ly_name=='结合韵母').value.find(item=>item.name=='ia').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							iao
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.yanyu.value.find(item=>item.ly_name=='结合韵母').value.find(item=>item.name=='iao').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							ian
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.yanyu.value.find(item=>item.ly_name=='结合韵母').value.find(item=>item.name=='ian').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							iang
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.yanyu.value.find(item=>item.ly_name=='结合韵母').value.find(item=>item.name=='iang').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							ua
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.yanyu.value.find(item=>item.ly_name=='结合韵母').value.find(item=>item.name=='ua').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							uo
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.yanyu.value.find(item=>item.ly_name=='结合韵母').value.find(item=>item.name=='uo').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							uai
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.yanyu.value.find(item=>item.ly_name=='结合韵母').value.find(item=>item.name=='uai').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							uan
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.yanyu.value.find(item=>item.ly_name=='结合韵母').value.find(item=>item.name=='uan').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							uang
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.yanyu.value.find(item=>item.ly_name=='结合韵母').value.find(item=>item.name=='uang').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							uan
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.yanyu.value.find(item=>item.ly_name=='结合韵母').value.find(item=>item.name=='uan').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							ong
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.yanyu.value.find(item=>item.ly_name=='结合韵母').value.find(item=>item.name=='ong').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
				</el-descriptions>

				<el-descriptions title="声母" :column="3" size="" border>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							b
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.yanyu.value.find(item=>item.ly_name=='声母').value.find(item=>item.name=='b').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							p
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.yanyu.value.find(item=>item.ly_name=='声母').value.find(item=>item.name=='p').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							h
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.yanyu.value.find(item=>item.ly_name=='声母').value.find(item=>item.name=='h').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							q
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.yanyu.value.find(item=>item.ly_name=='声母').value.find(item=>item.name=='q').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							zh
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.yanyu.value.find(item=>item.ly_name=='声母').value.find(item=>item.name=='zh').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							z
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.yanyu.value.find(item=>item.ly_name=='声母').value.find(item=>item.name=='z').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							m
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.yanyu.value.find(item=>item.ly_name=='声母').value.find(item=>item.name=='m').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							t
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.yanyu.value.find(item=>item.ly_name=='声母').value.find(item=>item.name=='t').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							d
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.yanyu.value.find(item=>item.ly_name=='声母').value.find(item=>item.name=='d').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							f
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.yanyu.value.find(item=>item.ly_name=='声母').value.find(item=>item.name=='f').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							n
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.yanyu.value.find(item=>item.ly_name=='声母').value.find(item=>item.name=='n').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							x
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.yanyu.value.find(item=>item.ly_name=='声母').value.find(item=>item.name=='x').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							j
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.yanyu.value.find(item=>item.ly_name=='声母').value.find(item=>item.name=='j').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							ch
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.yanyu.value.find(item=>item.ly_name=='声母').value.find(item=>item.name=='ch').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							c
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.yanyu.value.find(item=>item.ly_name=='声母').value.find(item=>item.name=='c').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							l
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.yanyu.value.find(item=>item.ly_name=='声母').value.find(item=>item.name=='l').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							k
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.yanyu.value.find(item=>item.ly_name=='声母').value.find(item=>item.name=='k').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							g
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.yanyu.value.find(item=>item.ly_name=='声母').value.find(item=>item.name=='g').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							s
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.yanyu.value.find(item=>item.ly_name=='声母').value.find(item=>item.name=='s').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							sh
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.yanyu.value.find(item=>item.ly_name=='声母').value.find(item=>item.name=='sh').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							r
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.yanyu.value.find(item=>item.ly_name=='声母').value.find(item=>item.name=='r').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
				</el-descriptions>
				<div class="el-descriptions__title margin-top" style="margin-bottom: 10px;">
					领域-认知
				</div>
				<el-descriptions title="分类及配对" :column="2" size="" border>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							能从不同类别做同类配对（1 岁）
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.renzhi.value.find(item=>item.ly_name=='分类及配对').value.find(item=>item.name=='能从不同类别做同类配对（1 岁）').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							能辨识真实的物品（1 岁）
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.renzhi.value.find(item=>item.ly_name=='分类及配对').value.find(item=>item.name=='能辨识真实的物品（1 岁）').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							几片大的整片的拼图片块（1 岁）
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.renzhi.value.find(item=>item.ly_name=='分类及配对').value.find(item=>item.name=='几片大的整片的拼图片块（1 岁）').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							实物与名词图片的配对（1.6~2 岁）
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.renzhi.value.find(item=>item.ly_name=='分类及配对').value.find(item=>item.name=='实物与名词图片的配对（1.6~2 岁）').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							实物与动词图片的配对（1.6~2 岁）
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.renzhi.value.find(item=>item.ly_name=='分类及配对').value.find(item=>item.name=='实物与动词图片的配对（1.6~2 岁）').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							一模一样的图片（各4 张）（1.6~2岁）
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.renzhi.value.find(item=>item.ly_name=='分类及配对').value.find(item=>item.name=='一模一样的图片（各4 张）（1.6~2岁）').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							同类物品做归类（1.6~2 岁）
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.renzhi.value.find(item=>item.ly_name=='分类及配对').value.find(item=>item.name=='同类物品做归类（1.6~2 岁）').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							能依类别将不同东西做归类（1.6~2 岁）
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.renzhi.value.find(item=>item.ly_name=='分类及配对').value.find(item=>item.name=='能依类别将不同东西做归类（1.6~2 岁）').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							5 片小的整片的拼图片块（1.6~2 岁）可配对之图片（2.5 岁）
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.renzhi.value.find(item=>item.ly_name=='分类及配对').value.find(item=>item.name=='5 片小的整片的拼图片块（1.6~2 岁）可配对之图片（2.5 岁）').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							能将各房间东西归类（2.5 岁）
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.renzhi.value.find(item=>item.ly_name=='分类及配对').value.find(item=>item.name=='能将各房间东西归类（2.5 岁）').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							分隔各半的拼图及容器（2.5 岁）
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.renzhi.value.find(item=>item.ly_name=='分类及配对').value.find(item=>item.name=='分隔各半的拼图及容器（2.5 岁）').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							物品缺少的部分（3 岁）
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.renzhi.value.find(item=>item.ly_name=='分类及配对').value.find(item=>item.name=='物品缺少的部分（3 岁）').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							服装与人物之联结（3 岁）
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.renzhi.value.find(item=>item.ly_name=='分类及配对').value.find(item=>item.name=='服装与人物之联结（3 岁）').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							动物吃的食物（3 岁）
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.renzhi.value.find(item=>item.ly_name=='分类及配对').value.find(item=>item.name=='动物吃的食物（3 岁）').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							不同商店相关的物品分类（3 岁）以拍拍手玩分类游戏（3 岁）
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.renzhi.value.find(item=>item.ly_name=='分类及配对').value.find(item=>item.name=='不同商店相关的物品分类（3 岁）以拍拍手玩分类游戏（3 岁）').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							分割 4 片的拼图（3 岁）
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.renzhi.value.find(item=>item.ly_name=='分类及配对').value.find(item=>item.name=='分割 4 片的拼图（3 岁）').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							各种职业的物品配对较复杂（4 岁）
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.renzhi.value.find(item=>item.ly_name=='分类及配对').value.find(item=>item.name=='各种职业的物品配对较复杂（4 岁）').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							较大图景的拼图（4 岁）
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.renzhi.value.find(item=>item.ly_name=='分类及配对').value.find(item=>item.name=='较大图景的拼图（4 岁）').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							其它：（{{cxpg_info.renzhi.value.find(item=>item.ly_name=='分类及配对').value.find(item=>item.name=='其它').text}}）
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.renzhi.value.find(item=>item.ly_name=='分类及配对').value.find(item=>item.name=='其它').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
				</el-descriptions>

				<el-descriptions title="颜色" :column="3" size="" border>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							红色
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.renzhi.value.find(item=>item.ly_name=='颜色').value.find(item=>item.name=='红色').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							蓝色
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.renzhi.value.find(item=>item.ly_name=='颜色').value.find(item=>item.name=='蓝色').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							黄色
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.renzhi.value.find(item=>item.ly_name=='颜色').value.find(item=>item.name=='黄色').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							绿色
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.renzhi.value.find(item=>item.ly_name=='颜色').value.find(item=>item.name=='绿色').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							白色
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.renzhi.value.find(item=>item.ly_name=='颜色').value.find(item=>item.name=='白色').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							黑色
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.renzhi.value.find(item=>item.ly_name=='颜色').value.find(item=>item.name=='黑色').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							橘色
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.renzhi.value.find(item=>item.ly_name=='颜色').value.find(item=>item.name=='橘色').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							粉红色
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.renzhi.value.find(item=>item.ly_name=='颜色').value.find(item=>item.name=='粉红色').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							紫色
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.renzhi.value.find(item=>item.ly_name=='颜色').value.find(item=>item.name=='紫色').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							橙色
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.renzhi.value.find(item=>item.ly_name=='颜色').value.find(item=>item.name=='橙色').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							咖啡色（棕色）
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.renzhi.value.find(item=>item.ly_name=='颜色').value.find(item=>item.name=='咖啡色（棕色）').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							黑白色
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.renzhi.value.find(item=>item.ly_name=='颜色').value.find(item=>item.name=='黑白色').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							彩色的
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.renzhi.value.find(item=>item.ly_name=='颜色').value.find(item=>item.name=='彩色的').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							灰色
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.renzhi.value.find(item=>item.ly_name=='颜色').value.find(item=>item.name=='灰色').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							深
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.renzhi.value.find(item=>item.ly_name=='颜色').value.find(item=>item.name=='深').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							浅
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.renzhi.value.find(item=>item.ly_name=='颜色').value.find(item=>item.name=='浅').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							金色
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.renzhi.value.find(item=>item.ly_name=='颜色').value.find(item=>item.name=='金色').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							银色
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.renzhi.value.find(item=>item.ly_name=='颜色').value.find(item=>item.name=='银色').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							金黄色
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.renzhi.value.find(item=>item.ly_name=='颜色').value.find(item=>item.name=='金黄色').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							相同—不相同
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.renzhi.value.find(item=>item.ly_name=='颜色').value.find(item=>item.name=='相同—不相同').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							不一样
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.renzhi.value.find(item=>item.ly_name=='颜色').value.find(item=>item.name=='不一样').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
				</el-descriptions>
				<div class="el-descriptions__title margin-top" style="margin-bottom: 10px;">
					数字概念
				</div>
				<el-descriptions title="唱数" :column="3" size="" border>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							1---3
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.renzhi.value.find(item=>item.ly_name=='数字概念').value.find(item=>item.name=='唱数').value.find(item=>item.name=='1---3').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							4---6
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.renzhi.value.find(item=>item.ly_name=='数字概念').value.find(item=>item.name=='唱数').value.find(item=>item.name=='4---6').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							7---10
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.renzhi.value.find(item=>item.ly_name=='数字概念').value.find(item=>item.name=='唱数').value.find(item=>item.name=='7---10').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							11---20
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.renzhi.value.find(item=>item.ly_name=='数字概念').value.find(item=>item.name=='唱数').value.find(item=>item.name=='11---20').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							20 以上
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.renzhi.value.find(item=>item.ly_name=='数字概念').value.find(item=>item.name=='唱数').value.find(item=>item.name=='20 以上').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
				</el-descriptions>
				<el-descriptions title="认识数字" :column="3" size="" border>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							1---3
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.renzhi.value.find(item=>item.ly_name=='数字概念').value.find(item=>item.name=='认识数字').value.find(item=>item.name=='1---3').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							4---6
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.renzhi.value.find(item=>item.ly_name=='数字概念').value.find(item=>item.name=='认识数字').value.find(item=>item.name=='4---6').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							7---10
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.renzhi.value.find(item=>item.ly_name=='数字概念').value.find(item=>item.name=='认识数字').value.find(item=>item.name=='7---10').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							11---20
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.renzhi.value.find(item=>item.ly_name=='数字概念').value.find(item=>item.name=='认识数字').value.find(item=>item.name=='11---20').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							20 以上
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.renzhi.value.find(item=>item.ly_name=='数字概念').value.find(item=>item.name=='认识数字').value.find(item=>item.name=='20 以上').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							比较数字大小
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.renzhi.value.find(item=>item.ly_name=='数字概念').value.find(item=>item.name=='认识数字').value.find(item=>item.name=='比较数字大小').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
				</el-descriptions>
				<el-descriptions title="量的概念" :column="3" size="" border>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							1---3
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.renzhi.value.find(item=>item.ly_name=='数字概念').value.find(item=>item.name=='量的概念').value.find(item=>item.name=='1---3').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							4---6
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.renzhi.value.find(item=>item.ly_name=='数字概念').value.find(item=>item.name=='量的概念').value.find(item=>item.name=='4---6').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							7---10
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.renzhi.value.find(item=>item.ly_name=='数字概念').value.find(item=>item.name=='量的概念').value.find(item=>item.name=='7---10').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							11---20
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.renzhi.value.find(item=>item.ly_name=='数字概念').value.find(item=>item.name=='量的概念').value.find(item=>item.name=='11---20').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							20 以上
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.renzhi.value.find(item=>item.ly_name=='数字概念').value.find(item=>item.name=='量的概念').value.find(item=>item.name=='20 以上').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							比较数量多少
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.renzhi.value.find(item=>item.ly_name=='数字概念').value.find(item=>item.name=='量的概念').value.find(item=>item.name=='比较数量多少').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
				</el-descriptions>
				<el-descriptions title="币值的概念" :column="3" size="" border>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							1角
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.renzhi.value.find(item=>item.ly_name=='数字概念').value.find(item=>item.name=='币值的概念').value.find(item=>item.name=='1角').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							5角
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.renzhi.value.find(item=>item.ly_name=='数字概念').value.find(item=>item.name=='币值的概念').value.find(item=>item.name=='5角').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							1元
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.renzhi.value.find(item=>item.ly_name=='数字概念').value.find(item=>item.name=='币值的概念').value.find(item=>item.name=='1元').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							5元
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.renzhi.value.find(item=>item.ly_name=='数字概念').value.find(item=>item.name=='币值的概念').value.find(item=>item.name=='5元').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							10元
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.renzhi.value.find(item=>item.ly_name=='数字概念').value.find(item=>item.name=='币值的概念').value.find(item=>item.name=='10元').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							20元
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.renzhi.value.find(item=>item.ly_name=='数字概念').value.find(item=>item.name=='币值的概念').value.find(item=>item.name=='20元').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							50元
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.renzhi.value.find(item=>item.ly_name=='数字概念').value.find(item=>item.name=='币值的概念').value.find(item=>item.name=='50元').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							100元
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.renzhi.value.find(item=>item.ly_name=='数字概念').value.find(item=>item.name=='币值的概念').value.find(item=>item.name=='100元').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
				</el-descriptions>

				<el-descriptions title="数的运算-加法" :column="3" size="" border>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							个位数
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.renzhi.value.find(item=>item.ly_name=='数字概念').value.find(item=>item.name=='数的运算').value.find(item=>item.name=='加法').value.find(item=>item.name=='个位数').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							十位数
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.renzhi.value.find(item=>item.ly_name=='数字概念').value.find(item=>item.name=='数的运算').value.find(item=>item.name=='加法').value.find(item=>item.name=='十位数').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
				</el-descriptions>
				<el-descriptions title="数的运算-百位数减法" :column="3" size="" border>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							百位数减法
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.renzhi.value.find(item=>item.ly_name=='数字概念').value.find(item=>item.name=='数的运算').value.find(item=>item.name=='百位数减法').value.find(item=>item.name=='百位数减法').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							个位数
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.renzhi.value.find(item=>item.ly_name=='数字概念').value.find(item=>item.name=='数的运算').value.find(item=>item.name=='百位数减法').value.find(item=>item.name=='个位数').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							十位数
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.renzhi.value.find(item=>item.ly_name=='数字概念').value.find(item=>item.name=='数的运算').value.find(item=>item.name=='百位数减法').value.find(item=>item.name=='十位数').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
				</el-descriptions>
				<el-descriptions title="数的运算-百位数乘法" :column="3" size="" border>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							百位数乘法
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.renzhi.value.find(item=>item.ly_name=='数字概念').value.find(item=>item.name=='数的运算').value.find(item=>item.name=='百位数乘法').value.find(item=>item.name=='百位数乘法').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							个位数
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.renzhi.value.find(item=>item.ly_name=='数字概念').value.find(item=>item.name=='数的运算').value.find(item=>item.name=='百位数乘法').value.find(item=>item.name=='个位数').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							十位数
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.renzhi.value.find(item=>item.ly_name=='数字概念').value.find(item=>item.name=='数的运算').value.find(item=>item.name=='百位数乘法').value.find(item=>item.name=='十位数').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
				</el-descriptions>
				<el-descriptions title="数的运算-除法" :column="3" size="" border>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							个位数
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.renzhi.value.find(item=>item.ly_name=='数字概念').value.find(item=>item.name=='数的运算').value.find(item=>item.name=='除法').value.find(item=>item.name=='个位数').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							十位数
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.renzhi.value.find(item=>item.ly_name=='数字概念').value.find(item=>item.name=='数的运算').value.find(item=>item.name=='除法').value.find(item=>item.name=='十位数').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
				</el-descriptions>
				<div class="el-descriptions__title margin-top" style="margin-bottom: 10px;">
					形状
				</div>
				<el-descriptions title="平面" :column="3" size="" border>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							圆形
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.renzhi.value.find(item=>item.ly_name=='形状').value.find(item=>item.name=='平面').value.find(item=>item.name=='圆形').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							三角形
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.renzhi.value.find(item=>item.ly_name=='形状').value.find(item=>item.name=='平面').value.find(item=>item.name=='三角形').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							正方形
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.renzhi.value.find(item=>item.ly_name=='形状').value.find(item=>item.name=='平面').value.find(item=>item.name=='正方形').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							长方形
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.renzhi.value.find(item=>item.ly_name=='形状').value.find(item=>item.name=='平面').value.find(item=>item.name=='长方形').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							星形
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.renzhi.value.find(item=>item.ly_name=='形状').value.find(item=>item.name=='平面').value.find(item=>item.name=='星形').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							梯形
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.renzhi.value.find(item=>item.ly_name=='形状').value.find(item=>item.name=='平面').value.find(item=>item.name=='梯形').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							心形
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.renzhi.value.find(item=>item.ly_name=='形状').value.find(item=>item.name=='平面').value.find(item=>item.name=='心形').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							半圆形
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.renzhi.value.find(item=>item.ly_name=='形状').value.find(item=>item.name=='平面').value.find(item=>item.name=='半圆形').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							平行四边形
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.renzhi.value.find(item=>item.ly_name=='形状').value.find(item=>item.name=='平面').value.find(item=>item.name=='平行四边形').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							椭圆形
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.renzhi.value.find(item=>item.ly_name=='形状').value.find(item=>item.name=='平面').value.find(item=>item.name=='椭圆形').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							六边形
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.renzhi.value.find(item=>item.ly_name=='形状').value.find(item=>item.name=='平面').value.find(item=>item.name=='六边形').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							菱形
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.renzhi.value.find(item=>item.ly_name=='形状').value.find(item=>item.name=='平面').value.find(item=>item.name=='菱形').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							四边形
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.renzhi.value.find(item=>item.ly_name=='形状').value.find(item=>item.name=='平面').value.find(item=>item.name=='四边形').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							其它:({{cxpg_info.renzhi.value.find(item=>item.ly_name=='形状').value.find(item=>item.name=='平面').value.find(item=>item.name=='其它').text}})
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.renzhi.value.find(item=>item.ly_name=='形状').value.find(item=>item.name=='平面').value.find(item=>item.name=='其它').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
				</el-descriptions>
				<el-descriptions title="立体" :column="3" size="" border>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							立方体
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.renzhi.value.find(item=>item.ly_name=='形状').value.find(item=>item.name=='立体').value.find(item=>item.name=='立方体').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							圆柱体
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.renzhi.value.find(item=>item.ly_name=='形状').value.find(item=>item.name=='立体').value.find(item=>item.name=='圆柱体').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							圆锥体
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.renzhi.value.find(item=>item.ly_name=='形状').value.find(item=>item.name=='立体').value.find(item=>item.name=='圆锥体').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							三角锥
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.renzhi.value.find(item=>item.ly_name=='形状').value.find(item=>item.name=='立体').value.find(item=>item.name=='三角锥').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							长方体
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.renzhi.value.find(item=>item.ly_name=='形状').value.find(item=>item.name=='立体').value.find(item=>item.name=='长方体').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							正方体
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.renzhi.value.find(item=>item.ly_name=='形状').value.find(item=>item.name=='立体').value.find(item=>item.name=='正方体').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
				</el-descriptions>
				<el-descriptions title="触觉感知" :column="3" size="" border>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							粘粘的
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.renzhi.value.find(item=>item.ly_name=='触觉感知').value.find(item=>item.name=='粘粘的').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							软软的
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.renzhi.value.find(item=>item.ly_name=='触觉感知').value.find(item=>item.name=='软软的').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							硬硬的
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.renzhi.value.find(item=>item.ly_name=='触觉感知').value.find(item=>item.name=='硬硬的').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							粗粗的
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.renzhi.value.find(item=>item.ly_name=='触觉感知').value.find(item=>item.name=='粗粗的').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							尖尖的
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.renzhi.value.find(item=>item.ly_name=='触觉感知').value.find(item=>item.name=='尖尖的').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							刺刺的
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.renzhi.value.find(item=>item.ly_name=='触觉感知').value.find(item=>item.name=='刺刺的').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							滑滑的
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.renzhi.value.find(item=>item.ly_name=='触觉感知').value.find(item=>item.name=='滑滑的').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							油油的
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.renzhi.value.find(item=>item.ly_name=='触觉感知').value.find(item=>item.name=='油油的').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							毛绒绒的
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.renzhi.value.find(item=>item.ly_name=='触觉感知').value.find(item=>item.name=='毛绒绒的').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							烫烫的
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.renzhi.value.find(item=>item.ly_name=='触觉感知').value.find(item=>item.name=='烫烫的').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							湿湿的
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.renzhi.value.find(item=>item.ly_name=='触觉感知').value.find(item=>item.name=='湿湿的').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							冰冰的
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.renzhi.value.find(item=>item.ly_name=='触觉感知').value.find(item=>item.name=='冰冰的').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							干干的
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.renzhi.value.find(item=>item.ly_name=='触觉感知').value.find(item=>item.name=='粘粘的').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							其它:({{cxpg_info.renzhi.value.find(item=>item.ly_name=='触觉感知').value.find(item=>item.name=='其它').text}})
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.renzhi.value.find(item=>item.ly_name=='触觉感知').value.find(item=>item.name=='其它').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
				</el-descriptions>

				<el-descriptions title="比较与对照" :column="2" size="" border>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							能在 4样物品中指认其中 3 个相同的（2.5~3岁）
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.renzhi.value.find(item=>item.ly_name=='比较与对照').value.find(item=>item.name=='能在 4样物品中指认其中 3 个相同的（2.5~3岁）').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							哪个不同？为什么？（2.5~3 岁）
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.renzhi.value.find(item=>item.ly_name=='比较与对照').value.find(item=>item.name=='哪个不同？为什么？（2.5~3 岁）').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							从 3 个相同一个不同中指出哪一个不一样（2.5~3岁）
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.renzhi.value.find(item=>item.ly_name=='比较与对照').value.find(item=>item.name=='从 3 个相同一个不同中指出哪一个不一样（2.5~3岁）').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							经听觉描述作选择（1~2 岁）—（2.5~3 岁）
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.renzhi.value.find(item=>item.ly_name=='比较与对照').value.find(item=>item.name=='经听觉描述作选择（1~2 岁）—（2.5~3 岁）').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							以实物列出哪个不一样？为什么？（4 岁）
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.renzhi.value.find(item=>item.ly_name=='比较与对照').value.find(item=>item.name=='以实物列出哪个不一样？为什么？（4 岁）').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							能依尺寸、味道来做比较（4岁）类推（4岁）
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.renzhi.value.find(item=>item.ly_name=='比较与对照').value.find(item=>item.name=='能依尺寸、味道来做比较（4岁）类推（4岁）').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							经听觉描述作选择（3~4岁）
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.renzhi.value.find(item=>item.ly_name=='比较与对照').value.find(item=>item.name=='经听觉描述作选择（3~4岁）').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							说出图片中哪些相似（5岁）
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.renzhi.value.find(item=>item.ly_name=='比较与对照').value.find(item=>item.name=='说出图片中哪些相似（5岁）').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							声母相同的押韵童谣（5岁）
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.renzhi.value.find(item=>item.ly_name=='比较与对照').value.find(item=>item.name=='声母相同的押韵童谣（5岁）').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							“相关联”之游戏（5 岁）
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.renzhi.value.find(item=>item.ly_name=='比较与对照').value.find(item=>item.name=='“相关联”之游戏（5 岁）').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							其它:({{cxpg_info.renzhi.value.find(item=>item.ly_name=='比较与对照').value.find(item=>item.name=='其它').text}})
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.renzhi.value.find(item=>item.ly_name=='比较与对照').value.find(item=>item.name=='其它').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
				</el-descriptions>

				<el-descriptions title="顺序概念" :column="2" size="" border>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							在家中的一些事情（3岁）
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.renzhi.value.find(item=>item.ly_name=='顺序概念').value.find(item=>item.name=='在家中的一些事情（3岁）').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							简单的手指游戏（3岁）
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.renzhi.value.find(item=>item.ly_name=='顺序概念').value.find(item=>item.name=='简单的手指游戏（3岁）').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							形状、数量（3岁）
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.renzhi.value.find(item=>item.ly_name=='顺序概念').value.find(item=>item.name=='形状、数量（3岁）').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							旅游（相片）（3岁）
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.renzhi.value.find(item=>item.ly_name=='顺序概念').value.find(item=>item.name=='旅游（相片）（3岁）').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							有顺序之指令（3岁）
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.renzhi.value.find(item=>item.ly_name=='顺序概念').value.find(item=>item.name=='有顺序之指令（3岁）').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							含2~3个段落的故事
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.renzhi.value.find(item=>item.ly_name=='顺序概念').value.find(item=>item.name=='含2~3个段落的故事').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							听故事及顺序（4岁）
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.renzhi.value.find(item=>item.ly_name=='顺序概念').value.find(item=>item.name=='听故事及顺序（4岁）').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							童谣、儿歌（4岁）
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.renzhi.value.find(item=>item.ly_name=='顺序概念').value.find(item=>item.name=='童谣、儿歌（4岁）').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							以不同顺序发展一则故事（5岁）
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.renzhi.value.find(item=>item.ly_name=='顺序概念').value.find(item=>item.name=='以不同顺序发展一则故事（5岁）').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							故事接龙（开始、中间或结局）
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.renzhi.value.find(item=>item.ly_name=='顺序概念').value.find(item=>item.name=='故事接龙（开始、中间或结局）').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							包含语法的顺序描述（6岁）
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.renzhi.value.find(item=>item.ly_name=='顺序概念').value.find(item=>item.name=='包含语法的顺序描述（6岁）').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							其它:({{cxpg_info.renzhi.value.find(item=>item.ly_name=='顺序概念').value.find(item=>item.name=='其它').text}})
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.renzhi.value.find(item=>item.ly_name=='顺序概念').value.find(item=>item.name=='其它').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
				</el-descriptions>
				<el-descriptions title="相似" :column="2" size="" border>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							功能相似
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.renzhi.value.find(item=>item.ly_name=='相似').value.find(item=>item.name=='功能相似').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							特征相似
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.renzhi.value.find(item=>item.ly_name=='相似').value.find(item=>item.name=='特征相似').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
				</el-descriptions>
				<el-descriptions title="推理/预测" :column="2" size="" border>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							事件推理
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.renzhi.value.find(item=>item.ly_name=='推理/预测').value.find(item=>item.name=='事件推理').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							时间推理
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.renzhi.value.find(item=>item.ly_name=='推理/预测').value.find(item=>item.name=='时间推理').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							字词推理
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.renzhi.value.find(item=>item.ly_name=='推理/预测').value.find(item=>item.name=='字词推理').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							找原因
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.renzhi.value.find(item=>item.ly_name=='推理/预测').value.find(item=>item.name=='找原因').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
				</el-descriptions>
				<el-descriptions title="类推" :column="1" size="" border>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							类推
						</template>
						{{cxpg_info.renzhi.value.find(item=>item.ly_name=='类推').value}}
					</el-descriptions-item>
				</el-descriptions>

				<el-descriptions title="同义词" :column="1" size="" border>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							同义词
						</template>
						{{cxpg_info.renzhi.value.find(item=>item.ly_name=='同义词').value}}
					</el-descriptions-item>
				</el-descriptions>
				<el-descriptions title="相反词" :column="1" size="" border>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							相反词
						</template>
						{{cxpg_info.renzhi.value.find(item=>item.ly_name=='相反词').value}}
					</el-descriptions-item>
				</el-descriptions>
				<el-descriptions title="双关语" :column="1" size="" border>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							双关语
						</template>
						{{cxpg_info.renzhi.value.find(item=>item.ly_name=='双关语').value}}
					</el-descriptions-item>
				</el-descriptions>
				<el-descriptions title="笑话" :column="1" size="" border>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							笑话
						</template>
						{{cxpg_info.renzhi.value.find(item=>item.ly_name=='笑话').value}}
					</el-descriptions-item>
				</el-descriptions>
				<el-descriptions title="谜语" :column="1" size="" border>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							谜语
						</template>
						{{cxpg_info.renzhi.value.find(item=>item.ly_name=='谜语').value}}
					</el-descriptions-item>
				</el-descriptions>
				<div class="el-descriptions__title margin-top" style="margin-bottom: 10px;">
					领域—沟通
				</div>
				<el-descriptions title="沟通行为" :column="3" size="" border>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							眼神的注视
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.goutong.value.find(item=>item.ly_name=='沟通行为').value.find(item=>item.name=='眼神的注视').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							轮替
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.goutong.value.find(item=>item.ly_name=='沟通行为').value.find(item=>item.name=='轮替').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							礼貌用语（例如：再见、谢谢、对不起……）
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.goutong.value.find(item=>item.ly_name=='沟通行为').value.find(item=>item.name=='礼貌用语（例如：再见、谢谢、对不起……）').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							问句
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.goutong.value.find(item=>item.ly_name=='沟通行为').value.find(item=>item.name=='问句').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							主动与他人互动
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.goutong.value.find(item=>item.ly_name=='沟通行为').value.find(item=>item.name=='主动与他人互动').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							开启话题开放式
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.goutong.value.find(item=>item.ly_name=='沟通行为').value.find(item=>item.name=='开启话题开放式').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							开启话题闭锁式
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.goutong.value.find(item=>item.ly_name=='沟通行为').value.find(item=>item.name=='开启话题闭锁式').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
				</el-descriptions>
				<el-descriptions title="沟通策略-基础" :column="3" size="" border>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							要求重复
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.goutong.value.find(item=>item.ly_name=='沟通策略').value.find(item=>item.name=='基础').value.find(item=>item.name=='要求重复').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							证实部分讯息
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.goutong.value.find(item=>item.ly_name=='沟通策略').value.find(item=>item.name=='基础').value.find(item=>item.name=='证实部分讯息').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							要求说明
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.goutong.value.find(item=>item.ly_name=='沟通策略').value.find(item=>item.name=='基础').value.find(item=>item.name=='要求说明').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							适当的转换话题
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.goutong.value.find(item=>item.ly_name=='沟通策略').value.find(item=>item.name=='基础').value.find(item=>item.name=='适当的转换话题').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							分享对话的主导权
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.goutong.value.find(item=>item.ly_name=='沟通策略').value.find(item=>item.name=='基础').value.find(item=>item.name=='分享对话的主导权').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							提供说明
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.goutong.value.find(item=>item.ly_name=='沟通策略').value.find(item=>item.name=='基础').value.find(item=>item.name=='提供说明').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
				</el-descriptions>
				<el-descriptions title="沟通策略-维持同一话题" :column="3" size="" border>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							一回
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.goutong.value.find(item=>item.ly_name=='沟通策略').value.find(item=>item.name=='维持同一话题').value.find(item=>item.name=='一回').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							两回
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.goutong.value.find(item=>item.ly_name=='沟通策略').value.find(item=>item.name=='维持同一话题').value.find(item=>item.name=='两回').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							三回
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.goutong.value.find(item=>item.ly_name=='沟通策略').value.find(item=>item.name=='维持同一话题').value.find(item=>item.name=='三回').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							延伸话题
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.goutong.value.find(item=>item.ly_name=='沟通策略').value.find(item=>item.name=='维持同一话题').value.find(item=>item.name=='延伸话题').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
				</el-descriptions>
				<el-descriptions title="沟通策略-高级" :column="2" size="" border>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							能用正式的言语作为问候与道别
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.goutong.value.find(item=>item.ly_name=='沟通策略').value.find(item=>item.name=='高级').value.find(item=>item.name=='能用正式的言语作为问候与道别').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							能用合宜的方式引起对方的注意
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.goutong.value.find(item=>item.ly_name=='沟通策略').value.find(item=>item.name=='高级').value.find(item=>item.name=='能用合宜的方式引起对方的注意').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							能用适当的言语征询他人的同意
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.goutong.value.find(item=>item.ly_name=='沟通策略').value.find(item=>item.name=='高级').value.find(item=>item.name=='能用适当的言语征询他人的同意').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							能询问信息
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.goutong.value.find(item=>item.ly_name=='沟通策略').value.find(item=>item.name=='高级').value.find(item=>item.name=='能询问信息').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							能询问更多的信息
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.goutong.value.find(item=>item.ly_name=='沟通策略').value.find(item=>item.name=='高级').value.find(item=>item.name=='能询问更多的信息').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							能给予评论的意见
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.goutong.value.find(item=>item.ly_name=='沟通策略').value.find(item=>item.name=='高级').value.find(item=>item.name=='能给予评论的意见').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							能给予评论的意见
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.goutong.value.find(item=>item.ly_name=='沟通策略').value.find(item=>item.name=='高级').value.find(item=>item.name=='能给予评论的意见').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							能适当的表达同意
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.goutong.value.find(item=>item.ly_name=='沟通策略').value.find(item=>item.name=='高级').value.find(item=>item.name=='能适当的表达同意').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							能适当的表达不同意
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.goutong.value.find(item=>item.ly_name=='沟通策略').value.find(item=>item.name=='高级').value.find(item=>item.name=='能适当的表达不同意').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							能合适的直接请求对方行动
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.goutong.value.find(item=>item.ly_name=='沟通策略').value.find(item=>item.name=='高级').value.find(item=>item.name=='能合适的直接请求对方行动').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							能以间接地方式表达自己的需求
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.goutong.value.find(item=>item.ly_name=='沟通策略').value.find(item=>item.name=='高级').value.find(item=>item.name=='能以间接地方式表达自己的需求').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							能合宜的表达抗议
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.goutong.value.find(item=>item.ly_name=='沟通策略').value.find(item=>item.name=='高级').value.find(item=>item.name=='能合宜的表达抗议').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
				</el-descriptions>
				<div class="el-descriptions__title margin-top" style="margin-bottom: 10px;">
					领域—家长表现
				</div>
				<el-descriptions title="对课堂教学的配合程度" :column="2" size="" border>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							很好
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.jiazhangbiaoxian.value.find(item=>item.name=='对课堂教学的配合程度').value.find(item=>item.name=='很好').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							一般
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.jiazhangbiaoxian.value.find(item=>item.name=='对课堂教学的配合程度').value.find(item=>item.name=='一般').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							较差：（{{cxpg_info.jiazhangbiaoxian.value.find(item=>item.name=='对课堂教学的配合程度').value.find(item=>item.name=='较差').text}}）
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.jiazhangbiaoxian.value.find(item=>item.name=='对课堂教学的配合程度').value.find(item=>item.name=='较差').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>

				</el-descriptions>
				<el-descriptions title="对已学会的技巧运用情况" :column="2" size="" border>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							很好
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.jiazhangbiaoxian.value.find(item=>item.name=='对已学会的技巧运用情况').value.find(item=>item.name=='很好').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							一般
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.jiazhangbiaoxian.value.find(item=>item.name=='对已学会的技巧运用情况').value.find(item=>item.name=='一般').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							较差：（{{cxpg_info.jiazhangbiaoxian.value.find(item=>item.name=='对已学会的技巧运用情况').value.find(item=>item.name=='较差').text}}）
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.jiazhangbiaoxian.value.find(item=>item.name=='对已学会的技巧运用情况').value.find(item=>item.name=='较差').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>

				</el-descriptions>
				<el-descriptions title="家庭康复任务完成情况" :column="2" size="" border>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							很好
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.jiazhangbiaoxian.value.find(item=>item.name=='家庭康复任务完成情况').value.find(item=>item.name=='很好').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							一般
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.jiazhangbiaoxian.value.find(item=>item.name=='家庭康复任务完成情况').value.find(item=>item.name=='一般').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							较差：（{{cxpg_info.jiazhangbiaoxian.value.find(item=>item.name=='家庭康复任务完成情况').value.find(item=>item.name=='较差').text}}）
						</template>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(e,i) in cxpg_info.jiazhangbiaoxian.value.find(item=>item.name=='家庭康复任务完成情况').value.find(item=>item.name=='较差').value"
								:key="i">
								<div style="display: flex; margin-right: 10px;">
									<div class="yuanquan">{{ e.num + 1 }}</div>
									<div class="fangkuai">{{ e.value }}</div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
				</el-descriptions>
				<div class="el-descriptions__title margin-top">
					在哪些方面有新的进步?
				</div>
				<el-input class="margin-top" style="font-size: 16px;" type="textarea" :rows="3" disabled
					v-model="newProgress">
				</el-input>
				<div class="el-descriptions__title margin-top">
					其它?
				</div>
				<el-input class="margin-top" style="font-size: 16px;" type="textarea" :rows="3" disabled
					v-model="newProgress1">
				</el-input>
				<el-descriptions title="" :column="2" size="" border>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							评估教师
						</template>
						{{cxpg_info.pg_teacher}}
					</el-descriptions-item>
				</el-descriptions>
			</el-card>
			<div style="height: 50px;width: 200px;"></div>

			<el-card id="id4">
				<div slot="header" class="clearfix">
					<span>教学计划</span>
				</div>
				<div>
					<el-descriptions title="基本资料" :column="3" size="" border>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								姓名
							</template>
							{{jiaoxuejihua.stu_name}}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								性别
							</template>
							{{jiaoxuejihua.stu_sex}}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								生理年龄
							</template>
							{{jiaoxuejihua.shengli_age_year}}岁{{jiaoxuejihua.shengli_age_month}}月
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								听觉年龄
							</template>
							{{jiaoxuejihua.tingli_age_year}}岁{{jiaoxuejihua.tingli_age_month}}月
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								起止时间
							</template>
							{{jiaoxuejihua.starttime}}——{{jiaoxuejihua.endtime}}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								授课频率
							</template>
							每（日/周/月）{{jiaoxuejihua.shoukepinlv}}小时
						</el-descriptions-item>
					</el-descriptions>
					<el-descriptions title="教学计划内容" :column="1" size="" border>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								听能
							</template>
							{{jiaoxuejihua.lingyu.find(item=>item.value=='听能').value2}}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								言语
							</template>
							{{jiaoxuejihua.lingyu.find(item=>item.value=='言语').value2}}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								语言
							</template>
							{{jiaoxuejihua.lingyu.find(item=>item.value=='语言').value2}}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								认知
							</template>
							{{jiaoxuejihua.lingyu.find(item=>item.value=='认知').value2}}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								沟通
							</template>
							{{jiaoxuejihua.lingyu.find(item=>item.value=='沟通').value2}}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								家庭指导计划
							</template>
							{{jiaoxuejihua.lingyu.find(item=>item.value=='家庭指导计划').value2}}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								其他
							</template>
							{{jiaoxuejihua.lingyu.find(item=>item.value=='其他').value2}}
						</el-descriptions-item>
					</el-descriptions>
					<el-descriptions title="日期&教师" :column="2" size="" border>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								评估日期
							</template>
							{{}}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								授课教师
							</template>
							{{}}
						</el-descriptions-item>
					</el-descriptions>
				</div>
			</el-card>

			<div style="height: 50px;width: 200px;"></div>
			<el-card id="id5">
				<div slot="header" class="clearfix">
					<span>日常教学记录</span>
				</div>
				<div>
					<el-descriptions title="" :column="3" size="" border>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								姓名
							</template>
							{{rcjxjh_info.stu_name}}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								性别
							</template>
							{{rcjxjh_info.sex}}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								助听设备佩戴方式
							</template>
							{{rcjxjh_info.ztq_pd}}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								生理年龄
							</template>
							{{rcjxjh_info.age}}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								听觉年龄
							</template>
							{{rcjxjh_info.tj_age}}
						</el-descriptions-item>
					</el-descriptions>
					<div class="el-descriptions__title margin-top" style="margin-bottom: 10px;">
						领域-常规
					</div>
					<el-descriptions title="1.助听设备工作状态" :column="2" size="" border>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								助听设备工作状态
							</template>
							{{rcjxjh_info.cg.neirong.ztq_zt.value}}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								说明：
							</template>
							{{rcjxjh_info.cg.neirong.ztq_zt.bc}}
						</el-descriptions-item>
					</el-descriptions>
					<el-descriptions title="2.林氏（Ling’s） 六音" :column="3" size="" border>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								领域
							</template>
							察觉
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								距离：
							</template>
							{{rcjxjh_info.cg.neirong.six_yin.cj.jl}}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								填写选项内容：
							</template>
							<div style="display: flex;flex-wrap: wrap;">
								<div v-for="(item,index) in rcjxjh_info.cg.neirong.six_yin.cj.value" :key="index">
									<span style="margin-left: 10px;">第{{item.name}}: </span>
									<span v-for="(item2,index2) in item.value" :key="index2">
										<span v-if="item2.value!=''">{{item2.name}}-{{item2.value}},</span>
									</span>
								</div>
							</div>
						</el-descriptions-item>
					</el-descriptions>
					<el-descriptions :column="3" size="" border>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								领域
							</template>
							辨识
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								距离：
							</template>
							{{rcjxjh_info.cg.neirong.six_yin.bs.jl}}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								填写选项内容：
							</template>
							<div style="display: flex;flex-wrap: wrap;">
								<div v-for="(item,index) in rcjxjh_info.cg.neirong.six_yin.bs.value" :key="index">
									<span style="margin-left: 10px;">第{{item.name}}: </span>
									<span v-for="(item2,index2) in item.value" :key="index2">
										<span v-if="item2.value!=''">{{item2.name}}-{{item2.value}},</span>
									</span>
								</div>
							</div>
						</el-descriptions-item>
					</el-descriptions>
					<div class="el-descriptions__title margin-top">
						常规-备注：
					</div>
					<el-input class="margin-top" style="font-size: 16px;" type="textarea" :rows="3" disabled
						v-model="rcjxjh_info.cg.bz">
					</el-input>

					<el-descriptions title="" :column="3" size="" border>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								领域
							</template>
							听能发展
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								内容
							</template>
							<div style="display: flex;">
								<div v-for="(itemkk,indexkk) in rcjxjh_info.tnfz.neirong" :key="indexkk">
									<span v-if="itemkk.text!=''"
										style="margin-right: 10px;">{{itemkk.text}}-{{itemkk.value}},</span>
								</div>
							</div>
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								备注：
							</template>
							{{rcjxjh_info.tnfz.bz}}
						</el-descriptions-item>
					</el-descriptions>
					<el-descriptions title="" :column="3" size="" border>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								领域
							</template>
							言语发展
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								内容
							</template>
							<div style="display: flex;">
								<div v-for="(itemkk,indexkk) in rcjxjh_info.yyfz1.neirong" :key="indexkk">
									<span v-if="itemkk.text!=''"
										style="margin-right: 10px;">{{itemkk.text}}-{{itemkk.value}},</span>
								</div>
							</div>
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								备注：
							</template>
							{{rcjxjh_info.yyfz1.bz}}
						</el-descriptions-item>
					</el-descriptions>
					<el-descriptions title="" :column="3" size="" border>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								领域
							</template>
							语言发展
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								内容
							</template>
							<div style="display: flex;">
								<div v-for="(itemkk,indexkk) in rcjxjh_info.yyfz2.neirong" :key="indexkk">
									<span v-if="itemkk.text!=''"
										style="margin-right: 10px;">{{itemkk.text}}-{{itemkk.value}},</span>
								</div>
							</div>
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								备注：
							</template>
							{{rcjxjh_info.yyfz2.bz}}
						</el-descriptions-item>
					</el-descriptions>
					<el-descriptions title="" :column="3" size="" border>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								领域
							</template>
							认知发展
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								内容
							</template>
							<div style="display: flex;">
								<div v-for="(itemkk,indexkk) in rcjxjh_info.rzfz.neirong" :key="indexkk">
									<span v-if="itemkk.text!=''"
										style="margin-right: 10px;">{{itemkk.text}}-{{itemkk.value}},</span>
								</div>
							</div>
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								备注：
							</template>
							{{rcjxjh_info.rzfz.bz}}
						</el-descriptions-item>
					</el-descriptions>
					<el-descriptions title="" :column="3" size="" border>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								领域
							</template>
							沟通技能
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								内容
							</template>
							<div style="display: flex;">
								<div v-for="(itemkk,indexkk) in rcjxjh_info.gtjn.neirong" :key="indexkk">
									<span v-if="itemkk.text!=''"
										style="margin-right: 10px;">{{itemkk.text}}-{{itemkk.value}},</span>
								</div>
							</div>
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								备注：
							</template>
							{{rcjxjh_info.gtjn.bz}}
						</el-descriptions-item>
					</el-descriptions>

					<el-descriptions title="家长表现" :column="2" size="" border>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								在课堂上理解了教师运用的方法与技巧
							</template>
							{{rcjxjh_info.jzbx.one}}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								对于技巧的掌握
							</template>
							{{rcjxjh_info.jzbx.two}}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								对孩子语言的输入符合孩子的听觉语言水平
							</template>
							{{rcjxjh_info.jzbx.three.value}}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								原因补充
							</template>
							<span v-if="rcjxjh_info.jzbx.three.value=='否'">
								{{rcjxjh_info.jzbx.three.bc}}
							</span>
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								给孩子输入时语速、语调合宜
							</template>
							{{rcjxjh_info.jzbx.four.value}}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								原因补充
							</template>
							<span v-if="rcjxjh_info.jzbx.four.value=='否'">
								{{rcjxjh_info.jzbx.four.bc}}
							</span>
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								对已学会的技巧能够熟练运用
							</template>
							{{rcjxjh_info.jzbx.five.value}}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								原因补充
							</template>
							<span v-if="rcjxjh_info.jzbx.five.value=='否'">
								{{rcjxjh_info.jzbx.five.bc}}
							</span>
						</el-descriptions-item>
					</el-descriptions>
					<el-descriptions title="" :column="2" size="" border>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								领域
							</template>
							家庭康复建议
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								内容
							</template>
							{{rcjxjh_info.jtkfjy}}
						</el-descriptions-item>
					</el-descriptions>
					<el-descriptions title="" :column="2" size="" border>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								领域
							</template>
							家庭康复记录
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								内容
							</template>
							{{rcjxjh_info.jtkfjl}}
						</el-descriptions-item>
					</el-descriptions>
					<el-descriptions title="日期&教师" :column="2" size="" border>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								授课日期
							</template>
							{{rcjxjh_info.riqi}}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								授课教师
							</template>
							{{rcjxjh_info.tea_name}}
						</el-descriptions-item>
					</el-descriptions>
				</div>
			</el-card>
			<div style="height: 50px;width: 200px;"></div>
			<el-card id="id6">
				<div slot="header" class="clearfix">
					<span>临床数据</span>
				</div>
				<div>
					<div class="el-descriptions__title margin-top-sm " style="margin-bottom: 20px;">
						耳聋史
					</div>
					<el-descriptions title="" :column="3" size="" border>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								何时出现耳聋
							</template>
							{{lcsj_info.erlongshi.find(item=>item.name=='何时出现耳聋').jieguo}}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								何时发现耳聋
							</template>
							{{lcsj_info.erlongshi.find(item=>item.name=='何时发现耳聋').value[0].name}}{{lcsj_info.erlongshi.find(item=>item.name=='何时发现耳聋').value[0].value}}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								可听见何种声音
							</template>
							<div style="display: flex; flex-wrap: wrap;">
								<div v-for="(item,index) in lcsj_info.erlongshi.find(item=>item.name=='可听见何种声音').value"
									:key="index">
									<span v-if="item.value.length!==0">{{item.value[0]}},</span>
								</div>
							</div>
						</el-descriptions-item>
					</el-descriptions>
					<el-descriptions title="目前配戴助听设备情况" :column="2" size="" border>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								助听设备-左耳
							</template>
							{{lcsj_info.erlongshi.find(item=>item.name=='目前配戴助听设备情况').value.find(item=>item.name=='左耳').value.find(item=>item.name=='助听设备').jieguo}}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								助听设备-右耳
							</template>
							{{lcsj_info.erlongshi.find(item=>item.name=='目前配戴助听设备情况').value.find(item=>item.name=='右耳').value.find(item=>item.name=='助听设备').jieguo}}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								验配或开机时间-左耳
							</template>
							{{lcsj_info.erlongshi.find(item=>item.name=='目前配戴助听设备情况').value.find(item=>item.name=='左耳').value.find(item=>item.name=='验配或开机时间').value}}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								验配或开机时间-右耳
							</template>
							{{lcsj_info.erlongshi.find(item=>item.name=='目前配戴助听设备情况').value.find(item=>item.name=='右耳').value.find(item=>item.name=='验配或开机时间').value}}
						</el-descriptions-item>

					</el-descriptions>
					<el-descriptions title="" :column="2" size="" border>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								配戴时间 -左耳
							</template>
							{{lcsj_info.erlongshi.find(item=>item.name=='目前配戴助听设备情况').value.find(item=>item.name=='左耳').value.find(item=>item.name=='佩戴时间').jieguo}}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								原因：
							</template>
							{{lcsj_info.erlongshi.find(item=>item.name=='目前配戴助听设备情况').value.find(item=>item.name=='左耳').value.find(item=>item.name=='佩戴时间').yuanyin}}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								配戴时间 -右耳
							</template>
							{{lcsj_info.erlongshi.find(item=>item.name=='目前配戴助听设备情况').value.find(item=>item.name=='右耳').value.find(item=>item.name=='佩戴时间').jieguo}}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								原因：
							</template>
							{{lcsj_info.erlongshi.find(item=>item.name=='目前配戴助听设备情况').value.find(item=>item.name=='右耳').value.find(item=>item.name=='佩戴时间').yuanyin}}
						</el-descriptions-item>
					</el-descriptions>
					<el-descriptions title="曾去何地诊治" :column="2" size="" border>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								首次医院：
							</template>
							{{lcsj_info.erlongshi.find(item=>item.name=='曾去何地治疗').value.find(item=>item.name=='首次医院').value}}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								就诊时间：
							</template>
							{{lcsj_info.erlongshi.find(item=>item.name=='曾去何地治疗').value.find(item=>item.name=='就诊时间').value}}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								结果-左耳 ABR
							</template>
							{{lcsj_info.erlongshi.find(item=>item.name=='曾去何地治疗').value.find(item=>item.name=='结果').value.find(item=>item.name=='左耳').value}}
							dBHL
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								结果-右耳 ABR
							</template>
							{{lcsj_info.erlongshi.find(item=>item.name=='曾去何地治疗').value.find(item=>item.name=='结果').value.find(item=>item.name=='右耳').value}}
							dBHL
						</el-descriptions-item>
					</el-descriptions>
					<el-descriptions title="" :column="2" size="" border>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								接受语言训练史：
							</template>
							{{lcsj_info.erlongshi.find(item=>item.name=='接受语言训练史').value}}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								耳聋时伴有何其他症状：
							</template>
							{{lcsj_info.erlongshi.find(item=>item.name=='耳聋时伴有何其他症状').value}}
						</el-descriptions-item>
					</el-descriptions>
					<div class="el-descriptions__title margin-top-sm " style="margin-bottom: 20px;">
						家族史
					</div>
					<el-descriptions title="" :column="3" size="" border>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								家族中是否还有耳聋病人：
							</template>
							{{lcsj_info.jiazushi.find(item=>item.name=='家族中是否还有耳聋病人').jieguo}}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								与患者关系：
							</template>
							{{lcsj_info.jiazushi.find(item=>item.name=='与患者关系').value}}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								家族病史备注：
							</template>
							{{lcsj_info.jiazushi.find(item=>item.name=='家族病史备注').value}}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								父母是否近亲结婚：
							</template>
							{{lcsj_info.jiazushi.find(item=>item.name=='父母是否近亲结婚').jieguo}}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								近亲结婚备注：
							</template>
							{{lcsj_info.jiazushi.find(item=>item.name=='近亲结婚备注').value}}
						</el-descriptions-item>
					</el-descriptions>
					<div class="el-descriptions__title margin-top-sm " style="margin-bottom: 20px;">
						妊娠史
					</div>
					<el-descriptions title="" :column="3" size="" border>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								母亲(3—4个月)是否传染病史：
							</template>
							{{lcsj_info.renshenshi.find(item=>item.name=='母亲(3—4个月)是否传染病史').jieguo}}(曾患：({{lcsj_info.renshenshi.find(item=>item.name=='母亲(3—4个月)是否传染病史').neirong}}))
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								母亲是否有耳毒性药物史：
							</template>
							{{lcsj_info.renshenshi.find(item=>item.name=='母亲是否有耳毒性药物史').jieguo}}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								毒性药物：
							</template>
							{{lcsj_info.renshenshi.find(item=>item.name=='毒性药物').jieguo}}(其它：({{lcsj_info.renshenshi.find(item=>item.name=='毒性药物').qita}}))
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								用药原因：
							</template>
							{{lcsj_info.renshenshi.find(item=>item.name=='用药原因').value}}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								用药剂量为：
							</template>
							{{lcsj_info.renshenshi.find(item=>item.name=='用药剂量为').value1}}/次
							{{lcsj_info.renshenshi.find(item=>item.name=='用药剂量为').value2}}次/天
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								有何反应：
							</template>
							{{lcsj_info.renshenshi.find(item=>item.name=='有何反应').value}}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								先兆流产：
							</template>
							{{lcsj_info.renshenshi.find(item=>item.name=='先兆流产').jieguo}}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								先兆流产发生时间：
							</template>
							{{lcsj_info.renshenshi.find(item=>item.name=='先兆流产发生时间：').value}}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								程度：
							</template>
							{{lcsj_info.renshenshi.find(item=>item.name=='程度').jieguo}}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								曾用保胎药：
							</template>
							{{lcsj_info.renshenshi.find(item=>item.name=='曾用保胎药').value}}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								有无子痫（高血压） ：
							</template>
							{{lcsj_info.renshenshi.find(item=>item.name=='有无子痫（高血压）').jieguo}}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								妊娠反应：
							</template>
							{{lcsj_info.renshenshi.find(item=>item.name=='妊娠反应').jieguo}}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								妊娠外伤史：
							</template>
							{{lcsj_info.renshenshi.find(item=>item.name=='妊娠外伤史：').value}}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								妊娠期其他疾病：
							</template>
							{{lcsj_info.renshenshi.find(item=>item.name=='妊娠期其他疾病：').value}}
						</el-descriptions-item>
					</el-descriptions>
					<div class="el-descriptions__title margin-top-sm " style="margin-bottom: 20px;">
						出生史
					</div>
					<el-descriptions title="" :column="3" size="" border>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								妊娠天数
							</template>
							{{lcsj_info.chushengshi.find(item=>item.name=='妊娠天数').value1}}周
							({{lcsj_info.chushengshi.find(item=>item.name=='妊娠天数').value2}}天
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								产次：
							</template>
							{{lcsj_info.chushengshi.find(item=>item.name=='产次').value}}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								分娩方式：
							</template>
							{{lcsj_info.chushengshi.find(item=>item.name=='分娩方式').jieguo}}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								助产方式：
							</template>
							{{lcsj_info.chushengshi.find(item=>item.name=='助产方式').jieguo}}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								产程：
							</template>
							{{lcsj_info.chushengshi.find(item=>item.name=='产程').jieguo}}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								出生时：
							</template>
							{{lcsj_info.chushengshi.find(item=>item.name=='出生时').jieguo}}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								出生时体重：
							</template>
							{{lcsj_info.chushengshi.find(item=>item.name=='出生时体重').value}}
						</el-descriptions-item>
					</el-descriptions>
					<div class="el-descriptions__title margin-top-sm " style="margin-bottom: 20px;">
						个人史
					</div>
					<el-descriptions title="" :column="3" size="" border>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								患过某病
							</template>
							<div style="display: flex; flex-wrap: wrap;">
								<div v-for="(item,index) in lcsj_info.gerenshi.find(item=>item.name=='患过某病').value"
									:key="index">
									<div v-if="item.value!=''">{{item.value}},</div>
								</div>
							</div>
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								患病时情况：
							</template>
							<div style="display: flex; flex-wrap: wrap;">
								<div v-for="(item,index) in lcsj_info.gerenshi.find(item=>item.name=='患病时情况').value"
									:key="index">
									<div v-if="item.value!=''">{{item.value}},</div>
								</div>
							</div>
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								病程及治疗情况：
							</template>
							{{lcsj_info.gerenshi.find(item=>item.name=='病程及治疗情况').value}}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								耳聋前耳中毒药物史：
							</template>
							{{lcsj_info.gerenshi.find(item=>item.name=='耳聋前耳中毒药物史').jieguo}}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								耳中毒药物：
							</template>
							{{lcsj_info.gerenshi.find(item=>item.name=='耳中毒药物').value}}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								用药剂量：
							</template>
							{{lcsj_info.gerenshi.find(item=>item.name=='用药剂量').value}}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								用药原因：
							</template>
							{{lcsj_info.gerenshi.find(item=>item.name=='用药原因').value}}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								用药时间：
							</template>
							{{lcsj_info.gerenshi.find(item=>item.name=='用药时间').value}}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								药物过敏：
							</template>
							{{lcsj_info.gerenshi.find(item=>item.name=='药物过敏').value}}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								平衡障碍：
							</template>
							{{lcsj_info.gerenshi.find(item=>item.name=='平衡障碍').jieguo}}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								全身情况：
							</template>
							{{lcsj_info.gerenshi.find(item=>item.name=='全身情况').jieguo}}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								耳聋治疗情况：
							</template>
							{{lcsj_info.gerenshi.find(item=>item.name=='耳聋治疗情况').jieguo}}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								噪音暴露史：
							</template>
							{{lcsj_info.gerenshi.find(item=>item.name=='噪音暴露史').value}}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								放射线接触：
							</template>
							{{lcsj_info.gerenshi.find(item=>item.name=='放射线接触').jieguo}}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								其他：
							</template>
							{{lcsj_info.gerenshi.find(item=>item.name=='其他').value}}
						</el-descriptions-item>
					</el-descriptions>
					<div class="el-descriptions__title margin-top-sm " style="margin-bottom: 20px;">
						体格检查
					</div>
					<el-descriptions title="" :column="3" size="" border>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								耳部查体：
							</template>
							{{lcsj_info.tigejiancha.find(item=>item.name=='耳部检查').jieguo}}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								发育：
							</template>
							{{lcsj_info.tigejiancha.find(item=>item.name=='发育').jieguo}}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								骨骼：
							</template>
							{{lcsj_info.tigejiancha.find(item=>item.name=='骨骼').jieguo}}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								甲状腺：
							</template>
							{{lcsj_info.tigejiancha.find(item=>item.name=='甲状腺').jieguo}}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								毛发：
							</template>
							{{lcsj_info.tigejiancha.find(item=>item.name=='毛发').jieguo}}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								视力视野：
							</template>
							{{lcsj_info.tigejiancha.find(item=>item.name=='视力视野').jieguo}}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								虹膜：
							</template>
							{{lcsj_info.tigejiancha.find(item=>item.name=='虹膜').jieguo}}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								巩膜：
							</template>
							{{lcsj_info.tigejiancha.find(item=>item.name=='巩膜').jieguo}}
						</el-descriptions-item>
					</el-descriptions>
					<div class="el-descriptions__title margin-top">
						备注
					</div>
					<el-input class="margin-top" style="font-size: 16px;" type="textarea" :rows="3" disabled
						v-model="lcsj_info.beizhu">
					</el-input>
					<el-descriptions title="" :column="3" size="" border>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								填写日期：
							</template>
							{{lcsj_info.date}}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								填写人：
							</template>
							{{lcsj_info.tianxieren}}
						</el-descriptions-item>
					</el-descriptions>
				</div>
			</el-card>
			<div style="height: 50px;width: 200px;"></div>
			<el-card id="id7">
				<div slot="header" class="clearfix">
					<span>诊断记录</span>
				</div>
				<div>
					<div class="el-descriptions__title">
						基本信息
					</div>
					<el-descriptions title="" :column="3" size="" border>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								姓名：
							</template>
							{{zdjl_info.stu_name}}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								性别：
							</template>
							{{zdjl_info.sex}}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								出生年月：
							</template>
							{{zdjl_info.formData.birthday}}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								听障确诊时间：
							</template>
							{{zdjl_info.formData.tingliday}}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								首次佩戴助听设备时间-左耳：
							</template>
							{{zdjl_info.formData.leftshebei}}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								首次佩戴助听设备时间-右耳：
							</template>
							{{zdjl_info.formData.rightshebei}}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								补偿/重建方式-左耳：
							</template>
							{{zdjl_info.formData.leftEar.option}}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								补偿/重建方式-右耳：
							</template>
							{{zdjl_info.formData.rightEar.option}}
						</el-descriptions-item>

					</el-descriptions>
					<el-descriptions title="" :column="3" size="" border>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								设备型号-右耳：
							</template>
							{{zdjl_info.formData.rightEar.deviceModel}}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								程序-右耳：
							</template>
							{{zdjl_info.formData.rightEar.program}}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								音量/敏感度-右耳：
							</template>
							{{zdjl_info.formData.rightEar.volumeSensitivity}}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								设备型号-左耳：
							</template>
							{{zdjl_info.formData.leftEar.deviceModel}}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								程序-左耳：
							</template>
							{{zdjl_info.formData.leftEar.program}}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								音量/敏感度-左耳：
							</template>
							{{zdjl_info.formData.leftEar.program}}
						</el-descriptions-item>
					</el-descriptions>

					<el-descriptions title="" :column="2" size="" border>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								裸耳平均听阈-右耳
							</template>
							{{zdjl_info.formData.rightEar.luoerpingjuntingyu}}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								裸耳平均听阈-左耳
							</template>
							{{zdjl_info.formData.leftEar.luoerpingjuntingyu}}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								助听器效果-右耳：
							</template>
							{{zdjl_info.formData.rightEar.zhutingqixiaoguo}}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								助听器效果-左耳：
							</template>
							{{zdjl_info.formData.leftEar.zhutingqixiaoguo}}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								评估日期
							</template>
							{{zdjl_info.formData.pingguriqi}}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								评估人员：
							</template>
							{{zdjl_info.formData.pinggurenyuan}}
						</el-descriptions-item>
					</el-descriptions>
					<div class="el-descriptions__title">
						检查项目与结果
					</div>
					<div class="el-descriptions__title">
						电生理测试-左耳
					</div>
					<el-table class="margin-top" :data="zdjl_list_assr" border style="width: 100%">
						<el-table-column prop="value" label="项" width="256">
						</el-table-column>
						<el-table-column prop="value" label="0.5KHz" width="180">
							<template slot-scope="data">
								<div>
									{{zdjl_info.testData["左耳"][data.row.key_name].values['0.5KHz']}}
									<!-- {{data.row.key_name}} -->
								</div>
							</template>
						</el-table-column>
						<el-table-column prop="value" label="1KHz" width="180">
							<template slot-scope="data">
								<div>
									{{zdjl_info.testData["左耳"][data.row.key_name].values['1KHz']}}
								</div>
							</template>
						</el-table-column>
						<el-table-column prop="value" label="2KHz" width="180">
							<template slot-scope="data">
								<div>
									{{zdjl_info.testData["左耳"][data.row.key_name].values['2KHz']}}
								</div>
							</template>
						</el-table-column>
						<el-table-column prop="value" label="4KHz" width="180">
							<template slot-scope="data">
								<div>
									{{zdjl_info.testData["左耳"][data.row.key_name].values['4KHz']}}
								</div>
							</template>
						</el-table-column>
						<el-table-column prop="value" label="备注" width="290">
							<template slot-scope="data">
								<div>
									{{zdjl_info.testData["左耳"][data.row.key_name].values['备注']}}
								</div>
							</template>
						</el-table-column>
					</el-table>
					<div class="el-descriptions__title">
						电生理测试-右耳
					</div>
					<el-table class="margin-top" :data="zdjl_list_assr" border style="width: 100%">
						<el-table-column prop="value" label="项" width="256">
						</el-table-column>
						<el-table-column prop="value" label="0.5KHz" width="180">
							<template slot-scope="data">
								<div>
									{{zdjl_info.testData["右耳"][data.row.key_name].values['0.5KHz']}}
									<!-- {{data.row.key_name}} -->
								</div>
							</template>
						</el-table-column>
						<el-table-column prop="value" label="1KHz" width="180">
							<template slot-scope="data">
								<div>
									{{zdjl_info.testData["右耳"][data.row.key_name].values['1KHz']}}
								</div>
							</template>
						</el-table-column>
						<el-table-column prop="value" label="2KHz" width="180">
							<template slot-scope="data">
								<div>
									{{zdjl_info.testData["右耳"][data.row.key_name].values['2KHz']}}
								</div>
							</template>
						</el-table-column>
						<el-table-column prop="value" label="4KHz" width="180">
							<template slot-scope="data">
								<div>
									{{zdjl_info.testData["右耳"][data.row.key_name].values['4KHz']}}
								</div>
							</template>
						</el-table-column>
						<el-table-column prop="value" label="备注" width="290">
							<template slot-scope="data">
								<div>
									{{zdjl_info.testData["右耳"][data.row.key_name].values['备注']}}
								</div>
							</template>
						</el-table-column>
					</el-table>

					<div class="el-descriptions__title">
						言语测听-左耳
					</div>
					<el-table class="margin-top" :data="zdjl_list_yyct" border style="width: 100%">
						<el-table-column prop="value" label="项" width="256">
						</el-table-column>
						<el-table-column prop="value" label="0.5KHz" width="180">
							<template slot-scope="data">
								<div>
									{{zdjl_info.testData["左耳"][data.row.key_name].values['0.5KHz']}}
									<!-- {{data.row.key_name}} -->
								</div>
							</template>
						</el-table-column>
						<el-table-column prop="value" label="1KHz" width="180">
							<template slot-scope="data">
								<div>
									{{zdjl_info.testData["左耳"][data.row.key_name].values['1KHz']}}
								</div>
							</template>
						</el-table-column>
						<el-table-column prop="value" label="2KHz" width="180">
							<template slot-scope="data">
								<div>
									{{zdjl_info.testData["左耳"][data.row.key_name].values['2KHz']}}
								</div>
							</template>
						</el-table-column>
						<el-table-column prop="value" label="4KHz" width="180">
							<template slot-scope="data">
								<div>
									{{zdjl_info.testData["左耳"][data.row.key_name].values['4KHz']}}
								</div>
							</template>
						</el-table-column>
						<el-table-column prop="value" label="备注" width="290">
							<template slot-scope="data">
								<div>
									{{zdjl_info.testData["左耳"][data.row.key_name].values['备注']}}
								</div>
							</template>
						</el-table-column>
					</el-table>
					<div class="el-descriptions__title">
						言语测听-右耳
					</div>
					<el-table class="margin-top" :data="zdjl_list_yyct" border style="width: 100%">
						<el-table-column prop="value" label="项" width="256">
						</el-table-column>
						<el-table-column prop="value" label="0.5KHz" width="180">
							<template slot-scope="data">
								<div>
									{{zdjl_info.testData["右耳"][data.row.key_name].values['0.5KHz']}}
									<!-- {{data.row.key_name}} -->
								</div>
							</template>
						</el-table-column>
						<el-table-column prop="value" label="1KHz" width="180">
							<template slot-scope="data">
								<div>
									{{zdjl_info.testData["右耳"][data.row.key_name].values['1KHz']}}
								</div>
							</template>
						</el-table-column>
						<el-table-column prop="value" label="2KHz" width="180">
							<template slot-scope="data">
								<div>
									{{zdjl_info.testData["右耳"][data.row.key_name].values['2KHz']}}
								</div>
							</template>
						</el-table-column>
						<el-table-column prop="value" label="4KHz" width="180">
							<template slot-scope="data">
								<div>
									{{zdjl_info.testData["右耳"][data.row.key_name].values['4KHz']}}
								</div>
							</template>
						</el-table-column>
						<el-table-column prop="value" label="备注" width="290">
							<template slot-scope="data">
								<div>
									{{zdjl_info.testData["右耳"][data.row.key_name].values['备注']}}
								</div>
							</template>
						</el-table-column>
					</el-table>

					<div class="el-descriptions__title">
						辅助检查-左耳
					</div>
					<el-table class="margin-top" :data="zdjl_list_fzjc" border style="width: 100%">
						<el-table-column prop="value" label="项" width="256">
						</el-table-column>
						<el-table-column prop="value" label="0.5KHz" width="180">
							<template slot-scope="data">
								<div>
									{{zdjl_info.testData["左耳"][data.row.key_name].values['0.5KHz']}}
									<!-- {{data.row.key_name}} -->
								</div>
							</template>
						</el-table-column>
						<el-table-column prop="value" label="1KHz" width="180">
							<template slot-scope="data">
								<div>
									{{zdjl_info.testData["左耳"][data.row.key_name].values['1KHz']}}
								</div>
							</template>
						</el-table-column>
						<el-table-column prop="value" label="2KHz" width="180">
							<template slot-scope="data">
								<div>
									{{zdjl_info.testData["左耳"][data.row.key_name].values['2KHz']}}
								</div>
							</template>
						</el-table-column>
						<el-table-column prop="value" label="4KHz" width="180">
							<template slot-scope="data">
								<div>
									{{zdjl_info.testData["左耳"][data.row.key_name].values['4KHz']}}
								</div>
							</template>
						</el-table-column>
						<el-table-column prop="value" label="备注" width="290">
							<template slot-scope="data">
								<div>
									{{zdjl_info.testData["左耳"][data.row.key_name].values['备注']}}
								</div>
							</template>
						</el-table-column>
					</el-table>
					
					<div class="el-descriptions__title">
						辅助检查-右耳
					</div>
					<el-table class="margin-top" :data="zdjl_list_fzjc" border style="width: 100%">
						<el-table-column prop="value" label="项" width="256">
						</el-table-column>
						<el-table-column prop="value" label="0.5KHz" width="180">
							<template slot-scope="data">
								<div>
									{{zdjl_info.testData["右耳"][data.row.key_name].values['0.5KHz']}}
									<!-- {{data.row.key_name}} -->
								</div>
							</template>
						</el-table-column>
						<el-table-column prop="value" label="1KHz" width="180">
							<template slot-scope="data">
								<div>
									{{zdjl_info.testData["右耳"][data.row.key_name].values['1KHz']}}
								</div>
							</template>
						</el-table-column>
						<el-table-column prop="value" label="2KHz" width="180">
							<template slot-scope="data">
								<div>
									{{zdjl_info.testData["右耳"][data.row.key_name].values['2KHz']}}
								</div>
							</template>
						</el-table-column>
						<el-table-column prop="value" label="4KHz" width="180">
							<template slot-scope="data">
								<div>
									{{zdjl_info.testData["右耳"][data.row.key_name].values['4KHz']}}
								</div>
							</template>
						</el-table-column>
						<el-table-column prop="value" label="备注" width="290">
							<template slot-scope="data">
								<div>
									{{zdjl_info.testData["右耳"][data.row.key_name].values['备注']}}
								</div>
							</template>
						</el-table-column>
					</el-table>
					<div class="el-descriptions__title margin-top">
						诊断
					</div>
					<el-input class="margin-top" style="font-size: 16px;" type="textarea" :rows="3" disabled
						v-model="zdjl_info.formData.zhenduan">
					</el-input>
					<div class="el-descriptions__title margin-top">
						听力师评语
					</div>
					<el-input class="margin-top" style="font-size: 16px;" type="textarea" :rows="3" disabled
						v-model="zdjl_info.formData.pingyu">
					</el-input>
					<el-descriptions title="" :column="3" size="" border>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								填写日期
							</template>
							{{zdjl_info.formData.pingguriqi2}}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								听力师签名：
							</template>
							{{zdjl_info.formData.pinggurenyuan}}
						</el-descriptions-item>
					</el-descriptions>
				</div>
			</el-card>
			<div style="height: 50px;width: 200px;"></div>
			<el-card id="id8">
				<div slot="header" class="clearfix">
					<span>听能服务日志</span>
				</div>
				<div>
					<el-descriptions title="" :column="3" size="" border>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								姓名
							</template>
							{{tnfwrz_info[0].stu_name}}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								性别
							</template>
							{{tnfwrz_info[0].sex}}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								出生年月
							</template>
							{{tnfwrz_info[0].chushenriqi}}
						</el-descriptions-item>
					</el-descriptions>
					<div v-for="(item,index) in tnfwrz_info" :key="index">
						<div class="el-descriptions__title " style="margin-bottom: 10px;">
							第{{`一二三`.charAt(Number.parseInt(item.dijici))}}次
						</div>
						<el-descriptions title="" :column="3" size="" border>
							<el-descriptions-item>
								<template slot="label">
									<i class="el-icon-user"></i>
									时间
								</template>
								{{item.duoxuan.riqi}}
							</el-descriptions-item>
							<el-descriptions-item>
								<template slot="label">
									<i class="el-icon-user"></i>
									工作内容
								</template>
								<div>
									<div v-for="(item_k,index_k) in item.duoxuan.xuanxiang" :key="index_k">
										<span v-if="item_k.value">{{item_k.name}} <span
												v-if="item_k.name=='其他:'">{{item.duoxuan.qita}}</span>,</span>
									</div>
								</div>
							</el-descriptions-item>
							<el-descriptions-item>
								<template slot="label">
									<i class="el-icon-user"></i>
									问题
								</template>
								{{item.tianxie.tianxie_xinxi.find(itemjj=>itemjj.biaoti=="问题").neirong}}
							</el-descriptions-item>
							<el-descriptions-item>
								<template slot="label">
									<i class="el-icon-user"></i>
									处理及结果
								</template>
								{{item.tianxie.tianxie_xinxi.find(itemjj=>itemjj.biaoti=="处理及结果").neirong}}
							</el-descriptions-item>
							<el-descriptions-item>
								<template slot="label">
									<i class="el-icon-user"></i>
									后期观察及反馈
								</template>
								{{item.tianxie.tianxie_xinxi.find(itemjj=>itemjj.biaoti=="后期观察及反馈").neirong}}
							</el-descriptions-item>
							<el-descriptions-item>
								<template slot="label">
									<i class="el-icon-user"></i>
									听力师签名
								</template>
								{{item.tianxie.pinggu.neirong}}
							</el-descriptions-item>
						</el-descriptions>
					</div>
				</div>
			</el-card>
			<div style="height: 50px;width: 200px;"></div>
			<el-card id="id9">
				<div slot="header" class="clearfix">
					<span>成长评价建议</span>
				</div>
				<el-descriptions title="" :column="3" size="" border>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							姓名
						</template>
						{{czpjjy_info.stu_name}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							性别
						</template>
						{{czpjjy_info.sex}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							出生年月
						</template>
						{{czpjjy_info.chushenriqi}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							身高
						</template>
						{{czpjjy_info.shujv.shengao}}厘米
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							体重
						</template>
						{{czpjjy_info.shujv.tizhong}}千克
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							血色素
						</template>
						{{czpjjy_info.shujv.xuesesu}}克
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							牙齿共有龋齿
						</template>
						{{czpjjy_info.shujv.quzhi}}颗
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							牙齿本学期新增龋齿
						</template>
						{{czpjjy_info.shujv.qinzengquzhi}}颗
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							视力-左
						</template>
						{{czpjjy_info.shujv.shili_zuo}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							视力-右
						</template>
						{{czpjjy_info.shujv.shili_you}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							评价
						</template>
						{{czpjjy_info.shujv.pinglun}}
					</el-descriptions-item>
				</el-descriptions>
				<el-descriptions title="五大领域发展现状" :column="2" size="" border>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							领域
						</template>
						健康
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							内容
						</template>
						{{czpjjy_info.shujv.wudalingyv.find(itemll=>itemll.biaoti=="健康：").neirong}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							领域
						</template>
						语言
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							内容
						</template>
						{{czpjjy_info.shujv.wudalingyv.find(itemll=>itemll.biaoti=="语言：").neirong}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							领域
						</template>
						社会
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							内容
						</template>
						{{czpjjy_info.shujv.wudalingyv.find(itemll=>itemll.biaoti=="社会：").neirong}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							领域
						</template>
						科学
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							内容
						</template>
						{{czpjjy_info.shujv.wudalingyv.find(itemll=>itemll.biaoti=="科学：").neirong}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							领域
						</template>
						艺术
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							内容
						</template>
						{{czpjjy_info.shujv.wudalingyv.find(itemll=>itemll.biaoti=="艺术：").neirong}}
					</el-descriptions-item>
				</el-descriptions>
				<el-descriptions title="" :column="2" size="" border>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							备注
						</template>
						{{czpjjy_info.shujv.beizhu}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							建议
						</template>
						{{czpjjy_info.shujv.jianyi}}
					</el-descriptions-item>
				</el-descriptions>
				<el-descriptions title="" :column="2" size="" border>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							评估日期
						</template>
						{{czpjjy_info.shujv.pingguriqi}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							评估教师
						</template>
						{{czpjjy_info.shujv.pinggulaoshi}}
					</el-descriptions-item>
				</el-descriptions>
			</el-card>

			<div style="height: 50px;width: 200px;"></div>
			<el-card id="id10">
				<div slot="header" class="clearfix">
					<span>结案报告</span>
				</div>
				<el-descriptions title="基本信息" :column="4" size="" border>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							姓名
						</template>
						{{jabg_info.stu_name}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							性别
						</template>
						{{jabg_info.sex}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							出生年月
						</template>
						{{jabg_info.chushenriqi}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							身份证号
						</template>
						{{jabg_info.stu_ID}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							户口所在址
						</template>
						{{jabg_info.jibenxinxi.huikousuozaidi.sheng}}省-{{jabg_info.jibenxinxi.huikousuozaidi.shi}}市-{{jabg_info.jibenxinxi.huikousuozaidi.xian}}县
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							民族
						</template>
						{{jabg_info.minzu=="undefined"?"未填写":jabg_info.minzu}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							联系人
						</template>
						{{jabg_info.jibenxinxi.lianxiren}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							联系人关系
						</template>
						{{jabg_info.jibenxinxi.lianxirenguanxi}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							联系电话
						</template>
						{{jabg_info.jibenxinxi.lianxidianhua}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							通讯地址
						</template>
						{{jabg_info.jibenxinxi.tongxundizhi}}
					</el-descriptions-item>
				</el-descriptions>
				<el-descriptions title="助听设备配戴情况" :column="6" size="" border>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							项
						</template>
						左耳
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							补偿/重建方式
						</template>
						{{jabg_info.zhutingshebenpeidaiqingkuang.xunhuan.find(itemkk=>itemkk.biaoti=="左耳").fangshi_jieguo}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							验配/开机时间
						</template>
						{{jabg_info.zhutingshebenpeidaiqingkuang.xunhuan.find(itemkk=>itemkk.biaoti=="左耳").shijian_jieguo}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							型号
						</template>
						{{jabg_info.zhutingshebenpeidaiqingkuang.xunhuan.find(itemkk=>itemkk.biaoti=="左耳").xunhuan.find(item_jj=>item_jj.biaoti=="型号：").jieguo}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							程序
						</template>
						{{jabg_info.zhutingshebenpeidaiqingkuang.xunhuan.find(itemkk=>itemkk.biaoti=="左耳").xunhuan.find(item_jj=>item_jj.biaoti=="程序：").jieguo}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							音量/敏感度
						</template>
						{{jabg_info.zhutingshebenpeidaiqingkuang.xunhuan.find(itemkk=>itemkk.biaoti=="左耳").xunhuan.find(item_jj=>item_jj.biaoti=="音量/敏感度：").jieguo}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							项
						</template>
						右耳
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							补偿/重建方式
						</template>
						{{jabg_info.zhutingshebenpeidaiqingkuang.xunhuan.find(itemkk=>itemkk.biaoti=="右耳").fangshi_jieguo}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							验配/开机时间
						</template>
						{{jabg_info.zhutingshebenpeidaiqingkuang.xunhuan.find(itemkk=>itemkk.biaoti=="右耳").shijian_jieguo}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							型号
						</template>
						{{jabg_info.zhutingshebenpeidaiqingkuang.xunhuan.find(itemkk=>itemkk.biaoti=="右耳").xunhuan.find(item_jj=>item_jj.biaoti=="型号：").jieguo}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							程序
						</template>
						{{jabg_info.zhutingshebenpeidaiqingkuang.xunhuan.find(itemkk=>itemkk.biaoti=="右耳").xunhuan.find(item_jj=>item_jj.biaoti=="程序：").jieguo}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							音量/敏感度
						</template>
						{{jabg_info.zhutingshebenpeidaiqingkuang.xunhuan.find(itemkk=>itemkk.biaoti=="右耳").xunhuan.find(item_jj=>item_jj.biaoti=="音量/敏感度：").jieguo}}
					</el-descriptions-item>
				</el-descriptions>
				<el-descriptions title="评估结果摘要" :column="4" size="" border>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							听力、言语残疾儿童听觉能力评估标准——康复级别
						</template>
						{{jabg_info.pinggujieguozhaiyao.xunhuan1.find(itemhh=>itemhh.biaoti1=="听力、言语残疾儿童听觉能力评估标准——康复级别").biaoti2_jieguo}}级
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							CAP听觉行为分级
						</template>
						{{jabg_info.pinggujieguozhaiyao.xunhuan1.find(itemhh=>itemhh.biaoti3=="CAP听觉行为分级:").biaoti3_jieguo}}级
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							听力、言语残疾儿童言语能力评估标准——康复级别
						</template>
						{{jabg_info.pinggujieguozhaiyao.xunhuan1.find(itemhh=>itemhh.biaoti1=="听力、言语残疾儿童言语能力评估标准——康复级别").biaoti2_jieguo}}级
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							SIR言语可懂度分级
						</template>
						{{jabg_info.pinggujieguozhaiyao.xunhuan1.find(itemhh=>itemhh.biaoti3=="SIR言语可懂度分级::").biaoti3_jieguo}}级
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							格雷费斯儿童精神发育商
						</template>
						{{jabg_info.pinggujieguozhaiyao.xunhuan2.find(itemhh=>itemhh.biaoti1=="格雷费斯儿童精神发育商—— ").biaoti1_jieguo}}级
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							希-内学习能力商
						</template>
						{{jabg_info.pinggujieguozhaiyao.xunhuan2.find(itemhh=>itemhh.biaoti1=="希-内学习能力商——").biaoti1_jieguo}}级
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							智商
						</template>
						{{jabg_info.pinggujieguozhaiyao.xunhuan2.find(itemhh=>itemhh.biaoti1=="智商——").biaoti1_jieguo}}级
					</el-descriptions-item>
				</el-descriptions>
				<el-descriptions title="康复结语" :column="1" size="" border>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							内容
						</template>
						{{jabg_info.pinggujieguozhaiyao.biaoti3_jieguo}}
					</el-descriptions-item>
				</el-descriptions>
				<el-descriptions title="" :column="2" size="" border>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							结案时间
						</template>
						{{jabg_info.jiean.biaoti2_jieguo}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							报告人
						</template>
						{{jabg_info.jiean.biaoti3_jieguo}}
					</el-descriptions-item>
				</el-descriptions>
			</el-card>
			<div style="height: 50px;width: 200px;"></div>
			<el-card id="id11">
				<div slot="header" class="clearfix">
					<span>回访记录</span>
				</div>
				<el-descriptions title="基本资料" :column="4" size="" border>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							姓名
						</template>
						{{hfjl_info.stu_name}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							性别
						</template>
						{{hfjl_info.sex}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							出生年月
						</template>
						{{hfjl_info.chushenriqi}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							离园日期
						</template>
						{{hfjl_info.jibenxinxi.liyuanshijian.jieguo}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							回访对象
						</template>
						{{hfjl_info.jibenxinxi.huifangduixiang.jieguo}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							回访方式
						</template>
						{{hfjl_info.jibenxinxi.huifangfangshi.jieguo}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							回访次数
						</template>
						{{hfjl_info.jibenxinxi.xunhuan.find(itemjj=>itemjj.wenzi=="回访次数:第").neirong}}次
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							联系方式
						</template>
						{{hfjl_info.jibenxinxi.xunhuan.find(itemjj=>itemjj.wenzi=="联系方式:").neirong}}
					</el-descriptions-item>
				</el-descriptions>
				<el-descriptions title="康复走向与机构信息" :column="4" size="" border>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							就读机构及性质
						</template>
						{{hfjl_info.kangfuzouxiang.jiudujigoujixingzhi_jieguo}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							年级
						</template>
						{{hfjl_info.kangfuzouxiang.nianji}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							机构教学方式
						</template>
						{{hfjl_info.kangfuzouxiang.jigoujiaoxuefangshi.jieguo}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							机构支持情况
						</template>
						{{hfjl_info.kangfuzouxiang.jigouzhichiqingkuang.neirong}}
					</el-descriptions-item>
				</el-descriptions>
				<el-descriptions title="" :column="3" size="" border>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							内容
						</template>
						助听设备使用状况
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							每天佩戴助听设备
						</template>
						{{hfjl_info.kangfuzouxiang.zhutingshebeishiyongqingkuang.fenzu1.xuanxiang}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							情况说明
						</template>
						{{hfjl_info.kangfuzouxiang.zhutingshebeishiyongqingkuang.fenzu1.jieguo}}
					</el-descriptions-item>

					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							内容
						</template>
						助听设备使用状况
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							定期维护助听设备
						</template>
						{{hfjl_info.kangfuzouxiang.zhutingshebeishiyongqingkuang.fenzu2.xuanxiang}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							情况说明
						</template>
						调试频率：{{hfjl_info.kangfuzouxiang.zhutingshebeishiyongqingkuang.fenzu2.biaoti3_neirong}}月/次
						----调机地点：{{hfjl_info.kangfuzouxiang.zhutingshebeishiyongqingkuang.fenzu2.biaoti4_neirong}}
					</el-descriptions-item>

					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							内容
						</template>
						助听设备使用状况
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							使用FM系统
						</template>
						{{hfjl_info.kangfuzouxiang.zhutingshebeishiyongqingkuang.fenzu3.xuanxiang}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							情况说明
						</template>
						地点：{{hfjl_info.kangfuzouxiang.zhutingshebeishiyongqingkuang.fenzu3.xuanxiang2}}
					</el-descriptions-item>

					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							内容
						</template>
						康复训练
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							定期做康复训练
						</template>
						{{hfjl_info.kangfuzouxiang.kangfuxunlian.xuanze1}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							情况说明
						</template>
						地点：{{hfjl_info.kangfuzouxiang.kangfuxunlian.xuanze2}}
					</el-descriptions-item>

					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							内容
						</template>
						交流沟通
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							主要的交流沟通方式
						</template>
						{{hfjl_info.kangfuzouxiang.jiaoliugoutong.xuanze.find(itemjj=>itemjj.biaoti=="1.主 要 的 交 流 沟 通 方 式。").jieguo}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							情况说明
						</template>
						{{hfjl_info.kangfuzouxiang.jiaoliugoutong.xuanze.find(itemjj=>itemjj.biaoti=="1.主 要 的 交 流 沟 通 方 式。").qingkuangshuoming_jieguo}}
					</el-descriptions-item>

					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							内容
						</template>
						交流沟通
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							口语表达的清楚程度
						</template>
						{{hfjl_info.kangfuzouxiang.jiaoliugoutong.xuanze.find(itemjj=>itemjj.biaoti=="2.口 语 表 达 的 清 楚 程 度。").jieguo}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							情况说明
						</template>
						{{hfjl_info.kangfuzouxiang.jiaoliugoutong.xuanze.find(itemjj=>itemjj.biaoti=="2.口 语 表 达 的 清 楚 程 度。").qingkuangshuoming_jieguo}}
					</el-descriptions-item>

					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							内容
						</template>
						交流沟通
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							周围人对孩子口语表达能力的评价
						</template>
						{{hfjl_info.kangfuzouxiang.jiaoliugoutong.xuanze.find(itemjj=>itemjj.biaoti=="3.周围人对孩子口语表达能力的评价。").jieguo}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							情况说明
						</template>
						{{hfjl_info.kangfuzouxiang.jiaoliugoutong.xuanze.find(itemjj=>itemjj.biaoti=="3.周围人对孩子口语表达能力的评价。").qingkuangshuoming_jieguo}}
					</el-descriptions-item>

					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							内容
						</template>
						社会适应
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							有好朋友
						</template>
						{{hfjl_info.kangfuzouxiang.shehuishiying.xuanze.find(itemjj=>itemjj.biaoti=="有好朋友。").jieguo}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							情况说明
						</template>
						{{hfjl_info.kangfuzouxiang.shehuishiying.xuanze.find(itemjj=>itemjj.biaoti=="有好朋友。").qingkuangshuoming_jieguo}}
					</el-descriptions-item>

					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							内容
						</template>
						社会适应
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							愿意主动结交新朋友
						</template>
						{{hfjl_info.kangfuzouxiang.shehuishiying.xuanze.find(itemjj=>itemjj.biaoti=="2.愿意主动结交新朋友。").jieguo}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							情况说明
						</template>
						{{hfjl_info.kangfuzouxiang.shehuishiying.xuanze.find(itemjj=>itemjj.biaoti=="2.愿意主动结交新朋友。").qingkuangshuoming_jieguo}}
					</el-descriptions-item>

					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							内容
						</template>
						社会适应
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							经常跟家人、朋友谈论学校或身边发生的事
						</template>
						{{hfjl_info.kangfuzouxiang.shehuishiying.xuanze.find(itemjj=>itemjj.biaoti=="3.经常跟家人、朋友谈论学校或身边发生的事。").jieguo}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							情况说明
						</template>
						{{hfjl_info.kangfuzouxiang.shehuishiying.xuanze.find(itemjj=>itemjj.biaoti=="3.经常跟家人、朋友谈论学校或身边发生的事。").qingkuangshuoming_jieguo}}
					</el-descriptions-item>

					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							内容
						</template>
						学习情况
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							能听懂课堂内容，不需要课后家长或其他人讲解、复习
						</template>
						{{hfjl_info.kangfuzouxiang.xuexiqingkuang.xuanze.find(itemjj=>itemjj.biaoti=="1.能听懂课堂内容，不需要课后家长或其他人讲解、复习。").jieguo}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							情况说明
						</template>
						{{hfjl_info.kangfuzouxiang.xuexiqingkuang.xuanze.find(itemjj=>itemjj.biaoti=="1.能听懂课堂内容，不需要课后家长或其他人讲解、复习。").qingkuangshuoming_jieguo}}
					</el-descriptions-item>

					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							内容
						</template>
						学习情况
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							能认真完成日常作业，不需要成人提供额外帮助
						</template>
						{{hfjl_info.kangfuzouxiang.xuexiqingkuang.xuanze.find(itemjj=>itemjj.biaoti=="2.能认真完成日常作业，不需要成人提供额外帮助。").jieguo}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							情况说明
						</template>
						{{hfjl_info.kangfuzouxiang.xuexiqingkuang.xuanze.find(itemjj=>itemjj.biaoti=="2.能认真完成日常作业，不需要成人提供额外帮助。").qingkuangshuoming_jieguo}}
					</el-descriptions-item>

					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							内容
						</template>
						学习情况
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							学习成绩在班级中的位置
						</template>
						{{hfjl_info.kangfuzouxiang.xuexiqingkuang.xuanze.find(itemjj=>itemjj.biaoti=="3.学习成绩在班级中的位置").jieguo}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							情况说明
						</template>
						{{hfjl_info.kangfuzouxiang.xuexiqingkuang.xuanze.find(itemjj=>itemjj.biaoti=="3.学习成绩在班级中的位置").qingkuangshuoming_jieguo}}
					</el-descriptions-item>

					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							内容
						</template>
						学习情况
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							特长与优势学科
						</template>
						{{hfjl_info.kangfuzouxiang.xuexiqingkuang.xuanze.biaoti2_neirong}}
					</el-descriptions-item>
				</el-descriptions>
				<el-descriptions title="问题及需求" :column="2" size="" border>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							内容
						</template>
						<div style="display: flex; flex-wrap: wrap;">
							<div v-for="(itemyy,indexyy) in hfjl_info.wentijixvqiu.wentijixvqiu_xuanxiang"
								:key="indexyy">
								<span v-if="itemyy.value" style="margin-right: 15px;">
									{{itemyy.name}}<span v-if="itemyy.name=='需要更换助听设备'">
										-类型:{{hfjl_info.wentijixvqiu.wentijixvqiu_danxuan}}
									</span>,
								</span>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							其它：
						</template>
						{{hfjl_info.wentijixvqiu.wentijixvqiu_qita}}
					</el-descriptions-item>

				</el-descriptions>
				<el-descriptions title="" :column="3" size="" border>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							建议
						</template>
						{{hfjl_info.jianyi.jianyi_neirong}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							下次回访须加强追踪的内容
						</template>
						<div style="display: flex; flex-wrap: wrap;">
							<div v-for="(itemyy,indexyy) in hfjl_info.xiacihuifangxvjiaqiang.xiacihuifangxvjiaqiang_duoxuan"
								:key="indexyy">
								<span v-if="itemyy.value" style="margin-right: 15px;">
									{{itemyy.name}}<span v-if="itemyy.name=='需要更换助听设备'">
										-类型:{{hfjl_info.wentijixvqiu.wentijixvqiu_danxuan}}
									</span>,
								</span>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							其它：
						</template>
						{{hfjl_info.xiacihuifangxvjiaqiang.qitajieguo}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							回访时间：
						</template>
						{{hfjl_info.huifang.biaoti2_neirong}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							回访人员：
						</template>
						{{hfjl_info.huifang.biaoti3_neirong}}
					</el-descriptions-item>
				</el-descriptions>
			</el-card>
			<div style="height: 50px;width: 200px;"></div>
			<el-card id="id12">
				<div slot="header" class="clearfix">
					<span>听觉能力评估</span>
				</div>
				<el-descriptions title="" :column="3" size="" border>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							幼儿姓名
						</template>
						{{tjnlpg_info.stu_name}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							出生日期
						</template>
						{{tjnlpg_info.chushenriqi}}
					</el-descriptions-item>
				</el-descriptions>
				<el-descriptions title="" :column="3" size="" border>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							评估内容
						</template>
						自然环境声响识别
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							错误走向记录（正确）——（错误）
						</template>
						{{tjnlpg_info.xunhuan.find(itemgg=>itemgg.biaoti=="自然环境声响识别").xuanxiang.find(itemgg=>itemgg.biaoti=="错误走向记录（正确）——（错误）").neirong}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							最大识别率
						</template>
						{{tjnlpg_info.xunhuan.find(itemgg=>itemgg.biaoti=="自然环境声响识别").xuanxiang.find(itemgg=>itemgg.biaoti=="最大识别率").neirong}}
					</el-descriptions-item>

					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							评估内容
						</template>
						语音识别-韵母识别
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							错误走向记录（正确）——（错误）
						</template>
						{{tjnlpg_info.xunhuan.find(itemgg=>itemgg.biaoti=="语音识别-韵母识别").xuanxiang.find(itemgg=>itemgg.biaoti=="错误走向记录（正确）——（错误）").neirong}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							最大识别率
						</template>
						{{tjnlpg_info.xunhuan.find(itemgg=>itemgg.biaoti=="语音识别-韵母识别").xuanxiang.find(itemgg=>itemgg.biaoti=="最大识别率").neirong}}
					</el-descriptions-item>

					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							评估内容
						</template>
						语音识别-声母识别
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							错误走向记录（正确）——（错误）
						</template>
						{{tjnlpg_info.xunhuan.find(itemgg=>itemgg.biaoti=="语音识别-声母识别").xuanxiang.find(itemgg=>itemgg.biaoti=="错误走向记录（正确）——（错误）").neirong}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							最大识别率
						</template>
						{{tjnlpg_info.xunhuan.find(itemgg=>itemgg.biaoti=="语音识别-声母识别").xuanxiang.find(itemgg=>itemgg.biaoti=="最大识别率").neirong}}
					</el-descriptions-item>

					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							评估内容
						</template>
						声调识别
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							错误走向记录（正确）——（错误）
						</template>
						{{tjnlpg_info.xunhuan.find(itemgg=>itemgg.biaoti=="声调识别").xuanxiang.find(itemgg=>itemgg.biaoti=="错误走向记录（正确）——（错误）").neirong}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							最大识别率
						</template>
						{{tjnlpg_info.xunhuan.find(itemgg=>itemgg.biaoti=="声调识别").xuanxiang.find(itemgg=>itemgg.biaoti=="最大识别率").neirong}}
					</el-descriptions-item>

					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							评估内容
						</template>
						双音节词识别
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							错误走向记录（正确）——（错误）
						</template>
						{{tjnlpg_info.xunhuan.find(itemgg=>itemgg.biaoti=="双音节词识别").xuanxiang.find(itemgg=>itemgg.biaoti=="错误走向记录（正确）——（错误）").neirong}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							最大识别率
						</template>
						{{tjnlpg_info.xunhuan.find(itemgg=>itemgg.biaoti=="双音节词识别").xuanxiang.find(itemgg=>itemgg.biaoti=="最大识别率").neirong}}
					</el-descriptions-item>

					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							评估内容
						</template>
						短句识别
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							错误走向记录（正确）——（错误）
						</template>
						{{tjnlpg_info.xunhuan.find(itemgg=>itemgg.biaoti=="短句识别").xuanxiang.find(itemgg=>itemgg.biaoti=="错误走向记录（正确）——（错误）").neirong}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							最大识别率
						</template>
						{{tjnlpg_info.xunhuan.find(itemgg=>itemgg.biaoti=="短句识别").xuanxiang.find(itemgg=>itemgg.biaoti=="最大识别率").neirong}}
					</el-descriptions-item>

					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							评估内容
						</template>
						选择性听取
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							错误走向记录（正确）——（错误）
						</template>
						{{tjnlpg_info.xunhuan.find(itemgg=>itemgg.biaoti=="选择性听取").xuanxiang.find(itemgg=>itemgg.biaoti=="错误走向记录（正确）——（错误）").neirong}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							最大识别率
						</template>
						{{tjnlpg_info.xunhuan.find(itemgg=>itemgg.biaoti=="选择性听取").xuanxiang.find(itemgg=>itemgg.biaoti=="最大识别率").neirong}}
					</el-descriptions-item>

					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							评估内容
						</template>
						数字识别
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							错误走向记录（正确）——（错误）
						</template>
						{{tjnlpg_info.xunhuan.find(itemgg=>itemgg.biaoti=="数字识别").xuanxiang.find(itemgg=>itemgg.biaoti=="错误走向记录（正确）——（错误）").neirong}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							最大识别率
						</template>
						{{tjnlpg_info.xunhuan.find(itemgg=>itemgg.biaoti=="数字识别").xuanxiang.find(itemgg=>itemgg.biaoti=="最大识别率").neirong}}
					</el-descriptions-item>

					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							评估内容
						</template>
						单音节词（字）识别
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							错误走向记录（正确）——（错误）
						</template>
						{{tjnlpg_info.xunhuan.find(itemgg=>itemgg.biaoti=="单音节词（字）识别").xuanxiang.find(itemgg=>itemgg.biaoti=="错误走向记录（正确）——（错误）").neirong}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							最大识别率
						</template>
						{{tjnlpg_info.xunhuan.find(itemgg=>itemgg.biaoti=="单音节词（字）识别").xuanxiang.find(itemgg=>itemgg.biaoti=="最大识别率").neirong}}
					</el-descriptions-item>

					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							评估内容
						</template>
						三音节词识别
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							错误走向记录（正确）——（错误）
						</template>
						{{tjnlpg_info.xunhuan.find(itemgg=>itemgg.biaoti=="三音节词识别").xuanxiang.find(itemgg=>itemgg.biaoti=="错误走向记录（正确）——（错误）").neirong}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							最大识别率
						</template>
						{{tjnlpg_info.xunhuan.find(itemgg=>itemgg.biaoti=="三音节词识别").xuanxiang.find(itemgg=>itemgg.biaoti=="最大识别率").neirong}}
					</el-descriptions-item>
				</el-descriptions>
				<el-descriptions title="" :column="2" size="" border>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							听觉康复级别
						</template>
						{{tjnlpg_info.tiankong.tingjuekangfujibie_jieguo}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							言语识别平均得分
						</template>
						{{tjnlpg_info.tiankong.yanyvshibiepingjundefen_jieguo}}
					</el-descriptions-item>
				</el-descriptions>
				<el-descriptions title="" :column="2" size="" border>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							康复建议
						</template>
						{{tjnlpg_info.tiankong.kangfujianyi_jieguo}}
					</el-descriptions-item>
				</el-descriptions>
				<el-descriptions title="" :column="2" size="" border>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							评估日期
						</template>
						{{tjnlpg_info.pinggu.biaoti2_jieguo}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							评估人员
						</template>
						{{tjnlpg_info.pinggu.biaoti3_jieguo}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							测试环境
						</template>
						{{tjnlpg_info.pinggu.biaoti4_jieguo}}
					</el-descriptions-item>
				</el-descriptions>
			</el-card>
			<div style="height: 50px;width: 200px;"></div>
			<el-card id="id13">
				<div slot="header" class="clearfix">
					<span>CAP分级表</span>
				</div>
				<el-descriptions title="" :column="3" size="" border>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							幼儿姓名
						</template>
						{{cap_info.stu_name}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							出生日期
						</template>
						{{cap_info.chushenriqi}}
					</el-descriptions-item>
				</el-descriptions>
				<el-table :data="cap_info.awp.lingyv" border style="width: 100%">
					<el-table-column prop="value" label="级别" width="285">
					</el-table-column>
					<el-table-column prop="value3" label="判断标准" width="350">
					</el-table-column>
					<el-table-column prop="value3" label="选择结果" width="345">
						<template slot-scope="scope">
							{{scope.row.value3==cap_info.awp.value2?"✓":''}}
						</template>
					</el-table-column>
				</el-table>
				<el-descriptions title="" :column="4" size="" border>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							级别
						</template>
						{{cap_info.awp.jibie}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							评估日期
						</template>
						{{cap_info.awp.quezhenriqi}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							评估人员
						</template>
						{{cap_info.awp.pinggurenyuan}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							测试环境
						</template>
						{{cap_info.awp.ceshihuanjing}}
					</el-descriptions-item>
				</el-descriptions>
			</el-card>
			<div style="height: 50px;width: 200px;"></div>
			<el-card id="id14">
				<div slot="header" class="clearfix">
					<span>语言能力评估</span>
				</div>
				<el-descriptions title="" :column="3" size="" border>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							幼儿姓名
						</template>
						{{yynlpg_info.stu_name}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							出生日期
						</template>
						{{yynlpg_info.chushenriqi}}
					</el-descriptions-item>
				</el-descriptions>
				<el-table class="" :data="yynlpg_info.xunhuan" border style="width: 100%">
					<el-table-column prop="biaoti" label="评估内容" width="285">
					</el-table-column>
					<el-table-column prop="xuanxiang" label="测试记录" width="350">
						<template slot-scope="scope">
							{{scope.row.xuanxiang.find(item=>item.biaoti=='测试记录').neirong}}
						</template>
					</el-table-column>
					<el-table-column prop="xuanxiang" label="测试结果" width="345">
						<template slot-scope="scope">
							{{scope.row.xuanxiang.find(item=>item.biaoti=='测试结果').neirong}}
						</template>
					</el-table-column>
					<el-table-column prop="xuanxiang" label="语言年龄" width="285">
						<template slot-scope="scope">
							{{scope.row.xuanxiang.find(item=>item.biaoti=='语言年龄').neirong}}
						</template>
					</el-table-column>
				</el-table>
				<el-descriptions title="" :column="3" size="" border>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							语言康复级别
						</template>
						{{yynlpg_info.tiankong.yvyankangfujibie_jieguo}}级
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							平均语言年龄水平
						</template>
						{{yynlpg_info.tiankong.pingjunnianlingshuiping_jieguo}}岁
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							康复建议
						</template>
						{{yynlpg_info.tiankong.kangfujianyi_jieguo}}
					</el-descriptions-item>
				</el-descriptions>
				<el-descriptions title="" :column="3" size="" border>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							评估日期
						</template>
						{{yynlpg_info.pinggu.biaoti2_jieguo}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							评估人员
						</template>
						{{yynlpg_info.pinggu.biaoti3_jieguo}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							测试环境
						</template>
						{{yynlpg_info.pinggu.biaoti4_jieguo}}
					</el-descriptions-item>
				</el-descriptions>
			</el-card>
			<div style="height: 50px;width: 200px;"></div>
			<el-card id="id15">
				<div slot="header" class="clearfix">
					<span>SIR分级表</span>
				</div>
				<el-descriptions title="" :column="3" size="" border>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							幼儿姓名
						</template>
						{{sir_info.stu_name}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							出生日期
						</template>
						{{sir_info.chushenriqi}}
					</el-descriptions-item>
				</el-descriptions>
				<el-table :data="sir_info.awp.lingyv" border style="width: 100%">
					<el-table-column prop="value" label="级别" width="285">
						<template slot-scope="scope">
							{{Number.parseInt(scope.row.value)+1}}
						</template>
					</el-table-column>
					<el-table-column prop="value3" label="判断标准" width="350">
					</el-table-column>
					<el-table-column prop="value3" label="选择结果" width="345">
						<template slot-scope="scope">
							{{scope.row.value3==sir_info.awp.value2?"✓":''}}
						</template>
					</el-table-column>
				</el-table>
				<el-descriptions title="" :column="4" size="" border>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							级别
						</template>
						{{sir_info.awp.jibie}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							评估日期
						</template>
						{{sir_info.awp.quezhenriqi}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							评估人员
						</template>
						{{sir_info.awp.pinggurenyuan}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							测试环境
						</template>
						{{sir_info.awp.ceshihuanjing}}
					</el-descriptions-item>
				</el-descriptions>
			</el-card>

			<div style="height: 50px;width: 200px;"></div>
			<el-card id="id16">
				<div slot="header" class="clearfix">
					<span>格雷费斯报告</span>
				</div>
				<div>
					<el-descriptions title="" :column="5" size="" border>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								姓名
							</template>
							{{glfs_info.stu_name}}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								性别
							</template>
							{{glfs_info.sex}}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								出生日期
							</template>
							{{glfs_info.chushenriqi}}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								出生体重
							</template>
							{{glfs_info.jibenxinxi.xunhuan1.find(itemkk=>itemkk.biaoti=="出生体重:").biaoti_jieguo}}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								孕期
							</template>
							{{glfs_info.jibenxinxi.xunhuan1.find(itemkk=>itemkk.biaoti=="孕期:").biaoti_jieguo}}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								胎
							</template>
							{{glfs_info.jibenxinxi.xunhuan2.find(itemkk=>itemkk.biaoti=="胎:").biaoti_jieguo}}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								产
							</template>
							{{glfs_info.jibenxinxi.xunhuan2.find(itemkk=>itemkk.biaoti=="产:").biaoti_jieguo}}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								顺（难）产
							</template>
							{{glfs_info.jibenxinxi.xunhuan2.find(itemkk=>itemkk.biaoti=="顺（难）产:").biaoti_jieguo}}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								曾患病
							</template>
							{{glfs_info.jibenxinxi.xunhuan3.find(itemkk=>itemkk.biaoti=="曾患病:").biaoti_jieguo}}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								现患病
							</template>
							{{glfs_info.jibenxinxi.xunhuan3.find(itemkk=>itemkk.biaoti=="现患病:").biaoti_jieguo}}
						</el-descriptions-item>
					</el-descriptions>
				</div>

				<div style="margin-top: 30px; margin-bottom: 30px;">
					<el-descriptions title="" :column="5" size="" border>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								父亲
							</template>
							{{glfs_info.jibenxinxi.xunhuan4.find(itemkk=>itemkk.xunhuan[0].biaoti=="父亲:").xunhuan.find(itemll=>itemll.biaoti=="父亲:").biaoti_jieguo}}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								民族
							</template>
							{{glfs_info.jibenxinxi.xunhuan4.find(itemkk=>itemkk.xunhuan[0].biaoti=="父亲:").xunhuan.find(itemll=>itemll.biaoti=="民族:").biaoti_jieguo}}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								职业
							</template>
							{{glfs_info.jibenxinxi.xunhuan4.find(itemkk=>itemkk.xunhuan[0].biaoti=="父亲:").xunhuan.find(itemll=>itemll.biaoti=="职业:").biaoti_jieguo}}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								文化程度
							</template>
							{{glfs_info.jibenxinxi.xunhuan4.find(itemkk=>itemkk.xunhuan[0].biaoti=="父亲:").xunhuan.find(itemll=>itemll.biaoti=="文化程度:").biaoti_jieguo}}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								儿童出生时年龄
							</template>
							{{glfs_info.jibenxinxi.xunhuan4.find(itemkk=>itemkk.xunhuan[0].biaoti=="父亲:").xunhuan.find(itemll=>itemll.biaoti=="儿童出生时年龄:").biaoti_jieguo}}
						</el-descriptions-item>

						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								母亲
							</template>
							{{glfs_info.jibenxinxi.xunhuan4.find(itemkk=>itemkk.xunhuan[0].biaoti=="母亲:").xunhuan.find(itemll=>itemll.biaoti=="母亲:").biaoti_jieguo}}
						</el-descriptions-item> <el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								民族
							</template>
							{{glfs_info.jibenxinxi.xunhuan4.find(itemkk=>itemkk.xunhuan[0].biaoti=="母亲:").xunhuan.find(itemll=>itemll.biaoti=="民族:").biaoti_jieguo}}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								职业
							</template>
							{{glfs_info.jibenxinxi.xunhuan4.find(itemkk=>itemkk.xunhuan[0].biaoti=="母亲:").xunhuan.find(itemll=>itemll.biaoti=="职业:").biaoti_jieguo}}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								文化程度
							</template>
							{{glfs_info.jibenxinxi.xunhuan4.find(itemkk=>itemkk.xunhuan[0].biaoti=="母亲:").xunhuan.find(itemll=>itemll.biaoti=="文化程度:").biaoti_jieguo}}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								儿童出生时年龄
							</template>
							{{glfs_info.jibenxinxi.xunhuan4.find(itemkk=>itemkk.xunhuan[0].biaoti=="母亲:").xunhuan.find(itemll=>itemll.biaoti=="儿童出生时年龄:").biaoti_jieguo}}
						</el-descriptions-item>
					</el-descriptions>
				</div>
				<div style="display: flex; justify-content: space-between;">
					<div ref="main" class="container"></div>
					<div>
						<el-descriptions title="" :column="3" size="" border>
							<el-descriptions-item>
								<template slot="label">
									<i class="el-icon-user"></i>
									领域
								</template>
								运动
							</el-descriptions-item>
							<el-descriptions-item>
								<template slot="label">
									<i class="el-icon-user"></i>
									智龄（月）
								</template>
								{{glfs_info.xunhuan.find(itemkk=>itemkk.biaoti=="运动").jieguo1}}月
							</el-descriptions-item>
							<el-descriptions-item>
								<template slot="label">
									<i class="el-icon-user"></i>
									发育商
								</template>
								{{glfs_info.chucun[0]}}
							</el-descriptions-item>

							<el-descriptions-item>
								<template slot="label">
									<i class="el-icon-user"></i>
									领域
								</template>
								社交
							</el-descriptions-item>
							<el-descriptions-item>
								<template slot="label">
									<i class="el-icon-user"></i>
									智龄（月）
								</template>
								{{glfs_info.xunhuan.find(itemkk=>itemkk.biaoti=="社交").jieguo1}}月
							</el-descriptions-item>
							<el-descriptions-item>
								<template slot="label">
									<i class="el-icon-user"></i>
									发育商
								</template>
								{{glfs_info.chucun[1]}}
							</el-descriptions-item>

							<el-descriptions-item>
								<template slot="label">
									<i class="el-icon-user"></i>
									领域
								</template>
								听力言语
							</el-descriptions-item>
							<el-descriptions-item>
								<template slot="label">
									<i class="el-icon-user"></i>
									智龄（月）
								</template>
								{{glfs_info.xunhuan.find(itemkk=>itemkk.biaoti=="听力言语").jieguo1}}月
							</el-descriptions-item>
							<el-descriptions-item>
								<template slot="label">
									<i class="el-icon-user"></i>
									发育商
								</template>
								{{glfs_info.chucun[2]}}
							</el-descriptions-item>

							<el-descriptions-item>
								<template slot="label">
									<i class="el-icon-user"></i>
									领域
								</template>
								手眼协调
							</el-descriptions-item>
							<el-descriptions-item>
								<template slot="label">
									<i class="el-icon-user"></i>
									智龄（月）
								</template>
								{{glfs_info.xunhuan.find(itemkk=>itemkk.biaoti=="手眼协调").jieguo1}}月
							</el-descriptions-item>
							<el-descriptions-item>
								<template slot="label">
									<i class="el-icon-user"></i>
									发育商
								</template>
								{{glfs_info.chucun[3]}}
							</el-descriptions-item>

							<el-descriptions-item>
								<template slot="label">
									<i class="el-icon-user"></i>
									领域
								</template>
								操作
							</el-descriptions-item>
							<el-descriptions-item>
								<template slot="label">
									<i class="el-icon-user"></i>
									智龄（月）
								</template>
								{{glfs_info.xunhuan.find(itemkk=>itemkk.biaoti=="操作").jieguo1}}月
							</el-descriptions-item>
							<el-descriptions-item>
								<template slot="label">
									<i class="el-icon-user"></i>
									发育商
								</template>
								{{glfs_info.chucun[4]}}
							</el-descriptions-item>

							<el-descriptions-item>
								<template slot="label">
									<i class="el-icon-user"></i>
									领域
								</template>
								推理
							</el-descriptions-item>
							<el-descriptions-item>
								<template slot="label">
									<i class="el-icon-user"></i>
									智龄（月）
								</template>
								{{glfs_info.xunhuan.find(itemkk=>itemkk.biaoti=="推理").jieguo1}}月
							</el-descriptions-item>
							<el-descriptions-item>
								<template slot="label">
									<i class="el-icon-user"></i>
									发育商
								</template>
								{{glfs_info.chucun[5]}}
							</el-descriptions-item>

							<el-descriptions-item>
								<template slot="label">
									<i class="el-icon-user"></i>
									领域
								</template>
								总计
							</el-descriptions-item>
							<el-descriptions-item>
								<template slot="label">
									<i class="el-icon-user"></i>
									智龄（月）
								</template>
								{{sum_yue}}月
							</el-descriptions-item>
							<el-descriptions-item>
								<template slot="label">
									<i class="el-icon-user"></i>
									发育商
								</template>
								{{sum}}
							</el-descriptions-item>
						</el-descriptions>
						<div class="el-descriptions__title margin-top">
							分析与建议
						</div>
						<el-input class="margin-top" style="font-size: 16px;" type="textarea" :rows="6" disabled
							v-model="glfs_info.beizhu.biaoti_jieguo">
						</el-input>
					</div>
				</div>

				<el-descriptions title="" :column="4" size="" border>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							评估日期
						</template>
						{{glfs_info.pinggu.pinggu_riqi}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							评估人员
						</template>
						{{glfs_info.pinggu.pinggu_renyuan}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							测试环境
						</template>
						{{glfs_info.pinggu.ceshi_huanjing}}
					</el-descriptions-item>
				</el-descriptions>

			</el-card>
			<div style="height: 50px;width: 200px;"></div>
			<el-card id="id17">
				<div slot="header" class="clearfix">
					<span>希一内报告单</span>
				</div>
				<div style="display: flex;justify-content: space-between;">
					<div ref="main_1" class="container"></div>
					<div>
						<el-descriptions title="" :column="2" size="" border>
							<el-descriptions-item>
								<template slot="label">
									<i class="el-icon-user"></i>
									姓名
								</template>
								{{xybgd_info.stu_name}}
							</el-descriptions-item>
							<el-descriptions-item>
								<template slot="label">
									<i class="el-icon-user"></i>
									性别
								</template>
								{{xybgd_info.sex}}
							</el-descriptions-item>
							<el-descriptions-item>
								<template slot="label">
									<i class="el-icon-user"></i>
									出生日期
								</template>
								{{xybgd_info.chushenriqi}}
							</el-descriptions-item>

							<el-descriptions-item>
								<template slot="label">
									<i class="el-icon-user"></i>
									实际年龄
								</template>
								{{xybgd_info.chucunsujv.chucun2[0]}}岁
							</el-descriptions-item>
							<el-descriptions-item>
								<template slot="label">
									<i class="el-icon-user"></i>
									中位数智龄
								</template>
								{{xybgd_info.chucunsujv.chucun2[1]}}岁
							</el-descriptions-item>
							<el-descriptions-item>
								<template slot="label">
									<i class="el-icon-user"></i>
									智商/学习能力商
								</template>
								{{xybgd_info.chucunsujv.chucun2[2]}}
							</el-descriptions-item>
							<el-descriptions-item>
								<template slot="label">
									<i class="el-icon-user"></i>
									百分位数
								</template>
								{{xybgd_info.chucunsujv.chucun2[3]}}
							</el-descriptions-item>
						</el-descriptions>
						<div class="el-descriptions__title margin-top">
							分析与建议
						</div>
						<el-input class="margin-top" style="font-size: 16px;" type="textarea" :rows="25" disabled
							v-model="xybgd_info.beizhu.biaoti_jieguo">
						</el-input>

					</div>
				</div>
				<el-descriptions title="" :column="3" size="" border>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							评估日期
						</template>
						{{xybgd_info.pinggu.pinggu_riqi}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							评估人员
						</template>
						{{xybgd_info.pinggu.pinggu_renyuan}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							测试环境
						</template>
						{{xybgd_info.pinggu.ceshi_huanjing}}
					</el-descriptions-item>
				</el-descriptions>
			</el-card>

			<div style="height: 50px;width: 200px;"></div>
			<el-card id="id18">
				<div slot="header" class="clearfix">
					<span>特殊病案会诊</span>
				</div>
				<el-descriptions title="" :column="2" size="" border>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							病案姓名
						</template>
						{{tsbahz_info.stu_name}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							会诊时间
						</template>
						{{tsbahz_info.teshubinganhuihzhenjilu.huizhenshijian}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							主要照顾者描述
						</template>
						{{tsbahz_info.teshubinganhuihzhenjilu.teshubinganhuihzhenjilu.find(itemkk=>itemkk.value=="主要照顾者描述").value2}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							个别化教师描述
						</template>
						{{tsbahz_info.teshubinganhuihzhenjilu.teshubinganhuihzhenjilu.find(itemkk=>itemkk.value=="个别化教师描述").value2}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							集体教师描述
						</template>
						{{tsbahz_info.teshubinganhuihzhenjilu.teshubinganhuihzhenjilu.find(itemkk=>itemkk.value=="集体教师描述").value2}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							听力师描述
						</template>
						{{tsbahz_info.teshubinganhuihzhenjilu.teshubinganhuihzhenjilu.find(itemkk=>itemkk.value=="听力师描述").value2}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							专家会诊意见
						</template>
						{{tsbahz_info.teshubinganhuihzhenjilu.teshubinganhuihzhenjilu.find(itemkk=>itemkk.value=="专家会诊意见").value2}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							会诊专家
						</template>
						{{tsbahz_info.teshubinganhuihzhenjilu.teshubinganhuihzhenjilu.find(itemkk=>itemkk.value=="会诊专家").value2}}
					</el-descriptions-item>
				</el-descriptions>
			</el-card>
			<div style="height: 50px;width: 200px;"></div>

		</div>
		<div class="rbuttong">
			<el-date-picker style="width: 8vw; margin-right: -15px;" v-model="date_time_year" type="year"
				placeholder="切换年份">
			</el-date-picker>
			<el-button @click="scrollT('id1')"
				style="margin-right: -15px; width: 8vw;margin-top: 10px;margin-left: 0px;">基本资料信息</el-button>
			<el-button @click="scrollT('id2')"
				style="margin-right: -15px; width: 8vw;margin-top: 10px;margin-left: 0px;"
				class="rbtn">首次评估表</el-button>
			<el-button @click="scrollT('id3')"
				style="margin-right: -15px; width: 8vw;margin-top: 10px;margin-left: 0px;"
				class="rbtn">持续评估表</el-button>
			<el-button @click="scrollT('id4')"
				style="margin-right: -15px; width: 8vw;margin-top: 10px;margin-left: 0px;">教学计划</el-button>
			<el-button @click="scrollT('id5')"
				style="margin-right: -15px; width: 8vw;margin-top: 10px;margin-left: 0px;"
				class="rbtn">日常教学记录</el-button>
			<el-button @click="scrollT('id6')"
				style="margin-right: -15px; width: 8vw;margin-top: 10px;margin-left: 0px;" class="rbtn">临床数据</el-button>
			<el-button @click="scrollT('id7')"
				style="margin-right: -15px; width: 8vw;margin-top: 10px;margin-left: 0px;" class="rbtn">诊断记录</el-button>
			<el-button @click="scrollT('id8')"
				style="margin-right: -15px; width: 8vw;margin-top: 10px;margin-left: 0px;"
				class="rbtn">听能服务日志</el-button>
			<el-button @click="scrollT('id9')"
				style="margin-right: -15px; width: 8vw;margin-top: 10px;margin-left: 0px;"
				class="rbtn">成长评价建议</el-button>
			<el-button @click="scrollT('id10')"
				style="margin-right: -15px; width: 8vw;margin-top: 10px;margin-left: 0px;" class="rbtn">结案报告</el-button>
			<el-button @click="scrollT('id11')"
				style="margin-right: -15px; width: 8vw;margin-top: 10px;margin-left: 0px;" class="rbtn">回访记录</el-button>
			<el-button @click="scrollT('id12')"
				style="margin-right: -15px; width: 8vw;margin-top: 10px;margin-left: 0px;"
				class="rbtn">听觉能力评估</el-button>
			<el-button @click="scrollT('id13')"
				style="margin-right: -15px; width: 8vw;margin-top: 10px;margin-left: 0px;"
				class="rbtn">CAP分级表</el-button>
			<el-button @click="scrollT('id14')"
				style="margin-right: -15px; width: 8vw;margin-top: 10px;margin-left: 0px;"
				class="rbtn">语言能力评估</el-button>
			<el-button @click="scrollT('id15')"
				style="margin-right: -15px; width: 8vw;margin-top: 10px;margin-left: 0px;"
				class="rbtn">SIR分级表</el-button>
			<el-button @click="scrollT('id16')"
				style="margin-right: -15px; width: 8vw;margin-top: 10px;margin-left: 0px;"
				class="rbtn">格雷费斯报告</el-button>
			<el-button @click="scrollT('id17')"
				style="margin-right: -15px; width: 8vw;margin-top: 10px;margin-left: 0px;"
				class="rbtn">希一内报告单</el-button>
			<el-button @click="scrollT('id18')"
				style="margin-right: -15px; width: 8vw;margin-top: 10px;margin-left: 0px;"
				class="rbtn">特殊病案会诊</el-button>
			<!-- <el-button @click="scrollT('id19')"
				style="margin-right: -15px; width: 8vw;margin-top: 10px;margin-left: 0px;" class="rbtn">家长培训</el-button> -->
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				stu_id: null,
				stu_type: "",
				stu_name: '',
				org_id: null,
				year: new Date().getFullYear(),
				date_time_year: new Date(),
				newProgress: "",
				newProgress1: "",
				zdjl_list_yyct: [{
						value: "言语识别阈测试（SRT）",
						key_name: 'SRT'
					},
					{
						value: "言语识别率（SRS）",
						key_name: 'SRS'
					},
					{
						value: "言语察觉阈（SDT）",
						key_name: 'SDT'
					},
					{
						value: "真耳测试",
						key_name: 'zhener'
					},
					{
						value: "助听设备性能检测",
						key_name: 'shebei'
					},
				],
				zdjl_list_fzjc: [{
						value: "影像学检查",
						key_name: 'yingxiangxue'
					},
					{
						value: "基因检测",
						key_name: 'jiyin'
					}, {
						value: "其他",
						key_name: 'qita'
					},
				],
				zdjl_list_assr: [{
						value: "听觉稳态电位测试（ASSR）",
						key_name: 'assr'
					},
					{
						value: "ToneburstABR（dBnHL）",
						key_name: 'abr'
					},
					{
						value: "脑干诱发电位（Click ABR dBnHL）",
						key_name: 'naogan'
					},
					{
						value: "瞬态诱发耳声发射测试（TEOAE）",
						key_name: 'TEOAE'
					},
					{
						value: "畸变产物耳声发射测试（DPOAE）",
						key_name: 'DPOAE'
					},
					{
						value: "声导抗测试（IMMITTANCE）",
						key_name: 'IMMITTANCE'
					},
					{
						value: "微音器电位测试（CM）",
						key_name: 'CM'
					},
					{
						value: "事件相关电位测试（ERP）",
						key_name: 'ERP'
					}
				],
				zdjl_list_titel: [{
					value: "0.5KHz"
				}, {
					value: "1KHz"
				}, {
					value: "2KHz"
				}, {
					value: "4KHz"
				}, {
					value: "备注"
				}],
				liuyin_list: [{
						value: "12cm"
					},
					{
						value: "50cm"
					},
					{
						value: "1m"
					},
					{
						value: "2m"
					}
				],
				// 基本资料信息
				stu_info_tlyy: {
					stu_info_jbxx: {

					},
					family_zhuangkuang: {

					},
					ruyuan_info: {

					}
				},
				// 临床数据
				lcsj_info: {
					gerenshi: [{
							"name": "患过某病",
							"value": [{
									"name": "脑膜炎 ",
									"value": ""
								},
								{
									"name": "斑疹伤寒",
									"value": ""
								},
								{
									"name": "大脑炎 ",
									"value": ""
								},
								{
									"name": "伤寒",
									"value": ""
								},
								{
									"name": "麻疹",
									"value": ""
								},
								{
									"name": "流感 ",
									"value": ""
								},
								{
									"name": "肝炎 ",
									"value": ""
								},
								{
									"name": "猩红热",
									"value": ""
								},
								{
									"name": "腮腺炎",
									"value": ""
								},
								{
									"name": "小儿麻疹",
									"value": ""
								},
								{
									"name": "百日咳 ",
									"value": ""
								},
								{
									"name": "风疹 ",
									"value": ""
								},
								{
									"name": "水痘",
									"value": ""
								},
								{
									"name": "肺炎",
									"value": ""
								},
								{
									"name": "疟疾  ",
									"value": ""
								},
								{
									"name": "腹泻",
									"value": ""
								},
								{
									"name": "中耳炎",
									"value": ""
								},
								{
									"name": "黄疽",
									"value": ""
								},
								{
									"name": "其他",
									"value": ""
								}
							]
						},
						{
							"name": "患病时情况",
							"value": [{
									"name": "发热",
									"value": ""
								},
								{
									"name": "惊厥",
									"value": ""
								},
								{
									"name": "冲突",
									"value": ""
								},
								{
									"name": "其他",
									"value": ""
								}
							]
						},
						{
							"name": "病程及治疗情况",
							"value": ""
						},
						{
							"name": "耳聋前耳中毒药物史",
							"value": [
								"无",
								"不清楚",
								"有"
							],
							"jieguo": ""
						},
						{
							"name": "耳中毒药物",
							"value": ""
						},
						{
							"name": "用药原因",
							"value": ""
						},
						{
							"name": "用药剂量",
							"value": ""
						},
						{
							"name": "用药时间",
							"value": "请选择"
						},
						{
							"name": "药物过敏",
							"value": ""
						},
						{
							"name": "平衡障碍",
							"value": [
								"无",
								"有"
							],
							"jieguo": ""
						},
						{
							"name": "全身情况",
							"value": [
								"好",
								"一般",
								"差"
							],
							"jieguo": ""
						},
						{
							"name": "耳聋治疗情况",
							"value": [
								"无",
								"有"
							],
							"jieguo": ""
						},
						{
							"name": "噪音暴露史",
							"value": ""
						},
						{
							"name": "放射线接触",
							"value": [
								"无",
								"有"
							],
							"jieguo": ""
						},
						{
							"name": "其他",
							"value": ""
						}
					],
					chushengshi: [{
							"name": "妊娠天数",
							"value1": "",
							"value2": ""
						},
						{
							"name": "产次",
							"value": ""
						},
						{
							"name": "助产方式",
							"value": [
								"产钳",
								"剖腹产",
								"牵引产"
							],
							"jieguo": ""
						},
						{
							"name": "出生时",
							"value": [
								"缺氧",
								"窒息",
								"宫内窘迫"
							],
							"jieguo": ""
						},
						{
							"name": "分娩方式",
							"value": [
								"顺产",
								"早产",
								"难产"
							],
							"jieguo": ""
						},
						{
							"name": "产程",
							"value": [
								"正常",
								"长",
								"短"
							],
							"jieguo": ""
						},
						{
							"name": "出生时体重",
							"value": ""
						}
					],
					jiazushi: [{
							"name": "家族中是否还有耳聋病人",
							"value": [
								"是（选择是时，需要填写以下2项）",
								"否"
							],
							"jieguo": ""
						},
						{
							"name": "与患者关系",
							"value": ""
						},
						{
							"name": "家族病史备注",
							"value": ""
						},
						{
							"name": "父母是否近亲结婚",
							"value": [
								"是（选择是时，需要填写以下1项）",
								"否"
							],
							"jieguo": ""
						},
						{
							"name": "近亲结婚备注",
							"value": ""
						}
					],
					renshenshi: [{
							"name": "母亲(3—4个月)是否传染病史",
							"value": [
								"是，曾患：",
								"否"
							],
							"jieguo": "",
							"neirong": ""
						},
						{
							"name": "母亲是否有耳毒性药物史",
							"value": [
								"否",
								"是(选择有时，需要填写以下信息)"
							],
							"jieguo": ""
						},
						{
							"name": "毒性药物",
							"value": [
								"链霉素",
								"庆大霉索",
								"卡那霉素",
								"新霉素",
								"其他："
							],
							"jieguo": "",
							"qita": ""
						},
						{
							"name": "用药原因",
							"value": ""
						},
						{
							"name": "用药剂量为",
							"value1": "",
							"value2": ""
						},
						{
							"name": "有何反应",
							"value": ""
						},
						{
							"name": "先兆流产",
							"value": [
								"有（选择有时，需要填写以下信息",
								"无"
							],
							"jieguo": ""
						},
						{
							"name": "先兆流产发生时间：",
							"value": "请选择"
						},
						{
							"name": "程度",
							"value": [
								"轻",
								"中",
								"重"
							],
							"jieguo": ""
						},
						{
							"name": "曾用保胎药",
							"value": ""
						},
						{
							"name": "有无子痫（高血压）",
							"value": [
								"有",
								"无"
							],
							"jieguo": ""
						},
						{
							"name": "妊娠反应",
							"value": [
								"重",
								"中",
								"轻",
								"无反应"
							],
							"jieguo": ""
						},
						{
							"name": "妊娠外伤史：",
							"value": ""
						},
						{
							"name": "妊娠期其他疾病：",
							"value": ""
						}
					],
					tigejiancha: [{
							"name": "耳部检查",
							"value": [
								"异常",
								"正常"
							],
							"jieguo": ""
						},
						{
							"name": "发育",
							"value": [
								"异常",
								"正常"
							],
							"jieguo": ""
						},
						{
							"name": "骨骼",
							"value": [
								"异常",
								"正常"
							],
							"jieguo": ""
						},
						{
							"name": "甲状腺",
							"value": [
								"异常",
								"正常"
							],
							"jieguo": ""
						},
						{
							"name": "毛发",
							"value": [
								"异常",
								"正常"
							],
							"jieguo": ""
						},
						{
							"name": "视力视野",
							"value": [
								"异常",
								"正常"
							],
							"jieguo": ""
						},
						{
							"name": "虹膜",
							"value": [
								"异常",
								"正常"
							],
							"jieguo": ""
						},
						{
							"name": "巩膜",
							"value": [
								"异常",
								"正常"
							],
							"jieguo": ""
						}
					],
					erlongshi: [{
							"name": "何时出现耳聋",
							"value": [
								"自幼听力正常，言语障碍",
								"出生后正常听力——后听力逐渐障碍",
								"自幼言语不清，听力略障碍",
								"自幼听力言语障碍"
							],
							"jieguo": ""
						},
						{
							"name": "何时发现耳聋",
							"value": [{
								"name": "发现耳聋时间：",
								"value": ""
							}]
						},
						{
							"name": "可听见何种声音",
							"value": [{
									"name": "打雷声",
									"value": ""
								},
								{
									"name": "鞭炮声",
									"value": ""
								},
								{
									"name": "汽车喇叭声",
									"value": [
										"汽车喇叭声"
									]
								},
								{
									"name": "大声说话",
									"value": ""
								},
								{
									"name": "拍手声",
									"value": [
										"拍手声"
									]
								},
								{
									"name": "普通讲话声",
									"value": [
										"普通讲话声"
									]
								},
								{
									"name": "其他",
									"value": ""
								}
							]
						},
						{
							"name": "目前配戴助听设备情况",
							"value": [{
									"name": "左耳",
									"value": [{
											"name": "助听设备",
											"jieguo": "",
											"value": [
												"助听器",
												"人工耳蜗",
												"其它"
											]
										},
										{
											"name": "验配或开机时间",
											"value": "请选择"
										},
										{
											"name": "佩戴时间",
											"jieguo": "",
											"yuanyin": "",
											"value": [
												"能持续佩戴",
												"除睡觉洗澡等外的时间都可以全天配戴",
												"其他",
												"不能持续佩戴"
											]
										}
									]
								},
								{
									"name": "右耳",
									"value": [{
											"name": "助听设备",
											"jieguo": "",
											"value": [
												"助听器",
												"人工耳蜗",
												"其它"
											]
										},
										{
											"name": "验配或开机时间",
											"value": "请选择"
										},
										{
											"name": "佩戴时间",
											"jieguo": "",
											"yuanyin": "",
											"value": [
												"能持续佩戴",
												"除睡觉洗澡等外的时间都可以全天配戴",
												"其他",
												"不能持续佩戴"
											]
										}
									]
								}
							]
						},
						{
							"name": "曾去何地治疗",
							"value": [{
									"name": "首次医院",
									"value": ""
								},
								{
									"name": "就诊时间",
									"value": "请选择"
								},
								{
									"name": "结果",
									"value": [{
											"name": "左耳",
											"value": ""
										},
										{
											"name": "右耳",
											"value": ""
										}
									]
								}
							]
						},
						{
							"name": "接受语言训练史",
							"value": ""
						},
						{
							"name": "耳聋时伴有何其他症状",
							"value": ""
						}
					],
				},
				// 日常教学记录
				rcjxjh_info: {
					"b_id": 49,
					"stu_id": 2227,
					"tea_id": 979,
					"tea_name": "",
					"stu_name": "",
					"age": "",
					"sex": "",
					"ztq_pd": "",
					"cg": {
						"neirong": {
							"ztq_zt": {
								"value": "",
								"bc": ""
							},
							"six_yin": {
								"cj": {
									"value": [{
											"name": "一次",
											"value": [{
													"name": "a",
													"value": ""
												},
												{
													"name": "i",
													"value": ""
												},
												{
													"name": "u",
													"value": ""
												},
												{
													"name": "sh",
													"value": ""
												},
												{
													"name": "s",
													"value": ""
												},
												{
													"name": "m",
													"value": ""
												}
											]
										},
										{
											"name": "二次",
											"value": [{
													"name": "a",
													"value": ""
												},
												{
													"name": "i",
													"value": ""
												},
												{
													"name": "u",
													"value": ""
												},
												{
													"name": "sh",
													"value": ""
												},
												{
													"name": "s",
													"value": ""
												},
												{
													"name": "m",
													"value": ""
												}
											]
										},
										{
											"name": "三次",
											"value": [{
													"name": "a",
													"value": ""
												},
												{
													"name": "i",
													"value": ""
												},
												{
													"name": "u",
													"value": ""
												},
												{
													"name": "sh",
													"value": ""
												},
												{
													"name": "s",
													"value": ""
												},
												{
													"name": "m",
													"value": ""
												}
											]
										}
									],
									"jl": null
								},
								"bs": {
									"value": [{
											"name": "一次",
											"value": [{
													"name": "a",
													"value": ""
												},
												{
													"name": "i",
													"value": ""
												},
												{
													"name": "u",
													"value": ""
												},
												{
													"name": "sh",
													"value": ""
												},
												{
													"name": "s",
													"value": ""
												},
												{
													"name": "m",
													"value": ""
												}
											]
										},
										{
											"name": "二次",
											"value": [{
													"name": "a",
													"value": ""
												},
												{
													"name": "i",
													"value": ""
												},
												{
													"name": "u",
													"value": ""
												},
												{
													"name": "sh",
													"value": ""
												},
												{
													"name": "s",
													"value": ""
												},
												{
													"name": "m",
													"value": ""
												}
											]
										},
										{
											"name": "三次",
											"value": [{
													"name": "a",
													"value": ""
												},
												{
													"name": "i",
													"value": ""
												},
												{
													"name": "u",
													"value": ""
												},
												{
													"name": "sh",
													"value": ""
												},
												{
													"name": "s",
													"value": ""
												},
												{
													"name": "m",
													"value": ""
												}
											]
										}
									],
									"jl": null
								}
							}
						},
						"bz": ""
					},
					"tnfz": {
						"neirong": [{
							"text": "",
							"value": ""
						}],
						"bz": ""
					},
					"yyfz1": {
						"neirong": [{
							"text": "",
							"value": ""
						}],
						"bz": ""
					},
					"yyfz2": {
						"neirong": [{
							"text": "",
							"value": ""
						}],
						"bz": ""
					},
					"rzfz": {
						"neirong": [{
							"text": "",
							"value": ""
						}],
						"bz": ""
					},
					"gtjn": {
						"neirong": [{
							"text": "",
							"value": ""
						}],
						"bz": ""
					},
					"jzbx": {
						"one": [],
						"two": [],
						"three": {
							"value": "",
							"bc": ""
						},
						"four": {
							"value": "",
							"bc": ""
						},
						"five": {
							"value": "",
							"bc": ""
						}
					},
					"jtkfjy": "",
					"jtkfjl": "",
					"inser_date": "2024-04-22T06:54:27.000Z",
					"riqi": "2023-04-22",
					"tj_age": "0岁:1月",
					"org_id": "78",
					"year": "2023"
				},
				// 诊断记录
				zdjl_info: {
					formData: {
						"leftEar": {
							"option": "",
							"deviceModel": "",
							"program": "",
							"luoerpingjuntingyu": "",
							"zhutingqixiaoguo": "",
							"volumeSensitivity": ""
						},
						"rightEar": {
							"option": "",
							"deviceModel": "",
							"program": "",
							"volumeSensitivity": "",
							"luoerpingjuntingyu": "",
							"zhutingqixiaoguo": ""
						},
						"pingguriqi": "",
						"pinggurenyuan": "",
						"pingguriqi2": "",
						"pinggurenyuan2": "",
						"starttime": "",
						"birthday": "",
						"tingliday": "",
						"rightshebei": "",
						"leftshebei": "",
						"endtime": "",
						"zhenduan": "",
						"pingyu": ""
					},
					testData: {
						"左耳": {
							"assr": {
								"unit": "dBSPL",
								"values": {
									"0.5KHz": null,
									"1KHz": null,
									"2KHz": null,
									"4KHz": null,
									"备注": ''
								},
								"remark": 'null'
							},
							"abr": {
								"values": {
									"0.5KHz": null,
									"1KHz": null,
									"2KHz": null,
									"4KHz": null,
									"备注": ''
								},
								"remark": ""
							},
							"naogan": {
								"values": {
									"0.5KHz": null,
									"1KHz": null,
									"2KHz": null,
									"4KHz": null,
									"备注": ''
								},
								"remark": ""
							},
							"TEOAE": {
								"values": {
									"0.5KHz": null,
									"1KHz": null,
									"2KHz": null,
									"4KHz": null,
									"备注": ''
								},
								"remark": ""
							},
							"DPOAE": {
								"values": {
									"0.5KHz": null,
									"1KHz": null,
									"2KHz": null,
									"4KHz": null,
									"备注": ''
								},
								"remark": ""
							},
							"IMMITTANCE": {
								"values": {
									"0.5KHz": null,
									"1KHz": null,
									"2KHz": null,
									"4KHz": null,
									"备注": ''
								},
								"remark": ""
							},
							"CM": {
								"values": {
									"0.5KHz": null,
									"1KHz": null,
									"2KHz": null,
									"4KHz": null,
									"备注": ''
								},
								"remark": ""
							},
							"ERP": {
								"values": {
									"0.5KHz": null,
									"1KHz": null,
									"2KHz": null,
									"4KHz": null,
									"备注": ''
								},
								"remark": ""
							},
							"SRT": {
								"values": {
									"0.5KHz": null,
									"1KHz": null,
									"2KHz": null,
									"4KHz": null,
									"备注": ''
								},
								"remark": ""
							},
							"SRS": {
								"values": {
									"0.5KHz": null,
									"1KHz": null,
									"2KHz": null,
									"4KHz": null,
									"备注": ''
								},
								"remark": ""
							},
							"SDT": {
								"values": {
									"0.5KHz": null,
									"1KHz": null,
									"2KHz": null,
									"4KHz": null,
									"备注": ''
								},
								"remark": ""
							},
							"zhener": {
								"values": {
									"0.5KHz": null,
									"1KHz": null,
									"2KHz": null,
									"4KHz": null,
									"备注": ''
								},
								"remark": ""
							},
							"shebei": {
								"values": {
									"0.5KHz": null,
									"1KHz": null,
									"2KHz": null,
									"4KHz": null,
									"备注": null
								},
								"remark": ""
							},
							"yingxiangxue": {
								"values": {
									"0.5KHz": null,
									"1KHz": null,
									"2KHz": null,
									"4KHz": null,
									"备注": null
								},
								"remark": ""
							},
							"jiyin": {
								"values": {
									"0.5KHz": null,
									"1KHz": null,
									"2KHz": null,
									"4KHz": null,
									"备注": null
								},
								"remark": ""
							},
							"qita": {
								"values": {
									"0.5KHz": null,
									"1KHz": null,
									"2KHz": null,
									"4KHz": null,
									"备注": null
								},
								"remark": ""
							}
						},
						"右耳": {
							"assr": {
								"unit": "dBSPL",
								"values": {
									"0.5KHz": null,
									"1KHz": null,
									"2KHz": null,
									"4KHz": null,
									"备注": null
								},
								"remark": ""
							},
							"abr": {
								"values": {
									"0.5KHz": null,
									"1KHz": null,
									"2KHz": null,
									"4KHz": null,
									"备注": null
								},
								"remark": ""
							},
							"naogan": {
								"values": {
									"0.5KHz": null,
									"1KHz": null,
									"2KHz": null,
									"4KHz": null,
									"备注": null
								},
								"remark": ""
							},
							"TEOAE": {
								"values": {
									"0.5KHz": null,
									"1KHz": null,
									"2KHz": null,
									"4KHz": null,
									"备注": null
								},
								"remark": ""
							},
							"DPOAE": {
								"values": {
									"0.5KHz": null,
									"1KHz": null,
									"2KHz": null,
									"4KHz": null,
									"备注": null
								},
								"remark": ""
							},
							"IMMITTANCE": {
								"values": {
									"0.5KHz": null,
									"1KHz": null,
									"2KHz": null,
									"4KHz": null,
									"备注": null
								},
								"remark": ""
							},
							"CM": {
								"values": {
									"0.5KHz": null,
									"1KHz": null,
									"2KHz": null,
									"4KHz": null,
									"备注": null
								},
								"remark": ""
							},
							"ERP": {
								"values": {
									"0.5KHz": null,
									"1KHz": null,
									"2KHz": null,
									"4KHz": null,
									"备注": null
								},
								"remark": ""
							},
							"SRT": {
								"values": {
									"0.5KHz": null,
									"1KHz": null,
									"2KHz": null,
									"4KHz": null,
									"备注": null
								},
								"remark": ""
							},
							"SRS": {
								"values": {
									"0.5KHz": null,
									"1KHz": null,
									"2KHz": null,
									"4KHz": null,
									"备注": null
								},
								"remark": ""
							},
							"SDT": {
								"values": {
									"0.5KHz": null,
									"1KHz": null,
									"2KHz": null,
									"4KHz": null,
									"备注": null
								},
								"remark": ""
							},
							"zhener": {
								"values": {
									"0.5KHz": null,
									"1KHz": null,
									"2KHz": null,
									"4KHz": null,
									"备注": null
								},
								"remark": ""
							},
							"shebei": {
								"values": {
									"0.5KHz": null,
									"1KHz": null,
									"2KHz": null,
									"4KHz": null,
									"备注": null
								},
								"remark": ""
							},
							"yingxiangxue": {
								"values": {
									"0.5KHz": null,
									"1KHz": null,
									"2KHz": null,
									"4KHz": null,
									"备注": ""
								},
								"remark": ""
							},
							"jiyin": {
								"values": {
									"0.5KHz": null,
									"1KHz": null,
									"2KHz": null,
									"4KHz": null,
									"备注": null
								},
								"remark": ""
							},
							"qita": {
								"values": {
									"0.5KHz": null,
									"1KHz": null,
									"2KHz": null,
									"4KHz": null,
									"备注": null
								},
								"remark": ""
							}
						}
					},
				},
				// 教学计划
				jiaoxuejihua: {
					lingyu: [{
							"value": "听能",
							"value2": "",
							"value3": "tingneng"
						},
						{
							"value": "言语",
							"value2": "",
							"value3": "yanyu"
						},
						{
							"value": "语言",
							"value2": "",
							"value3": "yuyan"
						},
						{
							"value": "认知",
							"value2": "",
							"value3": "renzhi"
						},
						{
							"value": "沟通",
							"value2": "",
							"value3": "goutong"
						},
						{
							"value": "家庭指导计划",
							"value2": ""
						},
						{
							"value": "其他",
							"value2": "",
							"value3": "qita"
						}
					],
				},
				// 首次评估信息
				shouci_list: {
					"id": 27,
					"stu_id": "",
					"tinglizhuangkuang": {
						"quezhentime": "",
						"pinggujieguo": [{
								"value": "左耳诊断评估结果",
								"tingsunchengdu": "",
								"chongjianfangshi": "",
								"chongjianfangshi_xinghao": "",
								"time": "",
								"zhuting": [{
										"zhuting_1": "250Hz",
										"zhuting1": "",
										"zhuting_2": "2kHz",
										"zhuting2": ""
									},
									{
										"zhuting_1": "500Hz",
										"zhuting1": "",
										"zhuting_2": "3kHz",
										"zhuting2": ""
									},
									{
										"zhuting_1": "1kHz",
										"zhuting1": "",
										"zhuting_2": "4kHz",
										"zhuting2": ""
									}
								]
							},
							{
								"value": "右耳诊断评估结果",
								"tingsunchengdu": "",
								"chongjianfangshi": "",
								"chongjianfangshi_xinghao": "",
								"time": "请选择日期",
								"zhuting": [{
										"zhuting_1": "250Hz",
										"zhuting1": "",
										"zhuting_2": "2kHz",
										"zhuting2": ""
									},
									{
										"zhuting_1": "500Hz",
										"zhuting1": "",
										"zhuting_2": "3kHz",
										"zhuting2": ""
									},
									{
										"zhuting_1": "1kHz",
										"zhuting1": "",
										"zhuting_2": "4kHz",
										"zhuting2": ""
									}
								]
							}
						],
						"tingli_ciji": ""
					},
					"awp": {
						"tingnenghuanjin": "",
						"tingjuexiguan": "",
						"tingnengguanlibeizhu": "",
						"tingjuejiyi_xiang": "",
						"tingjuejiyi_zuheleixing": "",
						"tingjuemiaoshu_bihe": "",
						"tingjuemiaoshu_kaifang": "",
						"tingjuenengli_beizhu": "",
						"goutongmuoshi": "",
						"lijiexingyvyanchengdu": "",
						"biaodaxingyvyanchengdu": "",
						"biaodaxingyvyanchengdu_tiankong": {
							"mofangfushu_changdu": "",
							"mofangfushu_liru": "",
							"zhudongbiaoda_changdu": "",
							"zhudongbiaoda_liru": ""
						},
						"wenjvnengli": "",
						"wenjvnengli_lijie": "",
						"wenjvnengli_huibiaodawenjv": "",
						"pingjunyvyannianlingshuiping": "",
						"yanyvkedongdu": "",
						"yanyvfasheng": "",
						"chaoshengduan_duoxuan": "",
						"chaoshengduan": [{
								"name": "音长短",
								"value": false
							},
							{
								"name": "音高低",
								"value": false
							},
							{
								"name": "音大小",
								"value": false
							},
							{
								"name": "四声",
								"value": false
							}
						],
						"mofangfasheng": "",
						"mofangfasheng_shuoming": "",
						"yvyannenglibeizhu": "",
						"biaodaxvqiufangshi": "",
						"goutongnengli_biaodaxvqiu": "",
						"dengdainengli": "",
						"goutongnenglibeizhu": "",
						"haoqixin": "",
						"wendingxing": "",
						"xingweiwenti": "",
						"xingweibiaoxian_xingweiwenti": "",
						"xingweibiaoxianbeizhu": "",
						"zilinenglibeizhu": "",
						"jiazhangpeixun": "",
						"jiazhanghudongyouxi": "",
						"qingxvjieduan": "",
						"ketangbiaoxian": "",
						"huiyinghaizixvqiu": "",
						"jiazhangshouxunbeizhu": "",
						"linshiliuyin_duoxuan": "",
						"liuyinfanying": [{
								"name": "察觉",
								"value": false
							},
							{
								"name": "辨识",
								"value": false
							}
						],
						"zhuting_danwei": "dB(HL)",
						"tingnengguanli": [{
								"tingnengguanli_biaoti": "确定家长了解保养及检查助听设备程序",
								"xuanze": ""
							},
							{
								"tingnengguanli_biaoti": "除睡觉及洗澡、游泳外是否都给幼儿配戴助听设备",
								"xuanze": ""
							}
						],
						"pingguneirong_tianxie": [{
								"pingguneirong_biaoti": "已有助听设备保养工具：",
								"neirong": ""
							},
							{
								"pingguneirong_biaoti": "配戴助听设备后幼儿对声音的反应有何改变？",
								"neirong": ""
							}
						],
						"tingjuenengli_xuanxiang": [{
								"tingjuenengli_biaoti": "幼儿对环境声音的反应：",
								"xuanxiang": ""
							},
							{
								"tingjuenengli_biaoti": "幼 儿 对 语 音 的 反 应",
								"xuanxiang": ""
							},
							{
								"tingjuenengli_biaoti": "幼儿对名字、家人称谓的反应",
								"xuanxiang": ""
							}
						],
						"tingjuenengli_linshiliuyin": [{
								"linshiliuyin_biaoti": "距离：",
								"chajue": "",
								"bianshi": ""
							},
							{
								"linshiliuyin_biaoti": "a",
								"chajue": "",
								"bianshi": ""
							},
							{
								"linshiliuyin_biaoti": "i",
								"chajue": "",
								"bianshi": ""
							},
							{
								"linshiliuyin_biaoti": "u",
								"chajue": "",
								"bianshi": ""
							},
							{
								"linshiliuyin_biaoti": "s",
								"chajue": "",
								"bianshi": ""
							},
							{
								"linshiliuyin_biaoti": "sh",
								"chajue": "",
								"bianshi": ""
							},
							{
								"linshiliuyin_biaoti": "m",
								"chajue": "",
								"bianshi": ""
							}
						],
						"tingjuenengli_tianxie": [{
								"tingjuenengli_biaoti1": "听力障碍儿童听觉能力评估标准：",
								"tingjuenengli_biaoti2": "言语识别平均得分：",
								"neirong": ""
							},
							{
								"tingjuenengli_biaoti1": "CAP听觉行为分级记录",
								"tingjuenengli_biaoti2": "级别：",
								"neirong": ""
							}
						],
						"biaodaxingyvyanfazhanjieduan_shifou": "",
						"biaodaxingyvyanfazhanjieduan": [{
								"xuanxiang": "咿呀期（简单发音阶段）："
							},
							{
								"xuanxiang": "儿语期（连续音节阶段）"
							},
							{
								"xuanxiang": "模仿期（学话萌芽阶段）"
							},
							{
								"xuanxiang": "单字期（单词句阶段）"
							},
							{
								"xuanxiang": "胡语期（乱语阶段）"
							},
							{
								"xuanxiang": "简单语词、电报期（双词句阶段）"
							},
							{
								"xuanxiang": "片语、句子和段落（完整句阶段）"
							}
						],
						"renzhinengli": [{
								"renzhinengli_biaoti": "分类：",
								"neirong": ""
							},
							{
								"renzhinengli_biaoti": "配对：",
								"neirong": ""
							},
							{
								"renzhinengli_biaoti": "颜色：",
								"neirong": ""
							},
							{
								"renzhinengli_biaoti": "形状：",
								"neirong": ""
							},
							{
								"renzhinengli_biaoti": "质感：",
								"neirong": ""
							},
							{
								"renzhinengli_biaoti": "数学概念：",
								"neirong": ""
							},
							{
								"renzhinengli_biaoti": "排序：",
								"neirong": ""
							},
							{
								"renzhinengli_biaoti": "其他思维能力：",
								"neirong": ""
							}
						],
						"renzhinengli_tianxie": [{
								"renzhinengli_biaoti1": "格雷费斯儿童精神发育检查报告：",
								"renzhinengli_biaoti2": "发育商：",
								"neirong": ""
							},
							{
								"renzhinengli_biaoti1": "希一内学习能力检验报告",
								"renzhinengli_biaoti2": "智商/学习能力商：",
								"neirong": ""
							}
						],
						"goutongnengli_xuanze": [{
								"goutongnengli_biaoti": "眼神交流：",
								"xuanxiang": "",
								"neirong": ""
							},
							{
								"goutongnengli_biaoti": "主动提问：",
								"xuanxiang": "",
								"neirong": ""
							},
							{
								"goutongnengli_biaoti": "主动互动：",
								"xuanxiang": "",
								"neirong": ""
							},
							{
								"goutongnengli_biaoti": "维持话题：",
								"xuanxiang": "",
								"neirong": ""
							},
							{
								"goutongnengli_biaoti": "开启话题：",
								"xuanxiang": "",
								"neirong": ""
							}
						],
						"zilinengli": [{
								"biaoti": "入厕",
								"xuanxiang": [{
										"xuanxiang_biaoti": "有大小便需求时，能自己入厕",
										"xuanxinag_jieguo": ""
									},
									{
										"xuanxiang_biaoti": "在成人提醒下便后会用水冲洗",
										"xuanxinag_jieguo": ""
									}
								]
							},
							{
								"biaoti": "进餐",
								"xuanxiang": [{
										"xuanxiang_biaoti": "能使用小勺独立进餐",
										"xuanxinag_jieguo": ""
									},
									{
										"xuanxiang_biaoti": "餐后能主动漱口和擦嘴",
										"xuanxinag_jieguo": ""
									}
								]
							},
							{
								"biaoti": "穿衣",
								"xuanxiang": [{
									"xuanxiang_biaoti": "能自己穿脱简单的衣裤和鞋袜",
									"xuanxinag_jieguo": ""
								}]
							},
							{
								"biaoti": "卫生习惯",
								"xuanxiang": [{
										"xuanxiang_biaoti": "能自己擦鼻涕",
										"xuanxinag_jieguo": ""
									},
									{
										"xuanxiang_biaoti": "饭前、便后、手脏时知道洗手",
										"xuanxinag_jieguo": ""
									},
									{
										"xuanxiang_biaoti": "在成人提醒下能早晚刷牙",
										"xuanxinag_jieguo": ""
									}
								]
							},
							{
								"biaoti": "安全",
								"xuanxiang": [{
										"xuanxiang_biaoti": "外出时跟随成人、不乱跑",
										"xuanxinag_jieguo": ""
									},
									{
										"xuanxiang_biaoti": "游戏时不做危险动作",
										"xuanxinag_jieguo": ""
									}
								]
							}
						],
						"jiazhangshouxun1": [{
								"biaoti": "家长技巧学习能力",
								"xuanxiang": {
									"xuanxiang1": "佳",
									"xuanxiang2": "1~2次引导即可",
									"xuanxiang3": "需三次以上引导"
								},
								"jieguo": ""
							},
							{
								"biaoti": "对孩子教养观念与信念",
								"xuanxiang": {
									"xuanxiang1": "佳",
									"xuanxiang2": "有概念但需提醒",
									"xuanxiang3": "无概念"
								},
								"jieguo": ""
							}
						],
						"jiazhangshouxun2": [{
								"biaoti": "对孩子的期望值",
								"xuanxiang": {
									"xuanxiang1": "高",
									"xuanxiang2": "低"
								},
								"jieguo": ""
							},
							{
								"biaoti": "对孩子的敏感度",
								"xuanxiang": {
									"xuanxiang1": "高",
									"xuanxiang2": "低"
								},
								"jieguo": ""
							},
							{
								"biaoti": "对幼儿发展的认知",
								"xuanxiang": {
									"xuanxiang1": "有",
									"xuanxiang2": "无",
									"xuanxiang3": "部分理解"
								},
								"jieguo": ""
							},
							{
								"biaoti": "阅读习惯",
								"xuanxiang": {
									"xuanxiang1": "有",
									"xuanxiang2": "无",
									"xuanxiang3": "有时间就做"
								},
								"jieguo": ""
							},
							{
								"biaoti": "作息规律性",
								"xuanxiang": {
									"xuanxiang1": "规律",
									"xuanxiang2": "不规律"
								},
								"jieguo": ""
							},
							{
								"biaoti": "资料收集能力",
								"xuanxiang": {
									"xuanxiang1": "主动",
									"xuanxiang2": "被动"
								},
								"jieguo": ""
							}
						]
					},
					"zonghefenxi": [{
							"biaoti": "简要描述、判断：",
							"neirong": ""
						},
						{
							"biaoti": "分析：",
							"neirong": ""
						},
						{
							"biaoti": "康复建议：",
							"neirong": ""
						}
					],
					"pinggurenyuanriqi": {
						"time": "",
						"pinggurenyuan": ""
					},
					"org_id": '',
					"ins_date": "",
					"year": "",
					"stu_ID": "",
					"stu_name": "",
					"shengri": "",
					"sex": ""
				},
				// 持续评估信息
				cxpg_info: {

					jiazhangbiaoxian: {
						"name": "家长表现",
						"value": [{
								"name": "对课堂教学的配合程度",
								"value": [{
										"name": "很好",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "一般",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "较差",
										"text": "",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									}
								]
							},
							{
								"name": "对已学会的技巧运用情况",
								"value": [{
										"name": "很好",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "一般",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "较差",
										"text": "",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									}
								]
							},
							{
								"name": "家庭康复任务完成情况",
								"value": [{
										"name": "很好",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "一般",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "较差",
										"text": "",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									}
								]
							},
							{
								"name": "在哪些方面有新的进步?",
								"value": ""
							},
							{
								"name": "其它?",
								"value": ""
							}
						]
					},
					goutong: {
						"name": "沟通",
						"value": [{
								"ly_name": "沟通行为",
								"value": [{
										"name": "眼神的注视",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "轮替",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "礼貌用语（例如：再见、谢谢、对不起……）",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "问句",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "主动与他人互动",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "开启话题开放式",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "开启话题闭锁式",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									}
								]
							},
							{
								"ly_name": "沟通策略",
								"value": [{
										"name": "基础",
										"value": [{
												"name": "要求重复",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "证实部分讯息",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "要求说明",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "适当的转换话题",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "分享对话的主导权",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "提供说明",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											}
										]
									},
									{
										"name": "维持同一话题",
										"value": [{
												"name": "一回",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "两回",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "三回",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "延伸话题",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											}
										]
									},
									{
										"name": "高级",
										"value": [{
												"name": "能用正式的言语作为问候与道别",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "能用合宜的方式引起对方的注意",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "能用适当的言语征询他人的同意",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "能询问信息",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "能询问更多的信息",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "能给予评论的意见",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "能给予评论的意见",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "能适当的表达同意",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "能适当的表达不同意",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "能合适的直接请求对方行动",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "能以间接地方式表达自己的需求",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "能合宜的表达抗议",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											}
										]
									}
								]
							}
						]
					},
					renzhi: {
						"name": "认知",
						"value": [{
								"ly_name": "分类及配对",
								"value": [{
										"name": "能从不同类别做同类配对（1 岁）",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "能辨识真实的物品（1 岁）",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "几片大的整片的拼图片块（1 岁）",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "实物与名词图片的配对（1.6~2 岁）",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "实物与动词图片的配对（1.6~2 岁）",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "一模一样的图片（各4 张）（1.6~2岁）",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "同类物品做归类（1.6~2 岁）",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "能依类别将不同东西做归类（1.6~2 岁）",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "5 片小的整片的拼图片块（1.6~2 岁）可配对之图片（2.5 岁）",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "能将各房间东西归类（2.5 岁）",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "分隔各半的拼图及容器（2.5 岁）",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "物品缺少的部分（3 岁）",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "服装与人物之联结（3 岁）",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "动物吃的食物（3 岁）",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "不同商店相关的物品分类（3 岁）以拍拍手玩分类游戏（3 岁）",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "分割 4 片的拼图（3 岁）",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "各种职业的物品配对较复杂（4 岁）",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "较大图景的拼图（4 岁）",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "其它",
										"text": "",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									}
								]
							},
							{
								"ly_name": "颜色",
								"value": [{
										"name": "红色",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "蓝色",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "黄色",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "绿色",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "白色",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "黑色",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "橘色",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "粉红色",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "紫色",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "橙色",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "咖啡色（棕色）",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "黑白色",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "彩色的",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "灰色",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "深",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "浅",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "金色",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "银色",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "金黄色",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "相同—不相同",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "不一样",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									}
								]
							},
							{
								"ly_name": "数字概念",
								"value": [{
										"name": "唱数",
										"value": [{
												"name": "1---3",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "4---6",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "7---10",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "11---20",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "20 以上",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											}
										]
									},
									{
										"name": "认识数字",
										"value": [{
												"name": "1---3",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "4---6",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "7---10",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "11---20",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "20 以上",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "比较数字大小",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											}
										]
									},
									{
										"name": "量的概念",
										"value": [{
												"name": "1---3",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "4---6",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "7---10",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "11---20",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "20 以上",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "比较数量多少",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											}
										]
									},
									{
										"name": "币值的概念",
										"value": [{
												"name": "1角",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "5角",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "1元",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "5元",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "10元",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "20元",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "50元",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "100元",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											}
										]
									},
									{
										"name": "数的运算",
										"value": [{
												"name": "加法",
												"value": [{
														"name": "个位数",
														"value": [{
																"num": 0,
																"value": ""
															},
															{
																"num": 1,
																"value": ""
															}
														]
													},
													{
														"name": "十位数",
														"value": [{
																"num": 0,
																"value": ""
															},
															{
																"num": 1,
																"value": ""
															}
														]
													}
												]
											},
											{
												"name": "百位数减法",
												"value": [{
														"name": "百位数减法",
														"value": [{
																"num": 0,
																"value": ""
															},
															{
																"num": 1,
																"value": ""
															}
														]
													},
													{
														"name": "个位数",
														"value": [{
																"num": 0,
																"value": ""
															},
															{
																"num": 1,
																"value": ""
															}
														]
													},
													{
														"name": "十位数",
														"value": [{
																"num": 0,
																"value": ""
															},
															{
																"num": 1,
																"value": ""
															}
														]
													}
												]
											},
											{
												"name": "百位数乘法",
												"value": [{
														"name": "百位数乘法",
														"value": [{
																"num": 0,
																"value": ""
															},
															{
																"num": 1,
																"value": ""
															}
														]
													},
													{
														"name": "个位数",
														"value": [{
																"num": 0,
																"value": ""
															},
															{
																"num": 1,
																"value": ""
															}
														]
													},
													{
														"name": "十位数",
														"value": [{
																"num": 0,
																"value": ""
															},
															{
																"num": 1,
																"value": ""
															}
														]
													}
												]
											},
											{
												"name": "除法",
												"value": [{
														"name": "个位数",
														"value": [{
																"num": 0,
																"value": ""
															},
															{
																"num": 1,
																"value": ""
															}
														]
													},
													{
														"name": "十位数",
														"value": [{
																"num": 0,
																"value": ""
															},
															{
																"num": 1,
																"value": ""
															}
														]
													}
												]
											}
										]
									}
								]
							},
							{
								"ly_name": "形状",
								"value": [{
										"name": "平面",
										"value": [{
												"name": "圆形",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "三角形",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "正方形",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "长方形",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "星形",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "梯形",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "心形",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "半圆形",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "平行四边形",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "椭圆形",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "六边形",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "菱形",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "四边形",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "其它",
												"text": "",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											}
										]
									},
									{
										"name": "立体",
										"value": [{
												"name": "立方体",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "圆柱体",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "圆锥体",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "三角锥",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "长方体",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "正方体",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											}
										]
									}
								]
							},
							{
								"ly_name": "触觉感知",
								"value": [{
										"name": "粘粘的",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "软软的",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "硬硬的",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "粗粗的",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "尖尖的",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "刺刺的",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "滑滑的",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "油油的",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "毛绒绒的",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "烫烫的",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "湿湿的",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "冰冰的",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "干干的",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "其它",
										"text": "",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									}
								]
							},
							{
								"ly_name": "比较与对照",
								"value": [{
										"name": "能在 4样物品中指认其中 3 个相同的（2.5~3岁）",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "哪个不同？为什么？（2.5~3 岁）",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "从 3 个相同一个不同中指出哪一个不一样（2.5~3岁）",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "经听觉描述作选择（1~2 岁）—（2.5~3 岁）",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "以实物列出哪个不一样？为什么？（4 岁）",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "能依尺寸、味道来做比较（4岁）类推（4岁）",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "经听觉描述作选择（3~4岁）",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "说出图片中哪些相似（5岁）",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "声母相同的押韵童谣（5岁）",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "“相关联”之游戏（5 岁）",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "其它",
										"text": "",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									}
								]
							},
							{
								"ly_name": "顺序概念",
								"value": [{
										"name": "在家中的一些事情（3岁）",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "简单的手指游戏（3岁）",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "形状、数量（3岁）",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "旅游（相片）（3岁）",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "有顺序之指令（3岁）",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "含2~3个段落的故事",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "听故事及顺序（4岁）",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "童谣、儿歌（4岁）",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "以不同顺序发展一则故事（5岁）",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "故事接龙（开始、中间或结局）",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "包含语法的顺序描述（6岁）",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "其它",
										"text": "",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									}
								]
							},
							{
								"ly_name": "相似",
								"value": [{
										"name": "功能相似",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "特征相似",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									}
								]
							},
							{
								"ly_name": "推理/预测",
								"value": [{
										"name": "事件推理",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "时间推理",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "字词推理",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "找原因",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									}
								]
							},
							{
								"ly_name": "类推",
								"value": ""
							},
							{
								"ly_name": "同义词",
								"value": ""
							},
							{
								"ly_name": "相反词",
								"value": ""
							},
							{
								"ly_name": "双关语",
								"value": ""
							},
							{
								"ly_name": "笑话",
								"value": ""
							},
							{
								"ly_name": "谜语",
								"value": ""
							}
						]
					},
					yanyu: {
						"name": "言语",
						"value": [{
								"ly_name": "音质",
								"value": [{
										"name": "音质自然流畅",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "音质较为自然流畅",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "有明显发音问题",
										"text_if": "（如：假声、硬起音、共鸣错误（鼻漏气）、聚焦错误等）",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "有严重发音问题",
										"text_if": "（如：假声、硬起音、共鸣错误、聚焦错误等）",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									}
								]
							},
							{
								"ly_name": "语词辨识度（可懂度）",
								"value": [{
										"name": "有情景提示下",
										"value": [{
												"name": "完全理解",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "基本理解",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "部分理解",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "不能理解",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											}
										]
									},
									{
										"name": "无情景提示下",
										"value": [{
												"name": "完全理解",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "基本理解",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "部分理解",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "不能理解",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											}
										]
									}
								]
							},
							{
								"ly_name": "超语段",
								"value": [{
										"name": "时间",
										"value": [{
												"name": "长音",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "短音",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "音长短变化音",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											}
										]
									},
									{
										"name": "量",
										"value": [{
												"name": "大",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "小",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "大小声变化音",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											}
										]
									},
									{
										"name": "调",
										"value": [{
												"name": "高",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "低",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "高低变化",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											}
										]
									}
								]
							},
							{
								"ly_name": "四声",
								"value": [{
										"name": "一声",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "二声",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "三声",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "四声",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "四声变化",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									}
								]
							},
							{
								"ly_name": "单韵母",
								"value": [{
										"name": "a",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "u",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "e",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "i",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "ü",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									}
								]
							},
							{
								"ly_name": "韵母轮换",
								"value": [{
										"name": "u-a",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "a-u",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "e-ⅰ",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "ⅰ-a",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "u-ⅰ",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "ⅰ-u",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "a-ⅰ",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									}
								]
							},
							{
								"ly_name": "复韵母结尾",
								"value": [{
										"name": "ou",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "ao",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "ei",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "ai",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "ie",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "iu",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "ui",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "üe",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									}
								]
							},
							{
								"ly_name": "复韵母声母结尾",
								"value": [{
										"name": "an",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "en",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "in",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "un",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "ün",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "ang",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "eng",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "ong",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "ing（省略后鼻音）",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									}
								]
							},
							{
								"ly_name": "结合韵母",
								"value": [{
										"name": "ia",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "iao",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "ian",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "iang",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "ua",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "uo",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "uai",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "uan",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "uang",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "uan",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "ong",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									}
								]
							},
							{
								"ly_name": "声母",
								"value": [{
										"name": "b",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "p",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "h",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "q",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "zh",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "z",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "m",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "t",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "d",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "f",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "n",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "x",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "j",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "ch",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "c",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "l",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "k",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "g",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "s",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "sh",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "r",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									}
								]
							}
						]
					},
					yuyan: {
						"name": "语言",
						"value": [{
								"ly_name": "初级词汇",
								"value": [{
										"name": "名词",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "动词",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "代词",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "形容词",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "副词",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "数量词",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "否定词",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "连词",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "日常表达性词语",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									}
								]
							},
							{
								"ly_name": "中级词汇",
								"value": [{
										"name": "名词",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "动词",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "代词",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "形容词",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "副词",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "数量词",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "否定词",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "连词",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "日常表达性词语",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									}
								]
							},
							{
								"ly_name": "高级词汇",
								"value": [{
										"name": "名词",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "动词",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "代词",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "形容词",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "副词",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "数量词",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "否定词",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "连词",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "日常表达性词语",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									}
								]
							},
							{
								"ly_name": "问句",
								"value": [{
										"name": "小于 2.5 岁",
										"value": [{
												"name": "那是什么？",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "他在做什么？",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "什么颜色？",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "有几个？",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											}
										]
									},
									{
										"name": "2.5~3 岁",
										"value": [{
												"name": "在哪里？",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "是谁？",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "哪一个？",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "什么形状？",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "做什么用的？",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "怎么了？",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "怎么办？",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "什么不见了？",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											}
										]
									},
									{
										"name": "3~4岁",
										"value": [{
												"name": "少了什么？",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "为什么",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "（名词）住在哪里？",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "哪一个不一样？",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "需要什么？",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "（代名词）叫什么名字？",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "什么地方？",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "多大了",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											}
										]
									},
									{
										"name": "4~5 岁",
										"value": [{
												"name": "多少？",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "什么时候？？",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "如何？",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "怎么做？（描述）",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "自创",
												"text": "",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											}
										]
									}
								]
							},
							{
								"ly_name": "语言能力评估",
								"value_age": "",
								"value_time": ""
							},
							{
								"ly_name": "SIR言语可懂度",
								"value_pj": "",
								"value_time": ""
							}
						]
					},
					tingneng: {
						"name": "听能",
						"value": [{
								"ly_name": "声音察觉与辨识",
								"value": [{
										"name": "察觉",
										"value": [{
												"name": "自己名字",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "语音",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "环境音",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "有声玩具",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											}
										]
									},
									{
										"name": "辨识",
										"value": [{
												"name": "自己名字",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "语音",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "环境音",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "有声玩具",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											}
										]
									}
								]
							},
							{
								"ly_name": "声源辨识",
								"value": [{
										"name": "优耳",
										"value": [{
												"name": "前方",
												"value50": [{
														"name": "50cm",
														"value": "",
														"num": 0
													},
													{
														"num": 1,
														"value": ""
													}
												],
												"value100": [{
														"name": "1m",
														"value": "",
														"num": 0
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "后方",
												"value50": [{
														"name": "50cm",
														"value": "",
														"num": 0
													},
													{
														"num": 1,
														"value": ""
													}
												],
												"value100": [{
														"name": "1m",
														"value": "",
														"num": 0
													},
													{
														"num": 1,
														"value": ""
													}
												]
											}
										]
									},
									{
										"name": "劣耳",
										"value": [{
												"name": "前方",
												"value50": [{
														"name": "50cm",
														"value": "",
														"num": 0
													},
													{
														"num": 1,
														"value": ""
													}
												],
												"value100": [{
														"name": "1m",
														"value": "",
														"num": 0
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "后方",
												"value50": [{
														"name": "50cm",
														"value": "",
														"num": 0
													},
													{
														"num": 1,
														"value": ""
													}
												],
												"value100": [{
														"name": "1m",
														"value": "",
														"num": 0
													},
													{
														"num": 1,
														"value": ""
													}
												]
											}
										]
									},
									{
										"name": "双耳",
										"value": [{
												"name": "前方",
												"value50": [{
														"name": "50cm",
														"value": "",
														"num": 0
													},
													{
														"num": 1,
														"value": ""
													}
												],
												"value100": [{
														"name": "1m",
														"value": "",
														"num": 0
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "后方",
												"value50": [{
														"name": "50cm",
														"value": "",
														"num": 0
													},
													{
														"num": 1,
														"value": ""
													}
												],
												"value100": [{
														"name": "1m",
														"value": "",
														"num": 0
													},
													{
														"num": 1,
														"value": ""
													}
												]
											}
										]
									}
								]
							},
							{
								"ly_name": "林氏六音",
								"value": [{
										"name": "m",
										"value": [{
												"name": "12cm",
												"value": [{
														"name": "察觉",
														"value": [{
																"num": 0,
																"value": ""
															},
															{
																"num": 1,
																"value": ""
															}
														]
													},
													{
														"name": "辨识",
														"value": [{
																"num": 0,
																"value": ""
															},
															{
																"num": 1,
																"value": ""
															}
														]
													}
												]
											},
											{
												"name": "50cm",
												"value": [{
														"name": "察觉",
														"value": [{
																"num": 0,
																"value": ""
															},
															{
																"num": 1,
																"value": ""
															}
														]
													},
													{
														"name": "辨识",
														"value": [{
																"num": 0,
																"value": ""
															},
															{
																"num": 1,
																"value": ""
															}
														]
													}
												]
											},
											{
												"name": "1m",
												"value": [{
														"name": "察觉",
														"value": [{
																"num": 0,
																"value": ""
															},
															{
																"num": 1,
																"value": ""
															}
														]
													},
													{
														"name": "辨识",
														"value": [{
																"num": 0,
																"value": ""
															},
															{
																"num": 1,
																"value": ""
															}
														]
													}
												]
											},
											{
												"name": "2m",
												"value": [{
														"name": "察觉",
														"value": [{
																"num": 0,
																"value": ""
															},
															{
																"num": 1,
																"value": ""
															}
														]
													},
													{
														"name": "辨识",
														"value": [{
																"num": 0,
																"value": ""
															},
															{
																"num": 1,
																"value": ""
															}
														]
													}
												]
											}
										]
									},
									{
										"name": "u",
										"value": [{
												"name": "12cm",
												"value": [{
														"name": "察觉",
														"value": [{
																"num": 0,
																"value": ""
															},
															{
																"num": 1,
																"value": ""
															}
														]
													},
													{
														"name": "辨识",
														"value": [{
																"num": 0,
																"value": ""
															},
															{
																"num": 1,
																"value": ""
															}
														]
													}
												]
											},
											{
												"name": "50cm",
												"value": [{
														"name": "察觉",
														"value": [{
																"num": 0,
																"value": ""
															},
															{
																"num": 1,
																"value": ""
															}
														]
													},
													{
														"name": "辨识",
														"value": [{
																"num": 0,
																"value": ""
															},
															{
																"num": 1,
																"value": ""
															}
														]
													}
												]
											},
											{
												"name": "1m",
												"value": [{
														"name": "察觉",
														"value": [{
																"num": 0,
																"value": ""
															},
															{
																"num": 1,
																"value": ""
															}
														]
													},
													{
														"name": "辨识",
														"value": [{
																"num": 0,
																"value": ""
															},
															{
																"num": 1,
																"value": ""
															}
														]
													}
												]
											},
											{
												"name": "2m",
												"value": [{
														"name": "察觉",
														"value": [{
																"num": 0,
																"value": ""
															},
															{
																"num": 1,
																"value": ""
															}
														]
													},
													{
														"name": "辨识",
														"value": [{
																"num": 0,
																"value": ""
															},
															{
																"num": 1,
																"value": ""
															}
														]
													}
												]
											}
										]
									},
									{
										"name": "a",
										"value": [{
												"name": "12cm",
												"value": [{
														"name": "察觉",
														"value": [{
																"num": 0,
																"value": ""
															},
															{
																"num": 1,
																"value": ""
															}
														]
													},
													{
														"name": "辨识",
														"value": [{
																"num": 0,
																"value": ""
															},
															{
																"num": 1,
																"value": ""
															}
														]
													}
												]
											},
											{
												"name": "50cm",
												"value": [{
														"name": "察觉",
														"value": [{
																"num": 0,
																"value": ""
															},
															{
																"num": 1,
																"value": ""
															}
														]
													},
													{
														"name": "辨识",
														"value": [{
																"num": 0,
																"value": ""
															},
															{
																"num": 1,
																"value": ""
															}
														]
													}
												]
											},
											{
												"name": "1m",
												"value": [{
														"name": "察觉",
														"value": [{
																"num": 0,
																"value": ""
															},
															{
																"num": 1,
																"value": ""
															}
														]
													},
													{
														"name": "辨识",
														"value": [{
																"num": 0,
																"value": ""
															},
															{
																"num": 1,
																"value": ""
															}
														]
													}
												]
											},
											{
												"name": "2m",
												"value": [{
														"name": "察觉",
														"value": [{
																"num": 0,
																"value": ""
															},
															{
																"num": 1,
																"value": ""
															}
														]
													},
													{
														"name": "辨识",
														"value": [{
																"num": 0,
																"value": ""
															},
															{
																"num": 1,
																"value": ""
															}
														]
													}
												]
											}
										]
									},
									{
										"name": "i",
										"value": [{
												"name": "12cm",
												"value": [{
														"name": "察觉",
														"value": [{
																"num": 0,
																"value": ""
															},
															{
																"num": 1,
																"value": ""
															}
														]
													},
													{
														"name": "辨识",
														"value": [{
																"num": 0,
																"value": ""
															},
															{
																"num": 1,
																"value": ""
															}
														]
													}
												]
											},
											{
												"name": "50cm",
												"value": [{
														"name": "察觉",
														"value": [{
																"num": 0,
																"value": ""
															},
															{
																"num": 1,
																"value": ""
															}
														]
													},
													{
														"name": "辨识",
														"value": [{
																"num": 0,
																"value": ""
															},
															{
																"num": 1,
																"value": ""
															}
														]
													}
												]
											},
											{
												"name": "1m",
												"value": [{
														"name": "察觉",
														"value": [{
																"num": 0,
																"value": ""
															},
															{
																"num": 1,
																"value": ""
															}
														]
													},
													{
														"name": "辨识",
														"value": [{
																"num": 0,
																"value": ""
															},
															{
																"num": 1,
																"value": ""
															}
														]
													}
												]
											},
											{
												"name": "2m",
												"value": [{
														"name": "察觉",
														"value": [{
																"num": 0,
																"value": ""
															},
															{
																"num": 1,
																"value": ""
															}
														]
													},
													{
														"name": "辨识",
														"value": [{
																"num": 0,
																"value": ""
															},
															{
																"num": 1,
																"value": ""
															}
														]
													}
												]
											}
										]
									},
									{
										"name": "sh",
										"value": [{
												"name": "12cm",
												"value": [{
														"name": "察觉",
														"value": [{
																"num": 0,
																"value": ""
															},
															{
																"num": 1,
																"value": ""
															}
														]
													},
													{
														"name": "辨识",
														"value": [{
																"num": 0,
																"value": ""
															},
															{
																"num": 1,
																"value": ""
															}
														]
													}
												]
											},
											{
												"name": "50cm",
												"value": [{
														"name": "察觉",
														"value": [{
																"num": 0,
																"value": ""
															},
															{
																"num": 1,
																"value": ""
															}
														]
													},
													{
														"name": "辨识",
														"value": [{
																"num": 0,
																"value": ""
															},
															{
																"num": 1,
																"value": ""
															}
														]
													}
												]
											},
											{
												"name": "1m",
												"value": [{
														"name": "察觉",
														"value": [{
																"num": 0,
																"value": ""
															},
															{
																"num": 1,
																"value": ""
															}
														]
													},
													{
														"name": "辨识",
														"value": [{
																"num": 0,
																"value": ""
															},
															{
																"num": 1,
																"value": ""
															}
														]
													}
												]
											},
											{
												"name": "2m",
												"value": [{
														"name": "察觉",
														"value": [{
																"num": 0,
																"value": ""
															},
															{
																"num": 1,
																"value": ""
															}
														]
													},
													{
														"name": "辨识",
														"value": [{
																"num": 0,
																"value": ""
															},
															{
																"num": 1,
																"value": ""
															}
														]
													}
												]
											}
										]
									},
									{
										"name": "s",
										"value": [{
												"name": "12cm",
												"value": [{
														"name": "察觉",
														"value": [{
																"num": 0,
																"value": ""
															},
															{
																"num": 1,
																"value": ""
															}
														]
													},
													{
														"name": "辨识",
														"value": [{
																"num": 0,
																"value": ""
															},
															{
																"num": 1,
																"value": ""
															}
														]
													}
												]
											},
											{
												"name": "50cm",
												"value": [{
														"name": "察觉",
														"value": [{
																"num": 0,
																"value": ""
															},
															{
																"num": 1,
																"value": ""
															}
														]
													},
													{
														"name": "辨识",
														"value": [{
																"num": 0,
																"value": ""
															},
															{
																"num": 1,
																"value": ""
															}
														]
													}
												]
											},
											{
												"name": "1m",
												"value": [{
														"name": "察觉",
														"value": [{
																"num": 0,
																"value": ""
															},
															{
																"num": 1,
																"value": ""
															}
														]
													},
													{
														"name": "辨识",
														"value": [{
																"num": 0,
																"value": ""
															},
															{
																"num": 1,
																"value": ""
															}
														]
													}
												]
											},
											{
												"name": "2m",
												"value": [{
														"name": "察觉",
														"value": [{
																"num": 0,
																"value": ""
															},
															{
																"num": 1,
																"value": ""
															}
														]
													},
													{
														"name": "辨识",
														"value": [{
																"num": 0,
																"value": ""
															},
															{
																"num": 1,
																"value": ""
															}
														]
													}
												]
											}
										]
									}
								]
							},
							{
								"ly_name": "词组中的字词",
								"value": [{
										"name": "韵母不同,音节不同",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "声母相同,韵母不同",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "声母不同,韵母相同",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "同音(声韵母相同),声调不同",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									}
								]
							},
							{
								"ly_name": "听觉记忆(小项)",
								"value": [{
										"name": "1项",
										"tingjuejiyi_num": "1",
										"value": [{
												"name": "拟声词",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "名词",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "动词",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "形容词",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "方位词",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											}
										]
									},
									{
										"name": "2项",
										"tingjuejiyi_num": "2",
										"value": [{
												"name": "两个名词",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "名词+动词",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "两个动词",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "形容词+名词",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "其他",
												"text": "",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											}
										]
									},
									{
										"name": "3项",
										"tingjuejiyi_num": "3",
										"value": [{
												"name": "三个名词",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "两个名词+动词",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "动词+ 两个名词",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "名词+两个动词",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "两个名词+ 方位词",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "两个名词+形容词",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "数量词+形容词+名词",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "两个形容词+名词",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "形容词+名词+动词",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "三个动词",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "数量词+名词+动词",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "其他",
												"text": "",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											}
										]
									},
									{
										"name": "4项",
										"tingjuejiyi_num": "4",
										"value": [{
												"name": "四个名词",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "三个名词+方位词",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "两个名词+两个动词",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "两个名词+两个方位词",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "两个名词+两个形容词",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "两个数量词+两个名词",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "形容词+名词+名词+方位词",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "其他",
												"text": "",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											}
										]
									},
									{
										"name": "5项",
										"tingjuejiyi_num": "5",
										"value": [{
												"name": "五个名词",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "两个名词+两个动词+时间副词",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "五个动词",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "其他",
												"text": "",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											}
										]
									},
									{
										"name": "5+项",
										"tingjuejiyi_num": "5+",
										"value": [{
											"name": "手填",
											"text": "",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										}]
									}
								]
							},
							{
								"ly_name": "可辨识的儿歌和童谣",
								"value": ""
							},
							{
								"ly_name": "能注意听延续的故事或对话内容",
								"value": ""
							},
							{
								"ly_name": "听觉描述",
								"value": [{
										"name": "闭合式阶段",
										"value": [{
												"name": "重复拟声词",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "加入关键词",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "相似特征",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "属性相同",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											}
										]
									},
									{
										"name": "开放式阶段",
										"value": [{
												"name": "重复拟声词",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "加入关键词",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "复杂描述",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "问问题找答案",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											}
										]
									}
								]
							},
							{
								"ly_name": "能听录音带的内容",
								"value": [{
										"name": "听觉记忆(项)",
										"value": [{
												"name": "0",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "1",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "2",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "3",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "4",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "5",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "5+",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											}
										]
									},
									{
										"name": "故事",
										"value": ""
									},
									{
										"name": "听觉描述",
										"value": [{
												"name": "闭合式阶段",
												"value": [{
														"name": "重复拟声词",
														"value": [{
																"num": 0,
																"value": ""
															},
															{
																"num": 1,
																"value": ""
															}
														]
													},
													{
														"name": "加入关键词",
														"value": [{
																"num": 0,
																"value": ""
															},
															{
																"num": 1,
																"value": ""
															}
														]
													},
													{
														"name": "相似特征",
														"value": [{
																"num": 0,
																"value": ""
															},
															{
																"num": 1,
																"value": ""
															}
														]
													},
													{
														"name": "属性相同",
														"value": [{
																"num": 0,
																"value": ""
															},
															{
																"num": 1,
																"value": ""
															}
														]
													}
												]
											},
											{
												"name": "开放式阶段",
												"value": [{
														"name": "重复拟声词",
														"value": [{
																"num": 0,
																"value": ""
															},
															{
																"num": 1,
																"value": ""
															}
														]
													},
													{
														"name": "加入关键词",
														"value": [{
																"num": 0,
																"value": ""
															},
															{
																"num": 1,
																"value": ""
															}
														]
													},
													{
														"name": "复杂描述",
														"value": [{
																"num": 0,
																"value": ""
															},
															{
																"num": 1,
																"value": ""
															}
														]
													}
												]
											}
										]
									}
								]
							},
							{
								"ly_name": "能在吵杂的环境中倾听",
								"value": [{
										"name": "听觉记忆(项)",
										"value": [{
												"name": "0",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "1",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "2",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "3",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "4",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "5",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "5+",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											}
										]
									},
									{
										"name": "听觉描述",
										"value": [{
												"name": "闭合式阶段",
												"value": [{
														"name": "重复拟声词",
														"value": [{
																"num": 0,
																"value": ""
															},
															{
																"num": 1,
																"value": ""
															}
														]
													},
													{
														"name": "加入关键词",
														"value": [{
																"num": 0,
																"value": ""
															},
															{
																"num": 1,
																"value": ""
															}
														]
													},
													{
														"name": "相似特征",
														"value": [{
																"num": 0,
																"value": ""
															},
															{
																"num": 1,
																"value": ""
															}
														]
													},
													{
														"name": "属性相同",
														"value": [{
																"num": 0,
																"value": ""
															},
															{
																"num": 1,
																"value": ""
															}
														]
													}
												]
											},
											{
												"name": "开放式阶段",
												"value": [{
														"name": "重复拟声词",
														"value": [{
																"num": 0,
																"value": ""
															},
															{
																"num": 1,
																"value": ""
															}
														]
													},
													{
														"name": "加入关键词",
														"value": [{
																"num": 0,
																"value": ""
															},
															{
																"num": 1,
																"value": ""
															}
														]
													},
													{
														"name": "复杂描述",
														"value": [{
																"num": 0,
																"value": ""
															},
															{
																"num": 1,
																"value": ""
															}
														]
													},
													{
														"name": "问问题找答案",
														"value": [{
																"num": 0,
																"value": ""
															},
															{
																"num": 1,
																"value": ""
															}
														]
													}
												]
											}
										]
									}
								]
							},
							{
								"ly_name": "能在团体对话中倾听",
								"value": [{
										"name": "听觉记忆(项)",
										"value": [{
												"name": "0",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "1",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "2",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "3",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "4",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "5",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											},
											{
												"name": "5+",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											}
										]
									},
									{
										"name": "听觉描述",
										"value": [{
												"name": "闭合式阶段",
												"value": [{
														"name": "重复拟声词",
														"value": [{
																"num": 0,
																"value": ""
															},
															{
																"num": 1,
																"value": ""
															}
														]
													},
													{
														"name": "加入关键词",
														"value": [{
																"num": 0,
																"value": ""
															},
															{
																"num": 1,
																"value": ""
															}
														]
													},
													{
														"name": "相似特征",
														"value": [{
																"num": 0,
																"value": ""
															},
															{
																"num": 1,
																"value": ""
															}
														]
													},
													{
														"name": "属性相同",
														"value": [{
																"num": 0,
																"value": ""
															},
															{
																"num": 1,
																"value": ""
															}
														]
													}
												]
											},
											{
												"name": "开放式阶段",
												"value": [{
														"name": "重复拟声词",
														"value": [{
																"num": 0,
																"value": ""
															},
															{
																"num": 1,
																"value": ""
															}
														]
													},
													{
														"name": "加入关键词",
														"value": [{
																"num": 0,
																"value": ""
															},
															{
																"num": 1,
																"value": ""
															}
														]
													},
													{
														"name": "复杂描述",
														"value": [{
																"num": 0,
																"value": ""
															},
															{
																"num": 1,
																"value": ""
															}
														]
													},
													{
														"name": "问问题找答案",
														"value": [{
																"num": 0,
																"value": ""
															},
															{
																"num": 1,
																"value": ""
															}
														]
													}
												]
											}
										]
									}
								]
							},
							{
								"ly_name": "接听电话技巧",
								"value": [{
										"name": "闭合式/熟悉的谈话者，听觉记忆 1-2 项，招呼语",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "闭合式/熟悉的谈话者，听觉描述—闭合式阶段 1-4，听觉记忆 3-4 项",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "开放式/熟悉的谈话者，听觉描述—开放式阶段 1-4",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "开放式/熟悉的谈话者/同一话题的对谈",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "开放式/熟悉的谈话者/延伸话题的对谈",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "闭合式/陌生的谈话者/主题式对谈a 事先设定情境（可预知谈话主题）b 告知孩子主题并事先讨论谈话内容",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "开放式/非主题式对话",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									}
								]
							},
							{
								"ly_name": "主动聆听技巧",
								"value": [{
										"name": "闭合式（事先预知谈话主题）/近距离/熟悉者的声音",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "闭合式/加长距离/熟悉者的声音/两人谈话",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "闭合式/加入背景噪音/熟悉者的声音/两人对话",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "闭合式/近距离/加入陌生者的声音/两人对话",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "闭合式/加长距离/陌生者的声音/两人对话",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "闭合式/加入背景噪音/陌生者的声音/两人对话",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "开放式（不事先告知主题）/重复阶段1-6 /两人对话",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									},
									{
										"name": "开放式/重复阶段 1-6/三人以上对话",
										"value": [{
												"num": 0,
												"value": ""
											},
											{
												"num": 1,
												"value": ""
											}
										]
									}
								]
							},
							{
								"ly_name": "听觉能力评估",
								"value_sbl": "",
								"value_time": ""
							},
							{
								"ly_name": "CAP听觉行为分级",
								"value_sbl": "",
								"value_time": ""
							}
						]
					}
				},
				// 听能服务日志
				tnfwrz_info: [{
						"id": 19,
						"stu_id": 2693,
						"dijici": "0",
						"duoxuan": {
							"biaoti": "工作内容",
							"xuanxiang": [{
									"name": "听力检测",
									"value": false
								},
								{
									"name": "助听设备验配/调试",
									"value": false
								},
								{
									"name": "助听设备维护",
									"value": false
								},
								{
									"name": "助听设备更换",
									"value": false
								},
								{
									"name": "家长咨询",
									"value": false
								},
								{
									"name": "教师咨询",
									"value": false
								},
								{
									"name": "个 案 会 诊 （可另附页）",
									"value": false
								},
								{
									"name": "其他:",
									"value": false
								}
							],
							"riqi": "",
							"qita": "",
							"duoxuanchucun": [
								"助听设备验配/调试",
								"助听设备更换",
								"教师咨询",
								"个 案 会 诊 （可另附页）",
								"助听设备维护"
							]
						},
						"tianxie": {
							"tianxie_xinxi": [{
									"biaoti": "问题",
									"neirong": "将心比心您"
								},
								{
									"biaoti": "处理及结果",
									"neirong": ""
								},
								{
									"biaoti": "后期观察及反馈",
									"neirong": ""
								}
							],
							"pinggu": {
								"biaoti": "评估人员：",
								"neirong": ""
							}
						},
						"year": "",
						"org_id": 78,
						"stu_ID": "",
						"stu_name": "",
						"sex": "",
						"chushenriqi": ""
					},
					{
						"id": 21,
						"stu_id": '',
						"dijici": "1",
						"duoxuan": {
							"biaoti": "工作内容",
							"xuanxiang": [{
									"name": "听力检测",
									"value": false
								},
								{
									"name": "助听设备验配/调试",
									"value": false
								},
								{
									"name": "助听设备维护",
									"value": false
								},
								{
									"name": "助听设备更换",
									"value": false
								},
								{
									"name": "家长咨询",
									"value": false
								},
								{
									"name": "教师咨询",
									"value": false
								},
								{
									"name": "个 案 会 诊 （可另附页）",
									"value": false
								},
								{
									"name": "其他:",
									"value": false
								}
							],
							"riqi": "",
							"qita": "",
							"duoxuanchucun": [
								"助听设备验配/调试",
								"个 案 会 诊 （可另附页）",
								"助听设备更换",
								"教师咨询"
							]
						},
						"tianxie": {
							"tianxie_xinxi": [{
									"biaoti": "问题",
									"neirong": ""
								},
								{
									"biaoti": "处理及结果",
									"neirong": ""
								},
								{
									"biaoti": "后期观察及反馈",
									"neirong": ""
								}
							],
							"pinggu": {
								"biaoti": "评估人员：",
								"neirong": ""
							}
						},
						"year": "",
						"org_id": '',
						"stu_ID": "",
						"stu_name": ""
					},
					{
						"id": 18,
						"stu_id": '',
						"dijici": "2",
						"duoxuan": {
							"biaoti": "工作内容",
							"xuanxiang": [{
									"name": "听力检测",
									"value": false
								},
								{
									"name": "助听设备验配/调试",
									"value": false
								},
								{
									"name": "助听设备维护",
									"value": false
								},
								{
									"name": "助听设备更换",
									"value": false
								},
								{
									"name": "家长咨询",
									"value": false
								},
								{
									"name": "教师咨询",
									"value": false
								},
								{
									"name": "个 案 会 诊 （可另附页）",
									"value": false
								},
								{
									"name": "其他:",
									"value": false
								}
							],
							"riqi": "",
							"qita": "",
							"duoxuanchucun": [
								"个 案 会 诊 （可另附页）",
								"家长咨询",
								"助听设备更换",
								"助听设备验配/调试"
							]
						},
						"tianxie": {
							"tianxie_xinxi": [{
									"biaoti": "问题",
									"neirong": ""
								},
								{
									"biaoti": "处理及结果",
									"neirong": ""
								},
								{
									"biaoti": "后期观察及反馈",
									"neirong": ""
								}
							],
							"pinggu": {
								"biaoti": "评估人员：",
								"neirong": ""
							}
						},
						"year": "",
						"org_id": '',
						"stu_ID": "",
						"stu_name": ""
					}
				],
				// 成长评价建议
				czpjjy_info: {
					"id": 7,
					"stu_id": "",
					"shujv": {
						"shengao": "",
						"tizhong": "",
						"xuesesu": "",
						"quzhi": "",
						"qinzengquzhi": "",
						"shili_zuo": "",
						"shili_you": "",
						"pinglun": "",
						"beizhu": "",
						"jianyi": "",
						"pinggulaoshi": "",
						"pingguriqi": "",
						"wudalingyv": [{
								"biaoti": "健康：",
								"tishi": "可从身心状况、动作发展、生活习惯与生活能力、对助听设备的保护四方面进行描述。",
								"neirong": ""
							},
							{
								"biaoti": "语言：",
								"tishi": "可从倾听与表达、阅读与书写准备两方面进行描述。",
								"neirong": ""
							},
							{
								"biaoti": "社会：",
								"tishi": "可从自我系统、人际交往、社会适应三方面进行描述。",
								"neirong": ""
							},
							{
								"biaoti": "科学：",
								"tishi": "可从数学认知、知识经验、科学探究三方面进行描述。",
								"neirong": ""
							},
							{
								"biaoti": "艺术：",
								"tishi": "可从数学认知感受与欣赏、表现与创造两方面进行描述。",
								"neirong": ""
							}
						]
					},
					"org_id": '',
					"year": "",
					"stu_ID": "",
					"stu_name": "",
					"sex": "",
					"chushenriqi": ""
				},
				// 结案报告
				jabg_info: {
					"id": 7,
					"stu_id": "",
					"jibenxinxi": {
						"biaoti": "基本信息",
						"lianxiren": "",
						"lianxirenguanxi": "",
						"lianxidianhua": "",
						"tongxundizhi": "",
						"huikousuozaidi": {
							"sheng": "",
							"shi": "",
							"xian": ""
						}
					},
					"zhutingshebenpeidaiqingkuang": {
						"biaoti": "助听设备配戴情况",
						"xunhuan": [{
								"biaoti": "左耳",
								"fangshi": "补偿/重建方式:",
								"fangshi_jieguo": "",
								"shijian": "验配/开机时间:",
								"shijian_jieguo": "",
								"xunhuan": [{
										"biaoti": "型号：",
										"jieguo": ""
									},
									{
										"biaoti": "程序：",
										"jieguo": ""
									},
									{
										"biaoti": "音量/敏感度：",
										"jieguo": ""
									}
								]
							},
							{
								"biaoti": "右耳",
								"fangshi": "补偿/重建方式:",
								"fangshi_jieguo": "",
								"shijian": "验配/开机时间:",
								"shijian_jieguo": "",
								"xunhuan": [{
										"biaoti": "型号：",
										"jieguo": ""
									},
									{
										"biaoti": "程序：",
										"jieguo": ""
									},
									{
										"biaoti": "音量/敏感度：",
										"jieguo": ""
									}
								]
							}
						]
					},
					"pinggujieguozhaiyao": {
						"biaoti1": "评估结果摘要",
						"biaoti2": "认知与学习能力评估结果（根据年龄选做其一）",
						"biaoti3": "康复结语：",
						"biaoti3_jieguo": "",
						"xunhuan1": [{
								"biaoti1": "听力、言语残疾儿童听觉能力评估标准——康复级别",
								"biaoti2": "级别：",
								"biaoti2_jieguo": "",
								"biaoti3": "CAP听觉行为分级:",
								"biaoti3_jieguo": "",
								"biaoti4": "级"
							},
							{
								"biaoti1": "听力、言语残疾儿童言语能力评估标准——康复级别",
								"biaoti2": "级别：",
								"biaoti2_jieguo": "",
								"biaoti3": "SIR言语可懂度分级::",
								"biaoti3_jieguo": "",
								"biaoti4": "级"
							}
						],
						"xunhuan2": [{
								"biaoti1": "格雷费斯儿童精神发育商—— ",
								"biaoti1_jieguo": "",
								"biaoti2": "级"
							},
							{
								"biaoti1": "希-内学习能力商——",
								"biaoti1_jieguo": "",
								"biaoti2": "级"
							},
							{
								"biaoti1": "智商——",
								"biaoti1_jieguo": "",
								"biaoti2": "级"
							}
						]
					},
					"jiean": {
						"biaoti1": "结案时间及报告人",
						"biaoti2": "结案时间：",
						"biaoti2_jieguo": "",
						"biaoti3": "报告人：",
						"biaoti3_jieguo": ""
					},
					"org_id": 78,
					"year": "",
					"stu_ID": "",
					"stu_name": "",
					"stu_home": "",
					"minzu": "",
					"family_phone": "",
					"family_name": "",
					"family_ID": ""
				},
				// 回访记录
				hfjl_info: {
					"stu_id": '',
					"id": 8,
					"jibenxinxi": {
						"liyuanshijian": {
							"biaoti": "离园时间:",
							"jieguo": ""
						},
						"huifangfangshi": {
							"biaoti": "回访方式:",
							"jieguo": ""
						},
						"huifangduixiang": {
							"biaoti": "回访对象",
							"jieguo": "",
							"xuanxiang": [{
									"xuanxiangbiaoti": "儿童"
								},
								{
									"xuanxiangbiaoti": "家长"
								}
							]
						},
						"xunhuan": [{
								"wenzi": "回访次数:第",
								"neirong": "",
								"wenzi2": "次"
							},
							{
								"wenzi": "联系方式:",
								"neirong": "",
								"wenzi2": ""
							}
						]
					},
					"kangfuzouxiang": {
						"jiudujigoujixingzhi_jieguo": "",
						"jiudujigoujixingzhi_biaoti": "就读机构及性质",
						"jiudujigoujixingzhi1": [{
								"xuanxiang": "幼儿园"
							},
							{
								"xuanxiang": "普校"
							},
							{
								"xuanxiang": "康复中心"
							},
							{
								"xuanxiang": "特校"
							}
						],
						"jiudujigoujixingzhi2": [{
								"xuanxiang": "家庭康复"
							},
							{
								"xuanxiang": "已工作"
							}
						],
						"jiudujigoujixingzhi_qita_tiankong": "",
						"nianji": "",
						"jigoujiaoxuefangshi": {
							"biaoti": "机构教学方式",
							"xuanxiang": [{
									"xuanxiangbiaoti": "口语"
								},
								{
									"xuanxiangbiaoti": "手语"
								},
								{
									"xuanxiangbiaoti": "手口语"
								}
							],
							"jieguo": ""
						},
						"jigouzhichiqingkuang": {
							"biaoti1": "机构支持情况",
							"biaoti2": "特殊支持:",
							"neirong": ""
						},
						"zhutingshebeishiyongqingkuang": {
							"biaoti": "助听设备使用状况",
							"fenzu1": {
								"biaoti1": "1.每天佩戴助听设备。",
								"biaoti2": "情况说明:",
								"xuanxiang": "是",
								"jieguo": ""
							},
							"fenzu2": {
								"biaoti1": "2.定期维护助听设备。",
								"biaoti2": "情况说明",
								"xuanxiang": "",
								"biaoti3": "调试频率:",
								"biaoti3_neirong": "",
								"biaoti4": "调机地点:",
								"biaoti4_neirong": ""
							},
							"fenzu3": {
								"biaoti1": "3.使用FM系统。",
								"biaoti2": "情况说明:地点",
								"xuanxiang": "",
								"xuanxiang2": ""
							}
						},
						"kangfuxunlian": {
							"biaoti": "康复训练",
							"biaoti2": "1.定期做康复训练。",
							"biaoti3": "情况说明:地点",
							"xuanze1": "",
							"xuanze2": ""
						},
						"jiaoliugoutong": {
							"biaoti": "交流沟通",
							"qingkuangshuoming": "情况说明",
							"xuanze": [{
									"biaoti": "1.主 要 的 交 流 沟 通 方 式。",
									"xuanxiang1": "口语",
									"xuanxiang2": "手语",
									"xuanxiang3": "口手语",
									"jieguo": "",
									"qingkuangshuoming_jieguo": ""
								},
								{
									"biaoti": "2.口 语 表 达 的 清 楚 程 度。",
									"xuanxiang1": "好",
									"xuanxiang2": "中",
									"xuanxiang3": "差",
									"jieguo": "",
									"qingkuangshuoming_jieguo": ""
								},
								{
									"biaoti": "3.周围人对孩子口语表达能力的评价。",
									"xuanxiang1": "好",
									"xuanxiang2": "中",
									"xuanxiang3": "差",
									"jieguo": "",
									"qingkuangshuoming_jieguo": ""
								}
							]
						},
						"shehuishiying": {
							"biaoti": "社会适应",
							"qingkuangshuoming": "情况说明",
							"xuanze": [{
									"biaoti": "有好朋友。",
									"xuanxiang1": "是",
									"xuanxiang2": "否",
									"jieguo": "",
									"qingkuangshuoming_jieguo": ""
								},
								{
									"biaoti": "2.愿意主动结交新朋友。",
									"xuanxiang1": "是",
									"xuanxiang2": "否",
									"jieguo": "",
									"qingkuangshuoming_jieguo": ""
								},
								{
									"biaoti": "3.经常跟家人、朋友谈论学校或身边发生的事。",
									"xuanxiang1": "是",
									"xuanxiang2": "否",
									"jieguo": "",
									"qingkuangshuoming_jieguo": ""
								}
							]
						},
						"xuexiqingkuang": {
							"biaoti": "学习情况",
							"qingkuangshuoming": "情况说明",
							"xuanze": [{
									"biaoti": "1.能听懂课堂内容，不需要课后家长或其他人讲解、复习。",
									"xuanxiang": [{
											"neirong": "是"
										},
										{
											"neirong": "否"
										}
									],
									"jieguo": "",
									"qingkuangshuoming_jieguo": ""
								},
								{
									"biaoti": "2.能认真完成日常作业，不需要成人提供额外帮助。",
									"xuanxiang": [{
											"neirong": "是"
										},
										{
											"neirong": "否"
										}
									],
									"jieguo": "",
									"qingkuangshuoming_jieguo": ""
								},
								{
									"biaoti": "3.学习成绩在班级中的位置",
									"xuanxiang": [{
											"neirong": "优"
										},
										{
											"neirong": "中"
										},
										{
											"neirong": "差"
										}
									],
									"jieguo": "",
									"qingkuangshuoming_jieguo": ""
								}
							],
							"biaoti2": "4. 特长与优势学科：",
							"biaoti2_neirong": ""
						}
					},
					"wentijixvqiu": {
						"wentijixvqiu_biaoti": "问题及需求：",
						"wentijixvqiu_xuanxiang": [{
								"name": "噪音环境下听取不理想",
								"value": false
							},
							{
								"name": "需要更换助听设备",
								"value": false
							},
							{
								"name": "希望定期得到个别化康复教育",
								"value": false
							},
							{
								"name": "家长希望定期得到康复指导",
								"value": false
							},
							{
								"name": "需要心理干预",
								"value": false
							},
							{
								"name": "入普、升学困难",
								"value": false
							},
							{
								"name": "希望得到经济援助",
								"value": false
							}
						],
						"wentijixvqiu_chucun": [],
						"wentijixvqiu_qita": "",
						"wentijixvqiu_danxuan": ""
					},
					"jianyi": {
						"jiangyi_biaoti": "建议：",
						"jianyi_neirong": ""
					},
					"xiacihuifangxvjiaqiang": {
						"xiacihuifangxvjiaqiang_biaoti": "下次回访须加强追踪的内容：",
						"xiacihuifangxvjiaqiang_jieguo": [
							"听能管理",
							"家庭康复状况"
						],
						"qitajieguo": "",
						"xiacihuifangxvjiaqiang_duoxuan": [{
								"name": "助听设备的使用",
								"value": false
							},
							{
								"name": "听能管理",
								"value": false
							},
							{
								"name": "学习状况",
								"value": false
							},
							{
								"name": "社会适应状况",
								"value": false
							},
							{
								"name": "家庭康复状况",
								"value": false
							}
						]
					},
					"huifang": {
						"biaoti1": "回访日期及人员",
						"biaoti2": "回访日期：",
						"biaoti3": "回访人员：",
						"biaoti2_neirong": "",
						"biaoti3_neirong": ""
					},
					"year": "",
					"org_id": '',
					"stu_ID": "",
					"stu_name": "",
					"stu_home": "",
					"minzu": "",
					"family_phone": "",
					"family_name": "",
					"family_ID": "",
					"sex": "",
					"chushenriqi": ""
				},
				// 听觉能力评估
				tjnlpg_info: {
					"id": 7,
					"stu_id": '',
					"xunhuan": [{
							"biaoti": "自然环境声响识别",
							"xuanxiang": [{
									"biaoti": "错误走向记录（正确）——（错误）",
									"neirong": ""
								},
								{
									"biaoti": "最大识别率",
									"neirong": ""
								}
							]
						},
						{
							"biaoti": "语音识别-韵母识别",
							"xuanxiang": [{
									"biaoti": "错误走向记录（正确）——（错误）",
									"neirong": ""
								},
								{
									"biaoti": "最大识别率",
									"neirong": ""
								}
							]
						},
						{
							"biaoti": "语音识别-声母识别",
							"xuanxiang": [{
									"biaoti": "错误走向记录（正确）——（错误）",
									"neirong": ""
								},
								{
									"biaoti": "最大识别率",
									"neirong": ""
								}
							]
						},
						{
							"biaoti": "声调识别",
							"xuanxiang": [{
									"biaoti": "错误走向记录（正确）——（错误）",
									"neirong": ""
								},
								{
									"biaoti": "最大识别率",
									"neirong": ""
								}
							]
						},
						{
							"biaoti": "双音节词识别",
							"xuanxiang": [{
									"biaoti": "错误走向记录（正确）——（错误）",
									"neirong": ""
								},
								{
									"biaoti": "最大识别率",
									"neirong": ""
								}
							]
						},
						{
							"biaoti": "短句识别",
							"xuanxiang": [{
									"biaoti": "错误走向记录（正确）——（错误）",
									"neirong": ""
								},
								{
									"biaoti": "最大识别率",
									"neirong": ""
								}
							]
						},
						{
							"biaoti": "选择性听取",
							"xuanxiang": [{
									"biaoti": "错误走向记录（正确）——（错误）",
									"neirong": ""
								},
								{
									"biaoti": "最大识别率",
									"neirong": ""
								}
							]
						},
						{
							"biaoti": "数字识别",
							"xuanxiang": [{
									"biaoti": "错误走向记录（正确）——（错误）",
									"neirong": ""
								},
								{
									"biaoti": "最大识别率",
									"neirong": ""
								}
							]
						},
						{
							"biaoti": "单音节词（字）识别",
							"xuanxiang": [{
									"biaoti": "错误走向记录（正确）——（错误）",
									"neirong": ""
								},
								{
									"biaoti": "最大识别率",
									"neirong": ""
								}
							]
						},
						{
							"biaoti": "三音节词识别",
							"xuanxiang": [{
									"biaoti": "错误走向记录（正确）——（错误）",
									"neirong": ""
								},
								{
									"biaoti": "最大识别率",
									"neirong": ""
								}
							]
						}
					],
					"tiankong": {
						"tingjuekangfujibie": "听觉康复级别：",
						"tingjuekangfujibie_jieguo": "",
						"yanyvshibiepingjundefen": "言语识别平均得分：",
						"yanyvshibiepingjundefen_jieguo": "",
						"kangfujianyi": "康复建议：",
						"kangfujianyi_jieguo": ""
					},
					"pinggu": {
						"biaoti1": "评估人员及日期",
						"biaoti2": "评估日期：",
						"biaoti2_jieguo": "",
						"biaoti3": "评估人员：",
						"biaoti3_jieguo": "",
						"biaoti4": "测试环境:",
						"biaoti4_jieguo": ""
					},
					"org_id": '',
					"year": "",
					"stu_ID": "",
					"stu_name": "",
					"stu_home": "",
					"minzu": "",
					"family_phone": "",
					"family_name": "",
					"family_ID": ""
				},
				// CAP分级表
				cap_info: {
					"id": 17,
					"stu_id": "",
					"awp": {
						"stu_sfz": "",
						"CAPfuhehaizishijiqingkuang": "",
						"jibie": "",
						"ceshihuanjing": "",
						"quezhenriqi": "",
						"quezhen_riqi": "",
						"value2": "",
						"lingyv": [{
								"value": "0",
								"value3": "不能察觉到环境声。"
							},
							{
								"value": "1",
								"value3": "能察觉到环境声。"
							},
							{
								"value": "2",
								"value3": "对言语声有反应。"
							},
							{
								"value": "3",
								"value3": "能识别出环境声。"
							},
							{
								"value": "4",
								"value3": "不借助唇读能分辨一些言语声。"
							},
							{
								"value": "5",
								"value3": "不借助唇读能理解常用短语。"
							},
							{
								"value": "6",
								"value3": "不借助唇读能理解交谈内容。"
							},
							{
								"value": "7",
								"value3": "能和认识的人打电话。"
							},
							{
								"value": "8",
								"value3": "在有回声或干扰噪声的房间（如教室或餐厅）里能听懂一组人交谈。"
							},
							{
								"value": "9",
								"value3": "在不知话题时能和陌生人打电话。"
							}
						],
						"pinggurenyuan": ""
					},
					"org_id": '',
					"year": "",
					"stu_ID": "",
					"stu_name": "",
					"stu_home": "",
					"minzu": "",
					"family_phone": "",
					"family_name": "",
					"family_ID": "",
					"sex": "",
					"chushenriqi": ""
				},
				// 语言能力评估
				yynlpg_info: {
					"stu_id": '',
					"id": 5,
					"xunhuan": [{
							"biaoti": "词汇量",
							"xuanxiang": [{
									"biaoti": "测试记录",
									"neirong": ""
								},
								{
									"biaoti": "测试结果",
									"neirong": ""
								},
								{
									"biaoti": "语言年龄",
									"neirong": ""
								}
							]
						},
						{
							"biaoti": "语法能力（模仿句长）",
							"xuanxiang": [{
									"biaoti": "测试记录",
									"neirong": ""
								},
								{
									"biaoti": "测试结果",
									"neirong": ""
								},
								{
									"biaoti": "语言年龄",
									"neirong": ""
								}
							]
						},
						{
							"biaoti": "理解能力（听话识图）",
							"xuanxiang": [{
									"biaoti": "测试记录",
									"neirong": ""
								},
								{
									"biaoti": "测试结果",
									"neirong": ""
								},
								{
									"biaoti": "语言年龄",
									"neirong": ""
								}
							]
						},
						{
							"biaoti": "表达能力（看图说话）",
							"xuanxiang": [{
									"biaoti": "测试记录",
									"neirong": ""
								},
								{
									"biaoti": "测试结果",
									"neirong": ""
								},
								{
									"biaoti": "语言年龄",
									"neirong": ""
								}
							]
						},
						{
							"biaoti": "交往能力（主题对话）",
							"xuanxiang": [{
									"biaoti": "测试记录",
									"neirong": ""
								},
								{
									"biaoti": "测试结果",
									"neirong": ""
								},
								{
									"biaoti": "语言年龄",
									"neirong": ""
								}
							]
						},
						{
							"biaoti": "语音清晰度（%）",
							"xuanxiang": [{
									"biaoti": "测试记录",
									"neirong": ""
								},
								{
									"biaoti": "测试结果",
									"neirong": ""
								},
								{
									"biaoti": "语言年龄",
									"neirong": ""
								}
							]
						}
					],
					"tiankong": {
						"yvyankangfujibie": "语言康复级别",
						"yvyankangfujibie_jieguo": "",
						"pingjunnianlingshuiping": "平均语言年龄水平",
						"pingjunnianlingshuiping_jieguo": "",
						"kangfujianyi": "康复建议：",
						"kangfujianyi_jieguo": ""
					},
					"pinggu": {
						"biaoti1": "评估人员及日期",
						"biaoti2": "评估日期：",
						"biaoti2_jieguo": "",
						"biaoti3": "评估人员：",
						"biaoti3_jieguo": "",
						"biaoti4": "测试环境:",
						"biaoti4_jieguo": ""
					},
					"org_id": '',
					"year": "",
					"stu_ID": "",
					"stu_name": "",
					"stu_home": "",
					"minzu": "",
					"family_phone": "",
					"family_name": "",
					"family_ID": "",
					"sex": "",
					"chushenriqi": ""
				},
				// SIR分级表
				sir_info: {
					"id": 11,
					"stu_id": "",
					"awp": {
						"stu_sfz": "",
						"SIRfuhehaizishijiqingkuang": "",
						"jibie": "",
						"ceshihuanjing": "",
						"quezhenriqi": "",
						"quezhen_riqi": "",
						"value2": "",
						"lingyv": [{
								"value": "0",
								"value3": "其连贯的言语(短语或句子)不能被听懂。其口语中的词汇不易被识别，日常交流的主要方式为手势。"
							},
							{
								"value": "1",
								"value3": "其连贯的言语不能被听懂。当结合上下文和唇读线索时，其言语中的单个词汇可逐渐被听懂。"
							},
							{
								"value": "2",
								"value3": "当集中注意力并结合唇读线索时，其连贯的言语能被听懂。"
							},
							{
								"value": "3",
								"value3": "其连贯的言语能被不熟悉的人听懂。"
							},
							{
								"value": "4",
								"value3": "其连贯的言语能被所有人听懂。日常语境下，儿童的言语能被轻易听懂。"
							}
						],
						"pinggurenyuan": ""
					},
					"org_id": '',
					"year": "",
					"stu_ID": "",
					"stu_name": "",
					"stu_home": "",
					"minzu": "",
					"family_phone": "",
					"family_name": "",
					"family_ID": "",
					"sex": "",
					"chushenriqi": ""
				},
				// 特殊病案会诊
				tsbahz_info: {
					"id": 10,
					"stu_id": "",
					"teshubinganhuihzhenjilu": {
						"stu_sfz": "",
						"teshubinganhuihzhenjilu": [{
								"value": "会诊专家",
								"value2": ""
							},
							{
								"value": "主要照顾者描述",
								"value2": ""
							},
							{
								"value": "个别化教师描述",
								"value2": ""
							},
							{
								"value": "集体教师描述",
								"value2": ""
							},
							{
								"value": "听力师描述",
								"value2": ""
							},
							{
								"value": "专家会诊意见",
								"value2": ""
							}
						],
						"stu_id": null,
						"huizhenshijian": ""
					},
					"org_id": '',
					"year": "",
					"stu_ID": "",
					"stu_name": "",
					"stu_home": "",
					"minzu": "",
					"family_phone": "",
					"family_name": "",
					"family_ID": ""
				},
				// 格雷费斯报告
				glfs_info: {
					"id": 9,
					"stu_id": '',
					"jibenxinxi": {
						"xunhuan1": [{
								"biaoti": "出生体重:",
								"biaoti_jieguo": ""
							},
							{
								"biaoti": "孕期:",
								"biaoti_jieguo": ""
							}
						],
						"xunhuan2": [{
								"biaoti": "胎:",
								"biaoti_jieguo": ""
							},
							{
								"biaoti": "产:",
								"biaoti_jieguo": ""
							},
							{
								"biaoti": "顺（难）产:",
								"biaoti_jieguo": ""
							}
						],
						"xunhuan3": [{
								"biaoti": "曾患病:",
								"biaoti_jieguo": ""
							},
							{
								"biaoti": "现患病:",
								"biaoti_jieguo": ""
							}
						],
						"xunhuan4": [{
								"xunhuan": [{
										"biaoti": "父亲:",
										"biaoti_jieguo": ""
									},
									{
										"biaoti": "民族:",
										"biaoti_jieguo": ""
									},
									{
										"biaoti": "职业:",
										"biaoti_jieguo": ""
									},
									{
										"biaoti": "文化程度:",
										"biaoti_jieguo": ""
									},
									{
										"biaoti": "儿童出生时年龄:",
										"biaoti_jieguo": ""
									}
								]
							},
							{
								"xunhuan": [{
										"biaoti": "母亲:",
										"biaoti_jieguo": ""
									},
									{
										"biaoti": "民族:",
										"biaoti_jieguo": ""
									},
									{
										"biaoti": "职业:",
										"biaoti_jieguo": ""
									},
									{
										"biaoti": "文化程度:",
										"biaoti_jieguo": ""
									},
									{
										"biaoti": "儿童出生时年龄:",
										"biaoti_jieguo": ""
									}
								]
							}
						]
					},
					"chucun": [
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"xunhuan": [{
							"biaoti": "运动",
							"jieguo1": "0"
						},
						{
							"biaoti": "社交",
							"jieguo1": "0"
						},
						{
							"biaoti": "听力言语",
							"jieguo1": "0"
						},
						{
							"biaoti": "手眼协调",
							"jieguo1": "0"
						},
						{
							"biaoti": "操作",
							"jieguo1": "0"
						},
						{
							"biaoti": "推理",
							"jieguo1": "0"
						}
					],
					"beizhu": {
						"biaoti": "分析与建议",
						"biaoti_jieguo": ""
					},
					"pinggu": {
						"biaoti": "评估人员、日期及环境",
						"pinggu_riqi_biaoti": "评估日期：",
						"pinggu_riqi": "",
						"pinggu_renyuan_biaoti": "评估人员：",
						"pinggu_renyuan": "",
						"ceshi_huanjing_biaoti": "测试环境：",
						"ceshi_huanjing": ""
					},
					"org_id": '',
					"year": "",
					"stu_ID": "",
					"stu_name": "",
					"stu_home": "",
					"minzu": "",
					"family_phone": "",
					"family_name": "",
					"family_ID": "",
					"sex": "",
					"chushenriqi": ""
				},
				// 希一内报告单
				xybgd_info: {
					"id": 15,
					"stu_id": '',
					"chucunsujv": {
						"jibenshujv": [{
								"biaoti": "实际年龄"
							},
							{
								"biaoti": "中位数智龄"
							},
							{
								"biaoti": "智商/学习能力商"
							},
							{
								"biaoti": "百分位数"
							}
						],
						"chucun2": [
							"",
							"",
							"",
							""
						],
						"chucun": [{
								"neirong": [
									0,
									0
								]
							},
							{
								"neirong": [
									0,
									0
								]
							},
							{
								"neirong": [
									0,
									0
								]
							},
							{
								"neirong": [
									0,
									0
								]
							},
							{
								"neirong": [
									0,
									0
								]
							},
							{
								"neirong": [
									0,
									0
								]
							},
							{
								"neirong": [
									0,
									0
								]
							}
						]
					},
					"xunhuan": [{
							"biaoti": "穿珠"
						},
						{
							"biaoti": "记颜色"
						},
						{
							"biaoti": "图"
						},
						{
							"biaoti": "联想辩认"
						},
						{
							"biaoti": "折纸"
						},
						{
							"biaoti": "摆方木"
						},
						{
							"biaoti": "完成图"
						}
					],
					"beizhu": {
						"biaoti": "分析与建议",
						"biaoti_jieguo": ""
					},
					"pinggu": {
						"biaoti": "评估人员、日期及环境",
						"pinggu_riqi_biaoti": "评估日期：",
						"pinggu_riqi": "",
						"pinggu_renyuan_biaoti": "评估人员：",
						"pinggu_renyuan": "",
						"ceshi_huanjing_biaoti": "测试环境：",
						"ceshi_huanjing": ""
					},
					"org_id": '',
					"year": "",
					"stu_ID": "",
					"stu_name": "",
					"stu_home": "",
					"minzu": "",
					"family_phone": "",
					"family_name": "",
					"family_ID": "",
					"sex": "",
					"chushenriqi": ""
				},
				sum_yue: 0,
				sum: 0
			}
		},
		async created() {
			var urlParams = new URLSearchParams(window.location.search);
			this.stu_id = urlParams.get('stuid')
			this.org_id = urlParams.get('org_id')
			this.stu_type = urlParams.get('stu_type')
			this.stu_name = urlParams.get('stu_name')
			this.year = new Date(urlParams.get('nian')).getFullYear()
			this.date_time_year = urlParams.get('nian')
			await this.request_get()
		},
		watch: {
			date_time_year() {
				console.log("改变时间了");
				let data = new Date(this.date_time_year)
				this.year = data.getFullYear()
				this.stu_info_tlyy = {
					stu_info_jbxx: {

					},
					family_zhuangkuang: {

					},
					ruyuan_info: {

					}
				}
				// 临床数据
				this.lcsj_info = {
						gerenshi: [{
								"name": "患过某病",
								"value": [{
										"name": "脑膜炎 ",
										"value": ""
									},
									{
										"name": "斑疹伤寒",
										"value": ""
									},
									{
										"name": "大脑炎 ",
										"value": ""
									},
									{
										"name": "伤寒",
										"value": ""
									},
									{
										"name": "麻疹",
										"value": ""
									},
									{
										"name": "流感 ",
										"value": ""
									},
									{
										"name": "肝炎 ",
										"value": ""
									},
									{
										"name": "猩红热",
										"value": ""
									},
									{
										"name": "腮腺炎",
										"value": ""
									},
									{
										"name": "小儿麻疹",
										"value": ""
									},
									{
										"name": "百日咳 ",
										"value": ""
									},
									{
										"name": "风疹 ",
										"value": ""
									},
									{
										"name": "水痘",
										"value": ""
									},
									{
										"name": "肺炎",
										"value": ""
									},
									{
										"name": "疟疾  ",
										"value": ""
									},
									{
										"name": "腹泻",
										"value": ""
									},
									{
										"name": "中耳炎",
										"value": ""
									},
									{
										"name": "黄疽",
										"value": ""
									},
									{
										"name": "其他",
										"value": ""
									}
								]
							},
							{
								"name": "患病时情况",
								"value": [{
										"name": "发热",
										"value": ""
									},
									{
										"name": "惊厥",
										"value": ""
									},
									{
										"name": "冲突",
										"value": ""
									},
									{
										"name": "其他",
										"value": ""
									}
								]
							},
							{
								"name": "病程及治疗情况",
								"value": ""
							},
							{
								"name": "耳聋前耳中毒药物史",
								"value": [
									"无",
									"不清楚",
									"有"
								],
								"jieguo": ""
							},
							{
								"name": "耳中毒药物",
								"value": ""
							},
							{
								"name": "用药原因",
								"value": ""
							},
							{
								"name": "用药剂量",
								"value": ""
							},
							{
								"name": "用药时间",
								"value": "请选择"
							},
							{
								"name": "药物过敏",
								"value": ""
							},
							{
								"name": "平衡障碍",
								"value": [
									"无",
									"有"
								],
								"jieguo": ""
							},
							{
								"name": "全身情况",
								"value": [
									"好",
									"一般",
									"差"
								],
								"jieguo": ""
							},
							{
								"name": "耳聋治疗情况",
								"value": [
									"无",
									"有"
								],
								"jieguo": ""
							},
							{
								"name": "噪音暴露史",
								"value": ""
							},
							{
								"name": "放射线接触",
								"value": [
									"无",
									"有"
								],
								"jieguo": ""
							},
							{
								"name": "其他",
								"value": ""
							}
						],
						chushengshi: [{
								"name": "妊娠天数",
								"value1": "",
								"value2": ""
							},
							{
								"name": "产次",
								"value": ""
							},
							{
								"name": "助产方式",
								"value": [
									"产钳",
									"剖腹产",
									"牵引产"
								],
								"jieguo": ""
							},
							{
								"name": "出生时",
								"value": [
									"缺氧",
									"窒息",
									"宫内窘迫"
								],
								"jieguo": ""
							},
							{
								"name": "分娩方式",
								"value": [
									"顺产",
									"早产",
									"难产"
								],
								"jieguo": ""
							},
							{
								"name": "产程",
								"value": [
									"正常",
									"长",
									"短"
								],
								"jieguo": ""
							},
							{
								"name": "出生时体重",
								"value": ""
							}
						],
						jiazushi: [{
								"name": "家族中是否还有耳聋病人",
								"value": [
									"是（选择是时，需要填写以下2项）",
									"否"
								],
								"jieguo": ""
							},
							{
								"name": "与患者关系",
								"value": ""
							},
							{
								"name": "家族病史备注",
								"value": ""
							},
							{
								"name": "父母是否近亲结婚",
								"value": [
									"是（选择是时，需要填写以下1项）",
									"否"
								],
								"jieguo": ""
							},
							{
								"name": "近亲结婚备注",
								"value": ""
							}
						],
						renshenshi: [{
								"name": "母亲(3—4个月)是否传染病史",
								"value": [
									"是，曾患：",
									"否"
								],
								"jieguo": "",
								"neirong": ""
							},
							{
								"name": "母亲是否有耳毒性药物史",
								"value": [
									"否",
									"是(选择有时，需要填写以下信息)"
								],
								"jieguo": ""
							},
							{
								"name": "毒性药物",
								"value": [
									"链霉素",
									"庆大霉索",
									"卡那霉素",
									"新霉素",
									"其他："
								],
								"jieguo": "",
								"qita": ""
							},
							{
								"name": "用药原因",
								"value": ""
							},
							{
								"name": "用药剂量为",
								"value1": "",
								"value2": ""
							},
							{
								"name": "有何反应",
								"value": ""
							},
							{
								"name": "先兆流产",
								"value": [
									"有（选择有时，需要填写以下信息",
									"无"
								],
								"jieguo": ""
							},
							{
								"name": "先兆流产发生时间：",
								"value": "请选择"
							},
							{
								"name": "程度",
								"value": [
									"轻",
									"中",
									"重"
								],
								"jieguo": ""
							},
							{
								"name": "曾用保胎药",
								"value": ""
							},
							{
								"name": "有无子痫（高血压）",
								"value": [
									"有",
									"无"
								],
								"jieguo": ""
							},
							{
								"name": "妊娠反应",
								"value": [
									"重",
									"中",
									"轻",
									"无反应"
								],
								"jieguo": ""
							},
							{
								"name": "妊娠外伤史：",
								"value": ""
							},
							{
								"name": "妊娠期其他疾病：",
								"value": ""
							}
						],
						tigejiancha: [{
								"name": "耳部检查",
								"value": [
									"异常",
									"正常"
								],
								"jieguo": ""
							},
							{
								"name": "发育",
								"value": [
									"异常",
									"正常"
								],
								"jieguo": ""
							},
							{
								"name": "骨骼",
								"value": [
									"异常",
									"正常"
								],
								"jieguo": ""
							},
							{
								"name": "甲状腺",
								"value": [
									"异常",
									"正常"
								],
								"jieguo": ""
							},
							{
								"name": "毛发",
								"value": [
									"异常",
									"正常"
								],
								"jieguo": ""
							},
							{
								"name": "视力视野",
								"value": [
									"异常",
									"正常"
								],
								"jieguo": ""
							},
							{
								"name": "虹膜",
								"value": [
									"异常",
									"正常"
								],
								"jieguo": ""
							},
							{
								"name": "巩膜",
								"value": [
									"异常",
									"正常"
								],
								"jieguo": ""
							}
						],
						erlongshi: [{
								"name": "何时出现耳聋",
								"value": [
									"自幼听力正常，言语障碍",
									"出生后正常听力——后听力逐渐障碍",
									"自幼言语不清，听力略障碍",
									"自幼听力言语障碍"
								],
								"jieguo": ""
							},
							{
								"name": "何时发现耳聋",
								"value": [{
									"name": "发现耳聋时间：",
									"value": ""
								}]
							},
							{
								"name": "可听见何种声音",
								"value": [{
										"name": "打雷声",
										"value": ""
									},
									{
										"name": "鞭炮声",
										"value": ""
									},
									{
										"name": "汽车喇叭声",
										"value": [
											"汽车喇叭声"
										]
									},
									{
										"name": "大声说话",
										"value": ""
									},
									{
										"name": "拍手声",
										"value": [
											"拍手声"
										]
									},
									{
										"name": "普通讲话声",
										"value": [
											"普通讲话声"
										]
									},
									{
										"name": "其他",
										"value": ""
									}
								]
							},
							{
								"name": "目前配戴助听设备情况",
								"value": [{
										"name": "左耳",
										"value": [{
												"name": "助听设备",
												"jieguo": "",
												"value": [
													"助听器",
													"人工耳蜗",
													"其它"
												]
											},
											{
												"name": "验配或开机时间",
												"value": "请选择"
											},
											{
												"name": "佩戴时间",
												"jieguo": "",
												"yuanyin": "",
												"value": [
													"能持续佩戴",
													"除睡觉洗澡等外的时间都可以全天配戴",
													"其他",
													"不能持续佩戴"
												]
											}
										]
									},
									{
										"name": "右耳",
										"value": [{
												"name": "助听设备",
												"jieguo": "",
												"value": [
													"助听器",
													"人工耳蜗",
													"其它"
												]
											},
											{
												"name": "验配或开机时间",
												"value": "请选择"
											},
											{
												"name": "佩戴时间",
												"jieguo": "",
												"yuanyin": "",
												"value": [
													"能持续佩戴",
													"除睡觉洗澡等外的时间都可以全天配戴",
													"其他",
													"不能持续佩戴"
												]
											}
										]
									}
								]
							},
							{
								"name": "曾去何地治疗",
								"value": [{
										"name": "首次医院",
										"value": ""
									},
									{
										"name": "就诊时间",
										"value": "请选择"
									},
									{
										"name": "结果",
										"value": [{
												"name": "左耳",
												"value": ""
											},
											{
												"name": "右耳",
												"value": ""
											}
										]
									}
								]
							},
							{
								"name": "接受语言训练史",
								"value": ""
							},
							{
								"name": "耳聋时伴有何其他症状",
								"value": ""
							}
						],
					},
					// 日常教学记录
					this.rcjxjh_info = {
						"b_id": 49,
						"stu_id": 2227,
						"tea_id": 979,
						"tea_name": "",
						"stu_name": "",
						"age": "",
						"sex": "",
						"ztq_pd": "",
						"cg": {
							"neirong": {
								"ztq_zt": {
									"value": "",
									"bc": ""
								},
								"six_yin": {
									"cj": {
										"value": [{
												"name": "一次",
												"value": [{
														"name": "a",
														"value": ""
													},
													{
														"name": "i",
														"value": ""
													},
													{
														"name": "u",
														"value": ""
													},
													{
														"name": "sh",
														"value": ""
													},
													{
														"name": "s",
														"value": ""
													},
													{
														"name": "m",
														"value": ""
													}
												]
											},
											{
												"name": "二次",
												"value": [{
														"name": "a",
														"value": ""
													},
													{
														"name": "i",
														"value": ""
													},
													{
														"name": "u",
														"value": ""
													},
													{
														"name": "sh",
														"value": ""
													},
													{
														"name": "s",
														"value": ""
													},
													{
														"name": "m",
														"value": ""
													}
												]
											},
											{
												"name": "三次",
												"value": [{
														"name": "a",
														"value": ""
													},
													{
														"name": "i",
														"value": ""
													},
													{
														"name": "u",
														"value": ""
													},
													{
														"name": "sh",
														"value": ""
													},
													{
														"name": "s",
														"value": ""
													},
													{
														"name": "m",
														"value": ""
													}
												]
											}
										],
										"jl": null
									},
									"bs": {
										"value": [{
												"name": "一次",
												"value": [{
														"name": "a",
														"value": ""
													},
													{
														"name": "i",
														"value": ""
													},
													{
														"name": "u",
														"value": ""
													},
													{
														"name": "sh",
														"value": ""
													},
													{
														"name": "s",
														"value": ""
													},
													{
														"name": "m",
														"value": ""
													}
												]
											},
											{
												"name": "二次",
												"value": [{
														"name": "a",
														"value": ""
													},
													{
														"name": "i",
														"value": ""
													},
													{
														"name": "u",
														"value": ""
													},
													{
														"name": "sh",
														"value": ""
													},
													{
														"name": "s",
														"value": ""
													},
													{
														"name": "m",
														"value": ""
													}
												]
											},
											{
												"name": "三次",
												"value": [{
														"name": "a",
														"value": ""
													},
													{
														"name": "i",
														"value": ""
													},
													{
														"name": "u",
														"value": ""
													},
													{
														"name": "sh",
														"value": ""
													},
													{
														"name": "s",
														"value": ""
													},
													{
														"name": "m",
														"value": ""
													}
												]
											}
										],
										"jl": null
									}
								}
							},
							"bz": ""
						},
						"tnfz": {
							"neirong": [{
								"text": "",
								"value": ""
							}],
							"bz": ""
						},
						"yyfz1": {
							"neirong": [{
								"text": "",
								"value": ""
							}],
							"bz": ""
						},
						"yyfz2": {
							"neirong": [{
								"text": "",
								"value": ""
							}],
							"bz": ""
						},
						"rzfz": {
							"neirong": [{
								"text": "",
								"value": ""
							}],
							"bz": ""
						},
						"gtjn": {
							"neirong": [{
								"text": "",
								"value": ""
							}],
							"bz": ""
						},
						"jzbx": {
							"one": [],
							"two": [],
							"three": {
								"value": "",
								"bc": ""
							},
							"four": {
								"value": "",
								"bc": ""
							},
							"five": {
								"value": "",
								"bc": ""
							}
						},
						"jtkfjy": "",
						"jtkfjl": "",
						"inser_date": "2024-04-22T06:54:27.000Z",
						"riqi": "2023-04-22",
						"tj_age": "0岁:1月",
						"org_id": "78",
						"year": "2023"
					},
					// 诊断记录
					this.zdjl_info = {
						formData: {
							"leftEar": {
								"option": "",
								"deviceModel": "",
								"program": "",
								"luoerpingjuntingyu": "",
								"zhutingqixiaoguo": "",
								"volumeSensitivity": ""
							},
							"rightEar": {
								"option": "",
								"deviceModel": "",
								"program": "",
								"volumeSensitivity": "",
								"luoerpingjuntingyu": "",
								"zhutingqixiaoguo": ""
							},
							"pingguriqi": "",
							"pinggurenyuan": "",
							"pingguriqi2": "",
							"pinggurenyuan2": "",
							"starttime": "",
							"birthday": "",
							"tingliday": "",
							"rightshebei": "",
							"leftshebei": "",
							"endtime": "",
							"zhenduan": "",
							"pingyu": ""
						},
						testData: {
							"左耳": {
								"assr": {
									"unit": "dBSPL",
									"values": {
										"0.5KHz": null,
										"1KHz": null,
										"2KHz": null,
										"4KHz": null,
										"备注": ''
									},
									"remark": 'null'
								},
								"abr": {
									"values": {
										"0.5KHz": null,
										"1KHz": null,
										"2KHz": null,
										"4KHz": null,
										"备注": ''
									},
									"remark": ""
								},
								"naogan": {
									"values": {
										"0.5KHz": null,
										"1KHz": null,
										"2KHz": null,
										"4KHz": null,
										"备注": ''
									},
									"remark": ""
								},
								"TEOAE": {
									"values": {
										"0.5KHz": null,
										"1KHz": null,
										"2KHz": null,
										"4KHz": null,
										"备注": ''
									},
									"remark": ""
								},
								"DPOAE": {
									"values": {
										"0.5KHz": null,
										"1KHz": null,
										"2KHz": null,
										"4KHz": null,
										"备注": ''
									},
									"remark": ""
								},
								"IMMITTANCE": {
									"values": {
										"0.5KHz": null,
										"1KHz": null,
										"2KHz": null,
										"4KHz": null,
										"备注": ''
									},
									"remark": ""
								},
								"CM": {
									"values": {
										"0.5KHz": null,
										"1KHz": null,
										"2KHz": null,
										"4KHz": null,
										"备注": ''
									},
									"remark": ""
								},
								"ERP": {
									"values": {
										"0.5KHz": null,
										"1KHz": null,
										"2KHz": null,
										"4KHz": null,
										"备注": ''
									},
									"remark": ""
								},
								"SRT": {
									"values": {
										"0.5KHz": null,
										"1KHz": null,
										"2KHz": null,
										"4KHz": null,
										"备注": ''
									},
									"remark": ""
								},
								"SRS": {
									"values": {
										"0.5KHz": null,
										"1KHz": null,
										"2KHz": null,
										"4KHz": null,
										"备注": ''
									},
									"remark": ""
								},
								"SDT": {
									"values": {
										"0.5KHz": null,
										"1KHz": null,
										"2KHz": null,
										"4KHz": null,
										"备注": ''
									},
									"remark": ""
								},
								"zhener": {
									"values": {
										"0.5KHz": null,
										"1KHz": null,
										"2KHz": null,
										"4KHz": null,
										"备注": ''
									},
									"remark": ""
								},
								"shebei": {
									"values": {
										"0.5KHz": null,
										"1KHz": null,
										"2KHz": null,
										"4KHz": null,
										"备注": null
									},
									"remark": ""
								},
								"yingxiangxue": {
									"values": {
										"0.5KHz": null,
										"1KHz": null,
										"2KHz": null,
										"4KHz": null,
										"备注": null
									},
									"remark": ""
								},
								"jiyin": {
									"values": {
										"0.5KHz": null,
										"1KHz": null,
										"2KHz": null,
										"4KHz": null,
										"备注": null
									},
									"remark": ""
								},
								"qita": {
									"values": {
										"0.5KHz": null,
										"1KHz": null,
										"2KHz": null,
										"4KHz": null,
										"备注": null
									},
									"remark": ""
								}
							},
							"右耳": {
								"assr": {
									"unit": "dBSPL",
									"values": {
										"0.5KHz": null,
										"1KHz": null,
										"2KHz": null,
										"4KHz": null,
										"备注": null
									},
									"remark": ""
								},
								"abr": {
									"values": {
										"0.5KHz": null,
										"1KHz": null,
										"2KHz": null,
										"4KHz": null,
										"备注": null
									},
									"remark": ""
								},
								"naogan": {
									"values": {
										"0.5KHz": null,
										"1KHz": null,
										"2KHz": null,
										"4KHz": null,
										"备注": null
									},
									"remark": ""
								},
								"TEOAE": {
									"values": {
										"0.5KHz": null,
										"1KHz": null,
										"2KHz": null,
										"4KHz": null,
										"备注": null
									},
									"remark": ""
								},
								"DPOAE": {
									"values": {
										"0.5KHz": null,
										"1KHz": null,
										"2KHz": null,
										"4KHz": null,
										"备注": null
									},
									"remark": ""
								},
								"IMMITTANCE": {
									"values": {
										"0.5KHz": null,
										"1KHz": null,
										"2KHz": null,
										"4KHz": null,
										"备注": null
									},
									"remark": ""
								},
								"CM": {
									"values": {
										"0.5KHz": null,
										"1KHz": null,
										"2KHz": null,
										"4KHz": null,
										"备注": null
									},
									"remark": ""
								},
								"ERP": {
									"values": {
										"0.5KHz": null,
										"1KHz": null,
										"2KHz": null,
										"4KHz": null,
										"备注": null
									},
									"remark": ""
								},
								"SRT": {
									"values": {
										"0.5KHz": null,
										"1KHz": null,
										"2KHz": null,
										"4KHz": null,
										"备注": null
									},
									"remark": ""
								},
								"SRS": {
									"values": {
										"0.5KHz": null,
										"1KHz": null,
										"2KHz": null,
										"4KHz": null,
										"备注": null
									},
									"remark": ""
								},
								"SDT": {
									"values": {
										"0.5KHz": null,
										"1KHz": null,
										"2KHz": null,
										"4KHz": null,
										"备注": null
									},
									"remark": ""
								},
								"zhener": {
									"values": {
										"0.5KHz": null,
										"1KHz": null,
										"2KHz": null,
										"4KHz": null,
										"备注": null
									},
									"remark": ""
								},
								"shebei": {
									"values": {
										"0.5KHz": null,
										"1KHz": null,
										"2KHz": null,
										"4KHz": null,
										"备注": null
									},
									"remark": ""
								},
								"yingxiangxue": {
									"values": {
										"0.5KHz": null,
										"1KHz": null,
										"2KHz": null,
										"4KHz": null,
										"备注": ""
									},
									"remark": ""
								},
								"jiyin": {
									"values": {
										"0.5KHz": null,
										"1KHz": null,
										"2KHz": null,
										"4KHz": null,
										"备注": null
									},
									"remark": ""
								},
								"qita": {
									"values": {
										"0.5KHz": null,
										"1KHz": null,
										"2KHz": null,
										"4KHz": null,
										"备注": null
									},
									"remark": ""
								}
							}
						},
					},
					// 教学计划
					this.jiaoxuejihua = {
						lingyu: [{
								"value": "听能",
								"value2": "",
								"value3": "tingneng"
							},
							{
								"value": "言语",
								"value2": "",
								"value3": "yanyu"
							},
							{
								"value": "语言",
								"value2": "",
								"value3": "yuyan"
							},
							{
								"value": "认知",
								"value2": "",
								"value3": "renzhi"
							},
							{
								"value": "沟通",
								"value2": "",
								"value3": "goutong"
							},
							{
								"value": "家庭指导计划",
								"value2": ""
							},
							{
								"value": "其他",
								"value2": "",
								"value3": "qita"
							}
						],
					},
					// 首次评估信息
					this.shouci_list = {
						"id": 27,
						"stu_id": "",
						"tinglizhuangkuang": {
							"quezhentime": "",
							"pinggujieguo": [{
									"value": "左耳诊断评估结果",
									"tingsunchengdu": "",
									"chongjianfangshi": "",
									"chongjianfangshi_xinghao": "",
									"time": "",
									"zhuting": [{
											"zhuting_1": "250Hz",
											"zhuting1": "",
											"zhuting_2": "2kHz",
											"zhuting2": ""
										},
										{
											"zhuting_1": "500Hz",
											"zhuting1": "",
											"zhuting_2": "3kHz",
											"zhuting2": ""
										},
										{
											"zhuting_1": "1kHz",
											"zhuting1": "",
											"zhuting_2": "4kHz",
											"zhuting2": ""
										}
									]
								},
								{
									"value": "右耳诊断评估结果",
									"tingsunchengdu": "",
									"chongjianfangshi": "",
									"chongjianfangshi_xinghao": "",
									"time": "请选择日期",
									"zhuting": [{
											"zhuting_1": "250Hz",
											"zhuting1": "",
											"zhuting_2": "2kHz",
											"zhuting2": ""
										},
										{
											"zhuting_1": "500Hz",
											"zhuting1": "",
											"zhuting_2": "3kHz",
											"zhuting2": ""
										},
										{
											"zhuting_1": "1kHz",
											"zhuting1": "",
											"zhuting_2": "4kHz",
											"zhuting2": ""
										}
									]
								}
							],
							"tingli_ciji": ""
						},
						"awp": {
							"tingnenghuanjin": "",
							"tingjuexiguan": "",
							"tingnengguanlibeizhu": "",
							"tingjuejiyi_xiang": "",
							"tingjuejiyi_zuheleixing": "",
							"tingjuemiaoshu_bihe": "",
							"tingjuemiaoshu_kaifang": "",
							"tingjuenengli_beizhu": "",
							"goutongmuoshi": "",
							"lijiexingyvyanchengdu": "",
							"biaodaxingyvyanchengdu": "",
							"biaodaxingyvyanchengdu_tiankong": {
								"mofangfushu_changdu": "",
								"mofangfushu_liru": "",
								"zhudongbiaoda_changdu": "",
								"zhudongbiaoda_liru": ""
							},
							"wenjvnengli": "",
							"wenjvnengli_lijie": "",
							"wenjvnengli_huibiaodawenjv": "",
							"pingjunyvyannianlingshuiping": "",
							"yanyvkedongdu": "",
							"yanyvfasheng": "",
							"chaoshengduan_duoxuan": "",
							"chaoshengduan": [{
									"name": "音长短",
									"value": false
								},
								{
									"name": "音高低",
									"value": false
								},
								{
									"name": "音大小",
									"value": false
								},
								{
									"name": "四声",
									"value": false
								}
							],
							"mofangfasheng": "",
							"mofangfasheng_shuoming": "",
							"yvyannenglibeizhu": "",
							"biaodaxvqiufangshi": "",
							"goutongnengli_biaodaxvqiu": "",
							"dengdainengli": "",
							"goutongnenglibeizhu": "",
							"haoqixin": "",
							"wendingxing": "",
							"xingweiwenti": "",
							"xingweibiaoxian_xingweiwenti": "",
							"xingweibiaoxianbeizhu": "",
							"zilinenglibeizhu": "",
							"jiazhangpeixun": "",
							"jiazhanghudongyouxi": "",
							"qingxvjieduan": "",
							"ketangbiaoxian": "",
							"huiyinghaizixvqiu": "",
							"jiazhangshouxunbeizhu": "",
							"linshiliuyin_duoxuan": "",
							"liuyinfanying": [{
									"name": "察觉",
									"value": false
								},
								{
									"name": "辨识",
									"value": false
								}
							],
							"zhuting_danwei": "dB(HL)",
							"tingnengguanli": [{
									"tingnengguanli_biaoti": "确定家长了解保养及检查助听设备程序",
									"xuanze": ""
								},
								{
									"tingnengguanli_biaoti": "除睡觉及洗澡、游泳外是否都给幼儿配戴助听设备",
									"xuanze": ""
								}
							],
							"pingguneirong_tianxie": [{
									"pingguneirong_biaoti": "已有助听设备保养工具：",
									"neirong": ""
								},
								{
									"pingguneirong_biaoti": "配戴助听设备后幼儿对声音的反应有何改变？",
									"neirong": ""
								}
							],
							"tingjuenengli_xuanxiang": [{
									"tingjuenengli_biaoti": "幼儿对环境声音的反应：",
									"xuanxiang": ""
								},
								{
									"tingjuenengli_biaoti": "幼 儿 对 语 音 的 反 应",
									"xuanxiang": ""
								},
								{
									"tingjuenengli_biaoti": "幼儿对名字、家人称谓的反应",
									"xuanxiang": ""
								}
							],
							"tingjuenengli_linshiliuyin": [{
									"linshiliuyin_biaoti": "距离：",
									"chajue": "",
									"bianshi": ""
								},
								{
									"linshiliuyin_biaoti": "a",
									"chajue": "",
									"bianshi": ""
								},
								{
									"linshiliuyin_biaoti": "i",
									"chajue": "",
									"bianshi": ""
								},
								{
									"linshiliuyin_biaoti": "u",
									"chajue": "",
									"bianshi": ""
								},
								{
									"linshiliuyin_biaoti": "s",
									"chajue": "",
									"bianshi": ""
								},
								{
									"linshiliuyin_biaoti": "sh",
									"chajue": "",
									"bianshi": ""
								},
								{
									"linshiliuyin_biaoti": "m",
									"chajue": "",
									"bianshi": ""
								}
							],
							"tingjuenengli_tianxie": [{
									"tingjuenengli_biaoti1": "听力障碍儿童听觉能力评估标准：",
									"tingjuenengli_biaoti2": "言语识别平均得分：",
									"neirong": ""
								},
								{
									"tingjuenengli_biaoti1": "CAP听觉行为分级记录",
									"tingjuenengli_biaoti2": "级别：",
									"neirong": ""
								}
							],
							"biaodaxingyvyanfazhanjieduan_shifou": "",
							"biaodaxingyvyanfazhanjieduan": [{
									"xuanxiang": "咿呀期（简单发音阶段）："
								},
								{
									"xuanxiang": "儿语期（连续音节阶段）"
								},
								{
									"xuanxiang": "模仿期（学话萌芽阶段）"
								},
								{
									"xuanxiang": "单字期（单词句阶段）"
								},
								{
									"xuanxiang": "胡语期（乱语阶段）"
								},
								{
									"xuanxiang": "简单语词、电报期（双词句阶段）"
								},
								{
									"xuanxiang": "片语、句子和段落（完整句阶段）"
								}
							],
							"renzhinengli": [{
									"renzhinengli_biaoti": "分类：",
									"neirong": ""
								},
								{
									"renzhinengli_biaoti": "配对：",
									"neirong": ""
								},
								{
									"renzhinengli_biaoti": "颜色：",
									"neirong": ""
								},
								{
									"renzhinengli_biaoti": "形状：",
									"neirong": ""
								},
								{
									"renzhinengli_biaoti": "质感：",
									"neirong": ""
								},
								{
									"renzhinengli_biaoti": "数学概念：",
									"neirong": ""
								},
								{
									"renzhinengli_biaoti": "排序：",
									"neirong": ""
								},
								{
									"renzhinengli_biaoti": "其他思维能力：",
									"neirong": ""
								}
							],
							"renzhinengli_tianxie": [{
									"renzhinengli_biaoti1": "格雷费斯儿童精神发育检查报告：",
									"renzhinengli_biaoti2": "发育商：",
									"neirong": ""
								},
								{
									"renzhinengli_biaoti1": "希一内学习能力检验报告",
									"renzhinengli_biaoti2": "智商/学习能力商：",
									"neirong": ""
								}
							],
							"goutongnengli_xuanze": [{
									"goutongnengli_biaoti": "眼神交流：",
									"xuanxiang": "",
									"neirong": ""
								},
								{
									"goutongnengli_biaoti": "主动提问：",
									"xuanxiang": "",
									"neirong": ""
								},
								{
									"goutongnengli_biaoti": "主动互动：",
									"xuanxiang": "",
									"neirong": ""
								},
								{
									"goutongnengli_biaoti": "维持话题：",
									"xuanxiang": "",
									"neirong": ""
								},
								{
									"goutongnengli_biaoti": "开启话题：",
									"xuanxiang": "",
									"neirong": ""
								}
							],
							"zilinengli": [{
									"biaoti": "入厕",
									"xuanxiang": [{
											"xuanxiang_biaoti": "有大小便需求时，能自己入厕",
											"xuanxinag_jieguo": ""
										},
										{
											"xuanxiang_biaoti": "在成人提醒下便后会用水冲洗",
											"xuanxinag_jieguo": ""
										}
									]
								},
								{
									"biaoti": "进餐",
									"xuanxiang": [{
											"xuanxiang_biaoti": "能使用小勺独立进餐",
											"xuanxinag_jieguo": ""
										},
										{
											"xuanxiang_biaoti": "餐后能主动漱口和擦嘴",
											"xuanxinag_jieguo": ""
										}
									]
								},
								{
									"biaoti": "穿衣",
									"xuanxiang": [{
										"xuanxiang_biaoti": "能自己穿脱简单的衣裤和鞋袜",
										"xuanxinag_jieguo": ""
									}]
								},
								{
									"biaoti": "卫生习惯",
									"xuanxiang": [{
											"xuanxiang_biaoti": "能自己擦鼻涕",
											"xuanxinag_jieguo": ""
										},
										{
											"xuanxiang_biaoti": "饭前、便后、手脏时知道洗手",
											"xuanxinag_jieguo": ""
										},
										{
											"xuanxiang_biaoti": "在成人提醒下能早晚刷牙",
											"xuanxinag_jieguo": ""
										}
									]
								},
								{
									"biaoti": "安全",
									"xuanxiang": [{
											"xuanxiang_biaoti": "外出时跟随成人、不乱跑",
											"xuanxinag_jieguo": ""
										},
										{
											"xuanxiang_biaoti": "游戏时不做危险动作",
											"xuanxinag_jieguo": ""
										}
									]
								}
							],
							"jiazhangshouxun1": [{
									"biaoti": "家长技巧学习能力",
									"xuanxiang": {
										"xuanxiang1": "佳",
										"xuanxiang2": "1~2次引导即可",
										"xuanxiang3": "需三次以上引导"
									},
									"jieguo": ""
								},
								{
									"biaoti": "对孩子教养观念与信念",
									"xuanxiang": {
										"xuanxiang1": "佳",
										"xuanxiang2": "有概念但需提醒",
										"xuanxiang3": "无概念"
									},
									"jieguo": ""
								}
							],
							"jiazhangshouxun2": [{
									"biaoti": "对孩子的期望值",
									"xuanxiang": {
										"xuanxiang1": "高",
										"xuanxiang2": "低"
									},
									"jieguo": ""
								},
								{
									"biaoti": "对孩子的敏感度",
									"xuanxiang": {
										"xuanxiang1": "高",
										"xuanxiang2": "低"
									},
									"jieguo": ""
								},
								{
									"biaoti": "对幼儿发展的认知",
									"xuanxiang": {
										"xuanxiang1": "有",
										"xuanxiang2": "无",
										"xuanxiang3": "部分理解"
									},
									"jieguo": ""
								},
								{
									"biaoti": "阅读习惯",
									"xuanxiang": {
										"xuanxiang1": "有",
										"xuanxiang2": "无",
										"xuanxiang3": "有时间就做"
									},
									"jieguo": ""
								},
								{
									"biaoti": "作息规律性",
									"xuanxiang": {
										"xuanxiang1": "规律",
										"xuanxiang2": "不规律"
									},
									"jieguo": ""
								},
								{
									"biaoti": "资料收集能力",
									"xuanxiang": {
										"xuanxiang1": "主动",
										"xuanxiang2": "被动"
									},
									"jieguo": ""
								}
							]
						},
						"zonghefenxi": [{
								"biaoti": "简要描述、判断：",
								"neirong": ""
							},
							{
								"biaoti": "分析：",
								"neirong": ""
							},
							{
								"biaoti": "康复建议：",
								"neirong": ""
							}
						],
						"pinggurenyuanriqi": {
							"time": "",
							"pinggurenyuan": ""
						},
						"org_id": '',
						"ins_date": "",
						"year": "",
						"stu_ID": "",
						"stu_name": "",
						"shengri": "",
						"sex": ""
					},
					// 持续评估信息
					this.cxpg_info = {

						jiazhangbiaoxian: {
							"name": "家长表现",
							"value": [{
									"name": "对课堂教学的配合程度",
									"value": [{
											"name": "很好",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "一般",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "较差",
											"text": "",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										}
									]
								},
								{
									"name": "对已学会的技巧运用情况",
									"value": [{
											"name": "很好",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "一般",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "较差",
											"text": "",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										}
									]
								},
								{
									"name": "家庭康复任务完成情况",
									"value": [{
											"name": "很好",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "一般",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "较差",
											"text": "",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										}
									]
								},
								{
									"name": "在哪些方面有新的进步?",
									"value": ""
								},
								{
									"name": "其它?",
									"value": ""
								}
							]
						},
						goutong: {
							"name": "沟通",
							"value": [{
									"ly_name": "沟通行为",
									"value": [{
											"name": "眼神的注视",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "轮替",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "礼貌用语（例如：再见、谢谢、对不起……）",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "问句",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "主动与他人互动",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "开启话题开放式",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "开启话题闭锁式",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										}
									]
								},
								{
									"ly_name": "沟通策略",
									"value": [{
											"name": "基础",
											"value": [{
													"name": "要求重复",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "证实部分讯息",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "要求说明",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "适当的转换话题",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "分享对话的主导权",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "提供说明",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												}
											]
										},
										{
											"name": "维持同一话题",
											"value": [{
													"name": "一回",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "两回",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "三回",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "延伸话题",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												}
											]
										},
										{
											"name": "高级",
											"value": [{
													"name": "能用正式的言语作为问候与道别",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "能用合宜的方式引起对方的注意",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "能用适当的言语征询他人的同意",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "能询问信息",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "能询问更多的信息",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "能给予评论的意见",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "能给予评论的意见",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "能适当的表达同意",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "能适当的表达不同意",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "能合适的直接请求对方行动",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "能以间接地方式表达自己的需求",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "能合宜的表达抗议",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												}
											]
										}
									]
								}
							]
						},
						renzhi: {
							"name": "认知",
							"value": [{
									"ly_name": "分类及配对",
									"value": [{
											"name": "能从不同类别做同类配对（1 岁）",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "能辨识真实的物品（1 岁）",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "几片大的整片的拼图片块（1 岁）",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "实物与名词图片的配对（1.6~2 岁）",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "实物与动词图片的配对（1.6~2 岁）",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "一模一样的图片（各4 张）（1.6~2岁）",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "同类物品做归类（1.6~2 岁）",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "能依类别将不同东西做归类（1.6~2 岁）",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "5 片小的整片的拼图片块（1.6~2 岁）可配对之图片（2.5 岁）",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "能将各房间东西归类（2.5 岁）",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "分隔各半的拼图及容器（2.5 岁）",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "物品缺少的部分（3 岁）",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "服装与人物之联结（3 岁）",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "动物吃的食物（3 岁）",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "不同商店相关的物品分类（3 岁）以拍拍手玩分类游戏（3 岁）",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "分割 4 片的拼图（3 岁）",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "各种职业的物品配对较复杂（4 岁）",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "较大图景的拼图（4 岁）",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "其它",
											"text": "",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										}
									]
								},
								{
									"ly_name": "颜色",
									"value": [{
											"name": "红色",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "蓝色",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "黄色",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "绿色",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "白色",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "黑色",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "橘色",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "粉红色",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "紫色",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "橙色",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "咖啡色（棕色）",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "黑白色",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "彩色的",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "灰色",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "深",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "浅",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "金色",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "银色",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "金黄色",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "相同—不相同",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "不一样",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										}
									]
								},
								{
									"ly_name": "数字概念",
									"value": [{
											"name": "唱数",
											"value": [{
													"name": "1---3",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "4---6",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "7---10",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "11---20",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "20 以上",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												}
											]
										},
										{
											"name": "认识数字",
											"value": [{
													"name": "1---3",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "4---6",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "7---10",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "11---20",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "20 以上",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "比较数字大小",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												}
											]
										},
										{
											"name": "量的概念",
											"value": [{
													"name": "1---3",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "4---6",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "7---10",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "11---20",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "20 以上",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "比较数量多少",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												}
											]
										},
										{
											"name": "币值的概念",
											"value": [{
													"name": "1角",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "5角",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "1元",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "5元",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "10元",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "20元",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "50元",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "100元",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												}
											]
										},
										{
											"name": "数的运算",
											"value": [{
													"name": "加法",
													"value": [{
															"name": "个位数",
															"value": [{
																	"num": 0,
																	"value": ""
																},
																{
																	"num": 1,
																	"value": ""
																}
															]
														},
														{
															"name": "十位数",
															"value": [{
																	"num": 0,
																	"value": ""
																},
																{
																	"num": 1,
																	"value": ""
																}
															]
														}
													]
												},
												{
													"name": "百位数减法",
													"value": [{
															"name": "百位数减法",
															"value": [{
																	"num": 0,
																	"value": ""
																},
																{
																	"num": 1,
																	"value": ""
																}
															]
														},
														{
															"name": "个位数",
															"value": [{
																	"num": 0,
																	"value": ""
																},
																{
																	"num": 1,
																	"value": ""
																}
															]
														},
														{
															"name": "十位数",
															"value": [{
																	"num": 0,
																	"value": ""
																},
																{
																	"num": 1,
																	"value": ""
																}
															]
														}
													]
												},
												{
													"name": "百位数乘法",
													"value": [{
															"name": "百位数乘法",
															"value": [{
																	"num": 0,
																	"value": ""
																},
																{
																	"num": 1,
																	"value": ""
																}
															]
														},
														{
															"name": "个位数",
															"value": [{
																	"num": 0,
																	"value": ""
																},
																{
																	"num": 1,
																	"value": ""
																}
															]
														},
														{
															"name": "十位数",
															"value": [{
																	"num": 0,
																	"value": ""
																},
																{
																	"num": 1,
																	"value": ""
																}
															]
														}
													]
												},
												{
													"name": "除法",
													"value": [{
															"name": "个位数",
															"value": [{
																	"num": 0,
																	"value": ""
																},
																{
																	"num": 1,
																	"value": ""
																}
															]
														},
														{
															"name": "十位数",
															"value": [{
																	"num": 0,
																	"value": ""
																},
																{
																	"num": 1,
																	"value": ""
																}
															]
														}
													]
												}
											]
										}
									]
								},
								{
									"ly_name": "形状",
									"value": [{
											"name": "平面",
											"value": [{
													"name": "圆形",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "三角形",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "正方形",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "长方形",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "星形",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "梯形",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "心形",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "半圆形",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "平行四边形",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "椭圆形",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "六边形",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "菱形",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "四边形",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "其它",
													"text": "",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												}
											]
										},
										{
											"name": "立体",
											"value": [{
													"name": "立方体",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "圆柱体",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "圆锥体",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "三角锥",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "长方体",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "正方体",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												}
											]
										}
									]
								},
								{
									"ly_name": "触觉感知",
									"value": [{
											"name": "粘粘的",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "软软的",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "硬硬的",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "粗粗的",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "尖尖的",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "刺刺的",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "滑滑的",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "油油的",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "毛绒绒的",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "烫烫的",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "湿湿的",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "冰冰的",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "干干的",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "其它",
											"text": "",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										}
									]
								},
								{
									"ly_name": "比较与对照",
									"value": [{
											"name": "能在 4样物品中指认其中 3 个相同的（2.5~3岁）",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "哪个不同？为什么？（2.5~3 岁）",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "从 3 个相同一个不同中指出哪一个不一样（2.5~3岁）",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "经听觉描述作选择（1~2 岁）—（2.5~3 岁）",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "以实物列出哪个不一样？为什么？（4 岁）",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "能依尺寸、味道来做比较（4岁）类推（4岁）",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "经听觉描述作选择（3~4岁）",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "说出图片中哪些相似（5岁）",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "声母相同的押韵童谣（5岁）",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "“相关联”之游戏（5 岁）",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "其它",
											"text": "",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										}
									]
								},
								{
									"ly_name": "顺序概念",
									"value": [{
											"name": "在家中的一些事情（3岁）",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "简单的手指游戏（3岁）",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "形状、数量（3岁）",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "旅游（相片）（3岁）",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "有顺序之指令（3岁）",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "含2~3个段落的故事",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "听故事及顺序（4岁）",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "童谣、儿歌（4岁）",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "以不同顺序发展一则故事（5岁）",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "故事接龙（开始、中间或结局）",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "包含语法的顺序描述（6岁）",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "其它",
											"text": "",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										}
									]
								},
								{
									"ly_name": "相似",
									"value": [{
											"name": "功能相似",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "特征相似",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										}
									]
								},
								{
									"ly_name": "推理/预测",
									"value": [{
											"name": "事件推理",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "时间推理",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "字词推理",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "找原因",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										}
									]
								},
								{
									"ly_name": "类推",
									"value": ""
								},
								{
									"ly_name": "同义词",
									"value": ""
								},
								{
									"ly_name": "相反词",
									"value": ""
								},
								{
									"ly_name": "双关语",
									"value": ""
								},
								{
									"ly_name": "笑话",
									"value": ""
								},
								{
									"ly_name": "谜语",
									"value": ""
								}
							]
						},
						yanyu: {
							"name": "言语",
							"value": [{
									"ly_name": "音质",
									"value": [{
											"name": "音质自然流畅",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "音质较为自然流畅",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "有明显发音问题",
											"text_if": "（如：假声、硬起音、共鸣错误（鼻漏气）、聚焦错误等）",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "有严重发音问题",
											"text_if": "（如：假声、硬起音、共鸣错误、聚焦错误等）",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										}
									]
								},
								{
									"ly_name": "语词辨识度（可懂度）",
									"value": [{
											"name": "有情景提示下",
											"value": [{
													"name": "完全理解",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "基本理解",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "部分理解",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "不能理解",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												}
											]
										},
										{
											"name": "无情景提示下",
											"value": [{
													"name": "完全理解",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "基本理解",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "部分理解",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "不能理解",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												}
											]
										}
									]
								},
								{
									"ly_name": "超语段",
									"value": [{
											"name": "时间",
											"value": [{
													"name": "长音",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "短音",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "音长短变化音",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												}
											]
										},
										{
											"name": "量",
											"value": [{
													"name": "大",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "小",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "大小声变化音",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												}
											]
										},
										{
											"name": "调",
											"value": [{
													"name": "高",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "低",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "高低变化",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												}
											]
										}
									]
								},
								{
									"ly_name": "四声",
									"value": [{
											"name": "一声",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "二声",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "三声",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "四声",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "四声变化",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										}
									]
								},
								{
									"ly_name": "单韵母",
									"value": [{
											"name": "a",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "u",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "e",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "i",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "ü",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										}
									]
								},
								{
									"ly_name": "韵母轮换",
									"value": [{
											"name": "u-a",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "a-u",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "e-ⅰ",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "ⅰ-a",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "u-ⅰ",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "ⅰ-u",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "a-ⅰ",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										}
									]
								},
								{
									"ly_name": "复韵母结尾",
									"value": [{
											"name": "ou",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "ao",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "ei",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "ai",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "ie",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "iu",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "ui",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "üe",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										}
									]
								},
								{
									"ly_name": "复韵母声母结尾",
									"value": [{
											"name": "an",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "en",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "in",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "un",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "ün",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "ang",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "eng",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "ong",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "ing（省略后鼻音）",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										}
									]
								},
								{
									"ly_name": "结合韵母",
									"value": [{
											"name": "ia",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "iao",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "ian",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "iang",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "ua",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "uo",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "uai",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "uan",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "uang",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "uan",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "ong",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										}
									]
								},
								{
									"ly_name": "声母",
									"value": [{
											"name": "b",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "p",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "h",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "q",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "zh",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "z",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "m",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "t",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "d",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "f",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "n",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "x",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "j",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "ch",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "c",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "l",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "k",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "g",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "s",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "sh",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "r",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										}
									]
								}
							]
						},
						yuyan: {
							"name": "语言",
							"value": [{
									"ly_name": "初级词汇",
									"value": [{
											"name": "名词",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "动词",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "代词",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "形容词",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "副词",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "数量词",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "否定词",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "连词",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "日常表达性词语",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										}
									]
								},
								{
									"ly_name": "中级词汇",
									"value": [{
											"name": "名词",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "动词",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "代词",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "形容词",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "副词",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "数量词",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "否定词",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "连词",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "日常表达性词语",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										}
									]
								},
								{
									"ly_name": "高级词汇",
									"value": [{
											"name": "名词",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "动词",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "代词",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "形容词",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "副词",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "数量词",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "否定词",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "连词",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "日常表达性词语",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										}
									]
								},
								{
									"ly_name": "问句",
									"value": [{
											"name": "小于 2.5 岁",
											"value": [{
													"name": "那是什么？",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "他在做什么？",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "什么颜色？",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "有几个？",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												}
											]
										},
										{
											"name": "2.5~3 岁",
											"value": [{
													"name": "在哪里？",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "是谁？",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "哪一个？",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "什么形状？",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "做什么用的？",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "怎么了？",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "怎么办？",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "什么不见了？",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												}
											]
										},
										{
											"name": "3~4岁",
											"value": [{
													"name": "少了什么？",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "为什么",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "（名词）住在哪里？",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "哪一个不一样？",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "需要什么？",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "（代名词）叫什么名字？",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "什么地方？",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "多大了",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												}
											]
										},
										{
											"name": "4~5 岁",
											"value": [{
													"name": "多少？",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "什么时候？？",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "如何？",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "怎么做？（描述）",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "自创",
													"text": "",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												}
											]
										}
									]
								},
								{
									"ly_name": "语言能力评估",
									"value_age": "",
									"value_time": ""
								},
								{
									"ly_name": "SIR言语可懂度",
									"value_pj": "",
									"value_time": ""
								}
							]
						},
						tingneng: {
							"name": "听能",
							"value": [{
									"ly_name": "声音察觉与辨识",
									"value": [{
											"name": "察觉",
											"value": [{
													"name": "自己名字",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "语音",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "环境音",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "有声玩具",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												}
											]
										},
										{
											"name": "辨识",
											"value": [{
													"name": "自己名字",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "语音",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "环境音",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "有声玩具",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												}
											]
										}
									]
								},
								{
									"ly_name": "声源辨识",
									"value": [{
											"name": "优耳",
											"value": [{
													"name": "前方",
													"value50": [{
															"name": "50cm",
															"value": "",
															"num": 0
														},
														{
															"num": 1,
															"value": ""
														}
													],
													"value100": [{
															"name": "1m",
															"value": "",
															"num": 0
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "后方",
													"value50": [{
															"name": "50cm",
															"value": "",
															"num": 0
														},
														{
															"num": 1,
															"value": ""
														}
													],
													"value100": [{
															"name": "1m",
															"value": "",
															"num": 0
														},
														{
															"num": 1,
															"value": ""
														}
													]
												}
											]
										},
										{
											"name": "劣耳",
											"value": [{
													"name": "前方",
													"value50": [{
															"name": "50cm",
															"value": "",
															"num": 0
														},
														{
															"num": 1,
															"value": ""
														}
													],
													"value100": [{
															"name": "1m",
															"value": "",
															"num": 0
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "后方",
													"value50": [{
															"name": "50cm",
															"value": "",
															"num": 0
														},
														{
															"num": 1,
															"value": ""
														}
													],
													"value100": [{
															"name": "1m",
															"value": "",
															"num": 0
														},
														{
															"num": 1,
															"value": ""
														}
													]
												}
											]
										},
										{
											"name": "双耳",
											"value": [{
													"name": "前方",
													"value50": [{
															"name": "50cm",
															"value": "",
															"num": 0
														},
														{
															"num": 1,
															"value": ""
														}
													],
													"value100": [{
															"name": "1m",
															"value": "",
															"num": 0
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "后方",
													"value50": [{
															"name": "50cm",
															"value": "",
															"num": 0
														},
														{
															"num": 1,
															"value": ""
														}
													],
													"value100": [{
															"name": "1m",
															"value": "",
															"num": 0
														},
														{
															"num": 1,
															"value": ""
														}
													]
												}
											]
										}
									]
								},
								{
									"ly_name": "林氏六音",
									"value": [{
											"name": "m",
											"value": [{
													"name": "12cm",
													"value": [{
															"name": "察觉",
															"value": [{
																	"num": 0,
																	"value": ""
																},
																{
																	"num": 1,
																	"value": ""
																}
															]
														},
														{
															"name": "辨识",
															"value": [{
																	"num": 0,
																	"value": ""
																},
																{
																	"num": 1,
																	"value": ""
																}
															]
														}
													]
												},
												{
													"name": "50cm",
													"value": [{
															"name": "察觉",
															"value": [{
																	"num": 0,
																	"value": ""
																},
																{
																	"num": 1,
																	"value": ""
																}
															]
														},
														{
															"name": "辨识",
															"value": [{
																	"num": 0,
																	"value": ""
																},
																{
																	"num": 1,
																	"value": ""
																}
															]
														}
													]
												},
												{
													"name": "1m",
													"value": [{
															"name": "察觉",
															"value": [{
																	"num": 0,
																	"value": ""
																},
																{
																	"num": 1,
																	"value": ""
																}
															]
														},
														{
															"name": "辨识",
															"value": [{
																	"num": 0,
																	"value": ""
																},
																{
																	"num": 1,
																	"value": ""
																}
															]
														}
													]
												},
												{
													"name": "2m",
													"value": [{
															"name": "察觉",
															"value": [{
																	"num": 0,
																	"value": ""
																},
																{
																	"num": 1,
																	"value": ""
																}
															]
														},
														{
															"name": "辨识",
															"value": [{
																	"num": 0,
																	"value": ""
																},
																{
																	"num": 1,
																	"value": ""
																}
															]
														}
													]
												}
											]
										},
										{
											"name": "u",
											"value": [{
													"name": "12cm",
													"value": [{
															"name": "察觉",
															"value": [{
																	"num": 0,
																	"value": ""
																},
																{
																	"num": 1,
																	"value": ""
																}
															]
														},
														{
															"name": "辨识",
															"value": [{
																	"num": 0,
																	"value": ""
																},
																{
																	"num": 1,
																	"value": ""
																}
															]
														}
													]
												},
												{
													"name": "50cm",
													"value": [{
															"name": "察觉",
															"value": [{
																	"num": 0,
																	"value": ""
																},
																{
																	"num": 1,
																	"value": ""
																}
															]
														},
														{
															"name": "辨识",
															"value": [{
																	"num": 0,
																	"value": ""
																},
																{
																	"num": 1,
																	"value": ""
																}
															]
														}
													]
												},
												{
													"name": "1m",
													"value": [{
															"name": "察觉",
															"value": [{
																	"num": 0,
																	"value": ""
																},
																{
																	"num": 1,
																	"value": ""
																}
															]
														},
														{
															"name": "辨识",
															"value": [{
																	"num": 0,
																	"value": ""
																},
																{
																	"num": 1,
																	"value": ""
																}
															]
														}
													]
												},
												{
													"name": "2m",
													"value": [{
															"name": "察觉",
															"value": [{
																	"num": 0,
																	"value": ""
																},
																{
																	"num": 1,
																	"value": ""
																}
															]
														},
														{
															"name": "辨识",
															"value": [{
																	"num": 0,
																	"value": ""
																},
																{
																	"num": 1,
																	"value": ""
																}
															]
														}
													]
												}
											]
										},
										{
											"name": "a",
											"value": [{
													"name": "12cm",
													"value": [{
															"name": "察觉",
															"value": [{
																	"num": 0,
																	"value": ""
																},
																{
																	"num": 1,
																	"value": ""
																}
															]
														},
														{
															"name": "辨识",
															"value": [{
																	"num": 0,
																	"value": ""
																},
																{
																	"num": 1,
																	"value": ""
																}
															]
														}
													]
												},
												{
													"name": "50cm",
													"value": [{
															"name": "察觉",
															"value": [{
																	"num": 0,
																	"value": ""
																},
																{
																	"num": 1,
																	"value": ""
																}
															]
														},
														{
															"name": "辨识",
															"value": [{
																	"num": 0,
																	"value": ""
																},
																{
																	"num": 1,
																	"value": ""
																}
															]
														}
													]
												},
												{
													"name": "1m",
													"value": [{
															"name": "察觉",
															"value": [{
																	"num": 0,
																	"value": ""
																},
																{
																	"num": 1,
																	"value": ""
																}
															]
														},
														{
															"name": "辨识",
															"value": [{
																	"num": 0,
																	"value": ""
																},
																{
																	"num": 1,
																	"value": ""
																}
															]
														}
													]
												},
												{
													"name": "2m",
													"value": [{
															"name": "察觉",
															"value": [{
																	"num": 0,
																	"value": ""
																},
																{
																	"num": 1,
																	"value": ""
																}
															]
														},
														{
															"name": "辨识",
															"value": [{
																	"num": 0,
																	"value": ""
																},
																{
																	"num": 1,
																	"value": ""
																}
															]
														}
													]
												}
											]
										},
										{
											"name": "i",
											"value": [{
													"name": "12cm",
													"value": [{
															"name": "察觉",
															"value": [{
																	"num": 0,
																	"value": ""
																},
																{
																	"num": 1,
																	"value": ""
																}
															]
														},
														{
															"name": "辨识",
															"value": [{
																	"num": 0,
																	"value": ""
																},
																{
																	"num": 1,
																	"value": ""
																}
															]
														}
													]
												},
												{
													"name": "50cm",
													"value": [{
															"name": "察觉",
															"value": [{
																	"num": 0,
																	"value": ""
																},
																{
																	"num": 1,
																	"value": ""
																}
															]
														},
														{
															"name": "辨识",
															"value": [{
																	"num": 0,
																	"value": ""
																},
																{
																	"num": 1,
																	"value": ""
																}
															]
														}
													]
												},
												{
													"name": "1m",
													"value": [{
															"name": "察觉",
															"value": [{
																	"num": 0,
																	"value": ""
																},
																{
																	"num": 1,
																	"value": ""
																}
															]
														},
														{
															"name": "辨识",
															"value": [{
																	"num": 0,
																	"value": ""
																},
																{
																	"num": 1,
																	"value": ""
																}
															]
														}
													]
												},
												{
													"name": "2m",
													"value": [{
															"name": "察觉",
															"value": [{
																	"num": 0,
																	"value": ""
																},
																{
																	"num": 1,
																	"value": ""
																}
															]
														},
														{
															"name": "辨识",
															"value": [{
																	"num": 0,
																	"value": ""
																},
																{
																	"num": 1,
																	"value": ""
																}
															]
														}
													]
												}
											]
										},
										{
											"name": "sh",
											"value": [{
													"name": "12cm",
													"value": [{
															"name": "察觉",
															"value": [{
																	"num": 0,
																	"value": ""
																},
																{
																	"num": 1,
																	"value": ""
																}
															]
														},
														{
															"name": "辨识",
															"value": [{
																	"num": 0,
																	"value": ""
																},
																{
																	"num": 1,
																	"value": ""
																}
															]
														}
													]
												},
												{
													"name": "50cm",
													"value": [{
															"name": "察觉",
															"value": [{
																	"num": 0,
																	"value": ""
																},
																{
																	"num": 1,
																	"value": ""
																}
															]
														},
														{
															"name": "辨识",
															"value": [{
																	"num": 0,
																	"value": ""
																},
																{
																	"num": 1,
																	"value": ""
																}
															]
														}
													]
												},
												{
													"name": "1m",
													"value": [{
															"name": "察觉",
															"value": [{
																	"num": 0,
																	"value": ""
																},
																{
																	"num": 1,
																	"value": ""
																}
															]
														},
														{
															"name": "辨识",
															"value": [{
																	"num": 0,
																	"value": ""
																},
																{
																	"num": 1,
																	"value": ""
																}
															]
														}
													]
												},
												{
													"name": "2m",
													"value": [{
															"name": "察觉",
															"value": [{
																	"num": 0,
																	"value": ""
																},
																{
																	"num": 1,
																	"value": ""
																}
															]
														},
														{
															"name": "辨识",
															"value": [{
																	"num": 0,
																	"value": ""
																},
																{
																	"num": 1,
																	"value": ""
																}
															]
														}
													]
												}
											]
										},
										{
											"name": "s",
											"value": [{
													"name": "12cm",
													"value": [{
															"name": "察觉",
															"value": [{
																	"num": 0,
																	"value": ""
																},
																{
																	"num": 1,
																	"value": ""
																}
															]
														},
														{
															"name": "辨识",
															"value": [{
																	"num": 0,
																	"value": ""
																},
																{
																	"num": 1,
																	"value": ""
																}
															]
														}
													]
												},
												{
													"name": "50cm",
													"value": [{
															"name": "察觉",
															"value": [{
																	"num": 0,
																	"value": ""
																},
																{
																	"num": 1,
																	"value": ""
																}
															]
														},
														{
															"name": "辨识",
															"value": [{
																	"num": 0,
																	"value": ""
																},
																{
																	"num": 1,
																	"value": ""
																}
															]
														}
													]
												},
												{
													"name": "1m",
													"value": [{
															"name": "察觉",
															"value": [{
																	"num": 0,
																	"value": ""
																},
																{
																	"num": 1,
																	"value": ""
																}
															]
														},
														{
															"name": "辨识",
															"value": [{
																	"num": 0,
																	"value": ""
																},
																{
																	"num": 1,
																	"value": ""
																}
															]
														}
													]
												},
												{
													"name": "2m",
													"value": [{
															"name": "察觉",
															"value": [{
																	"num": 0,
																	"value": ""
																},
																{
																	"num": 1,
																	"value": ""
																}
															]
														},
														{
															"name": "辨识",
															"value": [{
																	"num": 0,
																	"value": ""
																},
																{
																	"num": 1,
																	"value": ""
																}
															]
														}
													]
												}
											]
										}
									]
								},
								{
									"ly_name": "词组中的字词",
									"value": [{
											"name": "韵母不同,音节不同",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "声母相同,韵母不同",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "声母不同,韵母相同",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "同音(声韵母相同),声调不同",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										}
									]
								},
								{
									"ly_name": "听觉记忆(小项)",
									"value": [{
											"name": "1项",
											"tingjuejiyi_num": "1",
											"value": [{
													"name": "拟声词",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "名词",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "动词",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "形容词",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "方位词",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												}
											]
										},
										{
											"name": "2项",
											"tingjuejiyi_num": "2",
											"value": [{
													"name": "两个名词",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "名词+动词",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "两个动词",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "形容词+名词",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "其他",
													"text": "",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												}
											]
										},
										{
											"name": "3项",
											"tingjuejiyi_num": "3",
											"value": [{
													"name": "三个名词",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "两个名词+动词",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "动词+ 两个名词",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "名词+两个动词",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "两个名词+ 方位词",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "两个名词+形容词",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "数量词+形容词+名词",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "两个形容词+名词",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "形容词+名词+动词",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "三个动词",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "数量词+名词+动词",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "其他",
													"text": "",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												}
											]
										},
										{
											"name": "4项",
											"tingjuejiyi_num": "4",
											"value": [{
													"name": "四个名词",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "三个名词+方位词",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "两个名词+两个动词",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "两个名词+两个方位词",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "两个名词+两个形容词",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "两个数量词+两个名词",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "形容词+名词+名词+方位词",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "其他",
													"text": "",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												}
											]
										},
										{
											"name": "5项",
											"tingjuejiyi_num": "5",
											"value": [{
													"name": "五个名词",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "两个名词+两个动词+时间副词",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "五个动词",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "其他",
													"text": "",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												}
											]
										},
										{
											"name": "5+项",
											"tingjuejiyi_num": "5+",
											"value": [{
												"name": "手填",
												"text": "",
												"value": [{
														"num": 0,
														"value": ""
													},
													{
														"num": 1,
														"value": ""
													}
												]
											}]
										}
									]
								},
								{
									"ly_name": "可辨识的儿歌和童谣",
									"value": ""
								},
								{
									"ly_name": "能注意听延续的故事或对话内容",
									"value": ""
								},
								{
									"ly_name": "听觉描述",
									"value": [{
											"name": "闭合式阶段",
											"value": [{
													"name": "重复拟声词",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "加入关键词",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "相似特征",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "属性相同",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												}
											]
										},
										{
											"name": "开放式阶段",
											"value": [{
													"name": "重复拟声词",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "加入关键词",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "复杂描述",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "问问题找答案",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												}
											]
										}
									]
								},
								{
									"ly_name": "能听录音带的内容",
									"value": [{
											"name": "听觉记忆(项)",
											"value": [{
													"name": "0",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "1",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "2",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "3",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "4",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "5",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "5+",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												}
											]
										},
										{
											"name": "故事",
											"value": ""
										},
										{
											"name": "听觉描述",
											"value": [{
													"name": "闭合式阶段",
													"value": [{
															"name": "重复拟声词",
															"value": [{
																	"num": 0,
																	"value": ""
																},
																{
																	"num": 1,
																	"value": ""
																}
															]
														},
														{
															"name": "加入关键词",
															"value": [{
																	"num": 0,
																	"value": ""
																},
																{
																	"num": 1,
																	"value": ""
																}
															]
														},
														{
															"name": "相似特征",
															"value": [{
																	"num": 0,
																	"value": ""
																},
																{
																	"num": 1,
																	"value": ""
																}
															]
														},
														{
															"name": "属性相同",
															"value": [{
																	"num": 0,
																	"value": ""
																},
																{
																	"num": 1,
																	"value": ""
																}
															]
														}
													]
												},
												{
													"name": "开放式阶段",
													"value": [{
															"name": "重复拟声词",
															"value": [{
																	"num": 0,
																	"value": ""
																},
																{
																	"num": 1,
																	"value": ""
																}
															]
														},
														{
															"name": "加入关键词",
															"value": [{
																	"num": 0,
																	"value": ""
																},
																{
																	"num": 1,
																	"value": ""
																}
															]
														},
														{
															"name": "复杂描述",
															"value": [{
																	"num": 0,
																	"value": ""
																},
																{
																	"num": 1,
																	"value": ""
																}
															]
														}
													]
												}
											]
										}
									]
								},
								{
									"ly_name": "能在吵杂的环境中倾听",
									"value": [{
											"name": "听觉记忆(项)",
											"value": [{
													"name": "0",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "1",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "2",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "3",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "4",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "5",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "5+",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												}
											]
										},
										{
											"name": "听觉描述",
											"value": [{
													"name": "闭合式阶段",
													"value": [{
															"name": "重复拟声词",
															"value": [{
																	"num": 0,
																	"value": ""
																},
																{
																	"num": 1,
																	"value": ""
																}
															]
														},
														{
															"name": "加入关键词",
															"value": [{
																	"num": 0,
																	"value": ""
																},
																{
																	"num": 1,
																	"value": ""
																}
															]
														},
														{
															"name": "相似特征",
															"value": [{
																	"num": 0,
																	"value": ""
																},
																{
																	"num": 1,
																	"value": ""
																}
															]
														},
														{
															"name": "属性相同",
															"value": [{
																	"num": 0,
																	"value": ""
																},
																{
																	"num": 1,
																	"value": ""
																}
															]
														}
													]
												},
												{
													"name": "开放式阶段",
													"value": [{
															"name": "重复拟声词",
															"value": [{
																	"num": 0,
																	"value": ""
																},
																{
																	"num": 1,
																	"value": ""
																}
															]
														},
														{
															"name": "加入关键词",
															"value": [{
																	"num": 0,
																	"value": ""
																},
																{
																	"num": 1,
																	"value": ""
																}
															]
														},
														{
															"name": "复杂描述",
															"value": [{
																	"num": 0,
																	"value": ""
																},
																{
																	"num": 1,
																	"value": ""
																}
															]
														},
														{
															"name": "问问题找答案",
															"value": [{
																	"num": 0,
																	"value": ""
																},
																{
																	"num": 1,
																	"value": ""
																}
															]
														}
													]
												}
											]
										}
									]
								},
								{
									"ly_name": "能在团体对话中倾听",
									"value": [{
											"name": "听觉记忆(项)",
											"value": [{
													"name": "0",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "1",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "2",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "3",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "4",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "5",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												},
												{
													"name": "5+",
													"value": [{
															"num": 0,
															"value": ""
														},
														{
															"num": 1,
															"value": ""
														}
													]
												}
											]
										},
										{
											"name": "听觉描述",
											"value": [{
													"name": "闭合式阶段",
													"value": [{
															"name": "重复拟声词",
															"value": [{
																	"num": 0,
																	"value": ""
																},
																{
																	"num": 1,
																	"value": ""
																}
															]
														},
														{
															"name": "加入关键词",
															"value": [{
																	"num": 0,
																	"value": ""
																},
																{
																	"num": 1,
																	"value": ""
																}
															]
														},
														{
															"name": "相似特征",
															"value": [{
																	"num": 0,
																	"value": ""
																},
																{
																	"num": 1,
																	"value": ""
																}
															]
														},
														{
															"name": "属性相同",
															"value": [{
																	"num": 0,
																	"value": ""
																},
																{
																	"num": 1,
																	"value": ""
																}
															]
														}
													]
												},
												{
													"name": "开放式阶段",
													"value": [{
															"name": "重复拟声词",
															"value": [{
																	"num": 0,
																	"value": ""
																},
																{
																	"num": 1,
																	"value": ""
																}
															]
														},
														{
															"name": "加入关键词",
															"value": [{
																	"num": 0,
																	"value": ""
																},
																{
																	"num": 1,
																	"value": ""
																}
															]
														},
														{
															"name": "复杂描述",
															"value": [{
																	"num": 0,
																	"value": ""
																},
																{
																	"num": 1,
																	"value": ""
																}
															]
														},
														{
															"name": "问问题找答案",
															"value": [{
																	"num": 0,
																	"value": ""
																},
																{
																	"num": 1,
																	"value": ""
																}
															]
														}
													]
												}
											]
										}
									]
								},
								{
									"ly_name": "接听电话技巧",
									"value": [{
											"name": "闭合式/熟悉的谈话者，听觉记忆 1-2 项，招呼语",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "闭合式/熟悉的谈话者，听觉描述—闭合式阶段 1-4，听觉记忆 3-4 项",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "开放式/熟悉的谈话者，听觉描述—开放式阶段 1-4",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "开放式/熟悉的谈话者/同一话题的对谈",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "开放式/熟悉的谈话者/延伸话题的对谈",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "闭合式/陌生的谈话者/主题式对谈a 事先设定情境（可预知谈话主题）b 告知孩子主题并事先讨论谈话内容",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "开放式/非主题式对话",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										}
									]
								},
								{
									"ly_name": "主动聆听技巧",
									"value": [{
											"name": "闭合式（事先预知谈话主题）/近距离/熟悉者的声音",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "闭合式/加长距离/熟悉者的声音/两人谈话",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "闭合式/加入背景噪音/熟悉者的声音/两人对话",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "闭合式/近距离/加入陌生者的声音/两人对话",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "闭合式/加长距离/陌生者的声音/两人对话",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "闭合式/加入背景噪音/陌生者的声音/两人对话",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "开放式（不事先告知主题）/重复阶段1-6 /两人对话",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										},
										{
											"name": "开放式/重复阶段 1-6/三人以上对话",
											"value": [{
													"num": 0,
													"value": ""
												},
												{
													"num": 1,
													"value": ""
												}
											]
										}
									]
								},
								{
									"ly_name": "听觉能力评估",
									"value_sbl": "",
									"value_time": ""
								},
								{
									"ly_name": "CAP听觉行为分级",
									"value_sbl": "",
									"value_time": ""
								}
							]
						}
					},
					// 听能服务日志
					this.tnfwrz_info = [{
							"id": 19,
							"stu_id": 2693,
							"dijici": "0",
							"duoxuan": {
								"biaoti": "工作内容",
								"xuanxiang": [{
										"name": "听力检测",
										"value": false
									},
									{
										"name": "助听设备验配/调试",
										"value": false
									},
									{
										"name": "助听设备维护",
										"value": false
									},
									{
										"name": "助听设备更换",
										"value": false
									},
									{
										"name": "家长咨询",
										"value": false
									},
									{
										"name": "教师咨询",
										"value": false
									},
									{
										"name": "个 案 会 诊 （可另附页）",
										"value": false
									},
									{
										"name": "其他:",
										"value": false
									}
								],
								"riqi": "",
								"qita": "",
								"duoxuanchucun": [
									"助听设备验配/调试",
									"助听设备更换",
									"教师咨询",
									"个 案 会 诊 （可另附页）",
									"助听设备维护"
								]
							},
							"tianxie": {
								"tianxie_xinxi": [{
										"biaoti": "问题",
										"neirong": "将心比心您"
									},
									{
										"biaoti": "处理及结果",
										"neirong": ""
									},
									{
										"biaoti": "后期观察及反馈",
										"neirong": ""
									}
								],
								"pinggu": {
									"biaoti": "评估人员：",
									"neirong": ""
								}
							},
							"year": "",
							"org_id": 78,
							"stu_ID": "",
							"stu_name": "",
							"sex": "",
							"chushenriqi": ""
						},
						{
							"id": 21,
							"stu_id": '',
							"dijici": "1",
							"duoxuan": {
								"biaoti": "工作内容",
								"xuanxiang": [{
										"name": "听力检测",
										"value": false
									},
									{
										"name": "助听设备验配/调试",
										"value": false
									},
									{
										"name": "助听设备维护",
										"value": false
									},
									{
										"name": "助听设备更换",
										"value": false
									},
									{
										"name": "家长咨询",
										"value": false
									},
									{
										"name": "教师咨询",
										"value": false
									},
									{
										"name": "个 案 会 诊 （可另附页）",
										"value": false
									},
									{
										"name": "其他:",
										"value": false
									}
								],
								"riqi": "",
								"qita": "",
								"duoxuanchucun": [
									"助听设备验配/调试",
									"个 案 会 诊 （可另附页）",
									"助听设备更换",
									"教师咨询"
								]
							},
							"tianxie": {
								"tianxie_xinxi": [{
										"biaoti": "问题",
										"neirong": ""
									},
									{
										"biaoti": "处理及结果",
										"neirong": ""
									},
									{
										"biaoti": "后期观察及反馈",
										"neirong": ""
									}
								],
								"pinggu": {
									"biaoti": "评估人员：",
									"neirong": ""
								}
							},
							"year": "",
							"org_id": '',
							"stu_ID": "",
							"stu_name": ""
						},
						{
							"id": 18,
							"stu_id": '',
							"dijici": "2",
							"duoxuan": {
								"biaoti": "工作内容",
								"xuanxiang": [{
										"name": "听力检测",
										"value": false
									},
									{
										"name": "助听设备验配/调试",
										"value": false
									},
									{
										"name": "助听设备维护",
										"value": false
									},
									{
										"name": "助听设备更换",
										"value": false
									},
									{
										"name": "家长咨询",
										"value": false
									},
									{
										"name": "教师咨询",
										"value": false
									},
									{
										"name": "个 案 会 诊 （可另附页）",
										"value": false
									},
									{
										"name": "其他:",
										"value": false
									}
								],
								"riqi": "",
								"qita": "",
								"duoxuanchucun": [
									"个 案 会 诊 （可另附页）",
									"家长咨询",
									"助听设备更换",
									"助听设备验配/调试"
								]
							},
							"tianxie": {
								"tianxie_xinxi": [{
										"biaoti": "问题",
										"neirong": ""
									},
									{
										"biaoti": "处理及结果",
										"neirong": ""
									},
									{
										"biaoti": "后期观察及反馈",
										"neirong": ""
									}
								],
								"pinggu": {
									"biaoti": "评估人员：",
									"neirong": ""
								}
							},
							"year": "",
							"org_id": '',
							"stu_ID": "",
							"stu_name": ""
						}
					],
					// 成长评价建议
					this.czpjjy_info = {
						"id": 7,
						"stu_id": "",
						"shujv": {
							"shengao": "",
							"tizhong": "",
							"xuesesu": "",
							"quzhi": "",
							"qinzengquzhi": "",
							"shili_zuo": "",
							"shili_you": "",
							"pinglun": "",
							"beizhu": "",
							"jianyi": "",
							"pinggulaoshi": "",
							"pingguriqi": "",
							"wudalingyv": [{
									"biaoti": "健康：",
									"tishi": "可从身心状况、动作发展、生活习惯与生活能力、对助听设备的保护四方面进行描述。",
									"neirong": ""
								},
								{
									"biaoti": "语言：",
									"tishi": "可从倾听与表达、阅读与书写准备两方面进行描述。",
									"neirong": ""
								},
								{
									"biaoti": "社会：",
									"tishi": "可从自我系统、人际交往、社会适应三方面进行描述。",
									"neirong": ""
								},
								{
									"biaoti": "科学：",
									"tishi": "可从数学认知、知识经验、科学探究三方面进行描述。",
									"neirong": ""
								},
								{
									"biaoti": "艺术：",
									"tishi": "可从数学认知感受与欣赏、表现与创造两方面进行描述。",
									"neirong": ""
								}
							]
						},
						"org_id": '',
						"year": "",
						"stu_ID": "",
						"stu_name": "",
						"sex": "",
						"chushenriqi": ""
					},
					// 结案报告
					this.jabg_info = {
						"id": 7,
						"stu_id": "",
						"jibenxinxi": {
							"biaoti": "基本信息",
							"lianxiren": "",
							"lianxirenguanxi": "",
							"lianxidianhua": "",
							"tongxundizhi": "",
							"huikousuozaidi": {
								"sheng": "",
								"shi": "",
								"xian": ""
							}
						},
						"zhutingshebenpeidaiqingkuang": {
							"biaoti": "助听设备配戴情况",
							"xunhuan": [{
									"biaoti": "左耳",
									"fangshi": "补偿/重建方式:",
									"fangshi_jieguo": "",
									"shijian": "验配/开机时间:",
									"shijian_jieguo": "",
									"xunhuan": [{
											"biaoti": "型号：",
											"jieguo": ""
										},
										{
											"biaoti": "程序：",
											"jieguo": ""
										},
										{
											"biaoti": "音量/敏感度：",
											"jieguo": ""
										}
									]
								},
								{
									"biaoti": "右耳",
									"fangshi": "补偿/重建方式:",
									"fangshi_jieguo": "",
									"shijian": "验配/开机时间:",
									"shijian_jieguo": "",
									"xunhuan": [{
											"biaoti": "型号：",
											"jieguo": ""
										},
										{
											"biaoti": "程序：",
											"jieguo": ""
										},
										{
											"biaoti": "音量/敏感度：",
											"jieguo": ""
										}
									]
								}
							]
						},
						"pinggujieguozhaiyao": {
							"biaoti1": "评估结果摘要",
							"biaoti2": "认知与学习能力评估结果（根据年龄选做其一）",
							"biaoti3": "康复结语：",
							"biaoti3_jieguo": "",
							"xunhuan1": [{
									"biaoti1": "听力、言语残疾儿童听觉能力评估标准——康复级别",
									"biaoti2": "级别：",
									"biaoti2_jieguo": "",
									"biaoti3": "CAP听觉行为分级:",
									"biaoti3_jieguo": "",
									"biaoti4": "级"
								},
								{
									"biaoti1": "听力、言语残疾儿童言语能力评估标准——康复级别",
									"biaoti2": "级别：",
									"biaoti2_jieguo": "",
									"biaoti3": "SIR言语可懂度分级::",
									"biaoti3_jieguo": "",
									"biaoti4": "级"
								}
							],
							"xunhuan2": [{
									"biaoti1": "格雷费斯儿童精神发育商—— ",
									"biaoti1_jieguo": "",
									"biaoti2": "级"
								},
								{
									"biaoti1": "希-内学习能力商——",
									"biaoti1_jieguo": "",
									"biaoti2": "级"
								},
								{
									"biaoti1": "智商——",
									"biaoti1_jieguo": "",
									"biaoti2": "级"
								}
							]
						},
						"jiean": {
							"biaoti1": "结案时间及报告人",
							"biaoti2": "结案时间：",
							"biaoti2_jieguo": "",
							"biaoti3": "报告人：",
							"biaoti3_jieguo": ""
						},
						"org_id": 78,
						"year": "",
						"stu_ID": "",
						"stu_name": "",
						"stu_home": "",
						"minzu": "",
						"family_phone": "",
						"family_name": "",
						"family_ID": ""
					},
					// 回访记录
					this.hfjl_info = {
						"stu_id": '',
						"id": 8,
						"jibenxinxi": {
							"liyuanshijian": {
								"biaoti": "离园时间:",
								"jieguo": ""
							},
							"huifangfangshi": {
								"biaoti": "回访方式:",
								"jieguo": ""
							},
							"huifangduixiang": {
								"biaoti": "回访对象",
								"jieguo": "",
								"xuanxiang": [{
										"xuanxiangbiaoti": "儿童"
									},
									{
										"xuanxiangbiaoti": "家长"
									}
								]
							},
							"xunhuan": [{
									"wenzi": "回访次数:第",
									"neirong": "",
									"wenzi2": "次"
								},
								{
									"wenzi": "联系方式:",
									"neirong": "",
									"wenzi2": ""
								}
							]
						},
						"kangfuzouxiang": {
							"jiudujigoujixingzhi_jieguo": "",
							"jiudujigoujixingzhi_biaoti": "就读机构及性质",
							"jiudujigoujixingzhi1": [{
									"xuanxiang": "幼儿园"
								},
								{
									"xuanxiang": "普校"
								},
								{
									"xuanxiang": "康复中心"
								},
								{
									"xuanxiang": "特校"
								}
							],
							"jiudujigoujixingzhi2": [{
									"xuanxiang": "家庭康复"
								},
								{
									"xuanxiang": "已工作"
								}
							],
							"jiudujigoujixingzhi_qita_tiankong": "",
							"nianji": "",
							"jigoujiaoxuefangshi": {
								"biaoti": "机构教学方式",
								"xuanxiang": [{
										"xuanxiangbiaoti": "口语"
									},
									{
										"xuanxiangbiaoti": "手语"
									},
									{
										"xuanxiangbiaoti": "手口语"
									}
								],
								"jieguo": ""
							},
							"jigouzhichiqingkuang": {
								"biaoti1": "机构支持情况",
								"biaoti2": "特殊支持:",
								"neirong": ""
							},
							"zhutingshebeishiyongqingkuang": {
								"biaoti": "助听设备使用状况",
								"fenzu1": {
									"biaoti1": "1.每天佩戴助听设备。",
									"biaoti2": "情况说明:",
									"xuanxiang": "是",
									"jieguo": ""
								},
								"fenzu2": {
									"biaoti1": "2.定期维护助听设备。",
									"biaoti2": "情况说明",
									"xuanxiang": "",
									"biaoti3": "调试频率:",
									"biaoti3_neirong": "",
									"biaoti4": "调机地点:",
									"biaoti4_neirong": ""
								},
								"fenzu3": {
									"biaoti1": "3.使用FM系统。",
									"biaoti2": "情况说明:地点",
									"xuanxiang": "",
									"xuanxiang2": ""
								}
							},
							"kangfuxunlian": {
								"biaoti": "康复训练",
								"biaoti2": "1.定期做康复训练。",
								"biaoti3": "情况说明:地点",
								"xuanze1": "",
								"xuanze2": ""
							},
							"jiaoliugoutong": {
								"biaoti": "交流沟通",
								"qingkuangshuoming": "情况说明",
								"xuanze": [{
										"biaoti": "1.主 要 的 交 流 沟 通 方 式。",
										"xuanxiang1": "口语",
										"xuanxiang2": "手语",
										"xuanxiang3": "口手语",
										"jieguo": "",
										"qingkuangshuoming_jieguo": ""
									},
									{
										"biaoti": "2.口 语 表 达 的 清 楚 程 度。",
										"xuanxiang1": "好",
										"xuanxiang2": "中",
										"xuanxiang3": "差",
										"jieguo": "",
										"qingkuangshuoming_jieguo": ""
									},
									{
										"biaoti": "3.周围人对孩子口语表达能力的评价。",
										"xuanxiang1": "好",
										"xuanxiang2": "中",
										"xuanxiang3": "差",
										"jieguo": "",
										"qingkuangshuoming_jieguo": ""
									}
								]
							},
							"shehuishiying": {
								"biaoti": "社会适应",
								"qingkuangshuoming": "情况说明",
								"xuanze": [{
										"biaoti": "有好朋友。",
										"xuanxiang1": "是",
										"xuanxiang2": "否",
										"jieguo": "",
										"qingkuangshuoming_jieguo": ""
									},
									{
										"biaoti": "2.愿意主动结交新朋友。",
										"xuanxiang1": "是",
										"xuanxiang2": "否",
										"jieguo": "",
										"qingkuangshuoming_jieguo": ""
									},
									{
										"biaoti": "3.经常跟家人、朋友谈论学校或身边发生的事。",
										"xuanxiang1": "是",
										"xuanxiang2": "否",
										"jieguo": "",
										"qingkuangshuoming_jieguo": ""
									}
								]
							},
							"xuexiqingkuang": {
								"biaoti": "学习情况",
								"qingkuangshuoming": "情况说明",
								"xuanze": [{
										"biaoti": "1.能听懂课堂内容，不需要课后家长或其他人讲解、复习。",
										"xuanxiang": [{
												"neirong": "是"
											},
											{
												"neirong": "否"
											}
										],
										"jieguo": "",
										"qingkuangshuoming_jieguo": ""
									},
									{
										"biaoti": "2.能认真完成日常作业，不需要成人提供额外帮助。",
										"xuanxiang": [{
												"neirong": "是"
											},
											{
												"neirong": "否"
											}
										],
										"jieguo": "",
										"qingkuangshuoming_jieguo": ""
									},
									{
										"biaoti": "3.学习成绩在班级中的位置",
										"xuanxiang": [{
												"neirong": "优"
											},
											{
												"neirong": "中"
											},
											{
												"neirong": "差"
											}
										],
										"jieguo": "",
										"qingkuangshuoming_jieguo": ""
									}
								],
								"biaoti2": "4. 特长与优势学科：",
								"biaoti2_neirong": ""
							}
						},
						"wentijixvqiu": {
							"wentijixvqiu_biaoti": "问题及需求：",
							"wentijixvqiu_xuanxiang": [{
									"name": "噪音环境下听取不理想",
									"value": false
								},
								{
									"name": "需要更换助听设备",
									"value": false
								},
								{
									"name": "希望定期得到个别化康复教育",
									"value": false
								},
								{
									"name": "家长希望定期得到康复指导",
									"value": false
								},
								{
									"name": "需要心理干预",
									"value": false
								},
								{
									"name": "入普、升学困难",
									"value": false
								},
								{
									"name": "希望得到经济援助",
									"value": false
								}
							],
							"wentijixvqiu_chucun": [],
							"wentijixvqiu_qita": "",
							"wentijixvqiu_danxuan": ""
						},
						"jianyi": {
							"jiangyi_biaoti": "建议：",
							"jianyi_neirong": ""
						},
						"xiacihuifangxvjiaqiang": {
							"xiacihuifangxvjiaqiang_biaoti": "下次回访须加强追踪的内容：",
							"xiacihuifangxvjiaqiang_jieguo": [
								"听能管理",
								"家庭康复状况"
							],
							"qitajieguo": "",
							"xiacihuifangxvjiaqiang_duoxuan": [{
									"name": "助听设备的使用",
									"value": false
								},
								{
									"name": "听能管理",
									"value": false
								},
								{
									"name": "学习状况",
									"value": false
								},
								{
									"name": "社会适应状况",
									"value": false
								},
								{
									"name": "家庭康复状况",
									"value": false
								}
							]
						},
						"huifang": {
							"biaoti1": "回访日期及人员",
							"biaoti2": "回访日期：",
							"biaoti3": "回访人员：",
							"biaoti2_neirong": "",
							"biaoti3_neirong": ""
						},
						"year": "",
						"org_id": '',
						"stu_ID": "",
						"stu_name": "",
						"stu_home": "",
						"minzu": "",
						"family_phone": "",
						"family_name": "",
						"family_ID": "",
						"sex": "",
						"chushenriqi": ""
					},
					// 听觉能力评估
					this.tjnlpg_info = {
						"id": 7,
						"stu_id": '',
						"xunhuan": [{
								"biaoti": "自然环境声响识别",
								"xuanxiang": [{
										"biaoti": "错误走向记录（正确）——（错误）",
										"neirong": ""
									},
									{
										"biaoti": "最大识别率",
										"neirong": ""
									}
								]
							},
							{
								"biaoti": "语音识别-韵母识别",
								"xuanxiang": [{
										"biaoti": "错误走向记录（正确）——（错误）",
										"neirong": ""
									},
									{
										"biaoti": "最大识别率",
										"neirong": ""
									}
								]
							},
							{
								"biaoti": "语音识别-声母识别",
								"xuanxiang": [{
										"biaoti": "错误走向记录（正确）——（错误）",
										"neirong": ""
									},
									{
										"biaoti": "最大识别率",
										"neirong": ""
									}
								]
							},
							{
								"biaoti": "声调识别",
								"xuanxiang": [{
										"biaoti": "错误走向记录（正确）——（错误）",
										"neirong": ""
									},
									{
										"biaoti": "最大识别率",
										"neirong": ""
									}
								]
							},
							{
								"biaoti": "双音节词识别",
								"xuanxiang": [{
										"biaoti": "错误走向记录（正确）——（错误）",
										"neirong": ""
									},
									{
										"biaoti": "最大识别率",
										"neirong": ""
									}
								]
							},
							{
								"biaoti": "短句识别",
								"xuanxiang": [{
										"biaoti": "错误走向记录（正确）——（错误）",
										"neirong": ""
									},
									{
										"biaoti": "最大识别率",
										"neirong": ""
									}
								]
							},
							{
								"biaoti": "选择性听取",
								"xuanxiang": [{
										"biaoti": "错误走向记录（正确）——（错误）",
										"neirong": ""
									},
									{
										"biaoti": "最大识别率",
										"neirong": ""
									}
								]
							},
							{
								"biaoti": "数字识别",
								"xuanxiang": [{
										"biaoti": "错误走向记录（正确）——（错误）",
										"neirong": ""
									},
									{
										"biaoti": "最大识别率",
										"neirong": ""
									}
								]
							},
							{
								"biaoti": "单音节词（字）识别",
								"xuanxiang": [{
										"biaoti": "错误走向记录（正确）——（错误）",
										"neirong": ""
									},
									{
										"biaoti": "最大识别率",
										"neirong": ""
									}
								]
							},
							{
								"biaoti": "三音节词识别",
								"xuanxiang": [{
										"biaoti": "错误走向记录（正确）——（错误）",
										"neirong": ""
									},
									{
										"biaoti": "最大识别率",
										"neirong": ""
									}
								]
							}
						],
						"tiankong": {
							"tingjuekangfujibie": "听觉康复级别：",
							"tingjuekangfujibie_jieguo": "",
							"yanyvshibiepingjundefen": "言语识别平均得分：",
							"yanyvshibiepingjundefen_jieguo": "",
							"kangfujianyi": "康复建议：",
							"kangfujianyi_jieguo": ""
						},
						"pinggu": {
							"biaoti1": "评估人员及日期",
							"biaoti2": "评估日期：",
							"biaoti2_jieguo": "",
							"biaoti3": "评估人员：",
							"biaoti3_jieguo": "",
							"biaoti4": "测试环境:",
							"biaoti4_jieguo": ""
						},
						"org_id": '',
						"year": "",
						"stu_ID": "",
						"stu_name": "",
						"stu_home": "",
						"minzu": "",
						"family_phone": "",
						"family_name": "",
						"family_ID": ""
					},
					// CAP分级表
					this.cap_info = {
						"id": 17,
						"stu_id": "",
						"awp": {
							"stu_sfz": "",
							"CAPfuhehaizishijiqingkuang": "",
							"jibie": "",
							"ceshihuanjing": "",
							"quezhenriqi": "",
							"quezhen_riqi": "",
							"value2": "",
							"lingyv": [{
									"value": "0",
									"value3": "不能察觉到环境声。"
								},
								{
									"value": "1",
									"value3": "能察觉到环境声。"
								},
								{
									"value": "2",
									"value3": "对言语声有反应。"
								},
								{
									"value": "3",
									"value3": "能识别出环境声。"
								},
								{
									"value": "4",
									"value3": "不借助唇读能分辨一些言语声。"
								},
								{
									"value": "5",
									"value3": "不借助唇读能理解常用短语。"
								},
								{
									"value": "6",
									"value3": "不借助唇读能理解交谈内容。"
								},
								{
									"value": "7",
									"value3": "能和认识的人打电话。"
								},
								{
									"value": "8",
									"value3": "在有回声或干扰噪声的房间（如教室或餐厅）里能听懂一组人交谈。"
								},
								{
									"value": "9",
									"value3": "在不知话题时能和陌生人打电话。"
								}
							],
							"pinggurenyuan": ""
						},
						"org_id": '',
						"year": "",
						"stu_ID": "",
						"stu_name": "",
						"stu_home": "",
						"minzu": "",
						"family_phone": "",
						"family_name": "",
						"family_ID": "",
						"sex": "",
						"chushenriqi": ""
					},
					// 语言能力评估
					this.yynlpg_info = {
						"stu_id": '',
						"id": 5,
						"xunhuan": [{
								"biaoti": "词汇量",
								"xuanxiang": [{
										"biaoti": "测试记录",
										"neirong": ""
									},
									{
										"biaoti": "测试结果",
										"neirong": ""
									},
									{
										"biaoti": "语言年龄",
										"neirong": ""
									}
								]
							},
							{
								"biaoti": "语法能力（模仿句长）",
								"xuanxiang": [{
										"biaoti": "测试记录",
										"neirong": ""
									},
									{
										"biaoti": "测试结果",
										"neirong": ""
									},
									{
										"biaoti": "语言年龄",
										"neirong": ""
									}
								]
							},
							{
								"biaoti": "理解能力（听话识图）",
								"xuanxiang": [{
										"biaoti": "测试记录",
										"neirong": ""
									},
									{
										"biaoti": "测试结果",
										"neirong": ""
									},
									{
										"biaoti": "语言年龄",
										"neirong": ""
									}
								]
							},
							{
								"biaoti": "表达能力（看图说话）",
								"xuanxiang": [{
										"biaoti": "测试记录",
										"neirong": ""
									},
									{
										"biaoti": "测试结果",
										"neirong": ""
									},
									{
										"biaoti": "语言年龄",
										"neirong": ""
									}
								]
							},
							{
								"biaoti": "交往能力（主题对话）",
								"xuanxiang": [{
										"biaoti": "测试记录",
										"neirong": ""
									},
									{
										"biaoti": "测试结果",
										"neirong": ""
									},
									{
										"biaoti": "语言年龄",
										"neirong": ""
									}
								]
							},
							{
								"biaoti": "语音清晰度（%）",
								"xuanxiang": [{
										"biaoti": "测试记录",
										"neirong": ""
									},
									{
										"biaoti": "测试结果",
										"neirong": ""
									},
									{
										"biaoti": "语言年龄",
										"neirong": ""
									}
								]
							}
						],
						"tiankong": {
							"yvyankangfujibie": "语言康复级别",
							"yvyankangfujibie_jieguo": "",
							"pingjunnianlingshuiping": "平均语言年龄水平",
							"pingjunnianlingshuiping_jieguo": "",
							"kangfujianyi": "康复建议：",
							"kangfujianyi_jieguo": ""
						},
						"pinggu": {
							"biaoti1": "评估人员及日期",
							"biaoti2": "评估日期：",
							"biaoti2_jieguo": "",
							"biaoti3": "评估人员：",
							"biaoti3_jieguo": "",
							"biaoti4": "测试环境:",
							"biaoti4_jieguo": ""
						},
						"org_id": '',
						"year": "",
						"stu_ID": "",
						"stu_name": "",
						"stu_home": "",
						"minzu": "",
						"family_phone": "",
						"family_name": "",
						"family_ID": "",
						"sex": "",
						"chushenriqi": ""
					},
					// SIR分级表
					this.sir_info = {
						"id": 11,
						"stu_id": "",
						"awp": {
							"stu_sfz": "",
							"SIRfuhehaizishijiqingkuang": "",
							"jibie": "",
							"ceshihuanjing": "",
							"quezhenriqi": "",
							"quezhen_riqi": "",
							"value2": "",
							"lingyv": [{
									"value": "0",
									"value3": "其连贯的言语(短语或句子)不能被听懂。其口语中的词汇不易被识别，日常交流的主要方式为手势。"
								},
								{
									"value": "1",
									"value3": "其连贯的言语不能被听懂。当结合上下文和唇读线索时，其言语中的单个词汇可逐渐被听懂。"
								},
								{
									"value": "2",
									"value3": "当集中注意力并结合唇读线索时，其连贯的言语能被听懂。"
								},
								{
									"value": "3",
									"value3": "其连贯的言语能被不熟悉的人听懂。"
								},
								{
									"value": "4",
									"value3": "其连贯的言语能被所有人听懂。日常语境下，儿童的言语能被轻易听懂。"
								}
							],
							"pinggurenyuan": ""
						},
						"org_id": '',
						"year": "",
						"stu_ID": "",
						"stu_name": "",
						"stu_home": "",
						"minzu": "",
						"family_phone": "",
						"family_name": "",
						"family_ID": "",
						"sex": "",
						"chushenriqi": ""
					},
					// 特殊病案会诊
					this.tsbahz_info = {
						"id": 10,
						"stu_id": "",
						"teshubinganhuihzhenjilu": {
							"stu_sfz": "",
							"teshubinganhuihzhenjilu": [{
									"value": "会诊专家",
									"value2": ""
								},
								{
									"value": "主要照顾者描述",
									"value2": ""
								},
								{
									"value": "个别化教师描述",
									"value2": ""
								},
								{
									"value": "集体教师描述",
									"value2": ""
								},
								{
									"value": "听力师描述",
									"value2": ""
								},
								{
									"value": "专家会诊意见",
									"value2": ""
								}
							],
							"stu_id": null,
							"huizhenshijian": ""
						},
						"org_id": '',
						"year": "",
						"stu_ID": "",
						"stu_name": "",
						"stu_home": "",
						"minzu": "",
						"family_phone": "",
						"family_name": "",
						"family_ID": ""
					},
					// 格雷费斯报告
					this.glfs_info = {
						"id": 9,
						"stu_id": '',
						"jibenxinxi": {
							"xunhuan1": [{
									"biaoti": "出生体重:",
									"biaoti_jieguo": ""
								},
								{
									"biaoti": "孕期:",
									"biaoti_jieguo": ""
								}
							],
							"xunhuan2": [{
									"biaoti": "胎:",
									"biaoti_jieguo": ""
								},
								{
									"biaoti": "产:",
									"biaoti_jieguo": ""
								},
								{
									"biaoti": "顺（难）产:",
									"biaoti_jieguo": ""
								}
							],
							"xunhuan3": [{
									"biaoti": "曾患病:",
									"biaoti_jieguo": ""
								},
								{
									"biaoti": "现患病:",
									"biaoti_jieguo": ""
								}
							],
							"xunhuan4": [{
									"xunhuan": [{
											"biaoti": "父亲:",
											"biaoti_jieguo": ""
										},
										{
											"biaoti": "民族:",
											"biaoti_jieguo": ""
										},
										{
											"biaoti": "职业:",
											"biaoti_jieguo": ""
										},
										{
											"biaoti": "文化程度:",
											"biaoti_jieguo": ""
										},
										{
											"biaoti": "儿童出生时年龄:",
											"biaoti_jieguo": ""
										}
									]
								},
								{
									"xunhuan": [{
											"biaoti": "母亲:",
											"biaoti_jieguo": ""
										},
										{
											"biaoti": "民族:",
											"biaoti_jieguo": ""
										},
										{
											"biaoti": "职业:",
											"biaoti_jieguo": ""
										},
										{
											"biaoti": "文化程度:",
											"biaoti_jieguo": ""
										},
										{
											"biaoti": "儿童出生时年龄:",
											"biaoti_jieguo": ""
										}
									]
								}
							]
						},
						"chucun": [
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"xunhuan": [{
								"biaoti": "运动",
								"jieguo1": "0"
							},
							{
								"biaoti": "社交",
								"jieguo1": "0"
							},
							{
								"biaoti": "听力言语",
								"jieguo1": "0"
							},
							{
								"biaoti": "手眼协调",
								"jieguo1": "0"
							},
							{
								"biaoti": "操作",
								"jieguo1": "0"
							},
							{
								"biaoti": "推理",
								"jieguo1": "0"
							}
						],
						"beizhu": {
							"biaoti": "分析与建议",
							"biaoti_jieguo": ""
						},
						"pinggu": {
							"biaoti": "评估人员、日期及环境",
							"pinggu_riqi_biaoti": "评估日期：",
							"pinggu_riqi": "",
							"pinggu_renyuan_biaoti": "评估人员：",
							"pinggu_renyuan": "",
							"ceshi_huanjing_biaoti": "测试环境：",
							"ceshi_huanjing": ""
						},
						"org_id": '',
						"year": "",
						"stu_ID": "",
						"stu_name": "",
						"stu_home": "",
						"minzu": "",
						"family_phone": "",
						"family_name": "",
						"family_ID": "",
						"sex": "",
						"chushenriqi": ""
					},
					// 希一内报告单
					this.xybgd_info = {
						"id": 15,
						"stu_id": '',
						"chucunsujv": {
							"jibenshujv": [{
									"biaoti": "实际年龄"
								},
								{
									"biaoti": "中位数智龄"
								},
								{
									"biaoti": "智商/学习能力商"
								},
								{
									"biaoti": "百分位数"
								}
							],
							"chucun2": [
								"",
								"",
								"",
								""
							],
							"chucun": [{
									"neirong": [
										0,
										0
									]
								},
								{
									"neirong": [
										0,
										0
									]
								},
								{
									"neirong": [
										0,
										0
									]
								},
								{
									"neirong": [
										0,
										0
									]
								},
								{
									"neirong": [
										0,
										0
									]
								},
								{
									"neirong": [
										0,
										0
									]
								},
								{
									"neirong": [
										0,
										0
									]
								}
							]
						},
						"xunhuan": [{
								"biaoti": "穿珠"
							},
							{
								"biaoti": "记颜色"
							},
							{
								"biaoti": "图"
							},
							{
								"biaoti": "联想辩认"
							},
							{
								"biaoti": "折纸"
							},
							{
								"biaoti": "摆方木"
							},
							{
								"biaoti": "完成图"
							}
						],
						"beizhu": {
							"biaoti": "分析与建议",
							"biaoti_jieguo": ""
						},
						"pinggu": {
							"biaoti": "评估人员、日期及环境",
							"pinggu_riqi_biaoti": "评估日期：",
							"pinggu_riqi": "",
							"pinggu_renyuan_biaoti": "评估人员：",
							"pinggu_renyuan": "",
							"ceshi_huanjing_biaoti": "测试环境：",
							"ceshi_huanjing": ""
						},
						"org_id": '',
						"year": "",
						"stu_ID": "",
						"stu_name": "",
						"stu_home": "",
						"minzu": "",
						"family_phone": "",
						"family_name": "",
						"family_ID": "",
						"sex": "",
						"chushenriqi": ""
					},
					this.shouci_list = JSON.parse(JSON.stringify(this.shouci_list))
				this.request_get()
			}
		},
computed:{
       teatoken(){
			return window.localStorage.getItem("tea_token");
		},
	},
		methods: {
			option_xi() {
				let data = [null]
				for (var i = 0; i < this.xybgd_info.chucunsujv.chucun.length; i++) {
					data.push(
						`${this.xybgd_info.chucunsujv.chucun[i].neirong[0]+2}-${'06'.charAt(this.xybgd_info.chucunsujv.chucun[i].neirong[1])}`
					)
				}
				data.push(null)
				var myChart2 = this.$echarts.init(this.$refs.main_1, null, {
					width: 700,
					height: 900
				})
				myChart2.setOption({
					color: [
						'#d48265',
					],
					source: [],
					title: {
						text: '希一内报告单',
						left: 'center', // 水平居中
						top: 'top' // 垂直居中，也可以使用 'middle'
					},
					tooltip: {},
					xAxis: {
						type: 'category',
						data: ['智龄', '穿珠', '记颜色', '图', '联想辩认', '折纸', '短记忆力', '摆方木', '完成图'],
						boundaryGap: false,
						splitLine: {
							show: true
						}
					},
					yAxis: {
						type: 'category',
						data: ['2-6', '3-0', '3-6', '4-0', '4-6', '5-0', '5-6', '6-0', '6-6', '7-0', '7-6', '8-0',
							'8-6', '9-0', '9-6', '10-0', '10-6', '11-0', '11-6', '12-0', '12-6', '13-0',
							'13-6',
							'14-0', '14-6', '15-0', '15-6', '16-0', '16-6', '17-0', '17-6', '18-0', '18-6'
						],
						minorSplitLine: {
							show: true
						},
					},
					series: [{
						type: 'line',
						data: data,
						label: {
							show: true, // 在线条上显示数据数值
							formatter: '{c}' // 数据格式化为原始数据
						}
					}]
				})
			},
			option_glfs() {
				let data = [null]
				let sum = 0
				let sum_yue = 0
				for (let i = 0; i < this.glfs_info.chucun.length; i++) {
					data.push(this.glfs_info.chucun[i] == null ? 0 : Number.parseInt(this.glfs_info.chucun[i]))
					sum += this.glfs_info.chucun[i] == null ? 0 : Number.parseInt(this.glfs_info.chucun[i])
				}

				for (let i = 0; i < this.glfs_info.xunhuan.length; i++) {
					sum_yue += this.glfs_info.xunhuan[i].jieguo1 == null ? 0 : Number.parseInt(this.glfs_info.xunhuan[i]
						.jieguo1)
				}

				data.push(sum)
				this.sum = sum
				this.sum_yue = sum_yue
				// 数据整合
				let myChart = this.$echarts.init(this.$refs.main, null, {
					width: 600,
					height: 600
				})
				myChart.setOption({
					color: [
						'#d48265',
					],
					source: [],
					title: {
						text: '格雷费斯报告(单领域190封顶)',
						left: 'center', // 水平居中
						top: 'top' // 垂直居中，也可以使用 'middle'
					},
					tooltip: {},
					xAxis: {
						type: 'category',
						data: ['发育商', '运动', '社交', '听力言语', '手眼协调', '操作', '推理', '总计'],
						boundaryGap: false,
						splitLine: {
							show: true
						}
					},
					yAxis: {
						type: 'value',
						data: [0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100, 110, 120, 130, 140, 150,
							160, 170, 180, 190
						],
						minorSplitLine: {
							show: true
						},
					},
					series: [{
						type: 'line',
						data: data,
						label: {
							show: true, // 在线条上显示数据数值
							formatter: '{c}' // 数据格式化为原始数据
						}
					}]
				})
			},
			getdate(time) {
				let d = new Date(time)
				return d.getFullYear() + "-" + ((d.getMonth() + 1) < 10 ? "0" + (d.getMonth() + 1) : (d.getMonth() + 1)) +
					"-" + (d
						.getDate() < 10 ? "0" + d.getDate() : d.getDate())
			},
			scrollT(id) {
				setTimeout(() => {
					let idd = document.getElementById(id)
					idd.scrollIntoView()
				}, 80)
			},
			async request_get() {
				this.$axios.get(this.$urls + "test/get_dangan_stu", {
					params: {
						stu_id: this.stu_id,
						stu_type: this.stu_type,
						year: this.year,
						org_id: this.org_id
					},headers: {
				"teatoken": this.teatoken
			}
				}).then((rep) => {
					let list = rep.data
					// 基本资料  
					let obj = list.data.find(item => item.name == "基本资料")
					if (obj.value.length != 0) {
						for (let key in obj.value) {
							if (key == "family_info" || key == "family_zhuangkuang" || key == "ruyuan_info" ||
								key ==
								"stu_info_jbxx") {
								obj.value[key] = JSON.parse(obj.value[key])
							} else if (key == "age") {
								obj.value[key] = new Date().getFullYear() - Number.parseInt(obj.value.stu_ID
									.substring(6, 10))
								obj.value.shengri = obj.value.stu_ID.substring(6, 10) + "-" + obj.value.stu_ID
									.substring(10, 12) +
									"-" + obj.value.stu_ID.substring(12, 14)
							}
							if (obj.value[key] == "null" || obj.value[key] == undefined || obj.value[key] ==
								"undefined" || obj
								.value[key] == null || obj.value[key] == "") {
								obj.value[key] = "空"
							}
						}
						this.stu_info_tlyy = obj.value
						console.log(this.stu_info_tlyy, "stu_info_tlyy,基本资料");
					}
					// 首次评估
					let obj_sc = list.data.find(item => item.name == "首次评估")
					if (obj_sc.value.length != 0) {
						for (let key in obj_sc.value) {
							if (key == "stu_ID") {
								obj_sc.value.shengri = String(obj_sc.value.stu_ID).substring(6, 10) + "-" +
									String(obj_sc.value
										.stu_ID).substring(10, 12) + "-" + String(obj_sc.value.stu_ID)
									.substring(12, 14)
								obj_sc.value.sex = Number.parseInt(obj_sc.value.stu_ID.substring(16, 17)) %
									2 == 0 ? "女" : "男"
							}
						}
						this.shouci_list = obj_sc.value
						if (this.shouci_list.awp.length != 0) {
							this.shouci_list.awp = JSON.parse(this.shouci_list.awp.replace(/\n/g, " ").replace(
								/\t/g, " 。 "))
						}
						if (this.shouci_list.tinglizhuangkuang.length != 0) {
							this.shouci_list.tinglizhuangkuang = JSON.parse(this.shouci_list.tinglizhuangkuang
								.replace(/\n/g, " ")
								.replace(/\t/g, " 。 "))
						}

						if (this.shouci_list.zonghefenxi.length != 0) {
							this.shouci_list.zonghefenxi = JSON.parse(this.shouci_list.zonghefenxi.replace(
								/\n/g,
								" ").replace(
								/\t/g, " 。 "))
						}
						if (this.shouci_list.pinggurenyuanriqi.length != 0) {
							this.shouci_list.pinggurenyuanriqi = JSON.parse(this.shouci_list.pinggurenyuanriqi
								.replace(/\n/g, " ")
								.replace(/\t/g, " 。 "))
						}
						console.log(this.shouci_list, "shouci_list,首次评估");
					}

					// 持续评估 
					let obj_cxpg = list.data.find(item => item.name == "持续评估")
					if (obj_cxpg.value.length != 0) {
						this.cxpg_info = obj_cxpg.value
						if (this.cxpg_info.yuyan.length != 0) {
							this.cxpg_info.yuyan = JSON.parse(this.cxpg_info.yuyan.replace(/\n/g, " ").replace(
								/\t/g, " 。 "))
						}
						if (this.cxpg_info.tingneng.length != 0) {
							this.cxpg_info.tingneng = JSON.parse(this.cxpg_info.tingneng.replace(/\n/g, " ")
								.replace(
									/\t/g, " 。 "))
						}
						if (this.cxpg_info.tingjuejiyi.length != 0) {
							this.cxpg_info.tingjuejiyi = JSON.parse(this.cxpg_info.tingjuejiyi.replace(/\n/g,
									" ")
								.replace(
									/\t/g, " 。 "))
						}
						if (this.cxpg_info.renzhi.length != 0) {
							this.cxpg_info.renzhi = JSON.parse(this.cxpg_info.renzhi.replace(/\n/g, " ")
								.replace(
									/\t/g, " 。 "))
						}
						if (this.cxpg_info.yanyu.length != 0) {
							this.cxpg_info.yanyu = JSON.parse(this.cxpg_info.yanyu.replace(/\n/g, " ").replace(
								/\t/g, " 。 "))
						}
						if (this.cxpg_info.order_cxpg.length != 0) {
							this.cxpg_info.order_cxpg = JSON.parse(this.cxpg_info.order_cxpg.replace(/\n/g,
									" ")
								.replace(
									/\t/g, " 。 "))
						}
						if (this.cxpg_info.jiazhangbiaoxian.length != 0) {
							this.cxpg_info.jiazhangbiaoxian = JSON.parse(this.cxpg_info.jiazhangbiaoxian
								.replace(
									/\n/g, " ").replace(
									/\t/g, " 。 "))
						}
						if (this.cxpg_info.goutong.length != 0) {
							this.cxpg_info.goutong = JSON.parse(this.cxpg_info.goutong.replace(/\n/g, " ")
								.replace(
									/\t/g, " 。 "))
						}

						this.newProgress = this.cxpg_info.jiazhangbiaoxian.value.find(item => item.name ==
							'在哪些方面有新的进步?').value
						this.newProgress1 = this.cxpg_info.jiazhangbiaoxian.value.find(item => item.name ==
							'其它?').value


						console.log(this.cxpg_info, "cxpg_info,持续评估");
					}

					// 教学计划
					let obj_jiaoxuejihua = list.data.find(item => item.name == '教学计划')
					if (obj_jiaoxuejihua.value.length != 0) {
						this.jiaoxuejihua = obj_jiaoxuejihua.value
							this.jiaoxuejihua.lingyu = JSON.parse(this.jiaoxuejihua.lingyu)
						console.log(this.jiaoxuejihua.lingyu, "jiaoxuejihua,教学计划");
						this.jiaoxuejihua.stu_sex = Number.parseInt(this.jiaoxuejihua.stu_idcard.substring(16,
							17)) % 2 == 1 ? "男" : "女"
					}
					// 日常教学记录
					let obj_rcjxjl = list.data.find(item => item.name == '日常教学记录')
					if (obj_rcjxjl.value.length != 0) {
						this.rcjxjh_info = obj_rcjxjl.value
						if (this.rcjxjh_info.jzbx.length != 0) {
							this.rcjxjh_info.jzbx = JSON.parse(this.rcjxjh_info.jzbx.replace(/\n/g, " ")
								.replace(
									/\t/g, " 。 "))
						}
						if (this.rcjxjh_info.yyfz2.length != 0) {
							this.rcjxjh_info.yyfz2 = JSON.parse(this.rcjxjh_info.yyfz2.replace(/\n/g, " ")
								.replace(
									/\t/g, " 。 "))
						}
						if (this.rcjxjh_info.yyfz1.length != 0) {
							this.rcjxjh_info.yyfz1 = JSON.parse(this.rcjxjh_info.yyfz1.replace(/\n/g, " ")
								.replace(
									/\t/g, " 。 "))
						}
						if (this.rcjxjh_info.tnfz.length != 0) {
							this.rcjxjh_info.tnfz = JSON.parse(this.rcjxjh_info.tnfz.replace(/\n/g, " ")
								.replace(
									/\t/g, " 。 "))
						}
						if (this.rcjxjh_info.rzfz.length != 0) {
							this.rcjxjh_info.rzfz = JSON.parse(this.rcjxjh_info.rzfz.replace(/\n/g, " ")
								.replace(
									/\t/g, " 。 "))
						}
						if (this.rcjxjh_info.gtjn.length != 0) {
							this.rcjxjh_info.gtjn = JSON.parse(this.rcjxjh_info.gtjn.replace(/\n/g, " ")
								.replace(
									/\t/g, " 。 "))
						}
						if (this.rcjxjh_info.cg.length != 0) {
							this.rcjxjh_info.cg = JSON.parse(this.rcjxjh_info.cg.replace(/\n/g, " ").replace(
								/\t/g, " 。 "))
						}

						console.log(this.rcjxjh_info, "rcjxjh_info,日常教学记录");
					}

					// 临床数据
					let obj_lcsj = list.data.find(item => item.name == '临床数据')
					if (obj_lcsj.value.length != 0) {
						this.lcsj_info = obj_lcsj.value
						if (this.lcsj_info.erlongshi.length != 0) {
							this.lcsj_info.erlongshi = JSON.parse(this.lcsj_info.erlongshi.replace(/\n/g, " ")
								.replace(
									/\t/g, " 。 "))
						}
						if (this.lcsj_info.tigejiancha.length != 0) {
							this.lcsj_info.tigejiancha = JSON.parse(this.lcsj_info.tigejiancha.replace(/\n/g,
									" ")
								.replace(
									/\t/g, " 。 "))
						}
						if (this.lcsj_info.renshenshi.length != 0) {
							this.lcsj_info.renshenshi = JSON.parse(this.lcsj_info.renshenshi.replace(/\n/g,
									" ")
								.replace(
									/\t/g, " 。 "))
						}
						if (this.lcsj_info.jiazushi.length != 0) {
							this.lcsj_info.jiazushi = JSON.parse(this.lcsj_info.jiazushi.replace(/\n/g, " ")
								.replace(
									/\t/g, " 。 "))
						}
						if (this.lcsj_info.gerenshi.length != 0) {
							this.lcsj_info.gerenshi = JSON.parse(this.lcsj_info.gerenshi.replace(/\n/g, " ")
								.replace(
									/\t/g, " 。 "))
						}
						if (this.lcsj_info.chushengshi.length != 0) {
							this.lcsj_info.chushengshi = JSON.parse(this.lcsj_info.chushengshi.replace(/\n/g,
									" ")
								.replace(
									/\t/g, " 。 "))
						}
						console.log(this.lcsj_info, "lcsj_info,临床数据");
					}
					// 诊断记录
					let obj_zdjl = list.data.find(item => item.name == '诊断记录')
					if (obj_zdjl.value.length != 0) {
						this.zdjl_info = obj_zdjl.value
						if (this.zdjl_info.formData.length != 0) {
							this.zdjl_info.formData = JSON.parse(this.zdjl_info.formData.replace(/\n/g, " ")
								.replace(
									/\t/g, " 。 "))
						}
						if (this.zdjl_info.testData.length != 0) {
							this.zdjl_info.testData = JSON.parse(this.zdjl_info.testData.replace(/\n/g, " ")
								.replace(
									/\t/g, " 。 "))
						}


						this.zdjl_info.sex = this.zdjl_info.stu_ID.substring(16, 17) % 2 == 1 ? "男" : '女'
						console.log(this.zdjl_info, "zdjl_info,诊断记录");
					}
					// 听能服务日志
					let obj_tnfwrz = list.data.find(item => item.name == "听能服务日志")
					if (obj_tnfwrz.value.length != 0) {
						this.tnfwrz_info = obj_tnfwrz.value
						for (let i = 0; i < this.tnfwrz_info.length; i++) {
							if (i == 0 && this.tnfwrz_info[i].stu_ID) {
								this.tnfwrz_info[i].sex = this.tnfwrz_info[i].stu_ID.substring(16,
									17) % 2 == 1 ? "男" : '女'
								this.tnfwrz_info[i].chushenriqi = this.tnfwrz_info[i].stu_ID
									.substring(6, 10) + "-" + this.tnfwrz_info[i].stu_ID.substring(10, 12) +
									"-" + this.tnfwrz_info[i].stu_ID.substring(12, 14)
							}
							this.tnfwrz_info[i].duoxuan = JSON.parse(this.tnfwrz_info[i].duoxuan
								.replace(/\n/g, " ")
								.replace(
									/\t/g, " 。 "))
							this.tnfwrz_info[i].tianxie = JSON.parse(this.tnfwrz_info[i].tianxie
								.replace(/\n/g, " ")
								.replace(
									/\t/g, " 。 "))
						}
						console.log(this.tnfwrz_info, "tnfwrz_info,听能服务日志");
					}
					// 成长评价建议
					let obj_czpjjy = list.data.find(item => item.name == "成长评价建议")
					if (obj_czpjjy.value.length != 0) {
						this.czpjjy_info = obj_czpjjy.value
						this.czpjjy_info.shujv = JSON.parse(this.czpjjy_info.shujv.replace(/\n/g, " ")
							.replace(
								/\t/g, " 。 "))
						if (this.czpjjy_info.stu_ID) {
							this.czpjjy_info.sex = this.czpjjy_info.stu_ID.substring(16,
								17) % 2 == 1 ? "男" : '女'
							this.czpjjy_info.chushenriqi = this.czpjjy_info.stu_ID
								.substring(6, 10) + "-" + this.czpjjy_info.stu_ID.substring(10, 12) +
								"-" + this.czpjjy_info.stu_ID.substring(12, 14)
						}
						console.log(this.czpjjy_info, "czpjjy_info,成长评价建议");
					}

					// 结案报告
					let obj_jabg = list.data.find(item => item.name == "结案报告")
					if (obj_jabg.value.length != 0) {
						this.jabg_info = obj_jabg.value
						this.jabg_info.jibenxinxi = JSON.parse(this.jabg_info.jibenxinxi.replace(/\n/g, " ")
							.replace(
								/\t/g, " 。 "))
						this.jabg_info.jiean = JSON.parse(this.jabg_info.jiean.replace(/\n/g, " ")
							.replace(
								/\t/g, " 。 "))
						this.jabg_info.pinggujieguozhaiyao = JSON.parse(this.jabg_info.pinggujieguozhaiyao
							.replace(/\n/g, " ")
							.replace(
								/\t/g, " 。 "))
						this.jabg_info.zhutingshebenpeidaiqingkuang = JSON.parse(this.jabg_info
							.zhutingshebenpeidaiqingkuang.replace(/\n/g, " ")
							.replace(
								/\t/g, " 。 "))
						if (this.jabg_info.stu_ID) {
							this.jabg_info.sex = this.jabg_info.stu_ID.substring(16,
								17) % 2 == 1 ? "男" : '女'
							this.jabg_info.chushenriqi = this.jabg_info.stu_ID
								.substring(6, 10) + "-" + this.jabg_info.stu_ID.substring(10, 12) +
								"-" + this.jabg_info.stu_ID.substring(12, 14)
						}
						console.log(this.jabg_info, "jabg_info,结案报告");
					}

					// 回访记录
					let obj_hfjl = list.data.find(item => item.name == "回访记录")
					if (obj_hfjl.value.length != 0) {
						this.hfjl_info = obj_hfjl.value
						if (this.hfjl_info.stu_ID) {
							this.hfjl_info.sex = this.hfjl_info.stu_ID.substring(16,
								17) % 2 == 1 ? "男" : '女'
							this.hfjl_info.chushenriqi = this.hfjl_info.stu_ID
								.substring(6, 10) + "-" + this.hfjl_info.stu_ID.substring(10, 12) +
								"-" + this.hfjl_info.stu_ID.substring(12, 14)
						}
						this.hfjl_info.huifang = JSON.parse(this.hfjl_info.huifang.replace(/\n/g, " ")
							.replace(
								/\t/g, " 。 "))
						this.hfjl_info.jianyi = JSON.parse(this.hfjl_info.jianyi.replace(/\n/g, " ")
							.replace(
								/\t/g, " 。 "))
						this.hfjl_info.jibenxinxi = JSON.parse(this.hfjl_info.jibenxinxi.replace(/\n/g, " ")
							.replace(
								/\t/g, " 。 "))
						this.hfjl_info.kangfuzouxiang = JSON.parse(this.hfjl_info.kangfuzouxiang.replace(/\n/g,
								" ")
							.replace(
								/\t/g, " 。 "))
						this.hfjl_info.wentijixvqiu = JSON.parse(this.hfjl_info.wentijixvqiu.replace(/\n/g,
								" ")
							.replace(
								/\t/g, " 。 "))
						this.hfjl_info.xiacihuifangxvjiaqiang = JSON.parse(this.hfjl_info
							.xiacihuifangxvjiaqiang.replace(/\n/g, " ")
							.replace(
								/\t/g, " 。 "))
						console.log(this.hfjl_info, "hfjl_info,回访记录");
					}

					// 听觉能力评估
					let obj_tjnlpg = list.data.find(item => item.name == "听觉能力评估")
					if (obj_tjnlpg.value.length != 0) {
						this.tjnlpg_info = obj_tjnlpg.value
						if (this.tjnlpg_info.stu_ID) {
							this.tjnlpg_info.chushenriqi = this.tjnlpg_info.stu_ID
								.substring(6, 10) + "-" + this.tjnlpg_info.stu_ID.substring(10, 12) +
								"-" + this.tjnlpg_info.stu_ID.substring(12, 14)
						}
						this.tjnlpg_info.pinggu = JSON.parse(this.tjnlpg_info
							.pinggu.replace(/\n/g, " ")
							.replace(
								/\t/g, " 。 "))
						this.tjnlpg_info.tiankong = JSON.parse(this.tjnlpg_info
							.tiankong.replace(/\n/g, " ")
							.replace(
								/\t/g, " 。 "))
						this.tjnlpg_info.xunhuan = JSON.parse(this.tjnlpg_info
							.xunhuan.replace(/\n/g, " ")
							.replace(
								/\t/g, " 。 "))
						console.log(this.tjnlpg_info, "tjnlpg_info,听觉能力评估");
					}
					// CAP分级表
					let obj_cap = list.data.find(item => item.name == "CAP分级表")
					if (obj_cap.value.length != 0) {
						this.cap_info = obj_cap.value
						this.cap_info.awp = JSON.parse(this.cap_info
							.awp.replace(/\n/g, " ")
							.replace(
								/\t/g, " 。 "))
						if (this.cap_info.stu_ID) {
							this.cap_info.sex = this.cap_info.stu_ID.substring(16,
								17) % 2 == 1 ? "男" : '女'
							this.cap_info.chushenriqi = this.cap_info.stu_ID
								.substring(6, 10) + "-" + this.cap_info.stu_ID.substring(10, 12) +
								"-" + this.cap_info.stu_ID.substring(12, 14)
						}
						console.log(this.cap_info, "cap_info,CAP分级表");
					}

					// 语言能力评估
					let obj_yynlpg = list.data.find(item => item.name == "语言能力评估")
					if (obj_yynlpg.value.length != 0) {
						this.yynlpg_info = obj_yynlpg.value
						this.yynlpg_info.pinggu = JSON.parse(this.yynlpg_info
							.pinggu.replace(/\n/g, " ")
							.replace(
								/\t/g, " 。 "))
						this.yynlpg_info.tiankong = JSON.parse(this.yynlpg_info
							.tiankong.replace(/\n/g, " ")
							.replace(
								/\t/g, " 。 "))
						this.yynlpg_info.xunhuan = JSON.parse(this.yynlpg_info
							.xunhuan
							.replace(/\n/g, " ")
							.replace(
								/\t/g, " 。 "))
						if (this.yynlpg_info.stu_ID) {
							this.yynlpg_info.sex = this.yynlpg_info.stu_ID.substring(16,
								17) % 2 == 1 ? "男" : '女'
							this.yynlpg_info.chushenriqi = this.yynlpg_info.stu_ID
								.substring(6, 10) + "-" + this.yynlpg_info.stu_ID.substring(10, 12) +
								"-" + this.yynlpg_info.stu_ID.substring(12, 14)
						}
						console.log(this.yynlpg_info, "yynlpg_info,语言能力评估");
					}

					// SIR分级表
					let obj_sir = list.data.find(item => item.name == "SIR分级表")
					if (obj_sir.value.length != 0) {
						this.sir_info = obj_sir.value
						this.sir_info.awp = JSON.parse(this.sir_info.awp.replace(/\n/g, " ")
							.replace(
								/\t/g, " 。 "))
						if (this.sir_info.stu_ID) {
							this.sir_info.sex = this.sir_info.stu_ID.substring(16,
								17) % 2 == 1 ? "男" : '女'
							this.sir_info.chushenriqi = this.sir_info.stu_ID
								.substring(6, 10) + "-" + this.sir_info.stu_ID.substring(10, 12) +
								"-" + this.sir_info.stu_ID.substring(12, 14)
						}
						console.log(this.sir_info, "sir_info,SIR分级表");
					}

					// 特殊病案会诊
					let obj_tsbahz = list.data.find(item => item.name == "特殊病案会诊")
					if (obj_tsbahz.value.length != 0) {
						this.tsbahz_info = obj_tsbahz.value
						this.tsbahz_info.teshubinganhuihzhenjilu = JSON.parse(this.tsbahz_info
							.teshubinganhuihzhenjilu.replace(/\n/g, " ")
							.replace(
								/\t/g, " 。 "))
						console.log(this.tsbahz_info, "tsbahz_info,特殊病案会诊");
					}
					// 格雷费斯报告
					let obj_glfs = list.data.find(item => item.name == "格雷费斯报告")
					if (obj_glfs.value.length != 0) {
						this.glfs_info = obj_glfs.value
						if (this.glfs_info.stu_ID) {
							this.glfs_info.sex = this.glfs_info.stu_ID.substring(16,
								17) % 2 == 1 ? "男" : '女'
							this.glfs_info.chushenriqi = this.glfs_info.stu_ID
								.substring(6, 10) + "-" + this.glfs_info.stu_ID.substring(10, 12) +
								"-" + this.glfs_info.stu_ID.substring(12, 14)
						}
						this.glfs_info.beizhu = JSON.parse(this.glfs_info
							.beizhu.replace(/\n/g, " ")
							.replace(
								/\t/g, " 。 "))
						this.glfs_info.chucun = JSON.parse(this.glfs_info
							.chucun.replace(/\n/g, " ")
							.replace(
								/\t/g, " 。 "))
						this.glfs_info.jibenxinxi = JSON.parse(this.glfs_info
							.jibenxinxi.replace(/\n/g, " ")
							.replace(
								/\t/g, " 。 "))

						this.glfs_info.pinggu = JSON.parse(this.glfs_info
							.pinggu.replace(/\n/g, " ")
							.replace(
								/\t/g, " 。 "))
						this.glfs_info.xunhuan = JSON.parse(this.glfs_info
							.xunhuan.replace(/\n/g, " ")
							.replace(
								/\t/g, " 。 "))
						console.log(this.glfs_info, "glfs_info,格雷费斯报告");

					}
					this.option_glfs()
					// 希一内报告单
					let obj_xi = list.data.find(item => item.name == "希一内报告单")
					if (obj_xi.value.length != 0) {
						this.xybgd_info = obj_xi.value
						if (this.xybgd_info.stu_ID) {
							this.xybgd_info.sex = this.xybgd_info.stu_ID.substring(16,
								17) % 2 == 1 ? "男" : '女'
							this.xybgd_info.chushenriqi = this.xybgd_info.stu_ID
								.substring(6, 10) + "-" + this.xybgd_info.stu_ID.substring(10, 12) +
								"-" + this.xybgd_info.stu_ID.substring(12, 14)
						}
						this.xybgd_info.beizhu = JSON.parse(this.xybgd_info
							.beizhu.replace(/\n/g, " ")
							.replace(
								/\t/g, " 。 "))
						this.xybgd_info.chucunsujv = JSON.parse(this.xybgd_info
							.chucunsujv.replace(/\n/g, " ")
							.replace(
								/\t/g, " 。 "))
						this.xybgd_info.pinggu = JSON.parse(this.xybgd_info
							.pinggu.replace(/\n/g, " ")
							.replace(
								/\t/g, " 。 "))
						this.xybgd_info.xunhuan = JSON.parse(this.xybgd_info
							.xunhuan.replace(/\n/g, " ")
							.replace(
								/\t/g, " 。 "))
						console.log(this.xybgd_info, "xybgd_info,希一内报告单");

					}
					this.option_xi()
				})
			}
		}
	}
</script>

<style type="text/css">
	.queren {
		display: flex;
		align-items: center;
	}

	.rbuttong {
		position: fixed;
		right: 5px;
		width: 11vw;
		top: 50px;
		display: flex;
		flex-direction: column;
		align-items: center;
		height: 85vh;
		/* 设置 div 的高度 */
		overflow: auto;
		/* 设置滚动条 */
		overflow-x: hidden;
		/* 隐藏横向滚动条 */
	}

	.dbod {
		width: 80vw;
		margin-left: 5vw;
	}

	.margin-top {
		margin-top: 10px;
	}

	.fangkuai {
		display: flex;
		align-items: center;
		justify-content: center;
		height: 18px;
		width: 18px;
		border: 1px solid #717171;
	}

	.yuanquan {
		display: flex;
		align-items: center;
		justify-content: center;
		height: 20px;
		width: 20px;
		border-radius: 50%;
		background-color: royalblue;
		color: white;
	}
</style>